//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

const XUserAgent = "EVE Excel/1.8.74"
const App_Name = "EVE Excel"
const App_Version = "1.8.74"

export const customHeaders = {
    "X-User-Agent": XUserAgent,
    "App-Name": App_Name,
    "App-Version": App_Version,
}

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://esi.evetech.net";
    }

    /**
     * List all alliances
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return List of Alliance IDs
     */
    get_alliances(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/alliances/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_alliances(_response);
        });
    }

    protected processGet_alliances(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get alliance contact labels
     * @param alliance_id An EVE alliance ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of alliance contact labels
     */
    get_alliances_alliance_id_contacts_labels(alliance_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_alliances_alliance_id_contacts_labels_200_ok[]> {
        let url_ = this.baseUrl + "/v1/alliances/{alliance_id}/contacts/labels/?";
        if (alliance_id === undefined || alliance_id === null)
            throw new Error("The parameter 'alliance_id' must be defined.");
        url_ = url_.replace("{alliance_id}", encodeURIComponent("" + alliance_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_alliances_alliance_id_contacts_labels(_response);
        });
    }

    protected processGet_alliances_alliance_id_contacts_labels(response: Response): Promise<Get_alliances_alliance_id_contacts_labels_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_alliances_alliance_id_contacts_labels_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_alliances_alliance_id_contacts_labels_200_ok[]>(null as any);
    }

    /**
     * List alliance's corporations
     * @param alliance_id An EVE alliance ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return List of corporation IDs
     */
    get_alliances_alliance_id_corporations(alliance_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/alliances/{alliance_id}/corporations/?";
        if (alliance_id === undefined || alliance_id === null)
            throw new Error("The parameter 'alliance_id' must be defined.");
        url_ = url_.replace("{alliance_id}", encodeURIComponent("" + alliance_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_alliances_alliance_id_corporations(_response);
        });
    }

    protected processGet_alliances_alliance_id_corporations(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get alliance icon
     * @param alliance_id An EVE alliance ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Icon URLs for the given alliance id and server
     */
    get_alliances_alliance_id_icons(alliance_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_alliances_alliance_id_icons_ok> {
        let url_ = this.baseUrl + "/v1/alliances/{alliance_id}/icons/?";
        if (alliance_id === undefined || alliance_id === null)
            throw new Error("The parameter 'alliance_id' must be defined.");
        url_ = url_.replace("{alliance_id}", encodeURIComponent("" + alliance_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_alliances_alliance_id_icons(_response);
        });
    }

    protected processGet_alliances_alliance_id_icons(response: Response): Promise<Get_alliances_alliance_id_icons_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_alliances_alliance_id_icons_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_alliances_alliance_id_icons_not_found.fromJS(resultData404);
            return throwException("No image server for this datasource", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_alliances_alliance_id_icons_ok>(null as any);
    }

    /**
     * Get character asset names
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param item_ids A list of item ids
     * @param token (optional) Access token to use if unable to set a header
     * @return List of asset names
     */
    post_characters_character_id_assets_names(character_id: number, datasource: Datasource | null | undefined, item_ids: number[], token: string | null | undefined): Promise<Post_characters_character_id_assets_names_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/assets/names/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item_ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_characters_character_id_assets_names(_response);
        });
    }

    protected processPost_characters_character_id_assets_names(response: Response): Promise<Post_characters_character_id_assets_names_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Post_characters_character_id_assets_names_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post_characters_character_id_assets_names_200_ok[]>(null as any);
    }

    /**
     * Get character attributes
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Attributes of a character
     */
    get_characters_character_id_attributes(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_attributes_ok> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/attributes/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_attributes(_response);
        });
    }

    protected processGet_characters_character_id_attributes(response: Response): Promise<Get_characters_character_id_attributes_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_attributes_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_attributes_ok>(null as any);
    }

    /**
     * List calendar event summaries
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param from_event (optional) The event ID to retrieve events from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A collection of event summaries
     */
    get_characters_character_id_calendar(character_id: number, datasource: Datasource | null | undefined, from_event: number | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_calendar_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/calendar/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (from_event !== undefined && from_event !== null)
            url_ += "from_event=" + encodeURIComponent("" + from_event) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_calendar(_response);
        });
    }

    protected processGet_characters_character_id_calendar(response: Response): Promise<Get_characters_character_id_calendar_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_calendar_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_calendar_200_ok[]>(null as any);
    }

    /**
     * Get attendees
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param event_id The id of the event requested
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return List of attendees
     */
    get_characters_character_id_calendar_event_id_attendees(character_id: number, datasource: Datasource | null | undefined, event_id: number, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_calendar_event_id_attendees_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/calendar/{event_id}/attendees/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (event_id === undefined || event_id === null)
            throw new Error("The parameter 'event_id' must be defined.");
        url_ = url_.replace("{event_id}", encodeURIComponent("" + event_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_calendar_event_id_attendees(_response);
        });
    }

    protected processGet_characters_character_id_calendar_event_id_attendees(response: Response): Promise<Get_characters_character_id_calendar_event_id_attendees_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_calendar_event_id_attendees_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_characters_character_id_calendar_event_id_attendees_not_found.fromJS(resultData404);
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_calendar_event_id_attendees_200_ok[]>(null as any);
    }

    /**
     * Get contact labels
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of contact labels
     */
    get_characters_character_id_contacts_labels(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_contacts_labels_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/contacts/labels/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_contacts_labels(_response);
        });
    }

    protected processGet_characters_character_id_contacts_labels(response: Response): Promise<Get_characters_character_id_contacts_labels_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_contacts_labels_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_contacts_labels_200_ok[]>(null as any);
    }

    /**
     * Get contracts
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of contracts
     */
    get_characters_character_id_contracts(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_characters_character_id_contracts_200_ok[]>> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/contracts/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_contracts(_response);
        });
    }

    protected processGet_characters_character_id_contracts(response: Response): Promise<SwaggerResponse<Get_characters_character_id_contracts_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_contracts_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_characters_character_id_contracts_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get contract bids
     * @param character_id An EVE character ID
     * @param contract_id ID of a contract
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of bids
     */
    get_characters_character_id_contracts_contract_id_bids(character_id: number, contract_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_contracts_contract_id_bids_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/contracts/{contract_id}/bids/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (contract_id === undefined || contract_id === null)
            throw new Error("The parameter 'contract_id' must be defined.");
        url_ = url_.replace("{contract_id}", encodeURIComponent("" + contract_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_contracts_contract_id_bids(_response);
        });
    }

    protected processGet_characters_character_id_contracts_contract_id_bids(response: Response): Promise<Get_characters_character_id_contracts_contract_id_bids_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_contracts_contract_id_bids_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_characters_character_id_contracts_contract_id_bids_not_found.fromJS(resultData404);
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_contracts_contract_id_bids_200_ok[]>(null as any);
    }

    /**
     * Get contract items
     * @param character_id An EVE character ID
     * @param contract_id ID of a contract
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of items in this contract
     */
    get_characters_character_id_contracts_contract_id_items(character_id: number, contract_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_contracts_contract_id_items_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/contracts/{contract_id}/items/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (contract_id === undefined || contract_id === null)
            throw new Error("The parameter 'contract_id' must be defined.");
        url_ = url_.replace("{contract_id}", encodeURIComponent("" + contract_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_contracts_contract_id_items(_response);
        });
    }

    protected processGet_characters_character_id_contracts_contract_id_items(response: Response): Promise<Get_characters_character_id_contracts_contract_id_items_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_contracts_contract_id_items_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_characters_character_id_contracts_contract_id_items_not_found.fromJS(resultData404);
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_contracts_contract_id_items_200_ok[]>(null as any);
    }

    /**
     * Delete fitting
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param fitting_id ID for a fitting of this character
     * @param token (optional) Access token to use if unable to set a header
     * @return Fitting deleted
     */
    delete_characters_character_id_fittings_fitting_id(character_id: number, datasource: Datasource | null | undefined, fitting_id: number, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/fittings/{fitting_id}/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (fitting_id === undefined || fitting_id === null)
            throw new Error("The parameter 'fitting_id' must be defined.");
        url_ = url_.replace("{fitting_id}", encodeURIComponent("" + fitting_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete_characters_character_id_fittings_fitting_id(_response);
        });
    }

    protected processDelete_characters_character_id_fittings_fitting_id(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get character fleet info
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Details about the character's fleet
     */
    get_characters_character_id_fleet(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_fleet_ok> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/fleet/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_fleet(_response);
        });
    }

    protected processGet_characters_character_id_fleet(response: Response): Promise<Get_characters_character_id_fleet_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_fleet_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_characters_character_id_fleet_not_found.fromJS(resultData404);
            return throwException("The character is not in a fleet", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_fleet_ok>(null as any);
    }

    /**
     * Overview of a character involved in faction warfare
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Faction warfare statistics for a given character
     */
    get_characters_character_id_fw_stats(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_fw_stats_ok> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/fw/stats/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_fw_stats(_response);
        });
    }

    protected processGet_characters_character_id_fw_stats(response: Response): Promise<Get_characters_character_id_fw_stats_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_fw_stats_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_fw_stats_ok>(null as any);
    }

    /**
     * Get active implants
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of implant type ids
     */
    get_characters_character_id_implants(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/implants/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_implants(_response);
        });
    }

    protected processGet_characters_character_id_implants(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * List character industry jobs
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param include_completed (optional) Whether to retrieve completed character industry jobs. Only includes jobs from the past 90 days
     * @param token (optional) Access token to use if unable to set a header
     * @return Industry jobs placed by a character
     */
    get_characters_character_id_industry_jobs(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, include_completed: boolean | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_industry_jobs_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/industry/jobs/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (include_completed !== undefined && include_completed !== null)
            url_ += "include_completed=" + encodeURIComponent("" + include_completed) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_industry_jobs(_response);
        });
    }

    protected processGet_characters_character_id_industry_jobs(response: Response): Promise<Get_characters_character_id_industry_jobs_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_industry_jobs_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_industry_jobs_200_ok[]>(null as any);
    }

    /**
     * Get a character's recent kills and losses
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of killmail IDs and hashes
     */
    get_characters_character_id_killmails_recent(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_killmails_recent_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/killmails/recent/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_killmails_recent(_response);
        });
    }

    protected processGet_characters_character_id_killmails_recent(response: Response): Promise<Get_characters_character_id_killmails_recent_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_killmails_recent_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_killmails_recent_200_ok[]>(null as any);
    }

    /**
     * Get character location
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Information about the characters current location. Returns the current solar system id, and also the current station or structure ID if applicable
     */
    get_characters_character_id_location(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_location_ok> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/location/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_location(_response);
        });
    }

    protected processGet_characters_character_id_location(response: Response): Promise<Get_characters_character_id_location_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_location_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_location_ok>(null as any);
    }

    /**
     * Get loyalty points
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of loyalty points
     */
    get_characters_character_id_loyalty_points(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_loyalty_points_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/loyalty/points/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_loyalty_points(_response);
        });
    }

    protected processGet_characters_character_id_loyalty_points(response: Response): Promise<Get_characters_character_id_loyalty_points_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_loyalty_points_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_loyalty_points_200_ok[]>(null as any);
    }

    /**
     * Return mail headers
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param labels (optional) Fetch only mails that match one or more of the given labels
     * @param last_mail_id (optional) List only mail with an ID lower than the given ID, if present
     * @param token (optional) Access token to use if unable to set a header
     * @return The requested mail
     */
    get_characters_character_id_mail(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, labels: number[] | null | undefined, last_mail_id: number | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_mail_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/mail/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (labels !== undefined && labels !== null)
            labels && labels.forEach(item => { url_ += "labels=" + encodeURIComponent("" + item) + "&"; });
        if (last_mail_id !== undefined && last_mail_id !== null)
            url_ += "last_mail_id=" + encodeURIComponent("" + last_mail_id) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_mail(_response);
        });
    }

    protected processGet_characters_character_id_mail(response: Response): Promise<Get_characters_character_id_mail_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_mail_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_mail_200_ok[]>(null as any);
    }

    /**
     * Send a new mail
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param mail The mail to send
     * @param token (optional) Access token to use if unable to set a header
     * @return Mail created
     */
    post_characters_character_id_mail(character_id: number, datasource: Datasource | null | undefined, mail: Post_characters_character_id_mail_mail, token: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/mail/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mail);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_characters_character_id_mail(_response);
        });
    }

    protected processPost_characters_character_id_mail(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status === 520) {
            return response.text().then((_responseText) => {
            let result520: any = null;
            let resultData520 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result520 = Post_characters_character_id_mail_error_520.fromJS(resultData520);
            return throwException("Internal error thrown from the EVE server. Most of the time this means you have hit an EVE server rate limit", status, _responseText, _headers, result520);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Delete a mail label
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param label_id An EVE label id
     * @param token (optional) Access token to use if unable to set a header
     * @return Label deleted
     */
    delete_characters_character_id_mail_labels_label_id(character_id: number, datasource: Datasource | null | undefined, label_id: number, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/mail/labels/{label_id}/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (label_id === undefined || label_id === null)
            throw new Error("The parameter 'label_id' must be defined.");
        url_ = url_.replace("{label_id}", encodeURIComponent("" + label_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete_characters_character_id_mail_labels_label_id(_response);
        });
    }

    protected processDelete_characters_character_id_mail_labels_label_id(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Delete_characters_character_id_mail_labels_label_id_unprocessable_entity.fromJS(resultData422);
            return throwException("Default labels cannot be deleted", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Return mailing list subscriptions
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Mailing lists
     */
    get_characters_character_id_mail_lists(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_mail_lists_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/mail/lists/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_mail_lists(_response);
        });
    }

    protected processGet_characters_character_id_mail_lists(response: Response): Promise<Get_characters_character_id_mail_lists_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_mail_lists_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_mail_lists_200_ok[]>(null as any);
    }

    /**
     * Delete a mail
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param mail_id An EVE mail ID
     * @param token (optional) Access token to use if unable to set a header
     * @return Mail deleted
     */
    delete_characters_character_id_mail_mail_id(character_id: number, datasource: Datasource | null | undefined, mail_id: number, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/mail/{mail_id}/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (mail_id === undefined || mail_id === null)
            throw new Error("The parameter 'mail_id' must be defined.");
        url_ = url_.replace("{mail_id}", encodeURIComponent("" + mail_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete_characters_character_id_mail_mail_id(_response);
        });
    }

    protected processDelete_characters_character_id_mail_mail_id(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Return a mail
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param mail_id An EVE mail ID
     * @param token (optional) Access token to use if unable to set a header
     * @return Contents of a mail
     */
    get_characters_character_id_mail_mail_id(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, mail_id: number, token: string | null | undefined): Promise<Get_characters_character_id_mail_mail_id_ok> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/mail/{mail_id}/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (mail_id === undefined || mail_id === null)
            throw new Error("The parameter 'mail_id' must be defined.");
        url_ = url_.replace("{mail_id}", encodeURIComponent("" + mail_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_mail_mail_id(_response);
        });
    }

    protected processGet_characters_character_id_mail_mail_id(response: Response): Promise<Get_characters_character_id_mail_mail_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_mail_mail_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_characters_character_id_mail_mail_id_not_found.fromJS(resultData404);
            return throwException("Mail not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_mail_mail_id_ok>(null as any);
    }

    /**
     * Update metadata about a mail
     * @param character_id An EVE character ID
     * @param contents Data used to update the mail
     * @param datasource (optional) The server name you would like data from
     * @param mail_id An EVE mail ID
     * @param token (optional) Access token to use if unable to set a header
     * @return Mail updated
     */
    put_characters_character_id_mail_mail_id(character_id: number, contents: Put_characters_character_id_mail_mail_id_contents, datasource: Datasource | null | undefined, mail_id: number, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/mail/{mail_id}/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (mail_id === undefined || mail_id === null)
            throw new Error("The parameter 'mail_id' must be defined.");
        url_ = url_.replace("{mail_id}", encodeURIComponent("" + mail_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contents);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut_characters_character_id_mail_mail_id(_response);
        });
    }

    protected processPut_characters_character_id_mail_mail_id(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Character mining ledger
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return Mining ledger of a character
     */
    get_characters_character_id_mining(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_characters_character_id_mining_200_ok[]>> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/mining/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_mining(_response);
        });
    }

    protected processGet_characters_character_id_mining(response: Response): Promise<SwaggerResponse<Get_characters_character_id_mining_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_mining_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_characters_character_id_mining_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get a character's completed tasks
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of opportunities task ids
     */
    get_characters_character_id_opportunities(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_opportunities_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/opportunities/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_opportunities(_response);
        });
    }

    protected processGet_characters_character_id_opportunities(response: Response): Promise<Get_characters_character_id_opportunities_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_opportunities_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_opportunities_200_ok[]>(null as any);
    }

    /**
     * List historical orders by a character
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return Expired and cancelled market orders placed by a character
     */
    get_characters_character_id_orders_history(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_characters_character_id_orders_history_200_ok[]>> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/orders/history/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_orders_history(_response);
        });
    }

    protected processGet_characters_character_id_orders_history(response: Response): Promise<SwaggerResponse<Get_characters_character_id_orders_history_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_orders_history_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_characters_character_id_orders_history_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get colonies
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return List of colonies
     */
    get_characters_character_id_planets(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_planets_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/planets/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_planets(_response);
        });
    }

    protected processGet_characters_character_id_planets(response: Response): Promise<Get_characters_character_id_planets_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_planets_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_planets_200_ok[]>(null as any);
    }

    /**
     * Get current ship
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Get the current ship type, name and id
     */
    get_characters_character_id_ship(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_ship_ok> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/ship/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_ship(_response);
        });
    }

    protected processGet_characters_character_id_ship(response: Response): Promise<Get_characters_character_id_ship_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_ship_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_ship_ok>(null as any);
    }

    /**
     * Get a character's wallet balance
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Wallet balance
     */
    get_characters_character_id_wallet(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/wallet/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_wallet(_response);
        });
    }

    protected processGet_characters_character_id_wallet(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get wallet transactions
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param from_id (optional) Only show transactions happened before the one referenced by this id
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Wallet transactions
     */
    get_characters_character_id_wallet_transactions(character_id: number, datasource: Datasource | null | undefined, from_id: number | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_wallet_transactions_200_ok[]> {
        let url_ = this.baseUrl + "/v1/characters/{character_id}/wallet/transactions/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (from_id !== undefined && from_id !== null)
            url_ += "from_id=" + encodeURIComponent("" + from_id) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_wallet_transactions(_response);
        });
    }

    protected processGet_characters_character_id_wallet_transactions(response: Response): Promise<Get_characters_character_id_wallet_transactions_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_wallet_transactions_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_wallet_transactions_200_ok[]>(null as any);
    }

    /**
     * Get public contract bids
     * @param contract_id ID of a contract
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @return A list of bids
     */
    get_contracts_public_bids_contract_id(contract_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined): Promise<Get_contracts_public_bids_contract_id_200_ok[]> {
        let url_ = this.baseUrl + "/v1/contracts/public/bids/{contract_id}/?";
        if (contract_id === undefined || contract_id === null)
            throw new Error("The parameter 'contract_id' must be defined.");
        url_ = url_.replace("{contract_id}", encodeURIComponent("" + contract_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_contracts_public_bids_contract_id(_response);
        });
    }

    protected processGet_contracts_public_bids_contract_id(response: Response): Promise<Get_contracts_public_bids_contract_id_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_contracts_public_bids_contract_id_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("Contract expired or recently accepted by player", status, _responseText, _headers);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Get_contracts_public_bids_contract_id_forbidden.fromJS(resultData403);
            return throwException("Not Authorized to see contract", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_contracts_public_bids_contract_id_not_found.fromJS(resultData404);
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_contracts_public_bids_contract_id_200_ok[]>(null as any);
    }

    /**
     * Get public contract items
     * @param contract_id ID of a contract
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @return A list of items in this contract
     */
    get_contracts_public_items_contract_id(contract_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined): Promise<Get_contracts_public_items_contract_id_200_ok[]> {
        let url_ = this.baseUrl + "/v1/contracts/public/items/{contract_id}/?";
        if (contract_id === undefined || contract_id === null)
            throw new Error("The parameter 'contract_id' must be defined.");
        url_ = url_.replace("{contract_id}", encodeURIComponent("" + contract_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_contracts_public_items_contract_id(_response);
        });
    }

    protected processGet_contracts_public_items_contract_id(response: Response): Promise<Get_contracts_public_items_contract_id_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_contracts_public_items_contract_id_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("Contract expired or recently accepted by player", status, _responseText, _headers);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Get_contracts_public_items_contract_id_forbidden.fromJS(resultData403);
            return throwException("Not Authorized to see contract", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_contracts_public_items_contract_id_not_found.fromJS(resultData404);
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_contracts_public_items_contract_id_200_ok[]>(null as any);
    }

    /**
     * Get public contracts
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param region_id An EVE region id
     * @return A list of contracts
     */
    get_contracts_public_region_id(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, region_id: number): Promise<Get_contracts_public_region_id_200_ok[]> {
        let url_ = this.baseUrl + "/v1/contracts/public/{region_id}/?";
        if (region_id === undefined || region_id === null)
            throw new Error("The parameter 'region_id' must be defined.");
        url_ = url_.replace("{region_id}", encodeURIComponent("" + region_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_contracts_public_region_id(_response);
        });
    }

    protected processGet_contracts_public_region_id(response: Response): Promise<Get_contracts_public_region_id_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_contracts_public_region_id_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_contracts_public_region_id_not_found.fromJS(resultData404);
            return throwException("Region not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_contracts_public_region_id_200_ok[]>(null as any);
    }

    /**
     * Moon extraction timers
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of chunk timers
     */
    get_corporation_corporation_id_mining_extractions(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_corporation_corporation_id_mining_extractions_200_ok[]> {
        let url_ = this.baseUrl + "/v1/corporation/{corporation_id}/mining/extractions/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporation_corporation_id_mining_extractions(_response);
        });
    }

    protected processGet_corporation_corporation_id_mining_extractions(response: Response): Promise<Get_corporation_corporation_id_mining_extractions_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporation_corporation_id_mining_extractions_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporation_corporation_id_mining_extractions_200_ok[]>(null as any);
    }

    /**
     * Corporation mining observers
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return Observer list of a corporation
     */
    get_corporation_corporation_id_mining_observers(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporation_corporation_id_mining_observers_200_ok[]>> {
        let url_ = this.baseUrl + "/v1/corporation/{corporation_id}/mining/observers/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporation_corporation_id_mining_observers(_response);
        });
    }

    protected processGet_corporation_corporation_id_mining_observers(response: Response): Promise<SwaggerResponse<Get_corporation_corporation_id_mining_observers_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporation_corporation_id_mining_observers_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporation_corporation_id_mining_observers_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Observed corporation mining
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param observer_id A mining observer id
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return Mining ledger of an observer
     */
    get_corporation_corporation_id_mining_observers_observer_id(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, observer_id: number, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporation_corporation_id_mining_observers_observer_id_200_ok[]>> {
        let url_ = this.baseUrl + "/v1/corporation/{corporation_id}/mining/observers/{observer_id}/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (observer_id === undefined || observer_id === null)
            throw new Error("The parameter 'observer_id' must be defined.");
        url_ = url_.replace("{observer_id}", encodeURIComponent("" + observer_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporation_corporation_id_mining_observers_observer_id(_response);
        });
    }

    protected processGet_corporation_corporation_id_mining_observers_observer_id(response: Response): Promise<SwaggerResponse<Get_corporation_corporation_id_mining_observers_observer_id_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporation_corporation_id_mining_observers_observer_id_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporation_corporation_id_mining_observers_observer_id_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get corporation asset names
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param item_ids A list of item ids
     * @param token (optional) Access token to use if unable to set a header
     * @return List of asset names
     */
    post_corporations_corporation_id_assets_names(corporation_id: number, datasource: Datasource | null | undefined, item_ids: number[], token: string | null | undefined): Promise<Post_corporations_corporation_id_assets_names_200_ok[]> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/assets/names/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item_ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_corporations_corporation_id_assets_names(_response);
        });
    }

    protected processPost_corporations_corporation_id_assets_names(response: Response): Promise<Post_corporations_corporation_id_assets_names_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Post_corporations_corporation_id_assets_names_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Post_corporations_corporation_id_assets_names_not_found.fromJS(resultData404);
            return throwException("Invalid IDs", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post_corporations_corporation_id_assets_names_200_ok[]>(null as any);
    }

    /**
     * List corporation bookmarks
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return List of corporation owned bookmarks
     */
    get_corporations_corporation_id_bookmarks(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_bookmarks_200_ok[]> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/bookmarks/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_bookmarks(_response);
        });
    }

    protected processGet_corporations_corporation_id_bookmarks(response: Response): Promise<Get_corporations_corporation_id_bookmarks_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_bookmarks_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_bookmarks_200_ok[]>(null as any);
    }

    /**
     * List corporation bookmark folders
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return List of corporation owned bookmark folders
     */
    get_corporations_corporation_id_bookmarks_folders(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_bookmarks_folders_200_ok[]> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/bookmarks/folders/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_bookmarks_folders(_response);
        });
    }

    protected processGet_corporations_corporation_id_bookmarks_folders(response: Response): Promise<Get_corporations_corporation_id_bookmarks_folders_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_bookmarks_folders_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_bookmarks_folders_200_ok[]>(null as any);
    }

    /**
     * Get corporation contact labels
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of corporation contact labels
     */
    get_corporations_corporation_id_contacts_labels(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_contacts_labels_200_ok[]> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/contacts/labels/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_contacts_labels(_response);
        });
    }

    protected processGet_corporations_corporation_id_contacts_labels(response: Response): Promise<Get_corporations_corporation_id_contacts_labels_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_contacts_labels_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_contacts_labels_200_ok[]>(null as any);
    }

    /**
     * Get corporation contracts
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of contracts
     */
    get_corporations_corporation_id_contracts(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporations_corporation_id_contracts_200_ok[]>> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/contracts/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_contracts(_response);
        });
    }

    protected processGet_corporations_corporation_id_contracts(response: Response): Promise<SwaggerResponse<Get_corporations_corporation_id_contracts_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_contracts_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporations_corporation_id_contracts_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get corporation contract bids
     * @param contract_id ID of a contract
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of bids
     */
    get_corporations_corporation_id_contracts_contract_id_bids(contract_id: number, corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporations_corporation_id_contracts_contract_id_bids_200_ok[]>> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/contracts/{contract_id}/bids/?";
        if (contract_id === undefined || contract_id === null)
            throw new Error("The parameter 'contract_id' must be defined.");
        url_ = url_.replace("{contract_id}", encodeURIComponent("" + contract_id));
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_contracts_contract_id_bids(_response);
        });
    }

    protected processGet_corporations_corporation_id_contracts_contract_id_bids(response: Response): Promise<SwaggerResponse<Get_corporations_corporation_id_contracts_contract_id_bids_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_contracts_contract_id_bids_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_corporations_corporation_id_contracts_contract_id_bids_not_found.fromJS(resultData404);
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporations_corporation_id_contracts_contract_id_bids_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get corporation contract items
     * @param contract_id ID of a contract
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of items in this contract
     */
    get_corporations_corporation_id_contracts_contract_id_items(contract_id: number, corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_contracts_contract_id_items_200_ok[]> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/contracts/{contract_id}/items/?";
        if (contract_id === undefined || contract_id === null)
            throw new Error("The parameter 'contract_id' must be defined.");
        url_ = url_.replace("{contract_id}", encodeURIComponent("" + contract_id));
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_contracts_contract_id_items(_response);
        });
    }

    protected processGet_corporations_corporation_id_contracts_contract_id_items(response: Response): Promise<Get_corporations_corporation_id_contracts_contract_id_items_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_contracts_contract_id_items_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_corporations_corporation_id_contracts_contract_id_items_not_found.fromJS(resultData404);
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status === 520) {
            return response.text().then((_responseText) => {
            let result520: any = null;
            let resultData520 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result520 = Get_corporations_corporation_id_contracts_contract_id_items_error_520.fromJS(resultData520);
            return throwException("Internal error thrown from the EVE server. Most of the time this means you have hit an EVE server rate limit", status, _responseText, _headers, result520);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_contracts_contract_id_items_200_ok[]>(null as any);
    }

    /**
     * List corporation customs offices
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of customs offices and their settings
     */
    get_corporations_corporation_id_customs_offices(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporations_corporation_id_customs_offices_200_ok[]>> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/customs_offices/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_customs_offices(_response);
        });
    }

    protected processGet_corporations_corporation_id_customs_offices(response: Response): Promise<SwaggerResponse<Get_corporations_corporation_id_customs_offices_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_customs_offices_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporations_corporation_id_customs_offices_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Overview of a corporation involved in faction warfare
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Faction warfare statistics for a given corporation
     */
    get_corporations_corporation_id_fw_stats(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_fw_stats_ok> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/fw/stats/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_fw_stats(_response);
        });
    }

    protected processGet_corporations_corporation_id_fw_stats(response: Response): Promise<Get_corporations_corporation_id_fw_stats_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_corporations_corporation_id_fw_stats_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_fw_stats_ok>(null as any);
    }

    /**
     * List corporation industry jobs
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param include_completed (optional) Whether to retrieve completed corporation industry jobs. Only includes jobs from the past 90 days
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of corporation industry jobs
     */
    get_corporations_corporation_id_industry_jobs(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, include_completed: boolean | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporations_corporation_id_industry_jobs_200_ok[]>> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/industry/jobs/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (include_completed !== undefined && include_completed !== null)
            url_ += "include_completed=" + encodeURIComponent("" + include_completed) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_industry_jobs(_response);
        });
    }

    protected processGet_corporations_corporation_id_industry_jobs(response: Response): Promise<SwaggerResponse<Get_corporations_corporation_id_industry_jobs_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_industry_jobs_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporations_corporation_id_industry_jobs_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get a corporation's recent kills and losses
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of killmail IDs and hashes
     */
    get_corporations_corporation_id_killmails_recent(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_killmails_recent_200_ok[]> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/killmails/recent/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_killmails_recent(_response);
        });
    }

    protected processGet_corporations_corporation_id_killmails_recent(response: Response): Promise<Get_corporations_corporation_id_killmails_recent_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_killmails_recent_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_killmails_recent_200_ok[]>(null as any);
    }

    /**
     * Get corporation shareholders
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return List of shareholders
     */
    get_corporations_corporation_id_shareholders(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_shareholders_200_ok[]> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/shareholders/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders,
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_shareholders(_response);
        });
    }

    protected processGet_corporations_corporation_id_shareholders(response: Response): Promise<Get_corporations_corporation_id_shareholders_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_shareholders_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_shareholders_200_ok[]>(null as any);
    }

    /**
     * Returns a corporation's wallet balance
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return List of corporation wallets
     */
    get_corporations_corporation_id_wallets(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_wallets_200_ok[]> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/wallets/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_wallets(_response);
        });
    }

    protected processGet_corporations_corporation_id_wallets(response: Response): Promise<Get_corporations_corporation_id_wallets_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_wallets_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_wallets_200_ok[]>(null as any);
    }

    /**
     * Get corporation wallet transactions
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param division Wallet key of the division to fetch journals from
     * @param from_id (optional) Only show journal entries happened before the transaction referenced by this id
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Wallet transactions
     */
    get_corporations_corporation_id_wallets_division_transactions(corporation_id: number, datasource: Datasource | null | undefined, division: number, from_id: number | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_wallets_division_transactions_200_ok[]> {
        let url_ = this.baseUrl + "/v1/corporations/{corporation_id}/wallets/{division}/transactions/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (division === undefined || division === null)
            throw new Error("The parameter 'division' must be defined.");
        url_ = url_.replace("{division}", encodeURIComponent("" + division));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (from_id !== undefined && from_id !== null)
            url_ += "from_id=" + encodeURIComponent("" + from_id) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_wallets_division_transactions(_response);
        });
    }

    protected processGet_corporations_corporation_id_wallets_division_transactions(response: Response): Promise<Get_corporations_corporation_id_wallets_division_transactions_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_wallets_division_transactions_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_wallets_division_transactions_200_ok[]>(null as any);
    }

    /**
     * Get attributes
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of dogma attribute ids
     */
    get_dogma_attributes(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/dogma/attributes/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_dogma_attributes(_response);
        });
    }

    protected processGet_dogma_attributes(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get attribute information
     * @param attribute_id A dogma attribute ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Information about a dogma attribute
     */
    get_dogma_attributes_attribute_id(attribute_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_dogma_attributes_attribute_id_ok> {
        let url_ = this.baseUrl + "/v1/dogma/attributes/{attribute_id}/?";
        if (attribute_id === undefined || attribute_id === null)
            throw new Error("The parameter 'attribute_id' must be defined.");
        url_ = url_.replace("{attribute_id}", encodeURIComponent("" + attribute_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_dogma_attributes_attribute_id(_response);
        });
    }

    protected processGet_dogma_attributes_attribute_id(response: Response): Promise<Get_dogma_attributes_attribute_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_dogma_attributes_attribute_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_dogma_attributes_attribute_id_not_found.fromJS(resultData404);
            return throwException("Dogma attribute not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_dogma_attributes_attribute_id_ok>(null as any);
    }

    /**
     * Get dynamic item information
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param item_id item_id integer
     * @param type_id type_id integer
     * @return Details about a dynamic item
     */
    get_dogma_dynamic_items_type_id_item_id(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, item_id: number, type_id: number): Promise<Get_dogma_dynamic_items_type_id_item_id_ok> {
        let url_ = this.baseUrl + "/v1/dogma/dynamic/items/{type_id}/{item_id}/?";
        if (item_id === undefined || item_id === null)
            throw new Error("The parameter 'item_id' must be defined.");
        url_ = url_.replace("{item_id}", encodeURIComponent("" + item_id));
        if (type_id === undefined || type_id === null)
            throw new Error("The parameter 'type_id' must be defined.");
        url_ = url_.replace("{type_id}", encodeURIComponent("" + type_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_dogma_dynamic_items_type_id_item_id(_response);
        });
    }

    protected processGet_dogma_dynamic_items_type_id_item_id(response: Response): Promise<Get_dogma_dynamic_items_type_id_item_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_dogma_dynamic_items_type_id_item_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_dogma_dynamic_items_type_id_item_id_not_found.fromJS(resultData404);
            return throwException("Item not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_dogma_dynamic_items_type_id_item_id_ok>(null as any);
    }

    /**
     * Get effects
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of dogma effect ids
     */
    get_dogma_effects(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/dogma/effects/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_dogma_effects(_response);
        });
    }

    protected processGet_dogma_effects(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get fleet information
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Details about a fleet
     */
    get_fleets_fleet_id(datasource: Datasource | null | undefined, fleet_id: number, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_fleets_fleet_id_ok> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_fleets_fleet_id(_response);
        });
    }

    protected processGet_fleets_fleet_id(response: Response): Promise<Get_fleets_fleet_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_fleets_fleet_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_fleets_fleet_id_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_fleets_fleet_id_ok>(null as any);
    }

    /**
     * Update fleet
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param new_settings What to update for this fleet
     * @param token (optional) Access token to use if unable to set a header
     * @return Fleet updated
     */
    put_fleets_fleet_id(datasource: Datasource | null | undefined, fleet_id: number, new_settings: Put_fleets_fleet_id_new_settings, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(new_settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut_fleets_fleet_id(_response);
        });
    }

    protected processPut_fleets_fleet_id(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Put_fleets_fleet_id_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get fleet members
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of fleet members
     */
    get_fleets_fleet_id_members(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, fleet_id: number, if_None_Match: string | null | undefined, language: Language | null | undefined, token: string | null | undefined): Promise<Get_fleets_fleet_id_members_200_ok[]> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/members/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_fleets_fleet_id_members(_response);
        });
    }

    protected processGet_fleets_fleet_id_members(response: Response): Promise<Get_fleets_fleet_id_members_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_fleets_fleet_id_members_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_fleets_fleet_id_members_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_fleets_fleet_id_members_200_ok[]>(null as any);
    }

    /**
     * Create fleet invitation
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param invitation Details of the invitation
     * @param token (optional) Access token to use if unable to set a header
     * @return Fleet invitation sent
     */
    post_fleets_fleet_id_members(datasource: Datasource | null | undefined, fleet_id: number, invitation: Post_fleets_fleet_id_members_invitation, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/members/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invitation);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_fleets_fleet_id_members(_response);
        });
    }

    protected processPost_fleets_fleet_id_members(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Post_fleets_fleet_id_members_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Post_fleets_fleet_id_members_unprocessable_entity.fromJS(resultData422);
            return throwException("Errors in invitation", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Kick fleet member
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param member_id The character ID of a member in this fleet
     * @param token (optional) Access token to use if unable to set a header
     * @return Fleet member kicked
     */
    delete_fleets_fleet_id_members_member_id(datasource: Datasource | null | undefined, fleet_id: number, member_id: number, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/members/{member_id}/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (member_id === undefined || member_id === null)
            throw new Error("The parameter 'member_id' must be defined.");
        url_ = url_.replace("{member_id}", encodeURIComponent("" + member_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete_fleets_fleet_id_members_member_id(_response);
        });
    }

    protected processDelete_fleets_fleet_id_members_member_id(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Delete_fleets_fleet_id_members_member_id_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Move fleet member
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param member_id The character ID of a member in this fleet
     * @param movement Details of the invitation
     * @param token (optional) Access token to use if unable to set a header
     * @return Fleet invitation sent
     */
    put_fleets_fleet_id_members_member_id(datasource: Datasource | null | undefined, fleet_id: number, member_id: number, movement: Put_fleets_fleet_id_members_member_id_movement, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/members/{member_id}/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (member_id === undefined || member_id === null)
            throw new Error("The parameter 'member_id' must be defined.");
        url_ = url_.replace("{member_id}", encodeURIComponent("" + member_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(movement);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut_fleets_fleet_id_members_member_id(_response);
        });
    }

    protected processPut_fleets_fleet_id_members_member_id(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Put_fleets_fleet_id_members_member_id_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Put_fleets_fleet_id_members_member_id_unprocessable_entity.fromJS(resultData422);
            return throwException("Errors in invitation", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete fleet squad
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param squad_id The squad to delete
     * @param token (optional) Access token to use if unable to set a header
     * @return Squad deleted
     */
    delete_fleets_fleet_id_squads_squad_id(datasource: Datasource | null | undefined, fleet_id: number, squad_id: number, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/squads/{squad_id}/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (squad_id === undefined || squad_id === null)
            throw new Error("The parameter 'squad_id' must be defined.");
        url_ = url_.replace("{squad_id}", encodeURIComponent("" + squad_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete_fleets_fleet_id_squads_squad_id(_response);
        });
    }

    protected processDelete_fleets_fleet_id_squads_squad_id(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Delete_fleets_fleet_id_squads_squad_id_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Rename fleet squad
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param naming New name of the squad
     * @param squad_id The squad to rename
     * @param token (optional) Access token to use if unable to set a header
     * @return Squad renamed
     */
    put_fleets_fleet_id_squads_squad_id(datasource: Datasource | null | undefined, fleet_id: number, naming: Put_fleets_fleet_id_squads_squad_id_naming, squad_id: number, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/squads/{squad_id}/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (squad_id === undefined || squad_id === null)
            throw new Error("The parameter 'squad_id' must be defined.");
        url_ = url_.replace("{squad_id}", encodeURIComponent("" + squad_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(naming);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut_fleets_fleet_id_squads_squad_id(_response);
        });
    }

    protected processPut_fleets_fleet_id_squads_squad_id(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Put_fleets_fleet_id_squads_squad_id_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get fleet wings
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of fleet wings
     */
    get_fleets_fleet_id_wings(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, fleet_id: number, if_None_Match: string | null | undefined, language: Language | null | undefined, token: string | null | undefined): Promise<Get_fleets_fleet_id_wings_200_ok[]> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/wings/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_fleets_fleet_id_wings(_response);
        });
    }

    protected processGet_fleets_fleet_id_wings(response: Response): Promise<Get_fleets_fleet_id_wings_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_fleets_fleet_id_wings_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_fleets_fleet_id_wings_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_fleets_fleet_id_wings_200_ok[]>(null as any);
    }

    /**
     * Create fleet wing
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param token (optional) Access token to use if unable to set a header
     * @return Wing created
     */
    post_fleets_fleet_id_wings(datasource: Datasource | null | undefined, fleet_id: number, token: string | null | undefined): Promise<Post_fleets_fleet_id_wings_created> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/wings/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_fleets_fleet_id_wings(_response);
        });
    }

    protected processPost_fleets_fleet_id_wings(response: Response): Promise<Post_fleets_fleet_id_wings_created> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Post_fleets_fleet_id_wings_created.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Post_fleets_fleet_id_wings_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post_fleets_fleet_id_wings_created>(null as any);
    }

    /**
     * Delete fleet wing
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param token (optional) Access token to use if unable to set a header
     * @param wing_id The wing to delete
     * @return Wing deleted
     */
    delete_fleets_fleet_id_wings_wing_id(datasource: Datasource | null | undefined, fleet_id: number, token: string | null | undefined, wing_id: number): Promise<void> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/wings/{wing_id}/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (wing_id === undefined || wing_id === null)
            throw new Error("The parameter 'wing_id' must be defined.");
        url_ = url_.replace("{wing_id}", encodeURIComponent("" + wing_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete_fleets_fleet_id_wings_wing_id(_response);
        });
    }

    protected processDelete_fleets_fleet_id_wings_wing_id(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Delete_fleets_fleet_id_wings_wing_id_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Rename fleet wing
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param naming New name of the wing
     * @param token (optional) Access token to use if unable to set a header
     * @param wing_id The wing to rename
     * @return Wing renamed
     */
    put_fleets_fleet_id_wings_wing_id(datasource: Datasource | null | undefined, fleet_id: number, naming: Put_fleets_fleet_id_wings_wing_id_naming, token: string | null | undefined, wing_id: number): Promise<void> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/wings/{wing_id}/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (wing_id === undefined || wing_id === null)
            throw new Error("The parameter 'wing_id' must be defined.");
        url_ = url_.replace("{wing_id}", encodeURIComponent("" + wing_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(naming);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut_fleets_fleet_id_wings_wing_id(_response);
        });
    }

    protected processPut_fleets_fleet_id_wings_wing_id(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Put_fleets_fleet_id_wings_wing_id_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create fleet squad
     * @param datasource (optional) The server name you would like data from
     * @param fleet_id ID for a fleet
     * @param token (optional) Access token to use if unable to set a header
     * @param wing_id The wing_id to create squad in
     * @return Squad created
     */
    post_fleets_fleet_id_wings_wing_id_squads(datasource: Datasource | null | undefined, fleet_id: number, token: string | null | undefined, wing_id: number): Promise<Post_fleets_fleet_id_wings_wing_id_squads_created> {
        let url_ = this.baseUrl + "/v1/fleets/{fleet_id}/wings/{wing_id}/squads/?";
        if (fleet_id === undefined || fleet_id === null)
            throw new Error("The parameter 'fleet_id' must be defined.");
        url_ = url_.replace("{fleet_id}", encodeURIComponent("" + fleet_id));
        if (wing_id === undefined || wing_id === null)
            throw new Error("The parameter 'wing_id' must be defined.");
        url_ = url_.replace("{wing_id}", encodeURIComponent("" + wing_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_fleets_fleet_id_wings_wing_id_squads(_response);
        });
    }

    protected processPost_fleets_fleet_id_wings_wing_id_squads(response: Response): Promise<Post_fleets_fleet_id_wings_wing_id_squads_created> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Post_fleets_fleet_id_wings_wing_id_squads_created.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Post_fleets_fleet_id_wings_wing_id_squads_not_found.fromJS(resultData404);
            return throwException("The fleet does not exist or you don\'t have access to it", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post_fleets_fleet_id_wings_wing_id_squads_created>(null as any);
    }

    /**
     * List of the top factions in faction warfare
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Corporation leaderboard of kills and victory points within faction warfare
     */
    get_fw_leaderboards(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_fw_leaderboards_ok> {
        let url_ = this.baseUrl + "/v1/fw/leaderboards/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_fw_leaderboards(_response);
        });
    }

    protected processGet_fw_leaderboards(response: Response): Promise<Get_fw_leaderboards_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_fw_leaderboards_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_fw_leaderboards_ok>(null as any);
    }

    /**
     * List of the top pilots in faction warfare
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Character leaderboard of kills and victory points within faction warfare
     */
    get_fw_leaderboards_characters(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_fw_leaderboards_characters_ok> {
        let url_ = this.baseUrl + "/v1/fw/leaderboards/characters/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_fw_leaderboards_characters(_response);
        });
    }

    protected processGet_fw_leaderboards_characters(response: Response): Promise<Get_fw_leaderboards_characters_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_fw_leaderboards_characters_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_fw_leaderboards_characters_ok>(null as any);
    }

    /**
     * List of the top corporations in faction warfare
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Corporation leaderboard of kills and victory points within faction warfare
     */
    get_fw_leaderboards_corporations(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_fw_leaderboards_corporations_ok> {
        let url_ = this.baseUrl + "/v1/fw/leaderboards/corporations/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_fw_leaderboards_corporations(_response);
        });
    }

    protected processGet_fw_leaderboards_corporations(response: Response): Promise<Get_fw_leaderboards_corporations_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_fw_leaderboards_corporations_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_fw_leaderboards_corporations_ok>(null as any);
    }

    /**
     * An overview of statistics about factions involved in faction warfare
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Per faction breakdown of faction warfare statistics
     */
    get_fw_stats(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_fw_stats_200_ok[]> {
        let url_ = this.baseUrl + "/v1/fw/stats/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_fw_stats(_response);
        });
    }

    protected processGet_fw_stats(response: Response): Promise<Get_fw_stats_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_fw_stats_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_fw_stats_200_ok[]>(null as any);
    }

    /**
     * Data about which NPC factions are at war
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of NPC factions at war
     */
    get_fw_wars(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_fw_wars_200_ok[]> {
        let url_ = this.baseUrl + "/v1/fw/wars/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_fw_wars(_response);
        });
    }

    protected processGet_fw_wars(response: Response): Promise<Get_fw_wars_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_fw_wars_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_fw_wars_200_ok[]>(null as any);
    }

    /**
     * List incursions
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of incursions
     */
    get_incursions(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_incursions_200_ok[]> {
        let url_ = this.baseUrl + "/v1/incursions/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_incursions(_response);
        });
    }

    protected processGet_incursions(response: Response): Promise<Get_incursions_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_incursions_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_incursions_200_ok[]>(null as any);
    }

    /**
     * List industry facilities
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of facilities
     */
    get_industry_facilities(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_industry_facilities_200_ok[]> {
        let url_ = this.baseUrl + "/v1/industry/facilities/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_industry_facilities(_response);
        });
    }

    protected processGet_industry_facilities(response: Response): Promise<Get_industry_facilities_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_industry_facilities_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_industry_facilities_200_ok[]>(null as any);
    }

    /**
     * List solar system cost indices
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of cost indicies
     */
    get_industry_systems(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_industry_systems_200_ok[]> {
        let url_ = this.baseUrl + "/v1/industry/systems/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_industry_systems(_response);
        });
    }

    protected processGet_industry_systems(response: Response): Promise<Get_industry_systems_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_industry_systems_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_industry_systems_200_ok[]>(null as any);
    }

    /**
     * List insurance levels
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @return A list of insurance levels for all ship types
     */
    get_insurance_prices(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined): Promise<Get_insurance_prices_200_ok[]> {
        let url_ = this.baseUrl + "/v1/insurance/prices/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_insurance_prices(_response);
        });
    }

    protected processGet_insurance_prices(response: Response): Promise<Get_insurance_prices_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_insurance_prices_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_insurance_prices_200_ok[]>(null as any);
    }

    /**
     * Get a single killmail
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param killmail_hash The killmail hash for verification
     * @param killmail_id The killmail ID to be queried
     * @return A killmail
     */
    get_killmails_killmail_id_killmail_hash(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, killmail_hash: string, killmail_id: number): Promise<Get_killmails_killmail_id_killmail_hash_ok> {
        let url_ = this.baseUrl + "/v1/killmails/{killmail_id}/{killmail_hash}/?";
        if (killmail_hash === undefined || killmail_hash === null)
            throw new Error("The parameter 'killmail_hash' must be defined.");
        url_ = url_.replace("{killmail_hash}", encodeURIComponent("" + killmail_hash));
        if (killmail_id === undefined || killmail_id === null)
            throw new Error("The parameter 'killmail_id' must be defined.");
        url_ = url_.replace("{killmail_id}", encodeURIComponent("" + killmail_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_killmails_killmail_id_killmail_hash(_response);
        });
    }

    protected processGet_killmails_killmail_id_killmail_hash(response: Response): Promise<Get_killmails_killmail_id_killmail_hash_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_killmails_killmail_id_killmail_hash_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Get_killmails_killmail_id_killmail_hash_unprocessable_entity.fromJS(resultData422);
            return throwException("Invalid killmail_id and/or killmail_hash", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_killmails_killmail_id_killmail_hash_ok>(null as any);
    }

    /**
     * List loyalty store offers
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of offers
     */
    get_loyalty_stores_corporation_id_offers(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_loyalty_stores_corporation_id_offers_200_ok[]> {
        let url_ = this.baseUrl + "/v1/loyalty/stores/{corporation_id}/offers/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_loyalty_stores_corporation_id_offers(_response);
        });
    }

    protected processGet_loyalty_stores_corporation_id_offers(response: Response): Promise<Get_loyalty_stores_corporation_id_offers_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_loyalty_stores_corporation_id_offers_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_loyalty_stores_corporation_id_offers_not_found.fromJS(resultData404);
            return throwException("No loyalty point store found for the provided corporation", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_loyalty_stores_corporation_id_offers_200_ok[]>(null as any);
    }

    /**
     * Get item groups
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of item group ids
     */
    get_markets_groups(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/markets/groups/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_markets_groups(_response);
        });
    }

    protected processGet_markets_groups(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get item group information
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @param market_group_id An Eve item group ID
     * @return Information about an item group
     */
    get_markets_groups_market_group_id(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined, market_group_id: number): Promise<Get_markets_groups_market_group_id_ok> {
        let url_ = this.baseUrl + "/v1/markets/groups/{market_group_id}/?";
        if (market_group_id === undefined || market_group_id === null)
            throw new Error("The parameter 'market_group_id' must be defined.");
        url_ = url_.replace("{market_group_id}", encodeURIComponent("" + market_group_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_markets_groups_market_group_id(_response);
        });
    }

    protected processGet_markets_groups_market_group_id(response: Response): Promise<Get_markets_groups_market_group_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_markets_groups_market_group_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_markets_groups_market_group_id_not_found.fromJS(resultData404);
            return throwException("Market group not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_markets_groups_market_group_id_ok>(null as any);
    }

    /**
     * List market prices
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of prices
     */
    get_markets_prices(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_markets_prices_200_ok[]> {
        let url_ = this.baseUrl + "/v1/markets/prices/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_markets_prices(_response);
        });
    }

    protected processGet_markets_prices(response: Response): Promise<Get_markets_prices_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_markets_prices_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_markets_prices_200_ok[]>(null as any);
    }

    /**
     * List orders in a structure
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param structure_id Return orders in this structure
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of orders
     */
    get_markets_structures_structure_id(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, structure_id: number, token: string | null | undefined): Promise<SwaggerResponse<Get_markets_structures_structure_id_200_ok[]>> {
        let url_ = this.baseUrl + "/v1/markets/structures/{structure_id}/?";
        if (structure_id === undefined || structure_id === null)
            throw new Error("The parameter 'structure_id' must be defined.");
        url_ = url_.replace("{structure_id}", encodeURIComponent("" + structure_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_markets_structures_structure_id(_response);
        });
    }

    protected processGet_markets_structures_structure_id(response: Response): Promise<SwaggerResponse<Get_markets_structures_structure_id_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_markets_structures_structure_id_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_markets_structures_structure_id_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * List historical market statistics in a region
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param region_id Return statistics in this region
     * @param type_id Return statistics for this type
     * @return A list of historical market statistics
     */
    get_markets_region_id_history(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, region_id: number, type_id: number): Promise<Get_markets_region_id_history_200_ok[]> {
        let url_ = this.baseUrl + "/v1/markets/{region_id}/history/?";
        if (region_id === undefined || region_id === null)
            throw new Error("The parameter 'region_id' must be defined.");
        url_ = url_.replace("{region_id}", encodeURIComponent("" + region_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (type_id === undefined || type_id === null)
            throw new Error("The parameter 'type_id' must be defined and cannot be null.");
        else
            url_ += "type_id=" + encodeURIComponent("" + type_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_markets_region_id_history(_response);
        });
    }

    protected processGet_markets_region_id_history(response: Response): Promise<Get_markets_region_id_history_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_markets_region_id_history_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_markets_region_id_history_not_found.fromJS(resultData404);
            return throwException("Type not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Get_markets_region_id_history_unprocessable_entity.fromJS(resultData422);
            return throwException("Not found", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status === 520) {
            return response.text().then((_responseText) => {
            let result520: any = null;
            let resultData520 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result520 = Get_markets_region_id_history_error_520.fromJS(resultData520);
            return throwException("Internal error thrown from the EVE server", status, _responseText, _headers, result520);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_markets_region_id_history_200_ok[]>(null as any);
    }

    /**
     * List orders in a region
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param order_type Filter buy/sell orders, return all orders by default. If you query without type_id, we always return both buy and sell orders
     * @param page (optional) Which page of results to return
     * @param region_id Return orders in this region
     * @param type_id (optional) Return orders only for this type
     * @return A list of orders
     */
    get_markets_region_id_orders(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, order_type: Order_type, page: number | null | undefined, region_id: number, type_id: number | null | undefined): Promise<SwaggerResponse<Get_markets_region_id_orders_200_ok[]>> {
        let url_ = this.baseUrl + "/v1/markets/{region_id}/orders/?";
        if (region_id === undefined || region_id === null)
            throw new Error("The parameter 'region_id' must be defined.");
        url_ = url_.replace("{region_id}", encodeURIComponent("" + region_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (order_type === undefined || order_type === null)
            throw new Error("The parameter 'order_type' must be defined and cannot be null.");
        else
            url_ += "order_type=" + encodeURIComponent("" + order_type) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (type_id !== undefined && type_id !== null)
            url_ += "type_id=" + encodeURIComponent("" + type_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_markets_region_id_orders(_response);
        });
    }

    protected processGet_markets_region_id_orders(response: Response): Promise<SwaggerResponse<Get_markets_region_id_orders_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_markets_region_id_orders_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_markets_region_id_orders_not_found.fromJS(resultData404);
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Get_markets_region_id_orders_unprocessable_entity.fromJS(resultData422);
            return throwException("Not found", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_markets_region_id_orders_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * List type IDs relevant to a market
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param region_id Return statistics in this region
     * @return A list of type IDs
     */
    get_markets_region_id_types(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, region_id: number): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/markets/{region_id}/types/?";
        if (region_id === undefined || region_id === null)
            throw new Error("The parameter 'region_id' must be defined.");
        url_ = url_.replace("{region_id}", encodeURIComponent("" + region_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_markets_region_id_types(_response);
        });
    }

    protected processGet_markets_region_id_types(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get opportunities groups
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of opportunities group ids
     */
    get_opportunities_groups(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/opportunities/groups/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_opportunities_groups(_response);
        });
    }

    protected processGet_opportunities_groups(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get opportunities group
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param group_id ID of an opportunities group
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @return Details of an opportunities group
     */
    get_opportunities_groups_group_id(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, group_id: number, if_None_Match: string | null | undefined, language: Language | null | undefined): Promise<Get_opportunities_groups_group_id_ok> {
        let url_ = this.baseUrl + "/v1/opportunities/groups/{group_id}/?";
        if (group_id === undefined || group_id === null)
            throw new Error("The parameter 'group_id' must be defined.");
        url_ = url_.replace("{group_id}", encodeURIComponent("" + group_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_opportunities_groups_group_id(_response);
        });
    }

    protected processGet_opportunities_groups_group_id(response: Response): Promise<Get_opportunities_groups_group_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_opportunities_groups_group_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_opportunities_groups_group_id_ok>(null as any);
    }

    /**
     * Get opportunities tasks
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of opportunities task ids
     */
    get_opportunities_tasks(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/opportunities/tasks/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_opportunities_tasks(_response);
        });
    }

    protected processGet_opportunities_tasks(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get opportunities task
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param task_id ID of an opportunities task
     * @return Details of an opportunities task
     */
    get_opportunities_tasks_task_id(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, task_id: number): Promise<Get_opportunities_tasks_task_id_ok> {
        let url_ = this.baseUrl + "/v1/opportunities/tasks/{task_id}/?";
        if (task_id === undefined || task_id === null)
            throw new Error("The parameter 'task_id' must be defined.");
        url_ = url_.replace("{task_id}", encodeURIComponent("" + task_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_opportunities_tasks_task_id(_response);
        });
    }

    protected processGet_opportunities_tasks_task_id(response: Response): Promise<Get_opportunities_tasks_task_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_opportunities_tasks_task_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_opportunities_tasks_task_id_ok>(null as any);
    }

    /**
     * Get route
     * @param avoid (optional) avoid solar system ID(s)
     * @param connections (optional) connected solar system pairs
     * @param datasource (optional) The server name you would like data from
     * @param destination destination solar system ID
     * @param flag (optional) route security preference
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param origin origin solar system ID
     * @return Solar systems in route from origin to destination
     */
    get_route_origin_destination(avoid: number[] | null | undefined, connections: number[][] | null | undefined, datasource: Datasource | null | undefined, destination: number, flag: Flag | null | undefined, if_None_Match: string | null | undefined, origin: number): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/route/{origin}/{destination}/?";
        if (destination === undefined || destination === null)
            throw new Error("The parameter 'destination' must be defined.");
        url_ = url_.replace("{destination}", encodeURIComponent("" + destination));
        if (origin === undefined || origin === null)
            throw new Error("The parameter 'origin' must be defined.");
        url_ = url_.replace("{origin}", encodeURIComponent("" + origin));
        if (avoid !== undefined && avoid !== null)
            avoid && avoid.forEach(item => { url_ += "avoid=" + encodeURIComponent("" + item) + "&"; });
        if (connections !== undefined && connections !== null)
            connections && connections.forEach(item => { url_ += "connections=" + encodeURIComponent("" + item) + "&"; });
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (flag !== undefined && flag !== null)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_route_origin_destination(_response);
        });
    }

    protected processGet_route_origin_destination(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_route_origin_destination_not_found.fromJS(resultData404);
            return throwException("No route found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * List sovereignty campaigns
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of sovereignty campaigns
     */
    get_sovereignty_campaigns(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_sovereignty_campaigns_200_ok[]> {
        let url_ = this.baseUrl + "/v1/sovereignty/campaigns/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_sovereignty_campaigns(_response);
        });
    }

    protected processGet_sovereignty_campaigns(response: Response): Promise<Get_sovereignty_campaigns_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_sovereignty_campaigns_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_sovereignty_campaigns_200_ok[]>(null as any);
    }

    /**
     * List sovereignty of systems
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of sovereignty information for solar systems in New Eden
     */
    get_sovereignty_map(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_sovereignty_map_200_ok[]> {
        let url_ = this.baseUrl + "/v1/sovereignty/map/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_sovereignty_map(_response);
        });
    }

    protected processGet_sovereignty_map(response: Response): Promise<Get_sovereignty_map_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_sovereignty_map_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_sovereignty_map_200_ok[]>(null as any);
    }

    /**
     * List sovereignty structures
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of sovereignty structures
     */
    get_sovereignty_structures(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_sovereignty_structures_200_ok[]> {
        let url_ = this.baseUrl + "/v1/sovereignty/structures/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_sovereignty_structures(_response);
        });
    }

    protected processGet_sovereignty_structures(response: Response): Promise<Get_sovereignty_structures_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_sovereignty_structures_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_sovereignty_structures_200_ok[]>(null as any);
    }

    /**
     * Retrieve the uptime and player counts
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Server status
     */
    get_status(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_status_ok> {
        let url_ = this.baseUrl + "/v1/status/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_status(_response);
        });
    }

    protected processGet_status(response: Response): Promise<Get_status_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_status_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_status_ok>(null as any);
    }

    /**
     * Open Contract Window
     * @param contract_id The contract to open
     * @param datasource (optional) The server name you would like data from
     * @param token (optional) Access token to use if unable to set a header
     * @return Open window request received
     */
    post_ui_openwindow_contract(contract_id: number, datasource: Datasource | null | undefined, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/ui/openwindow/contract/?";
        if (contract_id === undefined || contract_id === null)
            throw new Error("The parameter 'contract_id' must be defined and cannot be null.");
        else
            url_ += "contract_id=" + encodeURIComponent("" + contract_id) + "&";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_ui_openwindow_contract(_response);
        });
    }

    protected processPost_ui_openwindow_contract(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Open Information Window
     * @param datasource (optional) The server name you would like data from
     * @param target_id The target to open
     * @param token (optional) Access token to use if unable to set a header
     * @return Open window request received
     */
    post_ui_openwindow_information(datasource: Datasource | null | undefined, target_id: number, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/ui/openwindow/information/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (target_id === undefined || target_id === null)
            throw new Error("The parameter 'target_id' must be defined and cannot be null.");
        else
            url_ += "target_id=" + encodeURIComponent("" + target_id) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_ui_openwindow_information(_response);
        });
    }

    protected processPost_ui_openwindow_information(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Open Market Details
     * @param datasource (optional) The server name you would like data from
     * @param token (optional) Access token to use if unable to set a header
     * @param type_id The item type to open in market window
     * @return Open window request received
     */
    post_ui_openwindow_marketdetails(datasource: Datasource | null | undefined, token: string | null | undefined, type_id: number): Promise<void> {
        let url_ = this.baseUrl + "/v1/ui/openwindow/marketdetails/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (type_id === undefined || type_id === null)
            throw new Error("The parameter 'type_id' must be defined and cannot be null.");
        else
            url_ += "type_id=" + encodeURIComponent("" + type_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_ui_openwindow_marketdetails(_response);
        });
    }

    protected processPost_ui_openwindow_marketdetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Open New Mail Window
     * @param datasource (optional) The server name you would like data from
     * @param new_mail The details of mail to create
     * @param token (optional) Access token to use if unable to set a header
     * @return Open window request received
     */
    post_ui_openwindow_newmail(datasource: Datasource | null | undefined, new_mail: Post_ui_openwindow_newmail_new_mail, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/ui/openwindow/newmail/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(new_mail);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_ui_openwindow_newmail(_response);
        });
    }

    protected processPost_ui_openwindow_newmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Post_ui_openwindow_newmail_unprocessable_entity.fromJS(resultData422);
            return throwException("Invalid request", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get ancestries
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @return A list of ancestries
     */
    get_universe_ancestries(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined): Promise<Get_universe_ancestries_200_ok[]> {
        let url_ = this.baseUrl + "/v1/universe/ancestries/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_ancestries(_response);
        });
    }

    protected processGet_universe_ancestries(response: Response): Promise<Get_universe_ancestries_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_universe_ancestries_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_ancestries_200_ok[]>(null as any);
    }

    /**
     * Get asteroid belt information
     * @param asteroid_belt_id asteroid_belt_id integer
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Information about an asteroid belt
     */
    get_universe_asteroid_belts_asteroid_belt_id(asteroid_belt_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_universe_asteroid_belts_asteroid_belt_id_ok> {
        let url_ = this.baseUrl + "/v1/universe/asteroid_belts/{asteroid_belt_id}/?";
        if (asteroid_belt_id === undefined || asteroid_belt_id === null)
            throw new Error("The parameter 'asteroid_belt_id' must be defined.");
        url_ = url_.replace("{asteroid_belt_id}", encodeURIComponent("" + asteroid_belt_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_asteroid_belts_asteroid_belt_id(_response);
        });
    }

    protected processGet_universe_asteroid_belts_asteroid_belt_id(response: Response): Promise<Get_universe_asteroid_belts_asteroid_belt_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_asteroid_belts_asteroid_belt_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_asteroid_belts_asteroid_belt_id_not_found.fromJS(resultData404);
            return throwException("Asteroid belt not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_asteroid_belts_asteroid_belt_id_ok>(null as any);
    }

    /**
     * Get bloodlines
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @return A list of bloodlines
     */
    get_universe_bloodlines(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined): Promise<Get_universe_bloodlines_200_ok[]> {
        let url_ = this.baseUrl + "/v1/universe/bloodlines/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_bloodlines(_response);
        });
    }

    protected processGet_universe_bloodlines(response: Response): Promise<Get_universe_bloodlines_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_universe_bloodlines_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_bloodlines_200_ok[]>(null as any);
    }

    /**
     * Get item categories
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of item category ids
     */
    get_universe_categories(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/universe/categories/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_categories(_response);
        });
    }

    protected processGet_universe_categories(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get item category information
     * @param accept_Language (optional) Language to use in the response
     * @param category_id An Eve item category ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @return Information about an item category
     */
    get_universe_categories_category_id(accept_Language: AcceptLanguage | null | undefined, category_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined): Promise<Get_universe_categories_category_id_ok> {
        let url_ = this.baseUrl + "/v1/universe/categories/{category_id}/?";
        if (category_id === undefined || category_id === null)
            throw new Error("The parameter 'category_id' must be defined.");
        url_ = url_.replace("{category_id}", encodeURIComponent("" + category_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_categories_category_id(_response);
        });
    }

    protected processGet_universe_categories_category_id(response: Response): Promise<Get_universe_categories_category_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_categories_category_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_categories_category_id_not_found.fromJS(resultData404);
            return throwException("Category not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_categories_category_id_ok>(null as any);
    }

    /**
     * Get constellations
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of constellation ids
     */
    get_universe_constellations(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/universe/constellations/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_constellations(_response);
        });
    }

    protected processGet_universe_constellations(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get constellation information
     * @param accept_Language (optional) Language to use in the response
     * @param constellation_id constellation_id integer
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @return Information about a constellation
     */
    get_universe_constellations_constellation_id(accept_Language: AcceptLanguage | null | undefined, constellation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined): Promise<Get_universe_constellations_constellation_id_ok> {
        let url_ = this.baseUrl + "/v1/universe/constellations/{constellation_id}/?";
        if (constellation_id === undefined || constellation_id === null)
            throw new Error("The parameter 'constellation_id' must be defined.");
        url_ = url_.replace("{constellation_id}", encodeURIComponent("" + constellation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_constellations_constellation_id(_response);
        });
    }

    protected processGet_universe_constellations_constellation_id(response: Response): Promise<Get_universe_constellations_constellation_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_constellations_constellation_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_constellations_constellation_id_not_found.fromJS(resultData404);
            return throwException("Constellation not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_constellations_constellation_id_ok>(null as any);
    }

    /**
     * Get graphics
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of graphic ids
     */
    get_universe_graphics(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/universe/graphics/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_graphics(_response);
        });
    }

    protected processGet_universe_graphics(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get graphic information
     * @param datasource (optional) The server name you would like data from
     * @param graphic_id graphic_id integer
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Information about a graphic
     */
    get_universe_graphics_graphic_id(datasource: Datasource | null | undefined, graphic_id: number, if_None_Match: string | null | undefined): Promise<Get_universe_graphics_graphic_id_ok> {
        let url_ = this.baseUrl + "/v1/universe/graphics/{graphic_id}/?";
        if (graphic_id === undefined || graphic_id === null)
            throw new Error("The parameter 'graphic_id' must be defined.");
        url_ = url_.replace("{graphic_id}", encodeURIComponent("" + graphic_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_graphics_graphic_id(_response);
        });
    }

    protected processGet_universe_graphics_graphic_id(response: Response): Promise<Get_universe_graphics_graphic_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_graphics_graphic_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_graphics_graphic_id_not_found.fromJS(resultData404);
            return throwException("Graphic not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_graphics_graphic_id_ok>(null as any);
    }

    /**
     * Get item groups
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @return A list of item group ids
     */
    get_universe_groups(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/universe/groups/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_groups(_response);
        });
    }

    protected processGet_universe_groups(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get item group information
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param group_id An Eve item group ID
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @return Information about an item group
     */
    get_universe_groups_group_id(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, group_id: number, if_None_Match: string | null | undefined, language: Language | null | undefined): Promise<Get_universe_groups_group_id_ok> {
        let url_ = this.baseUrl + "/v1/universe/groups/{group_id}/?";
        if (group_id === undefined || group_id === null)
            throw new Error("The parameter 'group_id' must be defined.");
        url_ = url_.replace("{group_id}", encodeURIComponent("" + group_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_groups_group_id(_response);
        });
    }

    protected processGet_universe_groups_group_id(response: Response): Promise<Get_universe_groups_group_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_groups_group_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_groups_group_id_not_found.fromJS(resultData404);
            return throwException("Group not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_groups_group_id_ok>(null as any);
    }

    /**
     * Bulk names to IDs
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @param names The names to resolve
     * @return List of id/name associations for a set of names divided by category. Any name passed in that did not have a match will be ommitted
     */
    post_universe_ids(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, language: Language | null | undefined, names: string[]): Promise<Post_universe_ids_ok> {
        let url_ = this.baseUrl + "/v1/universe/ids/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(names);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_universe_ids(_response);
        });
    }

    protected processPost_universe_ids(response: Response): Promise<Post_universe_ids_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Post_universe_ids_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post_universe_ids_ok>(null as any);
    }

    /**
     * Get moon information
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param moon_id moon_id integer
     * @return Information about a moon
     */
    get_universe_moons_moon_id(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, moon_id: number): Promise<Get_universe_moons_moon_id_ok> {
        let url_ = this.baseUrl + "/v1/universe/moons/{moon_id}/?";
        if (moon_id === undefined || moon_id === null)
            throw new Error("The parameter 'moon_id' must be defined.");
        url_ = url_.replace("{moon_id}", encodeURIComponent("" + moon_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_moons_moon_id(_response);
        });
    }

    protected processGet_universe_moons_moon_id(response: Response): Promise<Get_universe_moons_moon_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_moons_moon_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_moons_moon_id_not_found.fromJS(resultData404);
            return throwException("Moon not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_moons_moon_id_ok>(null as any);
    }

    /**
     * Get planet information
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param planet_id planet_id integer
     * @return Information about a planet
     */
    get_universe_planets_planet_id(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, planet_id: number): Promise<Get_universe_planets_planet_id_ok> {
        let url_ = this.baseUrl + "/v1/universe/planets/{planet_id}/?";
        if (planet_id === undefined || planet_id === null)
            throw new Error("The parameter 'planet_id' must be defined.");
        url_ = url_.replace("{planet_id}", encodeURIComponent("" + planet_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_planets_planet_id(_response);
        });
    }

    protected processGet_universe_planets_planet_id(response: Response): Promise<Get_universe_planets_planet_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_planets_planet_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_planets_planet_id_not_found.fromJS(resultData404);
            return throwException("Planet not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_planets_planet_id_ok>(null as any);
    }

    /**
     * Get character races
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @return A list of character races
     */
    get_universe_races(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined): Promise<Get_universe_races_200_ok[]> {
        let url_ = this.baseUrl + "/v1/universe/races/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_races(_response);
        });
    }

    protected processGet_universe_races(response: Response): Promise<Get_universe_races_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_universe_races_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_races_200_ok[]>(null as any);
    }

    /**
     * Get regions
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of region ids
     */
    get_universe_regions(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/universe/regions/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_regions(_response);
        });
    }

    protected processGet_universe_regions(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get region information
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @param region_id region_id integer
     * @return Information about a region
     */
    get_universe_regions_region_id(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined, region_id: number): Promise<Get_universe_regions_region_id_ok> {
        let url_ = this.baseUrl + "/v1/universe/regions/{region_id}/?";
        if (region_id === undefined || region_id === null)
            throw new Error("The parameter 'region_id' must be defined.");
        url_ = url_.replace("{region_id}", encodeURIComponent("" + region_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_regions_region_id(_response);
        });
    }

    protected processGet_universe_regions_region_id(response: Response): Promise<Get_universe_regions_region_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_regions_region_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_regions_region_id_not_found.fromJS(resultData404);
            return throwException("Region not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_regions_region_id_ok>(null as any);
    }

    /**
     * Get schematic information
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param schematic_id A PI schematic ID
     * @return Public data about a schematic
     */
    get_universe_schematics_schematic_id(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, schematic_id: number): Promise<Get_universe_schematics_schematic_id_ok> {
        let url_ = this.baseUrl + "/v1/universe/schematics/{schematic_id}/?";
        if (schematic_id === undefined || schematic_id === null)
            throw new Error("The parameter 'schematic_id' must be defined.");
        url_ = url_.replace("{schematic_id}", encodeURIComponent("" + schematic_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_schematics_schematic_id(_response);
        });
    }

    protected processGet_universe_schematics_schematic_id(response: Response): Promise<Get_universe_schematics_schematic_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_schematics_schematic_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_schematics_schematic_id_not_found.fromJS(resultData404);
            return throwException("Schematic not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_schematics_schematic_id_ok>(null as any);
    }

    /**
     * Get stargate information
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param stargate_id stargate_id integer
     * @return Information about a stargate
     */
    get_universe_stargates_stargate_id(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, stargate_id: number): Promise<Get_universe_stargates_stargate_id_ok> {
        let url_ = this.baseUrl + "/v1/universe/stargates/{stargate_id}/?";
        if (stargate_id === undefined || stargate_id === null)
            throw new Error("The parameter 'stargate_id' must be defined.");
        url_ = url_.replace("{stargate_id}", encodeURIComponent("" + stargate_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_stargates_stargate_id(_response);
        });
    }

    protected processGet_universe_stargates_stargate_id(response: Response): Promise<Get_universe_stargates_stargate_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_stargates_stargate_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_stargates_stargate_id_not_found.fromJS(resultData404);
            return throwException("Stargate not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_stargates_stargate_id_ok>(null as any);
    }

    /**
     * Get star information
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param star_id star_id integer
     * @return Information about a star
     */
    get_universe_stars_star_id(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, star_id: number): Promise<Get_universe_stars_star_id_ok> {
        let url_ = this.baseUrl + "/v1/universe/stars/{star_id}/?";
        if (star_id === undefined || star_id === null)
            throw new Error("The parameter 'star_id' must be defined.");
        url_ = url_.replace("{star_id}", encodeURIComponent("" + star_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_stars_star_id(_response);
        });
    }

    protected processGet_universe_stars_star_id(response: Response): Promise<Get_universe_stars_star_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_stars_star_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_stars_star_id_ok>(null as any);
    }

    /**
     * List all public structures
     * @param datasource (optional) The server name you would like data from
     * @param filter (optional) Only list public structures that have this service online
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return List of public structure IDs
     */
    get_universe_structures(datasource: Datasource | null | undefined, filter: Filter | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/universe/structures/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_structures(_response);
        });
    }

    protected processGet_universe_structures(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get system jumps
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of systems and number of jumps
     */
    get_universe_system_jumps(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_universe_system_jumps_200_ok[]> {
        let url_ = this.baseUrl + "/v1/universe/system_jumps/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_system_jumps(_response);
        });
    }

    protected processGet_universe_system_jumps(response: Response): Promise<Get_universe_system_jumps_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_universe_system_jumps_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_system_jumps_200_ok[]>(null as any);
    }

    /**
     * Get solar systems
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of solar system ids
     */
    get_universe_systems(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/universe/systems/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_systems(_response);
        });
    }

    protected processGet_universe_systems(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get types
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @return A list of type ids
     */
    get_universe_types(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/universe/types/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_types(_response);
        });
    }

    protected processGet_universe_types(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * List wars
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param max_war_id (optional) Only return wars with ID smaller than this
     * @return A list of war IDs, in descending order by war_id
     */
    get_wars(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, max_war_id: number | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/wars/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (max_war_id !== undefined && max_war_id !== null)
            url_ += "max_war_id=" + encodeURIComponent("" + max_war_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_wars(_response);
        });
    }

    protected processGet_wars(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get war information
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param war_id ID for a war
     * @return Details about a war
     */
    get_wars_war_id(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, war_id: number): Promise<Get_wars_war_id_ok> {
        let url_ = this.baseUrl + "/v1/wars/{war_id}/?";
        if (war_id === undefined || war_id === null)
            throw new Error("The parameter 'war_id' must be defined.");
        url_ = url_.replace("{war_id}", encodeURIComponent("" + war_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_wars_war_id(_response);
        });
    }

    protected processGet_wars_war_id(response: Response): Promise<Get_wars_war_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_wars_war_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Get_wars_war_id_unprocessable_entity.fromJS(resultData422);
            return throwException("War not found", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_wars_war_id_ok>(null as any);
    }

    /**
     * List kills for a war
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param war_id A valid war ID
     * @return A list of killmail IDs and hashes
     */
    get_wars_war_id_killmails(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, war_id: number): Promise<Get_wars_war_id_killmails_200_ok[]> {
        let url_ = this.baseUrl + "/v1/wars/{war_id}/killmails/?";
        if (war_id === undefined || war_id === null)
            throw new Error("The parameter 'war_id' must be defined.");
        url_ = url_.replace("{war_id}", encodeURIComponent("" + war_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_wars_war_id_killmails(_response);
        });
    }

    protected processGet_wars_war_id_killmails(response: Response): Promise<Get_wars_war_id_killmails_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_wars_war_id_killmails_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = Get_wars_war_id_killmails_unprocessable_entity.fromJS(resultData422);
            return throwException("War not found", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_wars_war_id_killmails_200_ok[]>(null as any);
    }

    /**
     * Get alliance contacts
     * @param alliance_id An EVE alliance ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of contacts
     */
    get_alliances_alliance_id_contacts(alliance_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_alliances_alliance_id_contacts_200_ok[]> {
        let url_ = this.baseUrl + "/v2/alliances/{alliance_id}/contacts/?";
        if (alliance_id === undefined || alliance_id === null)
            throw new Error("The parameter 'alliance_id' must be defined.");
        url_ = url_.replace("{alliance_id}", encodeURIComponent("" + alliance_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_alliances_alliance_id_contacts(_response);
        });
    }

    protected processGet_alliances_alliance_id_contacts(response: Response): Promise<Get_alliances_alliance_id_contacts_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_alliances_alliance_id_contacts_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_alliances_alliance_id_contacts_200_ok[]>(null as any);
    }

    /**
     * Character affiliation
     * @param characters The character IDs to fetch affiliations for. All characters must exist, or none will be returned
     * @param datasource (optional) The server name you would like data from
     * @return Character corporation, alliance and faction IDs
     */
    post_characters_affiliation(characters: number[], datasource: Datasource | null | undefined): Promise<Post_characters_affiliation_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/affiliation/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(characters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_characters_affiliation(_response);
        });
    }

    protected processPost_characters_affiliation(response: Response): Promise<Post_characters_affiliation_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Post_characters_affiliation_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post_characters_affiliation_200_ok[]>(null as any);
    }

    /**
     * Get agents research
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of agents research information
     */
    get_characters_character_id_agents_research(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_agents_research_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/agents_research/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_agents_research(_response);
        });
    }

    protected processGet_characters_character_id_agents_research(response: Response): Promise<Get_characters_character_id_agents_research_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_agents_research_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_agents_research_200_ok[]>(null as any);
    }

    /**
     * Get character asset locations
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param item_ids A list of item ids
     * @param token (optional) Access token to use if unable to set a header
     * @return List of asset locations
     */
    post_characters_character_id_assets_locations(character_id: number, datasource: Datasource | null | undefined, item_ids: number[], token: string | null | undefined): Promise<Post_characters_character_id_assets_locations_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/assets/locations/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item_ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_characters_character_id_assets_locations(_response);
        });
    }

    protected processPost_characters_character_id_assets_locations(response: Response): Promise<Post_characters_character_id_assets_locations_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Post_characters_character_id_assets_locations_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post_characters_character_id_assets_locations_200_ok[]>(null as any);
    }

    /**
     * List bookmarks
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of bookmarks
     */
    get_characters_character_id_bookmarks(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_bookmarks_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/bookmarks/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_bookmarks(_response);
        });
    }

    protected processGet_characters_character_id_bookmarks(response: Response): Promise<Get_characters_character_id_bookmarks_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_bookmarks_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_bookmarks_200_ok[]>(null as any);
    }

    /**
     * List bookmark folders
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return List of bookmark folders
     */
    get_characters_character_id_bookmarks_folders(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_bookmarks_folders_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/bookmarks/folders/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_bookmarks_folders(_response);
        });
    }

    protected processGet_characters_character_id_bookmarks_folders(response: Response): Promise<Get_characters_character_id_bookmarks_folders_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_bookmarks_folders_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_bookmarks_folders_200_ok[]>(null as any);
    }

    /**
     * Delete contacts
     * @param character_id An EVE character ID
     * @param contact_ids A list of contacts to delete
     * @param datasource (optional) The server name you would like data from
     * @param token (optional) Access token to use if unable to set a header
     * @return Contacts deleted
     */
    delete_characters_character_id_contacts(character_id: number, contact_ids: number[], datasource: Datasource | null | undefined, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/contacts/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (contact_ids === undefined || contact_ids === null)
            throw new Error("The parameter 'contact_ids' must be defined and cannot be null.");
        else
            contact_ids && contact_ids.forEach(item => { url_ += "contact_ids=" + encodeURIComponent("" + item) + "&"; });
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete_characters_character_id_contacts(_response);
        });
    }

    protected processDelete_characters_character_id_contacts(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get contacts
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of contacts
     */
    get_characters_character_id_contacts(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_contacts_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/contacts/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_contacts(_response);
        });
    }

    protected processGet_characters_character_id_contacts(response: Response): Promise<Get_characters_character_id_contacts_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_contacts_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_contacts_200_ok[]>(null as any);
    }

    /**
     * Add contacts
     * @param character_id An EVE character ID
     * @param contact_ids A list of contacts
     * @param datasource (optional) The server name you would like data from
     * @param label_ids (optional) Add custom labels to the new contact
     * @param standing Standing for the contact
     * @param token (optional) Access token to use if unable to set a header
     * @param watched (optional) Whether the contact should be watched, note this is only effective on characters
     * @return A list of contact ids that successfully created
     */
    post_characters_character_id_contacts(character_id: number, contact_ids: number[], datasource: Datasource | null | undefined, label_ids: number[] | null | undefined, standing: number, token: string | null | undefined, watched: boolean | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/contacts/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (label_ids !== undefined && label_ids !== null)
            label_ids && label_ids.forEach(item => { url_ += "label_ids=" + encodeURIComponent("" + item) + "&"; });
        if (standing === undefined || standing === null)
            throw new Error("The parameter 'standing' must be defined and cannot be null.");
        else
            url_ += "standing=" + encodeURIComponent("" + standing) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (watched !== undefined && watched !== null)
            url_ += "watched=" + encodeURIComponent("" + watched) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contact_ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_characters_character_id_contacts(_response);
        });
    }

    protected processPost_characters_character_id_contacts(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(item);
            }
            else {
                result201 = <any>null;
            }
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status === 520) {
            return response.text().then((_responseText) => {
            let result520: any = null;
            let resultData520 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result520 = Post_characters_character_id_contacts_error_520.fromJS(resultData520);
            return throwException("Internal error thrown from the EVE server", status, _responseText, _headers, result520);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Edit contacts
     * @param character_id An EVE character ID
     * @param contact_ids A list of contacts
     * @param datasource (optional) The server name you would like data from
     * @param label_ids (optional) Add custom labels to the contact
     * @param standing Standing for the contact
     * @param token (optional) Access token to use if unable to set a header
     * @param watched (optional) Whether the contact should be watched, note this is only effective on characters
     * @return Contacts updated
     */
    put_characters_character_id_contacts(character_id: number, contact_ids: number[], datasource: Datasource | null | undefined, label_ids: number[] | null | undefined, standing: number, token: string | null | undefined, watched: boolean | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/contacts/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (label_ids !== undefined && label_ids !== null)
            label_ids && label_ids.forEach(item => { url_ += "label_ids=" + encodeURIComponent("" + item) + "&"; });
        if (standing === undefined || standing === null)
            throw new Error("The parameter 'standing' must be defined and cannot be null.");
        else
            url_ += "standing=" + encodeURIComponent("" + standing) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (watched !== undefined && watched !== null)
            url_ += "watched=" + encodeURIComponent("" + watched) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contact_ids);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut_characters_character_id_contacts(_response);
        });
    }

    protected processPut_characters_character_id_contacts(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get corporation history
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Corporation history for the given character
     */
    get_characters_character_id_corporationhistory(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_characters_character_id_corporationhistory_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/corporationhistory/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_corporationhistory(_response);
        });
    }

    protected processGet_characters_character_id_corporationhistory(response: Response): Promise<Get_characters_character_id_corporationhistory_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_corporationhistory_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_corporationhistory_200_ok[]>(null as any);
    }

    /**
     * Get jump fatigue
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Jump activation and fatigue information
     */
    get_characters_character_id_fatigue(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_fatigue_ok> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/fatigue/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_fatigue(_response);
        });
    }

    protected processGet_characters_character_id_fatigue(response: Response): Promise<Get_characters_character_id_fatigue_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_fatigue_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_fatigue_ok>(null as any);
    }

    /**
     * Get fittings
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of fittings
     */
    get_characters_character_id_fittings(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_fittings_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/fittings/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_fittings(_response);
        });
    }

    protected processGet_characters_character_id_fittings(response: Response): Promise<Get_characters_character_id_fittings_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_fittings_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_fittings_200_ok[]>(null as any);
    }

    /**
     * Create fitting
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param fitting Details about the new fitting
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of fittings
     */
    post_characters_character_id_fittings(character_id: number, datasource: Datasource | null | undefined, fitting: Post_characters_character_id_fittings_fitting, token: string | null | undefined): Promise<Post_characters_character_id_fittings_created> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/fittings/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fitting);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_characters_character_id_fittings(_response);
        });
    }

    protected processPost_characters_character_id_fittings(response: Response): Promise<Post_characters_character_id_fittings_created> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Post_characters_character_id_fittings_created.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post_characters_character_id_fittings_created>(null as any);
    }

    /**
     * Create a mail label
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param label Label to create
     * @param token (optional) Access token to use if unable to set a header
     * @return Label created
     */
    post_characters_character_id_mail_labels(character_id: number, datasource: Datasource | null | undefined, label: Post_characters_character_id_mail_labels_label, token: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/mail/labels/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(label);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_characters_character_id_mail_labels(_response);
        });
    }

    protected processPost_characters_character_id_mail_labels(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get medals
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of medals
     */
    get_characters_character_id_medals(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_medals_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/medals/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_medals(_response);
        });
    }

    protected processGet_characters_character_id_medals(response: Response): Promise<Get_characters_character_id_medals_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_medals_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_medals_200_ok[]>(null as any);
    }

    /**
     * Get new contact notifications
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of contact notifications
     */
    get_characters_character_id_notifications_contacts(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_notifications_contacts_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/notifications/contacts/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_notifications_contacts(_response);
        });
    }

    protected processGet_characters_character_id_notifications_contacts(response: Response): Promise<Get_characters_character_id_notifications_contacts_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_notifications_contacts_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_notifications_contacts_200_ok[]>(null as any);
    }

    /**
     * Get character online
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Object describing the character's online status
     */
    get_characters_character_id_online(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_online_ok> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/online/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_online(_response);
        });
    }

    protected processGet_characters_character_id_online(response: Response): Promise<Get_characters_character_id_online_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_online_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_online_ok>(null as any);
    }

    /**
     * List open orders from a character
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Open market orders placed by a character
     */
    get_characters_character_id_orders(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_orders_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/orders/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_orders(_response);
        });
    }

    protected processGet_characters_character_id_orders(response: Response): Promise<Get_characters_character_id_orders_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_orders_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_orders_200_ok[]>(null as any);
    }

    /**
     * Get character portraits
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Public data for the given character
     */
    get_characters_character_id_portrait(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_characters_character_id_portrait_ok> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/portrait/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_portrait(_response);
        });
    }

    protected processGet_characters_character_id_portrait(response: Response): Promise<Get_characters_character_id_portrait_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_portrait_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_characters_character_id_portrait_not_found.fromJS(resultData404);
            return throwException("No image server for this datasource", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_portrait_ok>(null as any);
    }

    /**
     * Get character's skill queue
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return The current skill queue, sorted ascending by finishing time
     */
    get_characters_character_id_skillqueue(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_skillqueue_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/skillqueue/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_skillqueue(_response);
        });
    }

    protected processGet_characters_character_id_skillqueue(response: Response): Promise<Get_characters_character_id_skillqueue_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_skillqueue_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_skillqueue_200_ok[]>(null as any);
    }

    /**
     * Get standings
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of standings
     */
    get_characters_character_id_standings(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_standings_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/standings/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_standings(_response);
        });
    }

    protected processGet_characters_character_id_standings(response: Response): Promise<Get_characters_character_id_standings_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_standings_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_standings_200_ok[]>(null as any);
    }

    /**
     * Get character corporation titles
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of titles
     */
    get_characters_character_id_titles(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_titles_200_ok[]> {
        let url_ = this.baseUrl + "/v2/characters/{character_id}/titles/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_titles(_response);
        });
    }

    protected processGet_characters_character_id_titles(response: Response): Promise<Get_characters_character_id_titles_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_titles_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_titles_200_ok[]>(null as any);
    }

    /**
     * Get npc corporations
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of npc corporation ids
     */
    get_corporations_npccorps(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v2/corporations/npccorps/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_npccorps(_response);
        });
    }

    protected processGet_corporations_npccorps(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get corporation asset locations
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param item_ids A list of item ids
     * @param token (optional) Access token to use if unable to set a header
     * @return List of asset locations
     */
    post_corporations_corporation_id_assets_locations(corporation_id: number, datasource: Datasource | null | undefined, item_ids: number[], token: string | null | undefined): Promise<Post_corporations_corporation_id_assets_locations_200_ok[]> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/assets/locations/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item_ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_corporations_corporation_id_assets_locations(_response);
        });
    }

    protected processPost_corporations_corporation_id_assets_locations(response: Response): Promise<Post_corporations_corporation_id_assets_locations_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Post_corporations_corporation_id_assets_locations_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Post_corporations_corporation_id_assets_locations_not_found.fromJS(resultData404);
            return throwException("Invalid IDs", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post_corporations_corporation_id_assets_locations_200_ok[]>(null as any);
    }

    /**
     * Get corporation contacts
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of contacts
     */
    get_corporations_corporation_id_contacts(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_contacts_200_ok[]> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/contacts/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_contacts(_response);
        });
    }

    protected processGet_corporations_corporation_id_contacts(response: Response): Promise<Get_corporations_corporation_id_contacts_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_contacts_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_contacts_200_ok[]>(null as any);
    }

    /**
     * Get corporation divisions
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return List of corporation division names
     */
    get_corporations_corporation_id_divisions(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_divisions_ok> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/divisions/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_divisions(_response);
        });
    }

    protected processGet_corporations_corporation_id_divisions(response: Response): Promise<Get_corporations_corporation_id_divisions_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_corporations_corporation_id_divisions_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_divisions_ok>(null as any);
    }

    /**
     * Get corporation facilities
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return List of corporation facilities
     */
    get_corporations_corporation_id_facilities(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_facilities_200_ok[]> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/facilities/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_facilities(_response);
        });
    }

    protected processGet_corporations_corporation_id_facilities(response: Response): Promise<Get_corporations_corporation_id_facilities_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_facilities_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_facilities_200_ok[]>(null as any);
    }

    /**
     * Get corporation icon
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Urls for icons for the given corporation id and server
     */
    get_corporations_corporation_id_icons(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_corporations_corporation_id_icons_ok> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/icons/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_icons(_response);
        });
    }

    protected processGet_corporations_corporation_id_icons(response: Response): Promise<Get_corporations_corporation_id_icons_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_corporations_corporation_id_icons_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_corporations_corporation_id_icons_not_found.fromJS(resultData404);
            return throwException("No image server for this datasource", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_icons_ok>(null as any);
    }

    /**
     * Get corporation medals
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of medals
     */
    get_corporations_corporation_id_medals(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_medals_200_ok[]> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/medals/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_medals(_response);
        });
    }

    protected processGet_corporations_corporation_id_medals(response: Response): Promise<Get_corporations_corporation_id_medals_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_medals_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_medals_200_ok[]>(null as any);
    }

    /**
     * Get corporation issued medals
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of issued medals
     */
    get_corporations_corporation_id_medals_issued(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_medals_issued_200_ok[]> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/medals/issued/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_medals_issued(_response);
        });
    }

    protected processGet_corporations_corporation_id_medals_issued(response: Response): Promise<Get_corporations_corporation_id_medals_issued_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_medals_issued_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_medals_issued_200_ok[]>(null as any);
    }

    /**
     * Get corporation member limit
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return The corporation's member limit
     */
    get_corporations_corporation_id_members_limit(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/members/limit/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_members_limit(_response);
        });
    }

    protected processGet_corporations_corporation_id_members_limit(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get corporation's members' titles
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of members and theirs titles
     */
    get_corporations_corporation_id_members_titles(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_members_titles_200_ok[]> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/members/titles/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_members_titles(_response);
        });
    }

    protected processGet_corporations_corporation_id_members_titles(response: Response): Promise<Get_corporations_corporation_id_members_titles_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_members_titles_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_members_titles_200_ok[]>(null as any);
    }

    /**
     * Track corporation members
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return List of member character IDs
     */
    get_corporations_corporation_id_membertracking(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporations_corporation_id_membertracking_200_ok[]>> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/membertracking/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_membertracking(_response);
        });
    }

    protected processGet_corporations_corporation_id_membertracking(response: Response): Promise<SwaggerResponse<Get_corporations_corporation_id_membertracking_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_membertracking_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporations_corporation_id_membertracking_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * List historical orders from a corporation
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return Expired and cancelled market orders placed on behalf of a corporation
     */
    get_corporations_corporation_id_orders_history(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporations_corporation_id_orders_history_200_ok[]>> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/orders/history/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_orders_history(_response);
        });
    }

    protected processGet_corporations_corporation_id_orders_history(response: Response): Promise<SwaggerResponse<Get_corporations_corporation_id_orders_history_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_orders_history_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporations_corporation_id_orders_history_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get corporation member roles
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return List of member character ID's and roles
     */
    get_corporations_corporation_id_roles(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_roles_200_ok[]> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/roles/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_roles(_response);
        });
    }

    protected processGet_corporations_corporation_id_roles(response: Response): Promise<Get_corporations_corporation_id_roles_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_roles_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_roles_200_ok[]>(null as any);
    }

    /**
     * Get corporation member roles history
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return List of role changes
     */
    get_corporations_corporation_id_roles_history(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_roles_history_200_ok[]> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/roles/history/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_roles_history(_response);
        });
    }

    protected processGet_corporations_corporation_id_roles_history(response: Response): Promise<Get_corporations_corporation_id_roles_history_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_roles_history_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_roles_history_200_ok[]>(null as any);
    }

    /**
     * Get corporation standings
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of standings
     */
    get_corporations_corporation_id_standings(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_standings_200_ok[]> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/standings/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_standings(_response);
        });
    }

    protected processGet_corporations_corporation_id_standings(response: Response): Promise<Get_corporations_corporation_id_standings_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_standings_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_standings_200_ok[]>(null as any);
    }

    /**
     * Get corporation starbases (POSes)
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return List of starbases (POSes)
     */
    get_corporations_corporation_id_starbases(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_starbases_200_ok[]> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/starbases/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_starbases(_response);
        });
    }

    protected processGet_corporations_corporation_id_starbases(response: Response): Promise<Get_corporations_corporation_id_starbases_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_starbases_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_starbases_200_ok[]>(null as any);
    }

    /**
     * Get starbase (POS) detail
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param starbase_id An EVE starbase (POS) ID
     * @param system_id The solar system this starbase (POS) is located in,
     * @param token (optional) Access token to use if unable to set a header
     * @return List of starbases (POSes)
     */
    get_corporations_corporation_id_starbases_starbase_id(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, starbase_id: number, system_id: number, token: string | null | undefined): Promise<Get_corporations_corporation_id_starbases_starbase_id_ok> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/starbases/{starbase_id}/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (starbase_id === undefined || starbase_id === null)
            throw new Error("The parameter 'starbase_id' must be defined.");
        url_ = url_.replace("{starbase_id}", encodeURIComponent("" + starbase_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (system_id === undefined || system_id === null)
            throw new Error("The parameter 'system_id' must be defined and cannot be null.");
        else
            url_ += "system_id=" + encodeURIComponent("" + system_id) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_starbases_starbase_id(_response);
        });
    }

    protected processGet_corporations_corporation_id_starbases_starbase_id(response: Response): Promise<Get_corporations_corporation_id_starbases_starbase_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_corporations_corporation_id_starbases_starbase_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_starbases_starbase_id_ok>(null as any);
    }

    /**
     * Get corporation titles
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of titles
     */
    get_corporations_corporation_id_titles(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_titles_200_ok[]> {
        let url_ = this.baseUrl + "/v2/corporations/{corporation_id}/titles/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_titles(_response);
        });
    }

    protected processGet_corporations_corporation_id_titles(response: Response): Promise<Get_corporations_corporation_id_titles_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_titles_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_titles_200_ok[]>(null as any);
    }

    /**
     * Get effect information
     * @param datasource (optional) The server name you would like data from
     * @param effect_id A dogma effect ID
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Information about a dogma effect
     */
    get_dogma_effects_effect_id(datasource: Datasource | null | undefined, effect_id: number, if_None_Match: string | null | undefined): Promise<Get_dogma_effects_effect_id_ok> {
        let url_ = this.baseUrl + "/v2/dogma/effects/{effect_id}/?";
        if (effect_id === undefined || effect_id === null)
            throw new Error("The parameter 'effect_id' must be defined.");
        url_ = url_.replace("{effect_id}", encodeURIComponent("" + effect_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_dogma_effects_effect_id(_response);
        });
    }

    protected processGet_dogma_effects_effect_id(response: Response): Promise<Get_dogma_effects_effect_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_dogma_effects_effect_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_dogma_effects_effect_id_not_found.fromJS(resultData404);
            return throwException("Dogma effect not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_dogma_effects_effect_id_ok>(null as any);
    }

    /**
     * Ownership of faction warfare systems
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return All faction warfare solar systems
     */
    get_fw_systems(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_fw_systems_200_ok[]> {
        let url_ = this.baseUrl + "/v2/fw/systems/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_fw_systems(_response);
        });
    }

    protected processGet_fw_systems(response: Response): Promise<Get_fw_systems_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_fw_systems_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_fw_systems_200_ok[]>(null as any);
    }

    /**
     * Set Autopilot Waypoint
     * @param add_to_beginning Whether this solar system should be added to the beginning of all waypoints
     * @param clear_other_waypoints Whether clean other waypoints beforing adding this one
     * @param datasource (optional) The server name you would like data from
     * @param destination_id The destination to travel to, can be solar system, station or structure's id
     * @param token (optional) Access token to use if unable to set a header
     * @return Open window request received
     */
    post_ui_autopilot_waypoint(add_to_beginning: boolean, clear_other_waypoints: boolean, datasource: Datasource | null | undefined, destination_id: number, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v2/ui/autopilot/waypoint/?";
        if (add_to_beginning === undefined || add_to_beginning === null)
            throw new Error("The parameter 'add_to_beginning' must be defined and cannot be null.");
        else
            url_ += "add_to_beginning=" + encodeURIComponent("" + add_to_beginning) + "&";
        if (clear_other_waypoints === undefined || clear_other_waypoints === null)
            throw new Error("The parameter 'clear_other_waypoints' must be defined and cannot be null.");
        else
            url_ += "clear_other_waypoints=" + encodeURIComponent("" + clear_other_waypoints) + "&";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (destination_id === undefined || destination_id === null)
            throw new Error("The parameter 'destination_id' must be defined and cannot be null.");
        else
            url_ += "destination_id=" + encodeURIComponent("" + destination_id) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_ui_autopilot_waypoint(_response);
        });
    }

    protected processPost_ui_autopilot_waypoint(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get factions
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @return A list of factions
     */
    get_universe_factions(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined): Promise<Get_universe_factions_200_ok[]> {
        let url_ = this.baseUrl + "/v2/universe/factions/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_factions(_response);
        });
    }

    protected processGet_universe_factions(response: Response): Promise<Get_universe_factions_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_universe_factions_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_factions_200_ok[]>(null as any);
    }

    /**
     * Get station information
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param station_id station_id integer
     * @return Information about a station
     */
    get_universe_stations_station_id(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, station_id: number): Promise<Get_universe_stations_station_id_ok> {
        let url_ = this.baseUrl + "/v2/universe/stations/{station_id}/?";
        if (station_id === undefined || station_id === null)
            throw new Error("The parameter 'station_id' must be defined.");
        url_ = url_.replace("{station_id}", encodeURIComponent("" + station_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_stations_station_id(_response);
        });
    }

    protected processGet_universe_stations_station_id(response: Response): Promise<Get_universe_stations_station_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_stations_station_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_stations_station_id_not_found.fromJS(resultData404);
            return throwException("Station not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_stations_station_id_ok>(null as any);
    }

    /**
     * Get structure information
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param structure_id An Eve structure ID
     * @param token (optional) Access token to use if unable to set a header
     * @return Data about a structure
     */
    get_universe_structures_structure_id(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, structure_id: number, token: string | null | undefined): Promise<SwaggerResponse<Get_universe_structures_structure_id_ok>> {
        let url_ = this.baseUrl + "/v2/universe/structures/{structure_id}/?";
        if (structure_id === undefined || structure_id === null)
            throw new Error("The parameter 'structure_id' must be defined.");
        url_ = url_.replace("{structure_id}", encodeURIComponent("" + structure_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_structures_structure_id(_response);
        });
    }

    protected processGet_universe_structures_structure_id(response: Response): Promise<SwaggerResponse<Get_universe_structures_structure_id_ok>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_structures_structure_id_ok.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_structures_structure_id_not_found.fromJS(resultData404);
            return throwException("Structure not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_universe_structures_structure_id_ok>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get system kills
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return A list of systems and number of ship, pod and NPC kills
     */
    get_universe_system_kills(datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_universe_system_kills_200_ok[]> {
        let url_ = this.baseUrl + "/v2/universe/system_kills/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_system_kills(_response);
        });
    }

    protected processGet_universe_system_kills(response: Response): Promise<Get_universe_system_kills_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_universe_system_kills_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_system_kills_200_ok[]>(null as any);
    }

    /**
     * Get alliance information
     * @param alliance_id An EVE alliance ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Public data about an alliance
     */
    get_alliances_alliance_id(alliance_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_alliances_alliance_id_ok> {
        let url_ = this.baseUrl + "/v3/alliances/{alliance_id}/?";
        if (alliance_id === undefined || alliance_id === null)
            throw new Error("The parameter 'alliance_id' must be defined.");
        url_ = url_.replace("{alliance_id}", encodeURIComponent("" + alliance_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_alliances_alliance_id(_response);
        });
    }

    protected processGet_alliances_alliance_id(response: Response): Promise<Get_alliances_alliance_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_alliances_alliance_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_alliances_alliance_id_not_found.fromJS(resultData404);
            return throwException("Alliance not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_alliances_alliance_id_ok>(null as any);
    }

    /**
     * Get blueprints
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of blueprints
     */
    get_characters_character_id_blueprints(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_characters_character_id_blueprints_200_ok[]>> {
        let url_ = this.baseUrl + "/v3/characters/{character_id}/blueprints/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_blueprints(_response);
        });
    }

    protected processGet_characters_character_id_blueprints(response: Response): Promise<SwaggerResponse<Get_characters_character_id_blueprints_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_blueprints_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_characters_character_id_blueprints_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get an event
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param event_id The id of the event requested
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Full details of a specific event
     */
    get_characters_character_id_calendar_event_id(character_id: number, datasource: Datasource | null | undefined, event_id: number, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_calendar_event_id_ok> {
        let url_ = this.baseUrl + "/v3/characters/{character_id}/calendar/{event_id}/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (event_id === undefined || event_id === null)
            throw new Error("The parameter 'event_id' must be defined.");
        url_ = url_.replace("{event_id}", encodeURIComponent("" + event_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_calendar_event_id(_response);
        });
    }

    protected processGet_characters_character_id_calendar_event_id(response: Response): Promise<Get_characters_character_id_calendar_event_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_calendar_event_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_characters_character_id_calendar_event_id_not_found.fromJS(resultData404);
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_calendar_event_id_ok>(null as any);
    }

    /**
     * Respond to an event
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param event_id The ID of the event requested
     * @param response The response value to set, overriding current value
     * @param token (optional) Access token to use if unable to set a header
     * @return Event updated
     */
    put_characters_character_id_calendar_event_id(character_id: number, datasource: Datasource | null | undefined, event_id: number, response: Put_characters_character_id_calendar_event_id_response, token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v3/characters/{character_id}/calendar/{event_id}/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (event_id === undefined || event_id === null)
            throw new Error("The parameter 'event_id' must be defined.");
        url_ = url_.replace("{event_id}", encodeURIComponent("" + event_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(response);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut_characters_character_id_calendar_event_id(_response);
        });
    }

    protected processPut_characters_character_id_calendar_event_id(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get clones
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Clone information for the given character
     */
    get_characters_character_id_clones(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_clones_ok> {
        let url_ = this.baseUrl + "/v3/characters/{character_id}/clones/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_clones(_response);
        });
    }

    protected processGet_characters_character_id_clones(response: Response): Promise<Get_characters_character_id_clones_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_clones_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_clones_ok>(null as any);
    }

    /**
     * Get mail labels and unread counts
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of mail labels and unread counts
     */
    get_characters_character_id_mail_labels(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_mail_labels_ok> {
        let url_ = this.baseUrl + "/v3/characters/{character_id}/mail/labels/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_mail_labels(_response);
        });
    }

    protected processGet_characters_character_id_mail_labels(response: Response): Promise<Get_characters_character_id_mail_labels_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_mail_labels_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_mail_labels_ok>(null as any);
    }

    /**
     * Get colony layout
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param planet_id Planet id of the target planet
     * @param token (optional) Access token to use if unable to set a header
     * @return Colony layout
     */
    get_characters_character_id_planets_planet_id(character_id: number, datasource: Datasource | null | undefined, planet_id: number, token: string | null | undefined): Promise<Get_characters_character_id_planets_planet_id_ok> {
        let url_ = this.baseUrl + "/v3/characters/{character_id}/planets/{planet_id}/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (planet_id === undefined || planet_id === null)
            throw new Error("The parameter 'planet_id' must be defined.");
        url_ = url_.replace("{planet_id}", encodeURIComponent("" + planet_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_planets_planet_id(_response);
        });
    }

    protected processGet_characters_character_id_planets_planet_id(response: Response): Promise<Get_characters_character_id_planets_planet_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_planets_planet_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_characters_character_id_planets_planet_id_not_found.fromJS(resultData404);
            return throwException("Colony not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_planets_planet_id_ok>(null as any);
    }

    /**
     * Get character corporation roles
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return The character's roles in thier corporation
     */
    get_characters_character_id_roles(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_roles_ok> {
        let url_ = this.baseUrl + "/v3/characters/{character_id}/roles/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_roles(_response);
        });
    }

    protected processGet_characters_character_id_roles(response: Response): Promise<Get_characters_character_id_roles_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_roles_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_roles_ok>(null as any);
    }

    /**
     * Search on a string
     * @param accept_Language (optional) Language to use in the response
     * @param categories Type of entities to search for
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @param search The string to search on
     * @param strict (optional) Whether the search should be a strict match
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of search results
     */
    get_characters_character_id_search(accept_Language: AcceptLanguage | null | undefined, categories: Categories[], character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined, search: string, strict: boolean | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_search_ok> {
        let url_ = this.baseUrl + "/v3/characters/{character_id}/search/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (categories === undefined || categories === null)
            throw new Error("The parameter 'categories' must be defined and cannot be null.");
        else
            categories && categories.forEach(item => { url_ += "categories=" + encodeURIComponent("" + item) + "&"; });
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (search === undefined || search === null)
            throw new Error("The parameter 'search' must be defined and cannot be null.");
        else
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (strict !== undefined && strict !== null)
            url_ += "strict=" + encodeURIComponent("" + strict) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_search(_response);
        });
    }

    protected processGet_characters_character_id_search(response: Response): Promise<Get_characters_character_id_search_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_search_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_search_ok>(null as any);
    }

    /**
     * Get alliance history
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Alliance history for the given corporation
     */
    get_corporations_corporation_id_alliancehistory(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_corporations_corporation_id_alliancehistory_200_ok[]> {
        let url_ = this.baseUrl + "/v3/corporations/{corporation_id}/alliancehistory/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_alliancehistory(_response);
        });
    }

    protected processGet_corporations_corporation_id_alliancehistory(response: Response): Promise<Get_corporations_corporation_id_alliancehistory_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_alliancehistory_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_alliancehistory_200_ok[]>(null as any);
    }

    /**
     * Get corporation blueprints
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return List of corporation blueprints
     */
    get_corporations_corporation_id_blueprints(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporations_corporation_id_blueprints_200_ok[]>> {
        let url_ = this.baseUrl + "/v3/corporations/{corporation_id}/blueprints/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_blueprints(_response);
        });
    }

    protected processGet_corporations_corporation_id_blueprints(response: Response): Promise<SwaggerResponse<Get_corporations_corporation_id_blueprints_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_blueprints_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporations_corporation_id_blueprints_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get all corporation ALSC logs
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return List of corporation ALSC logs
     */
    get_corporations_corporation_id_containers_logs(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<Get_corporations_corporation_id_containers_logs_200_ok[]> {
        let url_ = this.baseUrl + "/v3/corporations/{corporation_id}/containers/logs/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_containers_logs(_response);
        });
    }

    protected processGet_corporations_corporation_id_containers_logs(response: Response): Promise<Get_corporations_corporation_id_containers_logs_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_containers_logs_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_containers_logs_200_ok[]>(null as any);
    }

    /**
     * List open orders from a corporation
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of open market orders
     */
    get_corporations_corporation_id_orders(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporations_corporation_id_orders_200_ok[]>> {
        let url_ = this.baseUrl + "/v3/corporations/{corporation_id}/orders/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_orders(_response);
        });
    }

    protected processGet_corporations_corporation_id_orders(response: Response): Promise<SwaggerResponse<Get_corporations_corporation_id_orders_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_orders_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporations_corporation_id_orders_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get names and categories for a set of IDs
     * @param datasource (optional) The server name you would like data from
     * @param ids The ids to resolve
     * @return List of id/name associations for a set of IDs. All IDs must resolve to a name, or nothing will be returned
     */
    post_universe_names(datasource: Datasource | null | undefined, ids: number[]): Promise<Post_universe_names_200_ok[]> {
        let url_ = this.baseUrl + "/v3/universe/names/?";
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_universe_names(_response);
        });
    }

    protected processPost_universe_names(response: Response): Promise<Post_universe_names_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Post_universe_names_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Post_universe_names_not_found.fromJS(resultData404);
            return throwException("Ensure all IDs are valid before resolving", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Post_universe_names_200_ok[]>(null as any);
    }

    /**
     * Get type information
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @param type_id An Eve item type ID
     * @return Information about a type
     */
    get_universe_types_type_id(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined, type_id: number): Promise<Get_universe_types_type_id_ok> {
        let url_ = this.baseUrl + "/v3/universe/types/{type_id}/?";
        if (type_id === undefined || type_id === null)
            throw new Error("The parameter 'type_id' must be defined.");
        url_ = url_.replace("{type_id}", encodeURIComponent("" + type_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_types_type_id(_response);
        });
    }

    protected processGet_universe_types_type_id(response: Response): Promise<Get_universe_types_type_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_types_type_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_types_type_id_not_found.fromJS(resultData404);
            return throwException("Type not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_types_type_id_ok>(null as any);
    }

    /**
     * Get character skills
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Known skills for the character
     */
    get_characters_character_id_skills(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_skills_ok> {
        let url_ = this.baseUrl + "/v4/characters/{character_id}/skills/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_skills(_response);
        });
    }

    protected processGet_characters_character_id_skills(response: Response): Promise<Get_characters_character_id_skills_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_skills_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_skills_ok>(null as any);
    }

    /**
     * Get corporation members
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return List of member character IDs
     */
    get_corporations_corporation_id_members(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/v4/corporations/{corporation_id}/members/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_members(_response);
        });
    }

    protected processGet_corporations_corporation_id_members(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Get corporation structures
     * @param accept_Language (optional) Language to use in the response
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return List of corporation structures' information
     */
    get_corporations_corporation_id_structures(accept_Language: AcceptLanguage | null | undefined, corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporations_corporation_id_structures_200_ok[]>> {
        let url_ = this.baseUrl + "/v4/corporations/{corporation_id}/structures/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_structures(_response);
        });
    }

    protected processGet_corporations_corporation_id_structures(response: Response): Promise<SwaggerResponse<Get_corporations_corporation_id_structures_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_structures_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporations_corporation_id_structures_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get corporation wallet journal
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param division Wallet key of the division to fetch journals from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return Journal entries
     */
    get_corporations_corporation_id_wallets_division_journal(corporation_id: number, datasource: Datasource | null | undefined, division: number, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporations_corporation_id_wallets_division_journal_200_ok[]>> {
        let url_ = this.baseUrl + "/v4/corporations/{corporation_id}/wallets/{division}/journal/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (division === undefined || division === null)
            throw new Error("The parameter 'division' must be defined.");
        url_ = url_.replace("{division}", encodeURIComponent("" + division));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_wallets_division_journal(_response);
        });
    }

    protected processGet_corporations_corporation_id_wallets_division_journal(response: Response): Promise<SwaggerResponse<Get_corporations_corporation_id_wallets_division_journal_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_wallets_division_journal_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporations_corporation_id_wallets_division_journal_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get solar system information
     * @param accept_Language (optional) Language to use in the response
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param language (optional) Language to use in the response, takes precedence over Accept-Language
     * @param system_id system_id integer
     * @return Information about a solar system
     */
    get_universe_systems_system_id(accept_Language: AcceptLanguage | null | undefined, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, language: Language | null | undefined, system_id: number): Promise<Get_universe_systems_system_id_ok> {
        let url_ = this.baseUrl + "/v4/universe/systems/{system_id}/?";
        if (system_id === undefined || system_id === null)
            throw new Error("The parameter 'system_id' must be defined.");
        url_ = url_.replace("{system_id}", encodeURIComponent("" + system_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_universe_systems_system_id(_response);
        });
    }

    protected processGet_universe_systems_system_id(response: Response): Promise<Get_universe_systems_system_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_universe_systems_system_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_universe_systems_system_id_not_found.fromJS(resultData404);
            return throwException("Solar system not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_universe_systems_system_id_ok>(null as any);
    }

    /**
     * Get character's public information
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Public data for the given character
     */
    get_characters_character_id(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_characters_character_id_ok> {
        let url_ = this.baseUrl + "/v5/characters/{character_id}/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id(_response);
        });
    }

    protected processGet_characters_character_id(response: Response): Promise<Get_characters_character_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_characters_character_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_characters_character_id_not_found.fromJS(resultData404);
            return throwException("Character not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_ok>(null as any);
    }

    /**
     * Get character assets
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A flat list of the users assets
     */
    get_characters_character_id_assets(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_characters_character_id_assets_200_ok[]>> {
        let url_ = this.baseUrl + "/v5/characters/{character_id}/assets/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_assets(_response);
        });
    }

    protected processGet_characters_character_id_assets(response: Response): Promise<SwaggerResponse<Get_characters_character_id_assets_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_assets_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_characters_character_id_assets_not_found.fromJS(resultData404);
            return throwException("Requested page does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_characters_character_id_assets_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Calculate a CSPA charge cost
     * @param character_id An EVE character ID
     * @param characters The target characters to calculate the charge for
     * @param datasource (optional) The server name you would like data from
     * @param token (optional) Access token to use if unable to set a header
     * @return Aggregate cost of sending a mail from the source character to the target characters, in ISK
     */
    post_characters_character_id_cspa(character_id: number, characters: number[], datasource: Datasource | null | undefined, token: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/v5/characters/{character_id}/cspa/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(characters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost_characters_character_id_cspa(_response);
        });
    }

    protected processPost_characters_character_id_cspa(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get character notifications
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param token (optional) Access token to use if unable to set a header
     * @return Returns your recent notifications
     */
    get_characters_character_id_notifications(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, token: string | null | undefined): Promise<Get_characters_character_id_notifications_200_ok[]> {
        let url_ = this.baseUrl + "/v5/characters/{character_id}/notifications/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_notifications(_response);
        });
    }

    protected processGet_characters_character_id_notifications(response: Response): Promise<Get_characters_character_id_notifications_200_ok[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_notifications_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_characters_character_id_notifications_200_ok[]>(null as any);
    }

    /**
     * Get corporation information
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @return Public information about a corporation
     */
    get_corporations_corporation_id(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined): Promise<Get_corporations_corporation_id_ok> {
        let url_ = this.baseUrl + "/v5/corporations/{corporation_id}/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id(_response);
        });
    }

    protected processGet_corporations_corporation_id(response: Response): Promise<Get_corporations_corporation_id_ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Get_corporations_corporation_id_ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Get_corporations_corporation_id_not_found.fromJS(resultData404);
            return throwException("Corporation not found", status, _responseText, _headers, result404);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Get_corporations_corporation_id_ok>(null as any);
    }

    /**
     * Get corporation assets
     * @param corporation_id An EVE corporation ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return A list of assets
     */
    get_corporations_corporation_id_assets(corporation_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_corporations_corporation_id_assets_200_ok[]>> {
        let url_ = this.baseUrl + "/v5/corporations/{corporation_id}/assets/?";
        if (corporation_id === undefined || corporation_id === null)
            throw new Error("The parameter 'corporation_id' must be defined.");
        url_ = url_.replace("{corporation_id}", encodeURIComponent("" + corporation_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_corporations_corporation_id_assets(_response);
        });
    }

    protected processGet_corporations_corporation_id_assets(response: Response): Promise<SwaggerResponse<Get_corporations_corporation_id_assets_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_corporations_corporation_id_assets_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_corporations_corporation_id_assets_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get character wallet journal
     * @param character_id An EVE character ID
     * @param datasource (optional) The server name you would like data from
     * @param if_None_Match (optional) ETag from a previous request. A 304 will be returned if this matches the current ETag
     * @param page (optional) Which page of results to return
     * @param token (optional) Access token to use if unable to set a header
     * @return Journal entries
     */
    get_characters_character_id_wallet_journal(character_id: number, datasource: Datasource | null | undefined, if_None_Match: string | null | undefined, page: number | null | undefined, token: string | null | undefined): Promise<SwaggerResponse<Get_characters_character_id_wallet_journal_200_ok[]>> {
        let url_ = this.baseUrl + "/v6/characters/{character_id}/wallet/journal/?";
        if (character_id === undefined || character_id === null)
            throw new Error("The parameter 'character_id' must be defined.");
        url_ = url_.replace("{character_id}", encodeURIComponent("" + character_id));
        if (datasource !== undefined && datasource !== null)
            url_ += "datasource=" + encodeURIComponent("" + datasource) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json",
                ...customHeaders
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_characters_character_id_wallet_journal(_response);
        });
    }

    protected processGet_characters_character_id_wallet_journal(response: Response): Promise<SwaggerResponse<Get_characters_character_id_wallet_journal_200_ok[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get_characters_character_id_wallet_journal_200_ok.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Bad_request.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = Unauthorized.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = Forbidden.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 420) {
            return response.text().then((_responseText) => {
            let result420: any = null;
            let resultData420 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result420 = Error_limited.fromJS(resultData420);
            return throwException("Error limited", status, _responseText, _headers, result420);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = Internal_server_error.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = Service_unavailable.fromJS(resultData503);
            return throwException("Service unavailable", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            let resultData504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result504 = Gateway_timeout.fromJS(resultData504);
            return throwException("Gateway timeout", status, _responseText, _headers, result504);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Get_characters_character_id_wallet_journal_200_ok[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

/** Bad request model */
export class Bad_request implements IBad_request {
    /** Bad request message */
    error!: string;

    constructor(data?: IBad_request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Bad_request {
        data = typeof data === 'object' ? data : {};
        let result = new Bad_request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Bad request model */
export interface IBad_request {
    /** Bad request message */
    error: string;
}

/** Error limited model */
export class Error_limited implements IError_limited {
    /** Error limited message */
    error!: string;

    constructor(data?: IError_limited) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Error_limited {
        data = typeof data === 'object' ? data : {};
        let result = new Error_limited();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Error limited model */
export interface IError_limited {
    /** Error limited message */
    error: string;
}

/** Forbidden model */
export class Forbidden implements IForbidden {
    /** Forbidden message */
    error!: string;
    /** status code received from SSO */
    sso_status?: number | undefined;

    constructor(data?: IForbidden) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.sso_status = _data["sso_status"];
        }
    }

    static fromJS(data: any): Forbidden {
        data = typeof data === 'object' ? data : {};
        let result = new Forbidden();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["sso_status"] = this.sso_status;
        return data;
    }
}

/** Forbidden model */
export interface IForbidden {
    /** Forbidden message */
    error: string;
    /** status code received from SSO */
    sso_status?: number | undefined;
}

/** Gateway timeout model */
export class Gateway_timeout implements IGateway_timeout {
    /** Gateway timeout message */
    error!: string;
    /** number of seconds the request was given */
    timeout?: number | undefined;

    constructor(data?: IGateway_timeout) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.timeout = _data["timeout"];
        }
    }

    static fromJS(data: any): Gateway_timeout {
        data = typeof data === 'object' ? data : {};
        let result = new Gateway_timeout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["timeout"] = this.timeout;
        return data;
    }
}

/** Gateway timeout model */
export interface IGateway_timeout {
    /** Gateway timeout message */
    error: string;
    /** number of seconds the request was given */
    timeout?: number | undefined;
}

/** Internal server error model */
export class Internal_server_error implements IInternal_server_error {
    /** Internal server error message */
    error!: string;

    constructor(data?: IInternal_server_error) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Internal_server_error {
        data = typeof data === 'object' ? data : {};
        let result = new Internal_server_error();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Internal server error model */
export interface IInternal_server_error {
    /** Internal server error message */
    error: string;
}

/** Service unavailable model */
export class Service_unavailable implements IService_unavailable {
    /** Service unavailable message */
    error!: string;

    constructor(data?: IService_unavailable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Service_unavailable {
        data = typeof data === 'object' ? data : {};
        let result = new Service_unavailable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Service unavailable model */
export interface IService_unavailable {
    /** Service unavailable message */
    error: string;
}

/** Unauthorized model */
export class Unauthorized implements IUnauthorized {
    /** Unauthorized message */
    error!: string;

    constructor(data?: IUnauthorized) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Unauthorized {
        data = typeof data === 'object' ? data : {};
        let result = new Unauthorized();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Unauthorized model */
export interface IUnauthorized {
    /** Unauthorized message */
    error: string;
}

/** The server name you would like data from */
export enum Datasource {
    Tranquility = "tranquility",
}

/** mail object */
export class Post_characters_character_id_mail_mail implements IPost_characters_character_id_mail_mail {
    /** approved_cost integer */
    approved_cost?: number | undefined;
    /** body string */
    body!: string;
    /** recipients array */
    recipients!: Recipients[];
    /** subject string */
    subject!: string;

    constructor(data?: IPost_characters_character_id_mail_mail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.approved_cost = 0;
            this.recipients = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approved_cost = _data["approved_cost"] !== undefined ? _data["approved_cost"] : 0;
            this.body = _data["body"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(Recipients.fromJS(item));
            }
            this.subject = _data["subject"];
        }
    }

    static fromJS(data: any): Post_characters_character_id_mail_mail {
        data = typeof data === 'object' ? data : {};
        let result = new Post_characters_character_id_mail_mail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approved_cost"] = this.approved_cost;
        data["body"] = this.body;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        data["subject"] = this.subject;
        return data;
    }
}

/** mail object */
export interface IPost_characters_character_id_mail_mail {
    /** approved_cost integer */
    approved_cost?: number | undefined;
    /** body string */
    body: string;
    /** recipients array */
    recipients: Recipients[];
    /** subject string */
    subject: string;
}

/** contents object */
export class Put_characters_character_id_mail_mail_id_contents implements IPut_characters_character_id_mail_mail_id_contents {
    /** Labels to assign to the mail. Pre-existing labels are unassigned. */
    labels?: number[] | undefined;
    /** Whether the mail is flagged as read */
    read?: boolean | undefined;

    constructor(data?: IPut_characters_character_id_mail_mail_id_contents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            this.read = _data["read"];
        }
    }

    static fromJS(data: any): Put_characters_character_id_mail_mail_id_contents {
        data = typeof data === 'object' ? data : {};
        let result = new Put_characters_character_id_mail_mail_id_contents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        data["read"] = this.read;
        return data;
    }
}

/** contents object */
export interface IPut_characters_character_id_mail_mail_id_contents {
    /** Labels to assign to the mail. Pre-existing labels are unassigned. */
    labels?: number[] | undefined;
    /** Whether the mail is flagged as read */
    read?: boolean | undefined;
}

/** new_settings object */
export class Put_fleets_fleet_id_new_settings implements IPut_fleets_fleet_id_new_settings {
    /** Should free-move be enabled in the fleet */
    is_free_move?: boolean | undefined;
    /** New fleet MOTD in CCP flavoured HTML */
    motd?: string | undefined;

    constructor(data?: IPut_fleets_fleet_id_new_settings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.is_free_move = _data["is_free_move"];
            this.motd = _data["motd"];
        }
    }

    static fromJS(data: any): Put_fleets_fleet_id_new_settings {
        data = typeof data === 'object' ? data : {};
        let result = new Put_fleets_fleet_id_new_settings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["is_free_move"] = this.is_free_move;
        data["motd"] = this.motd;
        return data;
    }
}

/** new_settings object */
export interface IPut_fleets_fleet_id_new_settings {
    /** Should free-move be enabled in the fleet */
    is_free_move?: boolean | undefined;
    /** New fleet MOTD in CCP flavoured HTML */
    motd?: string | undefined;
}

/** Language to use in the response */
export enum AcceptLanguage {
    En = "en",
    EnUs = "en-us",
    De = "de",
    Fr = "fr",
    Ja = "ja",
    Ru = "ru",
    Zh = "zh",
    Ko = "ko",
    Es = "es",
}

/** Language to use in the response, takes precedence over Accept-Language */
export enum Language {
    En = "en",
    EnUs = "en-us",
    De = "de",
    Fr = "fr",
    Ja = "ja",
    Ru = "ru",
    Zh = "zh",
    Ko = "ko",
    Es = "es",
}

/** invitation object */
export class Post_fleets_fleet_id_members_invitation implements IPost_fleets_fleet_id_members_invitation {
    /** The character you want to invite */
    character_id!: number;
    /** If a character is invited with the `fleet_commander` role, neither `wing_id` or `squad_id` should be specified. If a character is invited with the `wing_commander` role, only `wing_id` should be specified. If a character is invited with the `squad_commander` role, both `wing_id` and `squad_id` should be specified. If a character is invited with the `squad_member` role, `wing_id` and `squad_id` should either both be specified or not specified at all. If they aren’t specified, the invited character will join any squad with available positions. */
    role!: Post_fleets_fleet_id_members_invitationRole;
    /** squad_id integer */
    squad_id?: number | undefined;
    /** wing_id integer */
    wing_id?: number | undefined;

    constructor(data?: IPost_fleets_fleet_id_members_invitation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.character_id = _data["character_id"];
            this.role = _data["role"];
            this.squad_id = _data["squad_id"];
            this.wing_id = _data["wing_id"];
        }
    }

    static fromJS(data: any): Post_fleets_fleet_id_members_invitation {
        data = typeof data === 'object' ? data : {};
        let result = new Post_fleets_fleet_id_members_invitation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["character_id"] = this.character_id;
        data["role"] = this.role;
        data["squad_id"] = this.squad_id;
        data["wing_id"] = this.wing_id;
        return data;
    }
}

/** invitation object */
export interface IPost_fleets_fleet_id_members_invitation {
    /** The character you want to invite */
    character_id: number;
    /** If a character is invited with the `fleet_commander` role, neither `wing_id` or `squad_id` should be specified. If a character is invited with the `wing_commander` role, only `wing_id` should be specified. If a character is invited with the `squad_commander` role, both `wing_id` and `squad_id` should be specified. If a character is invited with the `squad_member` role, `wing_id` and `squad_id` should either both be specified or not specified at all. If they aren’t specified, the invited character will join any squad with available positions. */
    role: Post_fleets_fleet_id_members_invitationRole;
    /** squad_id integer */
    squad_id?: number | undefined;
    /** wing_id integer */
    wing_id?: number | undefined;
}

/** movement object */
export class Put_fleets_fleet_id_members_member_id_movement implements IPut_fleets_fleet_id_members_member_id_movement {
    /** If a character is moved to the `fleet_commander` role, neither `wing_id` or `squad_id` should be specified. If a character is moved to the `wing_commander` role, only `wing_id` should be specified. If a character is moved to the `squad_commander` role, both `wing_id` and `squad_id` should be specified. If a character is moved to the `squad_member` role, both `wing_id` and `squad_id` should be specified. */
    role!: Put_fleets_fleet_id_members_member_id_movementRole;
    /** squad_id integer */
    squad_id?: number | undefined;
    /** wing_id integer */
    wing_id?: number | undefined;

    constructor(data?: IPut_fleets_fleet_id_members_member_id_movement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.squad_id = _data["squad_id"];
            this.wing_id = _data["wing_id"];
        }
    }

    static fromJS(data: any): Put_fleets_fleet_id_members_member_id_movement {
        data = typeof data === 'object' ? data : {};
        let result = new Put_fleets_fleet_id_members_member_id_movement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["squad_id"] = this.squad_id;
        data["wing_id"] = this.wing_id;
        return data;
    }
}

/** movement object */
export interface IPut_fleets_fleet_id_members_member_id_movement {
    /** If a character is moved to the `fleet_commander` role, neither `wing_id` or `squad_id` should be specified. If a character is moved to the `wing_commander` role, only `wing_id` should be specified. If a character is moved to the `squad_commander` role, both `wing_id` and `squad_id` should be specified. If a character is moved to the `squad_member` role, both `wing_id` and `squad_id` should be specified. */
    role: Put_fleets_fleet_id_members_member_id_movementRole;
    /** squad_id integer */
    squad_id?: number | undefined;
    /** wing_id integer */
    wing_id?: number | undefined;
}

/** naming object */
export class Put_fleets_fleet_id_squads_squad_id_naming implements IPut_fleets_fleet_id_squads_squad_id_naming {
    /** name string */
    name!: string;

    constructor(data?: IPut_fleets_fleet_id_squads_squad_id_naming) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Put_fleets_fleet_id_squads_squad_id_naming {
        data = typeof data === 'object' ? data : {};
        let result = new Put_fleets_fleet_id_squads_squad_id_naming();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

/** naming object */
export interface IPut_fleets_fleet_id_squads_squad_id_naming {
    /** name string */
    name: string;
}

/** naming object */
export class Put_fleets_fleet_id_wings_wing_id_naming implements IPut_fleets_fleet_id_wings_wing_id_naming {
    /** name string */
    name!: string;

    constructor(data?: IPut_fleets_fleet_id_wings_wing_id_naming) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Put_fleets_fleet_id_wings_wing_id_naming {
        data = typeof data === 'object' ? data : {};
        let result = new Put_fleets_fleet_id_wings_wing_id_naming();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

/** naming object */
export interface IPut_fleets_fleet_id_wings_wing_id_naming {
    /** name string */
    name: string;
}

/** Filter buy/sell orders, return all orders by default. If you query without type_id, we always return both buy and sell orders */
export enum Order_type {
    Buy = "buy",
    Sell = "sell",
    All = "all",
}

/** route security preference */
export enum Flag {
    Shortest = "shortest",
    Secure = "secure",
    Insecure = "insecure",
}

/** new_mail object */
export class Post_ui_openwindow_newmail_new_mail implements IPost_ui_openwindow_newmail_new_mail {
    /** body string */
    body!: string;
    /** recipients array */
    recipients!: number[];
    /** subject string */
    subject!: string;
    /** to_corp_or_alliance_id integer */
    to_corp_or_alliance_id?: number | undefined;
    /** Corporations, alliances and mailing lists are all types of mailing groups. You may only send to one mailing group, at a time, so you may fill out either this field or the to_corp_or_alliance_ids field */
    to_mailing_list_id?: number | undefined;

    constructor(data?: IPost_ui_openwindow_newmail_new_mail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.recipients = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.body = _data["body"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.subject = _data["subject"];
            this.to_corp_or_alliance_id = _data["to_corp_or_alliance_id"];
            this.to_mailing_list_id = _data["to_mailing_list_id"];
        }
    }

    static fromJS(data: any): Post_ui_openwindow_newmail_new_mail {
        data = typeof data === 'object' ? data : {};
        let result = new Post_ui_openwindow_newmail_new_mail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["subject"] = this.subject;
        data["to_corp_or_alliance_id"] = this.to_corp_or_alliance_id;
        data["to_mailing_list_id"] = this.to_mailing_list_id;
        return data;
    }
}

/** new_mail object */
export interface IPost_ui_openwindow_newmail_new_mail {
    /** body string */
    body: string;
    /** recipients array */
    recipients: number[];
    /** subject string */
    subject: string;
    /** to_corp_or_alliance_id integer */
    to_corp_or_alliance_id?: number | undefined;
    /** Corporations, alliances and mailing lists are all types of mailing groups. You may only send to one mailing group, at a time, so you may fill out either this field or the to_corp_or_alliance_ids field */
    to_mailing_list_id?: number | undefined;
}

/** Only list public structures that have this service online */
export enum Filter {
    Market = "market",
    Manufacturing_basic = "manufacturing_basic",
}

/** fitting object */
export class Post_characters_character_id_fittings_fitting implements IPost_characters_character_id_fittings_fitting {
    /** description string */
    description!: string;
    /** items array */
    items!: Items[];
    /** name string */
    name!: string;
    /** ship_type_id integer */
    ship_type_id!: number;

    constructor(data?: IPost_characters_character_id_fittings_fitting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Items.fromJS(item));
            }
            this.name = _data["name"];
            this.ship_type_id = _data["ship_type_id"];
        }
    }

    static fromJS(data: any): Post_characters_character_id_fittings_fitting {
        data = typeof data === 'object' ? data : {};
        let result = new Post_characters_character_id_fittings_fitting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["ship_type_id"] = this.ship_type_id;
        return data;
    }
}

/** fitting object */
export interface IPost_characters_character_id_fittings_fitting {
    /** description string */
    description: string;
    /** items array */
    items: Items[];
    /** name string */
    name: string;
    /** ship_type_id integer */
    ship_type_id: number;
}

/** label object */
export class Post_characters_character_id_mail_labels_label implements IPost_characters_character_id_mail_labels_label {
    /** Hexadecimal string representing label color, in RGB format */
    color?: Post_characters_character_id_mail_labels_labelColor | undefined;
    /** name string */
    name!: string;

    constructor(data?: IPost_characters_character_id_mail_labels_label) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.color = Post_characters_character_id_mail_labels_labelColor._ffffff;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"] !== undefined ? _data["color"] : Post_characters_character_id_mail_labels_labelColor._ffffff;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Post_characters_character_id_mail_labels_label {
        data = typeof data === 'object' ? data : {};
        let result = new Post_characters_character_id_mail_labels_label();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["name"] = this.name;
        return data;
    }
}

/** label object */
export interface IPost_characters_character_id_mail_labels_label {
    /** Hexadecimal string representing label color, in RGB format */
    color?: Post_characters_character_id_mail_labels_labelColor | undefined;
    /** name string */
    name: string;
}

/** response object */
export class Put_characters_character_id_calendar_event_id_response implements IPut_characters_character_id_calendar_event_id_response {
    /** response string */
    response!: Put_characters_character_id_calendar_event_id_responseResponse;

    constructor(data?: IPut_characters_character_id_calendar_event_id_response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.response = _data["response"];
        }
    }

    static fromJS(data: any): Put_characters_character_id_calendar_event_id_response {
        data = typeof data === 'object' ? data : {};
        let result = new Put_characters_character_id_calendar_event_id_response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response;
        return data;
    }
}

/** response object */
export interface IPut_characters_character_id_calendar_event_id_response {
    /** response string */
    response: Put_characters_character_id_calendar_event_id_responseResponse;
}

export enum Categories {
    Agent = "agent",
    Alliance = "alliance",
    Character = "character",
    Constellation = "constellation",
    Corporation = "corporation",
    Faction = "faction",
    Inventory_type = "inventory_type",
    Region = "region",
    Solar_system = "solar_system",
    Station = "station",
    Structure = "structure",
}

/** 200 ok object */
export class Get_alliances_alliance_id_contacts_labels_200_ok implements IGet_alliances_alliance_id_contacts_labels_200_ok {
    /** label_id integer */
    label_id!: number;
    /** label_name string */
    label_name!: string;

    constructor(data?: IGet_alliances_alliance_id_contacts_labels_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label_id = _data["label_id"];
            this.label_name = _data["label_name"];
        }
    }

    static fromJS(data: any): Get_alliances_alliance_id_contacts_labels_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_alliances_alliance_id_contacts_labels_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label_id"] = this.label_id;
        data["label_name"] = this.label_name;
        return data;
    }
}

/** 200 ok object */
export interface IGet_alliances_alliance_id_contacts_labels_200_ok {
    /** label_id integer */
    label_id: number;
    /** label_name string */
    label_name: string;
}

/** 200 ok object */
export class Get_alliances_alliance_id_icons_ok implements IGet_alliances_alliance_id_icons_ok {
    /** px128x128 string */
    px128x128?: string | undefined;
    /** px64x64 string */
    px64x64?: string | undefined;

    constructor(data?: IGet_alliances_alliance_id_icons_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.px128x128 = _data["px128x128"];
            this.px64x64 = _data["px64x64"];
        }
    }

    static fromJS(data: any): Get_alliances_alliance_id_icons_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_alliances_alliance_id_icons_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["px128x128"] = this.px128x128;
        data["px64x64"] = this.px64x64;
        return data;
    }
}

/** 200 ok object */
export interface IGet_alliances_alliance_id_icons_ok {
    /** px128x128 string */
    px128x128?: string | undefined;
    /** px64x64 string */
    px64x64?: string | undefined;
}

/** No image server for this datasource */
export class Get_alliances_alliance_id_icons_not_found implements IGet_alliances_alliance_id_icons_not_found {
    /** error message */
    error?: string | undefined;

    constructor(data?: IGet_alliances_alliance_id_icons_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_alliances_alliance_id_icons_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_alliances_alliance_id_icons_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** No image server for this datasource */
export interface IGet_alliances_alliance_id_icons_not_found {
    /** error message */
    error?: string | undefined;
}

/** 200 ok object */
export class Post_characters_character_id_assets_names_200_ok implements IPost_characters_character_id_assets_names_200_ok {
    /** item_id integer */
    item_id!: number;
    /** name string */
    name!: string;

    constructor(data?: IPost_characters_character_id_assets_names_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item_id = _data["item_id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Post_characters_character_id_assets_names_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Post_characters_character_id_assets_names_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item_id"] = this.item_id;
        data["name"] = this.name;
        return data;
    }
}

/** 200 ok object */
export interface IPost_characters_character_id_assets_names_200_ok {
    /** item_id integer */
    item_id: number;
    /** name string */
    name: string;
}

/** 200 ok object */
export class Get_characters_character_id_attributes_ok implements IGet_characters_character_id_attributes_ok {
    /** Neural remapping cooldown after a character uses remap accrued over time */
    accrued_remap_cooldown_date?: Date | undefined;
    /** Number of available bonus character neural remaps */
    bonus_remaps?: number | undefined;
    /** charisma integer */
    charisma!: number;
    /** intelligence integer */
    intelligence!: number;
    /** Datetime of last neural remap, including usage of bonus remaps */
    last_remap_date?: Date | undefined;
    /** memory integer */
    memory!: number;
    /** perception integer */
    perception!: number;
    /** willpower integer */
    willpower!: number;

    constructor(data?: IGet_characters_character_id_attributes_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accrued_remap_cooldown_date = _data["accrued_remap_cooldown_date"] ? new Date(_data["accrued_remap_cooldown_date"].toString()) : <any>undefined;
            this.bonus_remaps = _data["bonus_remaps"];
            this.charisma = _data["charisma"];
            this.intelligence = _data["intelligence"];
            this.last_remap_date = _data["last_remap_date"] ? new Date(_data["last_remap_date"].toString()) : <any>undefined;
            this.memory = _data["memory"];
            this.perception = _data["perception"];
            this.willpower = _data["willpower"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_attributes_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_attributes_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accrued_remap_cooldown_date"] = this.accrued_remap_cooldown_date ? this.accrued_remap_cooldown_date.toISOString() : <any>undefined;
        data["bonus_remaps"] = this.bonus_remaps;
        data["charisma"] = this.charisma;
        data["intelligence"] = this.intelligence;
        data["last_remap_date"] = this.last_remap_date ? this.last_remap_date.toISOString() : <any>undefined;
        data["memory"] = this.memory;
        data["perception"] = this.perception;
        data["willpower"] = this.willpower;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_attributes_ok {
    /** Neural remapping cooldown after a character uses remap accrued over time */
    accrued_remap_cooldown_date?: Date | undefined;
    /** Number of available bonus character neural remaps */
    bonus_remaps?: number | undefined;
    /** charisma integer */
    charisma: number;
    /** intelligence integer */
    intelligence: number;
    /** Datetime of last neural remap, including usage of bonus remaps */
    last_remap_date?: Date | undefined;
    /** memory integer */
    memory: number;
    /** perception integer */
    perception: number;
    /** willpower integer */
    willpower: number;
}

/** event */
export class Get_characters_character_id_calendar_200_ok implements IGet_characters_character_id_calendar_200_ok {
    /** event_date string */
    event_date?: Date | undefined;
    /** event_id integer */
    event_id?: number | undefined;
    /** event_response string */
    event_response?: Get_characters_character_id_calendar_200_okEvent_response | undefined;
    /** importance integer */
    importance?: number | undefined;
    /** title string */
    title?: string | undefined;

    constructor(data?: IGet_characters_character_id_calendar_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event_date = _data["event_date"] ? new Date(_data["event_date"].toString()) : <any>undefined;
            this.event_id = _data["event_id"];
            this.event_response = _data["event_response"];
            this.importance = _data["importance"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_calendar_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_calendar_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event_date"] = this.event_date ? this.event_date.toISOString() : <any>undefined;
        data["event_id"] = this.event_id;
        data["event_response"] = this.event_response;
        data["importance"] = this.importance;
        data["title"] = this.title;
        return data;
    }
}

/** event */
export interface IGet_characters_character_id_calendar_200_ok {
    /** event_date string */
    event_date?: Date | undefined;
    /** event_id integer */
    event_id?: number | undefined;
    /** event_response string */
    event_response?: Get_characters_character_id_calendar_200_okEvent_response | undefined;
    /** importance integer */
    importance?: number | undefined;
    /** title string */
    title?: string | undefined;
}

/** character_id and response of an attendee */
export class Get_characters_character_id_calendar_event_id_attendees_200_ok implements IGet_characters_character_id_calendar_event_id_attendees_200_ok {
    /** character_id integer */
    character_id?: number | undefined;
    /** event_response string */
    event_response?: Get_characters_character_id_calendar_event_id_attendees_200_okEvent_response | undefined;

    constructor(data?: IGet_characters_character_id_calendar_event_id_attendees_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.character_id = _data["character_id"];
            this.event_response = _data["event_response"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_calendar_event_id_attendees_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_calendar_event_id_attendees_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["character_id"] = this.character_id;
        data["event_response"] = this.event_response;
        return data;
    }
}

/** character_id and response of an attendee */
export interface IGet_characters_character_id_calendar_event_id_attendees_200_ok {
    /** character_id integer */
    character_id?: number | undefined;
    /** event_response string */
    event_response?: Get_characters_character_id_calendar_event_id_attendees_200_okEvent_response | undefined;
}

/** Not found */
export class Get_characters_character_id_calendar_event_id_attendees_not_found implements IGet_characters_character_id_calendar_event_id_attendees_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_characters_character_id_calendar_event_id_attendees_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_calendar_event_id_attendees_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_calendar_event_id_attendees_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_characters_character_id_calendar_event_id_attendees_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_contacts_labels_200_ok implements IGet_characters_character_id_contacts_labels_200_ok {
    /** label_id integer */
    label_id!: number;
    /** label_name string */
    label_name!: string;

    constructor(data?: IGet_characters_character_id_contacts_labels_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label_id = _data["label_id"];
            this.label_name = _data["label_name"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_contacts_labels_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_contacts_labels_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label_id"] = this.label_id;
        data["label_name"] = this.label_name;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_contacts_labels_200_ok {
    /** label_id integer */
    label_id: number;
    /** label_name string */
    label_name: string;
}

/** 200 ok object */
export class Get_characters_character_id_contracts_200_ok implements IGet_characters_character_id_contracts_200_ok {
    /** Who will accept the contract */
    acceptor_id!: number;
    /** ID to whom the contract is assigned, can be alliance, corporation or character ID */
    assignee_id!: number;
    /** To whom the contract is available */
    availability!: Get_characters_character_id_contracts_200_okAvailability;
    /** Buyout price (for Auctions only) */
    buyout?: number | undefined;
    /** Collateral price (for Couriers only) */
    collateral?: number | undefined;
    /** contract_id integer */
    contract_id!: number;
    /** Date of confirmation of contract */
    date_accepted?: Date | undefined;
    /** Date of completed of contract */
    date_completed?: Date | undefined;
    /** Expiration date of the contract */
    date_expired!: Date;
    /** Сreation date of the contract */
    date_issued!: Date;
    /** Number of days to perform the contract */
    days_to_complete?: number | undefined;
    /** End location ID (for Couriers contract) */
    end_location_id?: number | undefined;
    /** true if the contract was issued on behalf of the issuer's corporation */
    for_corporation!: boolean;
    /** Character's corporation ID for the issuer */
    issuer_corporation_id!: number;
    /** Character ID for the issuer */
    issuer_id!: number;
    /** Price of contract (for ItemsExchange and Auctions) */
    price?: number | undefined;
    /** Remuneration for contract (for Couriers only) */
    reward?: number | undefined;
    /** Start location ID (for Couriers contract) */
    start_location_id?: number | undefined;
    /** Status of the the contract */
    status!: Get_characters_character_id_contracts_200_okStatus;
    /** Title of the contract */
    title?: string | undefined;
    /** Type of the contract */
    type!: Get_characters_character_id_contracts_200_okType;
    /** Volume of items in the contract */
    volume?: number | undefined;

    constructor(data?: IGet_characters_character_id_contracts_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acceptor_id = _data["acceptor_id"];
            this.assignee_id = _data["assignee_id"];
            this.availability = _data["availability"];
            this.buyout = _data["buyout"];
            this.collateral = _data["collateral"];
            this.contract_id = _data["contract_id"];
            this.date_accepted = _data["date_accepted"] ? new Date(_data["date_accepted"].toString()) : <any>undefined;
            this.date_completed = _data["date_completed"] ? new Date(_data["date_completed"].toString()) : <any>undefined;
            this.date_expired = _data["date_expired"] ? new Date(_data["date_expired"].toString()) : <any>undefined;
            this.date_issued = _data["date_issued"] ? new Date(_data["date_issued"].toString()) : <any>undefined;
            this.days_to_complete = _data["days_to_complete"];
            this.end_location_id = _data["end_location_id"];
            this.for_corporation = _data["for_corporation"];
            this.issuer_corporation_id = _data["issuer_corporation_id"];
            this.issuer_id = _data["issuer_id"];
            this.price = _data["price"];
            this.reward = _data["reward"];
            this.start_location_id = _data["start_location_id"];
            this.status = _data["status"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_contracts_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_contracts_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acceptor_id"] = this.acceptor_id;
        data["assignee_id"] = this.assignee_id;
        data["availability"] = this.availability;
        data["buyout"] = this.buyout;
        data["collateral"] = this.collateral;
        data["contract_id"] = this.contract_id;
        data["date_accepted"] = this.date_accepted ? this.date_accepted.toISOString() : <any>undefined;
        data["date_completed"] = this.date_completed ? this.date_completed.toISOString() : <any>undefined;
        data["date_expired"] = this.date_expired ? this.date_expired.toISOString() : <any>undefined;
        data["date_issued"] = this.date_issued ? this.date_issued.toISOString() : <any>undefined;
        data["days_to_complete"] = this.days_to_complete;
        data["end_location_id"] = this.end_location_id;
        data["for_corporation"] = this.for_corporation;
        data["issuer_corporation_id"] = this.issuer_corporation_id;
        data["issuer_id"] = this.issuer_id;
        data["price"] = this.price;
        data["reward"] = this.reward;
        data["start_location_id"] = this.start_location_id;
        data["status"] = this.status;
        data["title"] = this.title;
        data["type"] = this.type;
        data["volume"] = this.volume;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_contracts_200_ok {
    /** Who will accept the contract */
    acceptor_id: number;
    /** ID to whom the contract is assigned, can be alliance, corporation or character ID */
    assignee_id: number;
    /** To whom the contract is available */
    availability: Get_characters_character_id_contracts_200_okAvailability;
    /** Buyout price (for Auctions only) */
    buyout?: number | undefined;
    /** Collateral price (for Couriers only) */
    collateral?: number | undefined;
    /** contract_id integer */
    contract_id: number;
    /** Date of confirmation of contract */
    date_accepted?: Date | undefined;
    /** Date of completed of contract */
    date_completed?: Date | undefined;
    /** Expiration date of the contract */
    date_expired: Date;
    /** Сreation date of the contract */
    date_issued: Date;
    /** Number of days to perform the contract */
    days_to_complete?: number | undefined;
    /** End location ID (for Couriers contract) */
    end_location_id?: number | undefined;
    /** true if the contract was issued on behalf of the issuer's corporation */
    for_corporation: boolean;
    /** Character's corporation ID for the issuer */
    issuer_corporation_id: number;
    /** Character ID for the issuer */
    issuer_id: number;
    /** Price of contract (for ItemsExchange and Auctions) */
    price?: number | undefined;
    /** Remuneration for contract (for Couriers only) */
    reward?: number | undefined;
    /** Start location ID (for Couriers contract) */
    start_location_id?: number | undefined;
    /** Status of the the contract */
    status: Get_characters_character_id_contracts_200_okStatus;
    /** Title of the contract */
    title?: string | undefined;
    /** Type of the contract */
    type: Get_characters_character_id_contracts_200_okType;
    /** Volume of items in the contract */
    volume?: number | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_contracts_contract_id_bids_200_ok implements IGet_characters_character_id_contracts_contract_id_bids_200_ok {
    /** The amount bid, in ISK */
    amount!: number;
    /** Unique ID for the bid */
    bid_id!: number;
    /** Character ID of the bidder */
    bidder_id!: number;
    /** Datetime when the bid was placed */
    date_bid!: Date;

    constructor(data?: IGet_characters_character_id_contracts_contract_id_bids_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.bid_id = _data["bid_id"];
            this.bidder_id = _data["bidder_id"];
            this.date_bid = _data["date_bid"] ? new Date(_data["date_bid"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_characters_character_id_contracts_contract_id_bids_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_contracts_contract_id_bids_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["bid_id"] = this.bid_id;
        data["bidder_id"] = this.bidder_id;
        data["date_bid"] = this.date_bid ? this.date_bid.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_contracts_contract_id_bids_200_ok {
    /** The amount bid, in ISK */
    amount: number;
    /** Unique ID for the bid */
    bid_id: number;
    /** Character ID of the bidder */
    bidder_id: number;
    /** Datetime when the bid was placed */
    date_bid: Date;
}

/** Not found */
export class Get_characters_character_id_contracts_contract_id_bids_not_found implements IGet_characters_character_id_contracts_contract_id_bids_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_characters_character_id_contracts_contract_id_bids_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_contracts_contract_id_bids_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_contracts_contract_id_bids_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_characters_character_id_contracts_contract_id_bids_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_contracts_contract_id_items_200_ok implements IGet_characters_character_id_contracts_contract_id_items_200_ok {
    /** true if the contract issuer has submitted this item with the contract, false if the isser is asking for this item in the contract */
    is_included!: boolean;
    /** is_singleton boolean */
    is_singleton!: boolean;
    /** Number of items in the stack */
    quantity!: number;
    /** -1 indicates that the item is a singleton (non-stackable). If the item happens to be a Blueprint, -1 is an Original and -2 is a Blueprint Copy */
    raw_quantity?: number | undefined;
    /** Unique ID for the item */
    record_id!: number;
    /** Type ID for item */
    type_id!: number;

    constructor(data?: IGet_characters_character_id_contracts_contract_id_items_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.is_included = _data["is_included"];
            this.is_singleton = _data["is_singleton"];
            this.quantity = _data["quantity"];
            this.raw_quantity = _data["raw_quantity"];
            this.record_id = _data["record_id"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_contracts_contract_id_items_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_contracts_contract_id_items_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["is_included"] = this.is_included;
        data["is_singleton"] = this.is_singleton;
        data["quantity"] = this.quantity;
        data["raw_quantity"] = this.raw_quantity;
        data["record_id"] = this.record_id;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_contracts_contract_id_items_200_ok {
    /** true if the contract issuer has submitted this item with the contract, false if the isser is asking for this item in the contract */
    is_included: boolean;
    /** is_singleton boolean */
    is_singleton: boolean;
    /** Number of items in the stack */
    quantity: number;
    /** -1 indicates that the item is a singleton (non-stackable). If the item happens to be a Blueprint, -1 is an Original and -2 is a Blueprint Copy */
    raw_quantity?: number | undefined;
    /** Unique ID for the item */
    record_id: number;
    /** Type ID for item */
    type_id: number;
}

/** Not found */
export class Get_characters_character_id_contracts_contract_id_items_not_found implements IGet_characters_character_id_contracts_contract_id_items_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_characters_character_id_contracts_contract_id_items_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_contracts_contract_id_items_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_contracts_contract_id_items_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_characters_character_id_contracts_contract_id_items_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_fleet_ok implements IGet_characters_character_id_fleet_ok {
    /** The character's current fleet ID */
    fleet_id!: number;
    /** Member’s role in fleet */
    role!: Get_characters_character_id_fleet_okRole;
    /** ID of the squad the member is in. If not applicable, will be set to -1 */
    squad_id!: number;
    /** ID of the wing the member is in. If not applicable, will be set to -1 */
    wing_id!: number;

    constructor(data?: IGet_characters_character_id_fleet_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fleet_id = _data["fleet_id"];
            this.role = _data["role"];
            this.squad_id = _data["squad_id"];
            this.wing_id = _data["wing_id"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_fleet_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_fleet_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fleet_id"] = this.fleet_id;
        data["role"] = this.role;
        data["squad_id"] = this.squad_id;
        data["wing_id"] = this.wing_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_fleet_ok {
    /** The character's current fleet ID */
    fleet_id: number;
    /** Member’s role in fleet */
    role: Get_characters_character_id_fleet_okRole;
    /** ID of the squad the member is in. If not applicable, will be set to -1 */
    squad_id: number;
    /** ID of the wing the member is in. If not applicable, will be set to -1 */
    wing_id: number;
}

/** Not found */
export class Get_characters_character_id_fleet_not_found implements IGet_characters_character_id_fleet_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_characters_character_id_fleet_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_fleet_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_fleet_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_characters_character_id_fleet_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_fw_stats_ok implements IGet_characters_character_id_fw_stats_ok {
    /** The given character's current faction rank */
    current_rank?: number | undefined;
    /** The enlistment date of the given character into faction warfare. Will not be included if character is not enlisted in faction warfare */
    enlisted_on?: Date | undefined;
    /** The faction the given character is enlisted to fight for. Will not be included if character is not enlisted in faction warfare */
    faction_id?: number | undefined;
    /** The given character's highest faction rank achieved */
    highest_rank?: number | undefined;
    /** Summary of kills done by the given character against enemy factions */
    kills!: Kills;
    /** Summary of victory points gained by the given character for the enlisted faction */
    victory_points!: Victory_points;

    constructor(data?: IGet_characters_character_id_fw_stats_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.kills = new Kills();
            this.victory_points = new Victory_points();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.current_rank = _data["current_rank"];
            this.enlisted_on = _data["enlisted_on"] ? new Date(_data["enlisted_on"].toString()) : <any>undefined;
            this.faction_id = _data["faction_id"];
            this.highest_rank = _data["highest_rank"];
            this.kills = _data["kills"] ? Kills.fromJS(_data["kills"]) : new Kills();
            this.victory_points = _data["victory_points"] ? Victory_points.fromJS(_data["victory_points"]) : new Victory_points();
        }
    }

    static fromJS(data: any): Get_characters_character_id_fw_stats_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_fw_stats_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current_rank"] = this.current_rank;
        data["enlisted_on"] = this.enlisted_on ? this.enlisted_on.toISOString() : <any>undefined;
        data["faction_id"] = this.faction_id;
        data["highest_rank"] = this.highest_rank;
        data["kills"] = this.kills ? this.kills.toJSON() : <any>undefined;
        data["victory_points"] = this.victory_points ? this.victory_points.toJSON() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_fw_stats_ok {
    /** The given character's current faction rank */
    current_rank?: number | undefined;
    /** The enlistment date of the given character into faction warfare. Will not be included if character is not enlisted in faction warfare */
    enlisted_on?: Date | undefined;
    /** The faction the given character is enlisted to fight for. Will not be included if character is not enlisted in faction warfare */
    faction_id?: number | undefined;
    /** The given character's highest faction rank achieved */
    highest_rank?: number | undefined;
    /** Summary of kills done by the given character against enemy factions */
    kills: Kills;
    /** Summary of victory points gained by the given character for the enlisted faction */
    victory_points: Victory_points;
}

/** 200 ok object */
export class Get_characters_character_id_industry_jobs_200_ok implements IGet_characters_character_id_industry_jobs_200_ok {
    /** Job activity ID */
    activity_id!: number;
    /** blueprint_id integer */
    blueprint_id!: number;
    /** Location ID of the location from which the blueprint was installed. Normally a station ID, but can also be an asset (e.g. container) or corporation facility */
    blueprint_location_id!: number;
    /** blueprint_type_id integer */
    blueprint_type_id!: number;
    /** ID of the character which completed this job */
    completed_character_id?: number | undefined;
    /** Date and time when this job was completed */
    completed_date?: Date | undefined;
    /** The sume of job installation fee and industry facility tax */
    cost?: number | undefined;
    /** Job duration in seconds */
    duration!: number;
    /** Date and time when this job finished */
    end_date!: Date;
    /** ID of the facility where this job is running */
    facility_id!: number;
    /** ID of the character which installed this job */
    installer_id!: number;
    /** Unique job ID */
    job_id!: number;
    /** Number of runs blueprint is licensed for */
    licensed_runs?: number | undefined;
    /** Location ID of the location to which the output of the job will be delivered. Normally a station ID, but can also be a corporation facility */
    output_location_id!: number;
    /** Date and time when this job was paused (i.e. time when the facility where this job was installed went offline) */
    pause_date?: Date | undefined;
    /** Chance of success for invention */
    probability?: number | undefined;
    /** Type ID of product (manufactured, copied or invented) */
    product_type_id?: number | undefined;
    /** Number of runs for a manufacturing job, or number of copies to make for a blueprint copy */
    runs!: number;
    /** Date and time when this job started */
    start_date!: Date;
    /** ID of the station where industry facility is located */
    station_id!: number;
    /** status string */
    status!: Get_characters_character_id_industry_jobs_200_okStatus;
    /** Number of successful runs for this job. Equal to runs unless this is an invention job */
    successful_runs?: number | undefined;

    constructor(data?: IGet_characters_character_id_industry_jobs_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity_id = _data["activity_id"];
            this.blueprint_id = _data["blueprint_id"];
            this.blueprint_location_id = _data["blueprint_location_id"];
            this.blueprint_type_id = _data["blueprint_type_id"];
            this.completed_character_id = _data["completed_character_id"];
            this.completed_date = _data["completed_date"] ? new Date(_data["completed_date"].toString()) : <any>undefined;
            this.cost = _data["cost"];
            this.duration = _data["duration"];
            this.end_date = _data["end_date"] ? new Date(_data["end_date"].toString()) : <any>undefined;
            this.facility_id = _data["facility_id"];
            this.installer_id = _data["installer_id"];
            this.job_id = _data["job_id"];
            this.licensed_runs = _data["licensed_runs"];
            this.output_location_id = _data["output_location_id"];
            this.pause_date = _data["pause_date"] ? new Date(_data["pause_date"].toString()) : <any>undefined;
            this.probability = _data["probability"];
            this.product_type_id = _data["product_type_id"];
            this.runs = _data["runs"];
            this.start_date = _data["start_date"] ? new Date(_data["start_date"].toString()) : <any>undefined;
            this.station_id = _data["station_id"];
            this.status = _data["status"];
            this.successful_runs = _data["successful_runs"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_industry_jobs_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_industry_jobs_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity_id"] = this.activity_id;
        data["blueprint_id"] = this.blueprint_id;
        data["blueprint_location_id"] = this.blueprint_location_id;
        data["blueprint_type_id"] = this.blueprint_type_id;
        data["completed_character_id"] = this.completed_character_id;
        data["completed_date"] = this.completed_date ? this.completed_date.toISOString() : <any>undefined;
        data["cost"] = this.cost;
        data["duration"] = this.duration;
        data["end_date"] = this.end_date ? this.end_date.toISOString() : <any>undefined;
        data["facility_id"] = this.facility_id;
        data["installer_id"] = this.installer_id;
        data["job_id"] = this.job_id;
        data["licensed_runs"] = this.licensed_runs;
        data["output_location_id"] = this.output_location_id;
        data["pause_date"] = this.pause_date ? this.pause_date.toISOString() : <any>undefined;
        data["probability"] = this.probability;
        data["product_type_id"] = this.product_type_id;
        data["runs"] = this.runs;
        data["start_date"] = this.start_date ? this.start_date.toISOString() : <any>undefined;
        data["station_id"] = this.station_id;
        data["status"] = this.status;
        data["successful_runs"] = this.successful_runs;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_industry_jobs_200_ok {
    /** Job activity ID */
    activity_id: number;
    /** blueprint_id integer */
    blueprint_id: number;
    /** Location ID of the location from which the blueprint was installed. Normally a station ID, but can also be an asset (e.g. container) or corporation facility */
    blueprint_location_id: number;
    /** blueprint_type_id integer */
    blueprint_type_id: number;
    /** ID of the character which completed this job */
    completed_character_id?: number | undefined;
    /** Date and time when this job was completed */
    completed_date?: Date | undefined;
    /** The sume of job installation fee and industry facility tax */
    cost?: number | undefined;
    /** Job duration in seconds */
    duration: number;
    /** Date and time when this job finished */
    end_date: Date;
    /** ID of the facility where this job is running */
    facility_id: number;
    /** ID of the character which installed this job */
    installer_id: number;
    /** Unique job ID */
    job_id: number;
    /** Number of runs blueprint is licensed for */
    licensed_runs?: number | undefined;
    /** Location ID of the location to which the output of the job will be delivered. Normally a station ID, but can also be a corporation facility */
    output_location_id: number;
    /** Date and time when this job was paused (i.e. time when the facility where this job was installed went offline) */
    pause_date?: Date | undefined;
    /** Chance of success for invention */
    probability?: number | undefined;
    /** Type ID of product (manufactured, copied or invented) */
    product_type_id?: number | undefined;
    /** Number of runs for a manufacturing job, or number of copies to make for a blueprint copy */
    runs: number;
    /** Date and time when this job started */
    start_date: Date;
    /** ID of the station where industry facility is located */
    station_id: number;
    /** status string */
    status: Get_characters_character_id_industry_jobs_200_okStatus;
    /** Number of successful runs for this job. Equal to runs unless this is an invention job */
    successful_runs?: number | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_killmails_recent_200_ok implements IGet_characters_character_id_killmails_recent_200_ok {
    /** A hash of this killmail */
    killmail_hash!: string;
    /** ID of this killmail */
    killmail_id!: number;

    constructor(data?: IGet_characters_character_id_killmails_recent_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.killmail_hash = _data["killmail_hash"];
            this.killmail_id = _data["killmail_id"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_killmails_recent_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_killmails_recent_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["killmail_hash"] = this.killmail_hash;
        data["killmail_id"] = this.killmail_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_killmails_recent_200_ok {
    /** A hash of this killmail */
    killmail_hash: string;
    /** ID of this killmail */
    killmail_id: number;
}

/** 200 ok object */
export class Get_characters_character_id_location_ok implements IGet_characters_character_id_location_ok {
    /** solar_system_id integer */
    solar_system_id!: number;
    /** station_id integer */
    station_id?: number | undefined;
    /** structure_id integer */
    structure_id?: number | undefined;

    constructor(data?: IGet_characters_character_id_location_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solar_system_id = _data["solar_system_id"];
            this.station_id = _data["station_id"];
            this.structure_id = _data["structure_id"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_location_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_location_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solar_system_id"] = this.solar_system_id;
        data["station_id"] = this.station_id;
        data["structure_id"] = this.structure_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_location_ok {
    /** solar_system_id integer */
    solar_system_id: number;
    /** station_id integer */
    station_id?: number | undefined;
    /** structure_id integer */
    structure_id?: number | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_loyalty_points_200_ok implements IGet_characters_character_id_loyalty_points_200_ok {
    /** corporation_id integer */
    corporation_id!: number;
    /** loyalty_points integer */
    loyalty_points!: number;

    constructor(data?: IGet_characters_character_id_loyalty_points_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporation_id = _data["corporation_id"];
            this.loyalty_points = _data["loyalty_points"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_loyalty_points_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_loyalty_points_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corporation_id"] = this.corporation_id;
        data["loyalty_points"] = this.loyalty_points;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_loyalty_points_200_ok {
    /** corporation_id integer */
    corporation_id: number;
    /** loyalty_points integer */
    loyalty_points: number;
}

/** 200 ok object */
export class Get_characters_character_id_mail_200_ok implements IGet_characters_character_id_mail_200_ok {
    /** From whom the mail was sent */
    from?: number | undefined;
    /** is_read boolean */
    is_read?: boolean | undefined;
    /** labels array */
    labels?: number[] | undefined;
    /** mail_id integer */
    mail_id?: number | undefined;
    /** Recipients of the mail */
    recipients?: Recipients2[] | undefined;
    /** Mail subject */
    subject?: string | undefined;
    /** When the mail was sent */
    timestamp?: Date | undefined;

    constructor(data?: IGet_characters_character_id_mail_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.is_read = _data["is_read"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            this.mail_id = _data["mail_id"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(Recipients2.fromJS(item));
            }
            this.subject = _data["subject"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_characters_character_id_mail_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_mail_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["is_read"] = this.is_read;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        data["mail_id"] = this.mail_id;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        data["subject"] = this.subject;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_mail_200_ok {
    /** From whom the mail was sent */
    from?: number | undefined;
    /** is_read boolean */
    is_read?: boolean | undefined;
    /** labels array */
    labels?: number[] | undefined;
    /** mail_id integer */
    mail_id?: number | undefined;
    /** Recipients of the mail */
    recipients?: Recipients2[] | undefined;
    /** Mail subject */
    subject?: string | undefined;
    /** When the mail was sent */
    timestamp?: Date | undefined;
}

/** Error 520 */
export class Post_characters_character_id_mail_error_520 implements IPost_characters_character_id_mail_error_520 {
    /** Error 520 message */
    error?: string | undefined;

    constructor(data?: IPost_characters_character_id_mail_error_520) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Post_characters_character_id_mail_error_520 {
        data = typeof data === 'object' ? data : {};
        let result = new Post_characters_character_id_mail_error_520();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Error 520 */
export interface IPost_characters_character_id_mail_error_520 {
    /** Error 520 message */
    error?: string | undefined;
}

/** Unprocessable entity */
export class Delete_characters_character_id_mail_labels_label_id_unprocessable_entity implements IDelete_characters_character_id_mail_labels_label_id_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;

    constructor(data?: IDelete_characters_character_id_mail_labels_label_id_unprocessable_entity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Delete_characters_character_id_mail_labels_label_id_unprocessable_entity {
        data = typeof data === 'object' ? data : {};
        let result = new Delete_characters_character_id_mail_labels_label_id_unprocessable_entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Unprocessable entity */
export interface IDelete_characters_character_id_mail_labels_label_id_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_mail_lists_200_ok implements IGet_characters_character_id_mail_lists_200_ok {
    /** Mailing list ID */
    mailing_list_id!: number;
    /** name string */
    name!: string;

    constructor(data?: IGet_characters_character_id_mail_lists_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailing_list_id = _data["mailing_list_id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_mail_lists_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_mail_lists_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailing_list_id"] = this.mailing_list_id;
        data["name"] = this.name;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_mail_lists_200_ok {
    /** Mailing list ID */
    mailing_list_id: number;
    /** name string */
    name: string;
}

/** 200 ok object */
export class Get_characters_character_id_mail_mail_id_ok implements IGet_characters_character_id_mail_mail_id_ok {
    /** Mail's body */
    body?: string | undefined;
    /** From whom the mail was sent */
    from?: number | undefined;
    /** Labels attached to the mail */
    labels?: number[] | undefined;
    /** Whether the mail is flagged as read */
    read?: boolean | undefined;
    /** Recipients of the mail */
    recipients?: Recipients3[] | undefined;
    /** Mail subject */
    subject?: string | undefined;
    /** When the mail was sent */
    timestamp?: Date | undefined;

    constructor(data?: IGet_characters_character_id_mail_mail_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.body = _data["body"];
            this.from = _data["from"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            this.read = _data["read"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(Recipients3.fromJS(item));
            }
            this.subject = _data["subject"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_characters_character_id_mail_mail_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_mail_mail_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        data["from"] = this.from;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        data["read"] = this.read;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        data["subject"] = this.subject;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_mail_mail_id_ok {
    /** Mail's body */
    body?: string | undefined;
    /** From whom the mail was sent */
    from?: number | undefined;
    /** Labels attached to the mail */
    labels?: number[] | undefined;
    /** Whether the mail is flagged as read */
    read?: boolean | undefined;
    /** Recipients of the mail */
    recipients?: Recipients3[] | undefined;
    /** Mail subject */
    subject?: string | undefined;
    /** When the mail was sent */
    timestamp?: Date | undefined;
}

/** Not found */
export class Get_characters_character_id_mail_mail_id_not_found implements IGet_characters_character_id_mail_mail_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_characters_character_id_mail_mail_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_mail_mail_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_mail_mail_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_characters_character_id_mail_mail_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_mining_200_ok implements IGet_characters_character_id_mining_200_ok {
    /** date string */
    date!: Date;
    /** quantity integer */
    quantity!: number;
    /** solar_system_id integer */
    solar_system_id!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_characters_character_id_mining_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.solar_system_id = _data["solar_system_id"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_mining_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_mining_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["quantity"] = this.quantity;
        data["solar_system_id"] = this.solar_system_id;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_mining_200_ok {
    /** date string */
    date: Date;
    /** quantity integer */
    quantity: number;
    /** solar_system_id integer */
    solar_system_id: number;
    /** type_id integer */
    type_id: number;
}

/** 200 ok object */
export class Get_characters_character_id_opportunities_200_ok implements IGet_characters_character_id_opportunities_200_ok {
    /** completed_at string */
    completed_at!: Date;
    /** task_id integer */
    task_id!: number;

    constructor(data?: IGet_characters_character_id_opportunities_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completed_at = _data["completed_at"] ? new Date(_data["completed_at"].toString()) : <any>undefined;
            this.task_id = _data["task_id"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_opportunities_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_opportunities_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completed_at"] = this.completed_at ? this.completed_at.toISOString() : <any>undefined;
        data["task_id"] = this.task_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_opportunities_200_ok {
    /** completed_at string */
    completed_at: Date;
    /** task_id integer */
    task_id: number;
}

/** 200 ok object */
export class Get_characters_character_id_orders_history_200_ok implements IGet_characters_character_id_orders_history_200_ok {
    /** Number of days the order was valid for (starting from the issued date). An order expires at time issued + duration */
    duration!: number;
    /** For buy orders, the amount of ISK in escrow */
    escrow?: number | undefined;
    /** True if the order is a bid (buy) order */
    is_buy_order?: boolean | undefined;
    /** Signifies whether the buy/sell order was placed on behalf of a corporation. */
    is_corporation!: boolean;
    /** Date and time when this order was issued */
    issued!: Date;
    /** ID of the location where order was placed */
    location_id!: number;
    /** For buy orders, the minimum quantity that will be accepted in a matching sell order */
    min_volume?: number | undefined;
    /** Unique order ID */
    order_id!: number;
    /** Cost per unit for this order */
    price!: number;
    /** Valid order range, numbers are ranges in jumps */
    range!: Get_characters_character_id_orders_history_200_okRange;
    /** ID of the region where order was placed */
    region_id!: number;
    /** Current order state */
    state!: Get_characters_character_id_orders_history_200_okState;
    /** The type ID of the item transacted in this order */
    type_id!: number;
    /** Quantity of items still required or offered */
    volume_remain!: number;
    /** Quantity of items required or offered at time order was placed */
    volume_total!: number;

    constructor(data?: IGet_characters_character_id_orders_history_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
            this.escrow = _data["escrow"];
            this.is_buy_order = _data["is_buy_order"];
            this.is_corporation = _data["is_corporation"];
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : <any>undefined;
            this.location_id = _data["location_id"];
            this.min_volume = _data["min_volume"];
            this.order_id = _data["order_id"];
            this.price = _data["price"];
            this.range = _data["range"];
            this.region_id = _data["region_id"];
            this.state = _data["state"];
            this.type_id = _data["type_id"];
            this.volume_remain = _data["volume_remain"];
            this.volume_total = _data["volume_total"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_orders_history_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_orders_history_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["escrow"] = this.escrow;
        data["is_buy_order"] = this.is_buy_order;
        data["is_corporation"] = this.is_corporation;
        data["issued"] = this.issued ? this.issued.toISOString() : <any>undefined;
        data["location_id"] = this.location_id;
        data["min_volume"] = this.min_volume;
        data["order_id"] = this.order_id;
        data["price"] = this.price;
        data["range"] = this.range;
        data["region_id"] = this.region_id;
        data["state"] = this.state;
        data["type_id"] = this.type_id;
        data["volume_remain"] = this.volume_remain;
        data["volume_total"] = this.volume_total;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_orders_history_200_ok {
    /** Number of days the order was valid for (starting from the issued date). An order expires at time issued + duration */
    duration: number;
    /** For buy orders, the amount of ISK in escrow */
    escrow?: number | undefined;
    /** True if the order is a bid (buy) order */
    is_buy_order?: boolean | undefined;
    /** Signifies whether the buy/sell order was placed on behalf of a corporation. */
    is_corporation: boolean;
    /** Date and time when this order was issued */
    issued: Date;
    /** ID of the location where order was placed */
    location_id: number;
    /** For buy orders, the minimum quantity that will be accepted in a matching sell order */
    min_volume?: number | undefined;
    /** Unique order ID */
    order_id: number;
    /** Cost per unit for this order */
    price: number;
    /** Valid order range, numbers are ranges in jumps */
    range: Get_characters_character_id_orders_history_200_okRange;
    /** ID of the region where order was placed */
    region_id: number;
    /** Current order state */
    state: Get_characters_character_id_orders_history_200_okState;
    /** The type ID of the item transacted in this order */
    type_id: number;
    /** Quantity of items still required or offered */
    volume_remain: number;
    /** Quantity of items required or offered at time order was placed */
    volume_total: number;
}

/** 200 ok object */
export class Get_characters_character_id_planets_200_ok implements IGet_characters_character_id_planets_200_ok {
    /** last_update string */
    last_update!: Date;
    /** num_pins integer */
    num_pins!: number;
    /** owner_id integer */
    owner_id!: number;
    /** planet_id integer */
    planet_id!: number;
    /** planet_type string */
    planet_type!: Get_characters_character_id_planets_200_okPlanet_type;
    /** solar_system_id integer */
    solar_system_id!: number;
    /** upgrade_level integer */
    upgrade_level!: number;

    constructor(data?: IGet_characters_character_id_planets_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last_update = _data["last_update"] ? new Date(_data["last_update"].toString()) : <any>undefined;
            this.num_pins = _data["num_pins"];
            this.owner_id = _data["owner_id"];
            this.planet_id = _data["planet_id"];
            this.planet_type = _data["planet_type"];
            this.solar_system_id = _data["solar_system_id"];
            this.upgrade_level = _data["upgrade_level"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_planets_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_planets_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last_update"] = this.last_update ? this.last_update.toISOString() : <any>undefined;
        data["num_pins"] = this.num_pins;
        data["owner_id"] = this.owner_id;
        data["planet_id"] = this.planet_id;
        data["planet_type"] = this.planet_type;
        data["solar_system_id"] = this.solar_system_id;
        data["upgrade_level"] = this.upgrade_level;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_planets_200_ok {
    /** last_update string */
    last_update: Date;
    /** num_pins integer */
    num_pins: number;
    /** owner_id integer */
    owner_id: number;
    /** planet_id integer */
    planet_id: number;
    /** planet_type string */
    planet_type: Get_characters_character_id_planets_200_okPlanet_type;
    /** solar_system_id integer */
    solar_system_id: number;
    /** upgrade_level integer */
    upgrade_level: number;
}

/** 200 ok object */
export class Get_characters_character_id_ship_ok implements IGet_characters_character_id_ship_ok {
    /** Item id's are unique to a ship and persist until it is repackaged. This value can be used to track repeated uses of a ship, or detect when a pilot changes into a different instance of the same ship type. */
    ship_item_id!: number;
    /** ship_name string */
    ship_name!: string;
    /** ship_type_id integer */
    ship_type_id!: number;

    constructor(data?: IGet_characters_character_id_ship_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ship_item_id = _data["ship_item_id"];
            this.ship_name = _data["ship_name"];
            this.ship_type_id = _data["ship_type_id"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_ship_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_ship_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ship_item_id"] = this.ship_item_id;
        data["ship_name"] = this.ship_name;
        data["ship_type_id"] = this.ship_type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_ship_ok {
    /** Item id's are unique to a ship and persist until it is repackaged. This value can be used to track repeated uses of a ship, or detect when a pilot changes into a different instance of the same ship type. */
    ship_item_id: number;
    /** ship_name string */
    ship_name: string;
    /** ship_type_id integer */
    ship_type_id: number;
}

/** wallet transaction */
export class Get_characters_character_id_wallet_transactions_200_ok implements IGet_characters_character_id_wallet_transactions_200_ok {
    /** client_id integer */
    client_id!: number;
    /** Date and time of transaction */
    date!: Date;
    /** is_buy boolean */
    is_buy!: boolean;
    /** is_personal boolean */
    is_personal!: boolean;
    /** journal_ref_id integer */
    journal_ref_id!: number;
    /** location_id integer */
    location_id!: number;
    /** quantity integer */
    quantity!: number;
    /** Unique transaction ID */
    transaction_id!: number;
    /** type_id integer */
    type_id!: number;
    /** Amount paid per unit */
    unit_price!: number;

    constructor(data?: IGet_characters_character_id_wallet_transactions_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client_id = _data["client_id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.is_buy = _data["is_buy"];
            this.is_personal = _data["is_personal"];
            this.journal_ref_id = _data["journal_ref_id"];
            this.location_id = _data["location_id"];
            this.quantity = _data["quantity"];
            this.transaction_id = _data["transaction_id"];
            this.type_id = _data["type_id"];
            this.unit_price = _data["unit_price"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_wallet_transactions_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_wallet_transactions_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client_id"] = this.client_id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["is_buy"] = this.is_buy;
        data["is_personal"] = this.is_personal;
        data["journal_ref_id"] = this.journal_ref_id;
        data["location_id"] = this.location_id;
        data["quantity"] = this.quantity;
        data["transaction_id"] = this.transaction_id;
        data["type_id"] = this.type_id;
        data["unit_price"] = this.unit_price;
        return data;
    }
}

/** wallet transaction */
export interface IGet_characters_character_id_wallet_transactions_200_ok {
    /** client_id integer */
    client_id: number;
    /** Date and time of transaction */
    date: Date;
    /** is_buy boolean */
    is_buy: boolean;
    /** is_personal boolean */
    is_personal: boolean;
    /** journal_ref_id integer */
    journal_ref_id: number;
    /** location_id integer */
    location_id: number;
    /** quantity integer */
    quantity: number;
    /** Unique transaction ID */
    transaction_id: number;
    /** type_id integer */
    type_id: number;
    /** Amount paid per unit */
    unit_price: number;
}

/** 200 ok object */
export class Get_contracts_public_bids_contract_id_200_ok implements IGet_contracts_public_bids_contract_id_200_ok {
    /** The amount bid, in ISK */
    amount!: number;
    /** Unique ID for the bid */
    bid_id!: number;
    /** Datetime when the bid was placed */
    date_bid!: Date;

    constructor(data?: IGet_contracts_public_bids_contract_id_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.bid_id = _data["bid_id"];
            this.date_bid = _data["date_bid"] ? new Date(_data["date_bid"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_contracts_public_bids_contract_id_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_contracts_public_bids_contract_id_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["bid_id"] = this.bid_id;
        data["date_bid"] = this.date_bid ? this.date_bid.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_contracts_public_bids_contract_id_200_ok {
    /** The amount bid, in ISK */
    amount: number;
    /** Unique ID for the bid */
    bid_id: number;
    /** Datetime when the bid was placed */
    date_bid: Date;
}

/** Forbidden */
export class Get_contracts_public_bids_contract_id_forbidden implements IGet_contracts_public_bids_contract_id_forbidden {
    /** Forbidden message */
    error?: string | undefined;

    constructor(data?: IGet_contracts_public_bids_contract_id_forbidden) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_contracts_public_bids_contract_id_forbidden {
        data = typeof data === 'object' ? data : {};
        let result = new Get_contracts_public_bids_contract_id_forbidden();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Forbidden */
export interface IGet_contracts_public_bids_contract_id_forbidden {
    /** Forbidden message */
    error?: string | undefined;
}

/** Not found */
export class Get_contracts_public_bids_contract_id_not_found implements IGet_contracts_public_bids_contract_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_contracts_public_bids_contract_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_contracts_public_bids_contract_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_contracts_public_bids_contract_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_contracts_public_bids_contract_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_contracts_public_items_contract_id_200_ok implements IGet_contracts_public_items_contract_id_200_ok {
    /** is_blueprint_copy boolean */
    is_blueprint_copy?: boolean | undefined;
    /** true if the contract issuer has submitted this item with the contract, false if the isser is asking for this item in the contract */
    is_included!: boolean;
    /** Unique ID for the item being sold. Not present if item is being requested by contract rather than sold with contract */
    item_id?: number | undefined;
    /** Material Efficiency Level of the blueprint */
    material_efficiency?: number | undefined;
    /** Number of items in the stack */
    quantity!: number;
    /** Unique ID for the item, used by the contract system */
    record_id!: number;
    /** Number of runs remaining if the blueprint is a copy, -1 if it is an original */
    runs?: number | undefined;
    /** Time Efficiency Level of the blueprint */
    time_efficiency?: number | undefined;
    /** Type ID for item */
    type_id!: number;

    constructor(data?: IGet_contracts_public_items_contract_id_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.is_blueprint_copy = _data["is_blueprint_copy"];
            this.is_included = _data["is_included"];
            this.item_id = _data["item_id"];
            this.material_efficiency = _data["material_efficiency"];
            this.quantity = _data["quantity"];
            this.record_id = _data["record_id"];
            this.runs = _data["runs"];
            this.time_efficiency = _data["time_efficiency"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_contracts_public_items_contract_id_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_contracts_public_items_contract_id_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["is_blueprint_copy"] = this.is_blueprint_copy;
        data["is_included"] = this.is_included;
        data["item_id"] = this.item_id;
        data["material_efficiency"] = this.material_efficiency;
        data["quantity"] = this.quantity;
        data["record_id"] = this.record_id;
        data["runs"] = this.runs;
        data["time_efficiency"] = this.time_efficiency;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_contracts_public_items_contract_id_200_ok {
    /** is_blueprint_copy boolean */
    is_blueprint_copy?: boolean | undefined;
    /** true if the contract issuer has submitted this item with the contract, false if the isser is asking for this item in the contract */
    is_included: boolean;
    /** Unique ID for the item being sold. Not present if item is being requested by contract rather than sold with contract */
    item_id?: number | undefined;
    /** Material Efficiency Level of the blueprint */
    material_efficiency?: number | undefined;
    /** Number of items in the stack */
    quantity: number;
    /** Unique ID for the item, used by the contract system */
    record_id: number;
    /** Number of runs remaining if the blueprint is a copy, -1 if it is an original */
    runs?: number | undefined;
    /** Time Efficiency Level of the blueprint */
    time_efficiency?: number | undefined;
    /** Type ID for item */
    type_id: number;
}

/** Forbidden */
export class Get_contracts_public_items_contract_id_forbidden implements IGet_contracts_public_items_contract_id_forbidden {
    /** Forbidden message */
    error?: string | undefined;

    constructor(data?: IGet_contracts_public_items_contract_id_forbidden) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_contracts_public_items_contract_id_forbidden {
        data = typeof data === 'object' ? data : {};
        let result = new Get_contracts_public_items_contract_id_forbidden();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Forbidden */
export interface IGet_contracts_public_items_contract_id_forbidden {
    /** Forbidden message */
    error?: string | undefined;
}

/** Not found */
export class Get_contracts_public_items_contract_id_not_found implements IGet_contracts_public_items_contract_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_contracts_public_items_contract_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_contracts_public_items_contract_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_contracts_public_items_contract_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_contracts_public_items_contract_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_contracts_public_region_id_200_ok implements IGet_contracts_public_region_id_200_ok {
    /** Buyout price (for Auctions only) */
    buyout?: number | undefined;
    /** Collateral price (for Couriers only) */
    collateral?: number | undefined;
    /** contract_id integer */
    contract_id!: number;
    /** Expiration date of the contract */
    date_expired!: Date;
    /** Сreation date of the contract */
    date_issued!: Date;
    /** Number of days to perform the contract */
    days_to_complete?: number | undefined;
    /** End location ID (for Couriers contract) */
    end_location_id?: number | undefined;
    /** true if the contract was issued on behalf of the issuer's corporation */
    for_corporation?: boolean | undefined;
    /** Character's corporation ID for the issuer */
    issuer_corporation_id!: number;
    /** Character ID for the issuer */
    issuer_id!: number;
    /** Price of contract (for ItemsExchange and Auctions) */
    price?: number | undefined;
    /** Remuneration for contract (for Couriers only) */
    reward?: number | undefined;
    /** Start location ID (for Couriers contract) */
    start_location_id?: number | undefined;
    /** Title of the contract */
    title?: string | undefined;
    /** Type of the contract */
    type!: Get_contracts_public_region_id_200_okType;
    /** Volume of items in the contract */
    volume?: number | undefined;

    constructor(data?: IGet_contracts_public_region_id_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buyout = _data["buyout"];
            this.collateral = _data["collateral"];
            this.contract_id = _data["contract_id"];
            this.date_expired = _data["date_expired"] ? new Date(_data["date_expired"].toString()) : <any>undefined;
            this.date_issued = _data["date_issued"] ? new Date(_data["date_issued"].toString()) : <any>undefined;
            this.days_to_complete = _data["days_to_complete"];
            this.end_location_id = _data["end_location_id"];
            this.for_corporation = _data["for_corporation"];
            this.issuer_corporation_id = _data["issuer_corporation_id"];
            this.issuer_id = _data["issuer_id"];
            this.price = _data["price"];
            this.reward = _data["reward"];
            this.start_location_id = _data["start_location_id"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): Get_contracts_public_region_id_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_contracts_public_region_id_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buyout"] = this.buyout;
        data["collateral"] = this.collateral;
        data["contract_id"] = this.contract_id;
        data["date_expired"] = this.date_expired ? this.date_expired.toISOString() : <any>undefined;
        data["date_issued"] = this.date_issued ? this.date_issued.toISOString() : <any>undefined;
        data["days_to_complete"] = this.days_to_complete;
        data["end_location_id"] = this.end_location_id;
        data["for_corporation"] = this.for_corporation;
        data["issuer_corporation_id"] = this.issuer_corporation_id;
        data["issuer_id"] = this.issuer_id;
        data["price"] = this.price;
        data["reward"] = this.reward;
        data["start_location_id"] = this.start_location_id;
        data["title"] = this.title;
        data["type"] = this.type;
        data["volume"] = this.volume;
        return data;
    }
}

/** 200 ok object */
export interface IGet_contracts_public_region_id_200_ok {
    /** Buyout price (for Auctions only) */
    buyout?: number | undefined;
    /** Collateral price (for Couriers only) */
    collateral?: number | undefined;
    /** contract_id integer */
    contract_id: number;
    /** Expiration date of the contract */
    date_expired: Date;
    /** Сreation date of the contract */
    date_issued: Date;
    /** Number of days to perform the contract */
    days_to_complete?: number | undefined;
    /** End location ID (for Couriers contract) */
    end_location_id?: number | undefined;
    /** true if the contract was issued on behalf of the issuer's corporation */
    for_corporation?: boolean | undefined;
    /** Character's corporation ID for the issuer */
    issuer_corporation_id: number;
    /** Character ID for the issuer */
    issuer_id: number;
    /** Price of contract (for ItemsExchange and Auctions) */
    price?: number | undefined;
    /** Remuneration for contract (for Couriers only) */
    reward?: number | undefined;
    /** Start location ID (for Couriers contract) */
    start_location_id?: number | undefined;
    /** Title of the contract */
    title?: string | undefined;
    /** Type of the contract */
    type: Get_contracts_public_region_id_200_okType;
    /** Volume of items in the contract */
    volume?: number | undefined;
}

/** Not found */
export class Get_contracts_public_region_id_not_found implements IGet_contracts_public_region_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_contracts_public_region_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_contracts_public_region_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_contracts_public_region_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_contracts_public_region_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_corporation_corporation_id_mining_extractions_200_ok implements IGet_corporation_corporation_id_mining_extractions_200_ok {
    /** The time at which the chunk being extracted will arrive and can be fractured by the moon mining drill.
 */
    chunk_arrival_time!: Date;
    /** The time at which the current extraction was initiated.
 */
    extraction_start_time!: Date;
    /** moon_id integer */
    moon_id!: number;
    /** The time at which the chunk being extracted will naturally fracture if it is not first fractured by the moon mining drill.
 */
    natural_decay_time!: Date;
    /** structure_id integer */
    structure_id!: number;

    constructor(data?: IGet_corporation_corporation_id_mining_extractions_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chunk_arrival_time = _data["chunk_arrival_time"] ? new Date(_data["chunk_arrival_time"].toString()) : <any>undefined;
            this.extraction_start_time = _data["extraction_start_time"] ? new Date(_data["extraction_start_time"].toString()) : <any>undefined;
            this.moon_id = _data["moon_id"];
            this.natural_decay_time = _data["natural_decay_time"] ? new Date(_data["natural_decay_time"].toString()) : <any>undefined;
            this.structure_id = _data["structure_id"];
        }
    }

    static fromJS(data: any): Get_corporation_corporation_id_mining_extractions_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporation_corporation_id_mining_extractions_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chunk_arrival_time"] = this.chunk_arrival_time ? this.chunk_arrival_time.toISOString() : <any>undefined;
        data["extraction_start_time"] = this.extraction_start_time ? this.extraction_start_time.toISOString() : <any>undefined;
        data["moon_id"] = this.moon_id;
        data["natural_decay_time"] = this.natural_decay_time ? this.natural_decay_time.toISOString() : <any>undefined;
        data["structure_id"] = this.structure_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporation_corporation_id_mining_extractions_200_ok {
    /** The time at which the chunk being extracted will arrive and can be fractured by the moon mining drill.
 */
    chunk_arrival_time: Date;
    /** The time at which the current extraction was initiated.
 */
    extraction_start_time: Date;
    /** moon_id integer */
    moon_id: number;
    /** The time at which the chunk being extracted will naturally fracture if it is not first fractured by the moon mining drill.
 */
    natural_decay_time: Date;
    /** structure_id integer */
    structure_id: number;
}

/** 200 ok object */
export class Get_corporation_corporation_id_mining_observers_200_ok implements IGet_corporation_corporation_id_mining_observers_200_ok {
    /** last_updated string */
    last_updated!: Date;
    /** The entity that was observing the asteroid field when it was mined.
 */
    observer_id!: number;
    /** The category of the observing entity */
    observer_type!: Get_corporation_corporation_id_mining_observers_200_okObserver_type;

    constructor(data?: IGet_corporation_corporation_id_mining_observers_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last_updated = _data["last_updated"] ? new Date(_data["last_updated"].toString()) : <any>undefined;
            this.observer_id = _data["observer_id"];
            this.observer_type = _data["observer_type"];
        }
    }

    static fromJS(data: any): Get_corporation_corporation_id_mining_observers_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporation_corporation_id_mining_observers_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last_updated"] = this.last_updated ? formatDate(this.last_updated) : <any>undefined;
        data["observer_id"] = this.observer_id;
        data["observer_type"] = this.observer_type;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporation_corporation_id_mining_observers_200_ok {
    /** last_updated string */
    last_updated: Date;
    /** The entity that was observing the asteroid field when it was mined.
 */
    observer_id: number;
    /** The category of the observing entity */
    observer_type: Get_corporation_corporation_id_mining_observers_200_okObserver_type;
}

/** 200 ok object */
export class Get_corporation_corporation_id_mining_observers_observer_id_200_ok implements IGet_corporation_corporation_id_mining_observers_observer_id_200_ok {
    /** The character that did the mining
 */
    character_id!: number;
    /** last_updated string */
    last_updated!: Date;
    /** quantity integer */
    quantity!: number;
    /** The corporation id of the character at the time data was recorded.
 */
    recorded_corporation_id!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_corporation_corporation_id_mining_observers_observer_id_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.character_id = _data["character_id"];
            this.last_updated = _data["last_updated"] ? new Date(_data["last_updated"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.recorded_corporation_id = _data["recorded_corporation_id"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_corporation_corporation_id_mining_observers_observer_id_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporation_corporation_id_mining_observers_observer_id_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["character_id"] = this.character_id;
        data["last_updated"] = this.last_updated ? formatDate(this.last_updated) : <any>undefined;
        data["quantity"] = this.quantity;
        data["recorded_corporation_id"] = this.recorded_corporation_id;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporation_corporation_id_mining_observers_observer_id_200_ok {
    /** The character that did the mining
 */
    character_id: number;
    /** last_updated string */
    last_updated: Date;
    /** quantity integer */
    quantity: number;
    /** The corporation id of the character at the time data was recorded.
 */
    recorded_corporation_id: number;
    /** type_id integer */
    type_id: number;
}

/** 200 ok object */
export class Post_corporations_corporation_id_assets_names_200_ok implements IPost_corporations_corporation_id_assets_names_200_ok {
    /** item_id integer */
    item_id!: number;
    /** name string */
    name!: string;

    constructor(data?: IPost_corporations_corporation_id_assets_names_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item_id = _data["item_id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Post_corporations_corporation_id_assets_names_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Post_corporations_corporation_id_assets_names_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item_id"] = this.item_id;
        data["name"] = this.name;
        return data;
    }
}

/** 200 ok object */
export interface IPost_corporations_corporation_id_assets_names_200_ok {
    /** item_id integer */
    item_id: number;
    /** name string */
    name: string;
}

/** Not found */
export class Post_corporations_corporation_id_assets_names_not_found implements IPost_corporations_corporation_id_assets_names_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IPost_corporations_corporation_id_assets_names_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Post_corporations_corporation_id_assets_names_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Post_corporations_corporation_id_assets_names_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IPost_corporations_corporation_id_assets_names_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_bookmarks_200_ok implements IGet_corporations_corporation_id_bookmarks_200_ok {
    /** bookmark_id integer */
    bookmark_id!: number;
    /** Optional object that is returned if a bookmark was made on a planet or a random location in space. */
    coordinates?: Coordinates | undefined;
    /** created string */
    created!: Date;
    /** creator_id integer */
    creator_id!: number;
    /** folder_id integer */
    folder_id?: number | undefined;
    /** Optional object that is returned if a bookmark was made on a particular item. */
    item?: Item | undefined;
    /** label string */
    label!: string;
    /** location_id integer */
    location_id!: number;
    /** notes string */
    notes!: string;

    constructor(data?: IGet_corporations_corporation_id_bookmarks_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookmark_id = _data["bookmark_id"];
            this.coordinates = _data["coordinates"] ? Coordinates.fromJS(_data["coordinates"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.creator_id = _data["creator_id"];
            this.folder_id = _data["folder_id"];
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : <any>undefined;
            this.label = _data["label"];
            this.location_id = _data["location_id"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_bookmarks_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_bookmarks_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookmark_id"] = this.bookmark_id;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["creator_id"] = this.creator_id;
        data["folder_id"] = this.folder_id;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["label"] = this.label;
        data["location_id"] = this.location_id;
        data["notes"] = this.notes;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_bookmarks_200_ok {
    /** bookmark_id integer */
    bookmark_id: number;
    /** Optional object that is returned if a bookmark was made on a planet or a random location in space. */
    coordinates?: Coordinates | undefined;
    /** created string */
    created: Date;
    /** creator_id integer */
    creator_id: number;
    /** folder_id integer */
    folder_id?: number | undefined;
    /** Optional object that is returned if a bookmark was made on a particular item. */
    item?: Item | undefined;
    /** label string */
    label: string;
    /** location_id integer */
    location_id: number;
    /** notes string */
    notes: string;
}

/** 200 ok object */
export class Get_corporations_corporation_id_bookmarks_folders_200_ok implements IGet_corporations_corporation_id_bookmarks_folders_200_ok {
    /** creator_id integer */
    creator_id?: number | undefined;
    /** folder_id integer */
    folder_id!: number;
    /** name string */
    name!: string;

    constructor(data?: IGet_corporations_corporation_id_bookmarks_folders_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creator_id = _data["creator_id"];
            this.folder_id = _data["folder_id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_bookmarks_folders_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_bookmarks_folders_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creator_id"] = this.creator_id;
        data["folder_id"] = this.folder_id;
        data["name"] = this.name;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_bookmarks_folders_200_ok {
    /** creator_id integer */
    creator_id?: number | undefined;
    /** folder_id integer */
    folder_id: number;
    /** name string */
    name: string;
}

/** 200 ok object */
export class Get_corporations_corporation_id_contacts_labels_200_ok implements IGet_corporations_corporation_id_contacts_labels_200_ok {
    /** label_id integer */
    label_id!: number;
    /** label_name string */
    label_name!: string;

    constructor(data?: IGet_corporations_corporation_id_contacts_labels_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label_id = _data["label_id"];
            this.label_name = _data["label_name"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_contacts_labels_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_contacts_labels_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label_id"] = this.label_id;
        data["label_name"] = this.label_name;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_contacts_labels_200_ok {
    /** label_id integer */
    label_id: number;
    /** label_name string */
    label_name: string;
}

/** 200 ok object */
export class Get_corporations_corporation_id_contracts_200_ok implements IGet_corporations_corporation_id_contracts_200_ok {
    /** Who will accept the contract */
    acceptor_id!: number;
    /** ID to whom the contract is assigned, can be corporation or character ID */
    assignee_id!: number;
    /** To whom the contract is available */
    availability!: Get_corporations_corporation_id_contracts_200_okAvailability;
    /** Buyout price (for Auctions only) */
    buyout?: number | undefined;
    /** Collateral price (for Couriers only) */
    collateral?: number | undefined;
    /** contract_id integer */
    contract_id!: number;
    /** Date of confirmation of contract */
    date_accepted?: Date | undefined;
    /** Date of completed of contract */
    date_completed?: Date | undefined;
    /** Expiration date of the contract */
    date_expired!: Date;
    /** Сreation date of the contract */
    date_issued!: Date;
    /** Number of days to perform the contract */
    days_to_complete?: number | undefined;
    /** End location ID (for Couriers contract) */
    end_location_id?: number | undefined;
    /** true if the contract was issued on behalf of the issuer's corporation */
    for_corporation!: boolean;
    /** Character's corporation ID for the issuer */
    issuer_corporation_id!: number;
    /** Character ID for the issuer */
    issuer_id!: number;
    /** Price of contract (for ItemsExchange and Auctions) */
    price?: number | undefined;
    /** Remuneration for contract (for Couriers only) */
    reward?: number | undefined;
    /** Start location ID (for Couriers contract) */
    start_location_id?: number | undefined;
    /** Status of the the contract */
    status!: Get_corporations_corporation_id_contracts_200_okStatus;
    /** Title of the contract */
    title?: string | undefined;
    /** Type of the contract */
    type!: Get_corporations_corporation_id_contracts_200_okType;
    /** Volume of items in the contract */
    volume?: number | undefined;

    constructor(data?: IGet_corporations_corporation_id_contracts_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acceptor_id = _data["acceptor_id"];
            this.assignee_id = _data["assignee_id"];
            this.availability = _data["availability"];
            this.buyout = _data["buyout"];
            this.collateral = _data["collateral"];
            this.contract_id = _data["contract_id"];
            this.date_accepted = _data["date_accepted"] ? new Date(_data["date_accepted"].toString()) : <any>undefined;
            this.date_completed = _data["date_completed"] ? new Date(_data["date_completed"].toString()) : <any>undefined;
            this.date_expired = _data["date_expired"] ? new Date(_data["date_expired"].toString()) : <any>undefined;
            this.date_issued = _data["date_issued"] ? new Date(_data["date_issued"].toString()) : <any>undefined;
            this.days_to_complete = _data["days_to_complete"];
            this.end_location_id = _data["end_location_id"];
            this.for_corporation = _data["for_corporation"];
            this.issuer_corporation_id = _data["issuer_corporation_id"];
            this.issuer_id = _data["issuer_id"];
            this.price = _data["price"];
            this.reward = _data["reward"];
            this.start_location_id = _data["start_location_id"];
            this.status = _data["status"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_contracts_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_contracts_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acceptor_id"] = this.acceptor_id;
        data["assignee_id"] = this.assignee_id;
        data["availability"] = this.availability;
        data["buyout"] = this.buyout;
        data["collateral"] = this.collateral;
        data["contract_id"] = this.contract_id;
        data["date_accepted"] = this.date_accepted ? this.date_accepted.toISOString() : <any>undefined;
        data["date_completed"] = this.date_completed ? this.date_completed.toISOString() : <any>undefined;
        data["date_expired"] = this.date_expired ? this.date_expired.toISOString() : <any>undefined;
        data["date_issued"] = this.date_issued ? this.date_issued.toISOString() : <any>undefined;
        data["days_to_complete"] = this.days_to_complete;
        data["end_location_id"] = this.end_location_id;
        data["for_corporation"] = this.for_corporation;
        data["issuer_corporation_id"] = this.issuer_corporation_id;
        data["issuer_id"] = this.issuer_id;
        data["price"] = this.price;
        data["reward"] = this.reward;
        data["start_location_id"] = this.start_location_id;
        data["status"] = this.status;
        data["title"] = this.title;
        data["type"] = this.type;
        data["volume"] = this.volume;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_contracts_200_ok {
    /** Who will accept the contract */
    acceptor_id: number;
    /** ID to whom the contract is assigned, can be corporation or character ID */
    assignee_id: number;
    /** To whom the contract is available */
    availability: Get_corporations_corporation_id_contracts_200_okAvailability;
    /** Buyout price (for Auctions only) */
    buyout?: number | undefined;
    /** Collateral price (for Couriers only) */
    collateral?: number | undefined;
    /** contract_id integer */
    contract_id: number;
    /** Date of confirmation of contract */
    date_accepted?: Date | undefined;
    /** Date of completed of contract */
    date_completed?: Date | undefined;
    /** Expiration date of the contract */
    date_expired: Date;
    /** Сreation date of the contract */
    date_issued: Date;
    /** Number of days to perform the contract */
    days_to_complete?: number | undefined;
    /** End location ID (for Couriers contract) */
    end_location_id?: number | undefined;
    /** true if the contract was issued on behalf of the issuer's corporation */
    for_corporation: boolean;
    /** Character's corporation ID for the issuer */
    issuer_corporation_id: number;
    /** Character ID for the issuer */
    issuer_id: number;
    /** Price of contract (for ItemsExchange and Auctions) */
    price?: number | undefined;
    /** Remuneration for contract (for Couriers only) */
    reward?: number | undefined;
    /** Start location ID (for Couriers contract) */
    start_location_id?: number | undefined;
    /** Status of the the contract */
    status: Get_corporations_corporation_id_contracts_200_okStatus;
    /** Title of the contract */
    title?: string | undefined;
    /** Type of the contract */
    type: Get_corporations_corporation_id_contracts_200_okType;
    /** Volume of items in the contract */
    volume?: number | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_contracts_contract_id_bids_200_ok implements IGet_corporations_corporation_id_contracts_contract_id_bids_200_ok {
    /** The amount bid, in ISK */
    amount!: number;
    /** Unique ID for the bid */
    bid_id!: number;
    /** Character ID of the bidder */
    bidder_id!: number;
    /** Datetime when the bid was placed */
    date_bid!: Date;

    constructor(data?: IGet_corporations_corporation_id_contracts_contract_id_bids_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.bid_id = _data["bid_id"];
            this.bidder_id = _data["bidder_id"];
            this.date_bid = _data["date_bid"] ? new Date(_data["date_bid"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_contracts_contract_id_bids_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_contracts_contract_id_bids_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["bid_id"] = this.bid_id;
        data["bidder_id"] = this.bidder_id;
        data["date_bid"] = this.date_bid ? this.date_bid.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_contracts_contract_id_bids_200_ok {
    /** The amount bid, in ISK */
    amount: number;
    /** Unique ID for the bid */
    bid_id: number;
    /** Character ID of the bidder */
    bidder_id: number;
    /** Datetime when the bid was placed */
    date_bid: Date;
}

/** Not found */
export class Get_corporations_corporation_id_contracts_contract_id_bids_not_found implements IGet_corporations_corporation_id_contracts_contract_id_bids_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_corporations_corporation_id_contracts_contract_id_bids_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_contracts_contract_id_bids_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_contracts_contract_id_bids_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_corporations_corporation_id_contracts_contract_id_bids_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_contracts_contract_id_items_200_ok implements IGet_corporations_corporation_id_contracts_contract_id_items_200_ok {
    /** true if the contract issuer has submitted this item with the contract, false if the isser is asking for this item in the contract */
    is_included!: boolean;
    /** is_singleton boolean */
    is_singleton!: boolean;
    /** Number of items in the stack */
    quantity!: number;
    /** -1 indicates that the item is a singleton (non-stackable). If the item happens to be a Blueprint, -1 is an Original and -2 is a Blueprint Copy */
    raw_quantity?: number | undefined;
    /** Unique ID for the item */
    record_id!: number;
    /** Type ID for item */
    type_id!: number;

    constructor(data?: IGet_corporations_corporation_id_contracts_contract_id_items_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.is_included = _data["is_included"];
            this.is_singleton = _data["is_singleton"];
            this.quantity = _data["quantity"];
            this.raw_quantity = _data["raw_quantity"];
            this.record_id = _data["record_id"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_contracts_contract_id_items_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_contracts_contract_id_items_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["is_included"] = this.is_included;
        data["is_singleton"] = this.is_singleton;
        data["quantity"] = this.quantity;
        data["raw_quantity"] = this.raw_quantity;
        data["record_id"] = this.record_id;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_contracts_contract_id_items_200_ok {
    /** true if the contract issuer has submitted this item with the contract, false if the isser is asking for this item in the contract */
    is_included: boolean;
    /** is_singleton boolean */
    is_singleton: boolean;
    /** Number of items in the stack */
    quantity: number;
    /** -1 indicates that the item is a singleton (non-stackable). If the item happens to be a Blueprint, -1 is an Original and -2 is a Blueprint Copy */
    raw_quantity?: number | undefined;
    /** Unique ID for the item */
    record_id: number;
    /** Type ID for item */
    type_id: number;
}

/** Not found */
export class Get_corporations_corporation_id_contracts_contract_id_items_not_found implements IGet_corporations_corporation_id_contracts_contract_id_items_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_corporations_corporation_id_contracts_contract_id_items_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_contracts_contract_id_items_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_contracts_contract_id_items_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_corporations_corporation_id_contracts_contract_id_items_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** Error 520 */
export class Get_corporations_corporation_id_contracts_contract_id_items_error_520 implements IGet_corporations_corporation_id_contracts_contract_id_items_error_520 {
    /** Error 520 message */
    error?: string | undefined;

    constructor(data?: IGet_corporations_corporation_id_contracts_contract_id_items_error_520) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_contracts_contract_id_items_error_520 {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_contracts_contract_id_items_error_520();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Error 520 */
export interface IGet_corporations_corporation_id_contracts_contract_id_items_error_520 {
    /** Error 520 message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_customs_offices_200_ok implements IGet_corporations_corporation_id_customs_offices_200_ok {
    /** Only present if alliance access is allowed */
    alliance_tax_rate?: number | undefined;
    /** standing_level and any standing related tax rate only present when this is true */
    allow_access_with_standings!: boolean;
    /** allow_alliance_access boolean */
    allow_alliance_access!: boolean;
    /** bad_standing_tax_rate number */
    bad_standing_tax_rate?: number | undefined;
    /** corporation_tax_rate number */
    corporation_tax_rate?: number | undefined;
    /** Tax rate for entities with excellent level of standing, only present if this level is allowed, same for all other standing related tax rates */
    excellent_standing_tax_rate?: number | undefined;
    /** good_standing_tax_rate number */
    good_standing_tax_rate?: number | undefined;
    /** neutral_standing_tax_rate number */
    neutral_standing_tax_rate?: number | undefined;
    /** unique ID of this customs office */
    office_id!: number;
    /** reinforce_exit_end integer */
    reinforce_exit_end!: number;
    /** Together with reinforce_exit_end, marks a 2-hour period where this customs office could exit reinforcement mode during the day after initial attack */
    reinforce_exit_start!: number;
    /** Access is allowed only for entities with this level of standing or better */
    standing_level?: Get_corporations_corporation_id_customs_offices_200_okStanding_level | undefined;
    /** ID of the solar system this customs office is located in */
    system_id!: number;
    /** terrible_standing_tax_rate number */
    terrible_standing_tax_rate?: number | undefined;

    constructor(data?: IGet_corporations_corporation_id_customs_offices_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_tax_rate = _data["alliance_tax_rate"];
            this.allow_access_with_standings = _data["allow_access_with_standings"];
            this.allow_alliance_access = _data["allow_alliance_access"];
            this.bad_standing_tax_rate = _data["bad_standing_tax_rate"];
            this.corporation_tax_rate = _data["corporation_tax_rate"];
            this.excellent_standing_tax_rate = _data["excellent_standing_tax_rate"];
            this.good_standing_tax_rate = _data["good_standing_tax_rate"];
            this.neutral_standing_tax_rate = _data["neutral_standing_tax_rate"];
            this.office_id = _data["office_id"];
            this.reinforce_exit_end = _data["reinforce_exit_end"];
            this.reinforce_exit_start = _data["reinforce_exit_start"];
            this.standing_level = _data["standing_level"];
            this.system_id = _data["system_id"];
            this.terrible_standing_tax_rate = _data["terrible_standing_tax_rate"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_customs_offices_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_customs_offices_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_tax_rate"] = this.alliance_tax_rate;
        data["allow_access_with_standings"] = this.allow_access_with_standings;
        data["allow_alliance_access"] = this.allow_alliance_access;
        data["bad_standing_tax_rate"] = this.bad_standing_tax_rate;
        data["corporation_tax_rate"] = this.corporation_tax_rate;
        data["excellent_standing_tax_rate"] = this.excellent_standing_tax_rate;
        data["good_standing_tax_rate"] = this.good_standing_tax_rate;
        data["neutral_standing_tax_rate"] = this.neutral_standing_tax_rate;
        data["office_id"] = this.office_id;
        data["reinforce_exit_end"] = this.reinforce_exit_end;
        data["reinforce_exit_start"] = this.reinforce_exit_start;
        data["standing_level"] = this.standing_level;
        data["system_id"] = this.system_id;
        data["terrible_standing_tax_rate"] = this.terrible_standing_tax_rate;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_customs_offices_200_ok {
    /** Only present if alliance access is allowed */
    alliance_tax_rate?: number | undefined;
    /** standing_level and any standing related tax rate only present when this is true */
    allow_access_with_standings: boolean;
    /** allow_alliance_access boolean */
    allow_alliance_access: boolean;
    /** bad_standing_tax_rate number */
    bad_standing_tax_rate?: number | undefined;
    /** corporation_tax_rate number */
    corporation_tax_rate?: number | undefined;
    /** Tax rate for entities with excellent level of standing, only present if this level is allowed, same for all other standing related tax rates */
    excellent_standing_tax_rate?: number | undefined;
    /** good_standing_tax_rate number */
    good_standing_tax_rate?: number | undefined;
    /** neutral_standing_tax_rate number */
    neutral_standing_tax_rate?: number | undefined;
    /** unique ID of this customs office */
    office_id: number;
    /** reinforce_exit_end integer */
    reinforce_exit_end: number;
    /** Together with reinforce_exit_end, marks a 2-hour period where this customs office could exit reinforcement mode during the day after initial attack */
    reinforce_exit_start: number;
    /** Access is allowed only for entities with this level of standing or better */
    standing_level?: Get_corporations_corporation_id_customs_offices_200_okStanding_level | undefined;
    /** ID of the solar system this customs office is located in */
    system_id: number;
    /** terrible_standing_tax_rate number */
    terrible_standing_tax_rate?: number | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_fw_stats_ok implements IGet_corporations_corporation_id_fw_stats_ok {
    /** The enlistment date of the given corporation into faction warfare. Will not be included if corporation is not enlisted in faction warfare */
    enlisted_on?: Date | undefined;
    /** The faction the given corporation is enlisted to fight for. Will not be included if corporation is not enlisted in faction warfare */
    faction_id?: number | undefined;
    /** Summary of kills done by the given corporation against enemy factions */
    kills!: Kills2;
    /** How many pilots the enlisted corporation has. Will not be included if corporation is not enlisted in faction warfare */
    pilots?: number | undefined;
    /** Summary of victory points gained by the given corporation for the enlisted faction */
    victory_points!: Victory_points2;

    constructor(data?: IGet_corporations_corporation_id_fw_stats_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.kills = new Kills2();
            this.victory_points = new Victory_points2();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enlisted_on = _data["enlisted_on"] ? new Date(_data["enlisted_on"].toString()) : <any>undefined;
            this.faction_id = _data["faction_id"];
            this.kills = _data["kills"] ? Kills2.fromJS(_data["kills"]) : new Kills2();
            this.pilots = _data["pilots"];
            this.victory_points = _data["victory_points"] ? Victory_points2.fromJS(_data["victory_points"]) : new Victory_points2();
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_fw_stats_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_fw_stats_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enlisted_on"] = this.enlisted_on ? this.enlisted_on.toISOString() : <any>undefined;
        data["faction_id"] = this.faction_id;
        data["kills"] = this.kills ? this.kills.toJSON() : <any>undefined;
        data["pilots"] = this.pilots;
        data["victory_points"] = this.victory_points ? this.victory_points.toJSON() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_fw_stats_ok {
    /** The enlistment date of the given corporation into faction warfare. Will not be included if corporation is not enlisted in faction warfare */
    enlisted_on?: Date | undefined;
    /** The faction the given corporation is enlisted to fight for. Will not be included if corporation is not enlisted in faction warfare */
    faction_id?: number | undefined;
    /** Summary of kills done by the given corporation against enemy factions */
    kills: Kills2;
    /** How many pilots the enlisted corporation has. Will not be included if corporation is not enlisted in faction warfare */
    pilots?: number | undefined;
    /** Summary of victory points gained by the given corporation for the enlisted faction */
    victory_points: Victory_points2;
}

/** 200 ok object */
export class Get_corporations_corporation_id_industry_jobs_200_ok implements IGet_corporations_corporation_id_industry_jobs_200_ok {
    /** Job activity ID */
    activity_id!: number;
    /** blueprint_id integer */
    blueprint_id!: number;
    /** Location ID of the location from which the blueprint was installed. Normally a station ID, but can also be an asset (e.g. container) or corporation facility */
    blueprint_location_id!: number;
    /** blueprint_type_id integer */
    blueprint_type_id!: number;
    /** ID of the character which completed this job */
    completed_character_id?: number | undefined;
    /** Date and time when this job was completed */
    completed_date?: Date | undefined;
    /** The sume of job installation fee and industry facility tax */
    cost?: number | undefined;
    /** Job duration in seconds */
    duration!: number;
    /** Date and time when this job finished */
    end_date!: Date;
    /** ID of the facility where this job is running */
    facility_id!: number;
    /** ID of the character which installed this job */
    installer_id!: number;
    /** Unique job ID */
    job_id!: number;
    /** Number of runs blueprint is licensed for */
    licensed_runs?: number | undefined;
    /** ID of the location for the industry facility */
    location_id!: number;
    /** Location ID of the location to which the output of the job will be delivered. Normally a station ID, but can also be a corporation facility */
    output_location_id!: number;
    /** Date and time when this job was paused (i.e. time when the facility where this job was installed went offline) */
    pause_date?: Date | undefined;
    /** Chance of success for invention */
    probability?: number | undefined;
    /** Type ID of product (manufactured, copied or invented) */
    product_type_id?: number | undefined;
    /** Number of runs for a manufacturing job, or number of copies to make for a blueprint copy */
    runs!: number;
    /** Date and time when this job started */
    start_date!: Date;
    /** status string */
    status!: Get_corporations_corporation_id_industry_jobs_200_okStatus;
    /** Number of successful runs for this job. Equal to runs unless this is an invention job */
    successful_runs?: number | undefined;

    constructor(data?: IGet_corporations_corporation_id_industry_jobs_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity_id = _data["activity_id"];
            this.blueprint_id = _data["blueprint_id"];
            this.blueprint_location_id = _data["blueprint_location_id"];
            this.blueprint_type_id = _data["blueprint_type_id"];
            this.completed_character_id = _data["completed_character_id"];
            this.completed_date = _data["completed_date"] ? new Date(_data["completed_date"].toString()) : <any>undefined;
            this.cost = _data["cost"];
            this.duration = _data["duration"];
            this.end_date = _data["end_date"] ? new Date(_data["end_date"].toString()) : <any>undefined;
            this.facility_id = _data["facility_id"];
            this.installer_id = _data["installer_id"];
            this.job_id = _data["job_id"];
            this.licensed_runs = _data["licensed_runs"];
            this.location_id = _data["location_id"];
            this.output_location_id = _data["output_location_id"];
            this.pause_date = _data["pause_date"] ? new Date(_data["pause_date"].toString()) : <any>undefined;
            this.probability = _data["probability"];
            this.product_type_id = _data["product_type_id"];
            this.runs = _data["runs"];
            this.start_date = _data["start_date"] ? new Date(_data["start_date"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.successful_runs = _data["successful_runs"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_industry_jobs_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_industry_jobs_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity_id"] = this.activity_id;
        data["blueprint_id"] = this.blueprint_id;
        data["blueprint_location_id"] = this.blueprint_location_id;
        data["blueprint_type_id"] = this.blueprint_type_id;
        data["completed_character_id"] = this.completed_character_id;
        data["completed_date"] = this.completed_date ? this.completed_date.toISOString() : <any>undefined;
        data["cost"] = this.cost;
        data["duration"] = this.duration;
        data["end_date"] = this.end_date ? this.end_date.toISOString() : <any>undefined;
        data["facility_id"] = this.facility_id;
        data["installer_id"] = this.installer_id;
        data["job_id"] = this.job_id;
        data["licensed_runs"] = this.licensed_runs;
        data["location_id"] = this.location_id;
        data["output_location_id"] = this.output_location_id;
        data["pause_date"] = this.pause_date ? this.pause_date.toISOString() : <any>undefined;
        data["probability"] = this.probability;
        data["product_type_id"] = this.product_type_id;
        data["runs"] = this.runs;
        data["start_date"] = this.start_date ? this.start_date.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["successful_runs"] = this.successful_runs;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_industry_jobs_200_ok {
    /** Job activity ID */
    activity_id: number;
    /** blueprint_id integer */
    blueprint_id: number;
    /** Location ID of the location from which the blueprint was installed. Normally a station ID, but can also be an asset (e.g. container) or corporation facility */
    blueprint_location_id: number;
    /** blueprint_type_id integer */
    blueprint_type_id: number;
    /** ID of the character which completed this job */
    completed_character_id?: number | undefined;
    /** Date and time when this job was completed */
    completed_date?: Date | undefined;
    /** The sume of job installation fee and industry facility tax */
    cost?: number | undefined;
    /** Job duration in seconds */
    duration: number;
    /** Date and time when this job finished */
    end_date: Date;
    /** ID of the facility where this job is running */
    facility_id: number;
    /** ID of the character which installed this job */
    installer_id: number;
    /** Unique job ID */
    job_id: number;
    /** Number of runs blueprint is licensed for */
    licensed_runs?: number | undefined;
    /** ID of the location for the industry facility */
    location_id: number;
    /** Location ID of the location to which the output of the job will be delivered. Normally a station ID, but can also be a corporation facility */
    output_location_id: number;
    /** Date and time when this job was paused (i.e. time when the facility where this job was installed went offline) */
    pause_date?: Date | undefined;
    /** Chance of success for invention */
    probability?: number | undefined;
    /** Type ID of product (manufactured, copied or invented) */
    product_type_id?: number | undefined;
    /** Number of runs for a manufacturing job, or number of copies to make for a blueprint copy */
    runs: number;
    /** Date and time when this job started */
    start_date: Date;
    /** status string */
    status: Get_corporations_corporation_id_industry_jobs_200_okStatus;
    /** Number of successful runs for this job. Equal to runs unless this is an invention job */
    successful_runs?: number | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_killmails_recent_200_ok implements IGet_corporations_corporation_id_killmails_recent_200_ok {
    /** A hash of this killmail */
    killmail_hash!: string;
    /** ID of this killmail */
    killmail_id!: number;

    constructor(data?: IGet_corporations_corporation_id_killmails_recent_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.killmail_hash = _data["killmail_hash"];
            this.killmail_id = _data["killmail_id"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_killmails_recent_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_killmails_recent_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["killmail_hash"] = this.killmail_hash;
        data["killmail_id"] = this.killmail_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_killmails_recent_200_ok {
    /** A hash of this killmail */
    killmail_hash: string;
    /** ID of this killmail */
    killmail_id: number;
}

/** 200 ok object */
export class Get_corporations_corporation_id_shareholders_200_ok implements IGet_corporations_corporation_id_shareholders_200_ok {
    /** share_count integer */
    share_count!: number;
    /** shareholder_id integer */
    shareholder_id!: number;
    /** shareholder_type string */
    shareholder_type!: Get_corporations_corporation_id_shareholders_200_okShareholder_type;

    constructor(data?: IGet_corporations_corporation_id_shareholders_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.share_count = _data["share_count"];
            this.shareholder_id = _data["shareholder_id"];
            this.shareholder_type = _data["shareholder_type"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_shareholders_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_shareholders_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["share_count"] = this.share_count;
        data["shareholder_id"] = this.shareholder_id;
        data["shareholder_type"] = this.shareholder_type;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_shareholders_200_ok {
    /** share_count integer */
    share_count: number;
    /** shareholder_id integer */
    shareholder_id: number;
    /** shareholder_type string */
    shareholder_type: Get_corporations_corporation_id_shareholders_200_okShareholder_type;
}

/** 200 ok object */
export class Get_corporations_corporation_id_wallets_200_ok implements IGet_corporations_corporation_id_wallets_200_ok {
    /** balance number */
    balance!: number;
    /** division integer */
    division!: number;

    constructor(data?: IGet_corporations_corporation_id_wallets_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"];
            this.division = _data["division"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_wallets_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_wallets_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        data["division"] = this.division;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_wallets_200_ok {
    /** balance number */
    balance: number;
    /** division integer */
    division: number;
}

/** wallet transaction */
export class Get_corporations_corporation_id_wallets_division_transactions_200_ok implements IGet_corporations_corporation_id_wallets_division_transactions_200_ok {
    /** client_id integer */
    client_id!: number;
    /** Date and time of transaction */
    date!: Date;
    /** is_buy boolean */
    is_buy!: boolean;
    /** -1 if there is no corresponding wallet journal entry */
    journal_ref_id!: number;
    /** location_id integer */
    location_id!: number;
    /** quantity integer */
    quantity!: number;
    /** Unique transaction ID */
    transaction_id!: number;
    /** type_id integer */
    type_id!: number;
    /** Amount paid per unit */
    unit_price!: number;

    constructor(data?: IGet_corporations_corporation_id_wallets_division_transactions_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client_id = _data["client_id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.is_buy = _data["is_buy"];
            this.journal_ref_id = _data["journal_ref_id"];
            this.location_id = _data["location_id"];
            this.quantity = _data["quantity"];
            this.transaction_id = _data["transaction_id"];
            this.type_id = _data["type_id"];
            this.unit_price = _data["unit_price"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_wallets_division_transactions_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_wallets_division_transactions_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client_id"] = this.client_id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["is_buy"] = this.is_buy;
        data["journal_ref_id"] = this.journal_ref_id;
        data["location_id"] = this.location_id;
        data["quantity"] = this.quantity;
        data["transaction_id"] = this.transaction_id;
        data["type_id"] = this.type_id;
        data["unit_price"] = this.unit_price;
        return data;
    }
}

/** wallet transaction */
export interface IGet_corporations_corporation_id_wallets_division_transactions_200_ok {
    /** client_id integer */
    client_id: number;
    /** Date and time of transaction */
    date: Date;
    /** is_buy boolean */
    is_buy: boolean;
    /** -1 if there is no corresponding wallet journal entry */
    journal_ref_id: number;
    /** location_id integer */
    location_id: number;
    /** quantity integer */
    quantity: number;
    /** Unique transaction ID */
    transaction_id: number;
    /** type_id integer */
    type_id: number;
    /** Amount paid per unit */
    unit_price: number;
}

/** 200 ok object */
export class Get_dogma_attributes_attribute_id_ok implements IGet_dogma_attributes_attribute_id_ok {
    /** attribute_id integer */
    attribute_id!: number;
    /** default_value number */
    default_value?: number | undefined;
    /** description string */
    description?: string | undefined;
    /** display_name string */
    display_name?: string | undefined;
    /** high_is_good boolean */
    high_is_good?: boolean | undefined;
    /** icon_id integer */
    icon_id?: number | undefined;
    /** name string */
    name?: string | undefined;
    /** published boolean */
    published?: boolean | undefined;
    /** stackable boolean */
    stackable?: boolean | undefined;
    /** unit_id integer */
    unit_id?: number | undefined;

    constructor(data?: IGet_dogma_attributes_attribute_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attribute_id = _data["attribute_id"];
            this.default_value = _data["default_value"];
            this.description = _data["description"];
            this.display_name = _data["display_name"];
            this.high_is_good = _data["high_is_good"];
            this.icon_id = _data["icon_id"];
            this.name = _data["name"];
            this.published = _data["published"];
            this.stackable = _data["stackable"];
            this.unit_id = _data["unit_id"];
        }
    }

    static fromJS(data: any): Get_dogma_attributes_attribute_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_dogma_attributes_attribute_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute_id"] = this.attribute_id;
        data["default_value"] = this.default_value;
        data["description"] = this.description;
        data["display_name"] = this.display_name;
        data["high_is_good"] = this.high_is_good;
        data["icon_id"] = this.icon_id;
        data["name"] = this.name;
        data["published"] = this.published;
        data["stackable"] = this.stackable;
        data["unit_id"] = this.unit_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_dogma_attributes_attribute_id_ok {
    /** attribute_id integer */
    attribute_id: number;
    /** default_value number */
    default_value?: number | undefined;
    /** description string */
    description?: string | undefined;
    /** display_name string */
    display_name?: string | undefined;
    /** high_is_good boolean */
    high_is_good?: boolean | undefined;
    /** icon_id integer */
    icon_id?: number | undefined;
    /** name string */
    name?: string | undefined;
    /** published boolean */
    published?: boolean | undefined;
    /** stackable boolean */
    stackable?: boolean | undefined;
    /** unit_id integer */
    unit_id?: number | undefined;
}

/** Not found */
export class Get_dogma_attributes_attribute_id_not_found implements IGet_dogma_attributes_attribute_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_dogma_attributes_attribute_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_dogma_attributes_attribute_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_dogma_attributes_attribute_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_dogma_attributes_attribute_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_dogma_dynamic_items_type_id_item_id_ok implements IGet_dogma_dynamic_items_type_id_item_id_ok {
    /** The ID of the character who created the item */
    created_by!: number;
    /** dogma_attributes array */
    dogma_attributes!: Dogma_attributes[];
    /** dogma_effects array */
    dogma_effects!: Dogma_effects[];
    /** The type ID of the mutator used to generate the dynamic item. */
    mutator_type_id!: number;
    /** The type ID of the source item the mutator was applied to create the dynamic item. */
    source_type_id!: number;

    constructor(data?: IGet_dogma_dynamic_items_type_id_item_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dogma_attributes = [];
            this.dogma_effects = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created_by = _data["created_by"];
            if (Array.isArray(_data["dogma_attributes"])) {
                this.dogma_attributes = [] as any;
                for (let item of _data["dogma_attributes"])
                    this.dogma_attributes!.push(Dogma_attributes.fromJS(item));
            }
            if (Array.isArray(_data["dogma_effects"])) {
                this.dogma_effects = [] as any;
                for (let item of _data["dogma_effects"])
                    this.dogma_effects!.push(Dogma_effects.fromJS(item));
            }
            this.mutator_type_id = _data["mutator_type_id"];
            this.source_type_id = _data["source_type_id"];
        }
    }

    static fromJS(data: any): Get_dogma_dynamic_items_type_id_item_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_dogma_dynamic_items_type_id_item_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created_by"] = this.created_by;
        if (Array.isArray(this.dogma_attributes)) {
            data["dogma_attributes"] = [];
            for (let item of this.dogma_attributes)
                data["dogma_attributes"].push(item.toJSON());
        }
        if (Array.isArray(this.dogma_effects)) {
            data["dogma_effects"] = [];
            for (let item of this.dogma_effects)
                data["dogma_effects"].push(item.toJSON());
        }
        data["mutator_type_id"] = this.mutator_type_id;
        data["source_type_id"] = this.source_type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_dogma_dynamic_items_type_id_item_id_ok {
    /** The ID of the character who created the item */
    created_by: number;
    /** dogma_attributes array */
    dogma_attributes: Dogma_attributes[];
    /** dogma_effects array */
    dogma_effects: Dogma_effects[];
    /** The type ID of the mutator used to generate the dynamic item. */
    mutator_type_id: number;
    /** The type ID of the source item the mutator was applied to create the dynamic item. */
    source_type_id: number;
}

/** Not found */
export class Get_dogma_dynamic_items_type_id_item_id_not_found implements IGet_dogma_dynamic_items_type_id_item_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_dogma_dynamic_items_type_id_item_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_dogma_dynamic_items_type_id_item_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_dogma_dynamic_items_type_id_item_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_dogma_dynamic_items_type_id_item_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_fleets_fleet_id_ok implements IGet_fleets_fleet_id_ok {
    /** Is free-move enabled */
    is_free_move!: boolean;
    /** Does the fleet have an active fleet advertisement */
    is_registered!: boolean;
    /** Is EVE Voice enabled */
    is_voice_enabled!: boolean;
    /** Fleet MOTD in CCP flavoured HTML */
    motd!: string;

    constructor(data?: IGet_fleets_fleet_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.is_free_move = _data["is_free_move"];
            this.is_registered = _data["is_registered"];
            this.is_voice_enabled = _data["is_voice_enabled"];
            this.motd = _data["motd"];
        }
    }

    static fromJS(data: any): Get_fleets_fleet_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_fleets_fleet_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["is_free_move"] = this.is_free_move;
        data["is_registered"] = this.is_registered;
        data["is_voice_enabled"] = this.is_voice_enabled;
        data["motd"] = this.motd;
        return data;
    }
}

/** 200 ok object */
export interface IGet_fleets_fleet_id_ok {
    /** Is free-move enabled */
    is_free_move: boolean;
    /** Does the fleet have an active fleet advertisement */
    is_registered: boolean;
    /** Is EVE Voice enabled */
    is_voice_enabled: boolean;
    /** Fleet MOTD in CCP flavoured HTML */
    motd: string;
}

/** Not found */
export class Get_fleets_fleet_id_not_found implements IGet_fleets_fleet_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_fleets_fleet_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_fleets_fleet_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_fleets_fleet_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_fleets_fleet_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** Not found */
export class Put_fleets_fleet_id_not_found implements IPut_fleets_fleet_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IPut_fleets_fleet_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Put_fleets_fleet_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Put_fleets_fleet_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IPut_fleets_fleet_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_fleets_fleet_id_members_200_ok implements IGet_fleets_fleet_id_members_200_ok {
    /** character_id integer */
    character_id!: number;
    /** join_time string */
    join_time!: Date;
    /** Member’s role in fleet */
    role!: Get_fleets_fleet_id_members_200_okRole;
    /** Localized role names */
    role_name!: string;
    /** ship_type_id integer */
    ship_type_id!: number;
    /** Solar system the member is located in */
    solar_system_id!: number;
    /** ID of the squad the member is in. If not applicable, will be set to -1 */
    squad_id!: number;
    /** Station in which the member is docked in, if applicable */
    station_id?: number | undefined;
    /** Whether the member take fleet warps */
    takes_fleet_warp!: boolean;
    /** ID of the wing the member is in. If not applicable, will be set to -1 */
    wing_id!: number;

    constructor(data?: IGet_fleets_fleet_id_members_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.character_id = _data["character_id"];
            this.join_time = _data["join_time"] ? new Date(_data["join_time"].toString()) : <any>undefined;
            this.role = _data["role"];
            this.role_name = _data["role_name"];
            this.ship_type_id = _data["ship_type_id"];
            this.solar_system_id = _data["solar_system_id"];
            this.squad_id = _data["squad_id"];
            this.station_id = _data["station_id"];
            this.takes_fleet_warp = _data["takes_fleet_warp"];
            this.wing_id = _data["wing_id"];
        }
    }

    static fromJS(data: any): Get_fleets_fleet_id_members_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_fleets_fleet_id_members_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["character_id"] = this.character_id;
        data["join_time"] = this.join_time ? this.join_time.toISOString() : <any>undefined;
        data["role"] = this.role;
        data["role_name"] = this.role_name;
        data["ship_type_id"] = this.ship_type_id;
        data["solar_system_id"] = this.solar_system_id;
        data["squad_id"] = this.squad_id;
        data["station_id"] = this.station_id;
        data["takes_fleet_warp"] = this.takes_fleet_warp;
        data["wing_id"] = this.wing_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_fleets_fleet_id_members_200_ok {
    /** character_id integer */
    character_id: number;
    /** join_time string */
    join_time: Date;
    /** Member’s role in fleet */
    role: Get_fleets_fleet_id_members_200_okRole;
    /** Localized role names */
    role_name: string;
    /** ship_type_id integer */
    ship_type_id: number;
    /** Solar system the member is located in */
    solar_system_id: number;
    /** ID of the squad the member is in. If not applicable, will be set to -1 */
    squad_id: number;
    /** Station in which the member is docked in, if applicable */
    station_id?: number | undefined;
    /** Whether the member take fleet warps */
    takes_fleet_warp: boolean;
    /** ID of the wing the member is in. If not applicable, will be set to -1 */
    wing_id: number;
}

/** Not found */
export class Get_fleets_fleet_id_members_not_found implements IGet_fleets_fleet_id_members_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_fleets_fleet_id_members_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_fleets_fleet_id_members_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_fleets_fleet_id_members_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_fleets_fleet_id_members_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** Not found */
export class Post_fleets_fleet_id_members_not_found implements IPost_fleets_fleet_id_members_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IPost_fleets_fleet_id_members_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Post_fleets_fleet_id_members_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Post_fleets_fleet_id_members_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IPost_fleets_fleet_id_members_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 422 unprocessable entity object */
export class Post_fleets_fleet_id_members_unprocessable_entity implements IPost_fleets_fleet_id_members_unprocessable_entity {
    /** error message */
    error?: string | undefined;

    constructor(data?: IPost_fleets_fleet_id_members_unprocessable_entity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Post_fleets_fleet_id_members_unprocessable_entity {
        data = typeof data === 'object' ? data : {};
        let result = new Post_fleets_fleet_id_members_unprocessable_entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** 422 unprocessable entity object */
export interface IPost_fleets_fleet_id_members_unprocessable_entity {
    /** error message */
    error?: string | undefined;
}

/** Not found */
export class Delete_fleets_fleet_id_members_member_id_not_found implements IDelete_fleets_fleet_id_members_member_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IDelete_fleets_fleet_id_members_member_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Delete_fleets_fleet_id_members_member_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Delete_fleets_fleet_id_members_member_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IDelete_fleets_fleet_id_members_member_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** Not found */
export class Put_fleets_fleet_id_members_member_id_not_found implements IPut_fleets_fleet_id_members_member_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IPut_fleets_fleet_id_members_member_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Put_fleets_fleet_id_members_member_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Put_fleets_fleet_id_members_member_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IPut_fleets_fleet_id_members_member_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 422 unprocessable entity object */
export class Put_fleets_fleet_id_members_member_id_unprocessable_entity implements IPut_fleets_fleet_id_members_member_id_unprocessable_entity {
    /** error message */
    error?: string | undefined;

    constructor(data?: IPut_fleets_fleet_id_members_member_id_unprocessable_entity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Put_fleets_fleet_id_members_member_id_unprocessable_entity {
        data = typeof data === 'object' ? data : {};
        let result = new Put_fleets_fleet_id_members_member_id_unprocessable_entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** 422 unprocessable entity object */
export interface IPut_fleets_fleet_id_members_member_id_unprocessable_entity {
    /** error message */
    error?: string | undefined;
}

/** Not found */
export class Delete_fleets_fleet_id_squads_squad_id_not_found implements IDelete_fleets_fleet_id_squads_squad_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IDelete_fleets_fleet_id_squads_squad_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Delete_fleets_fleet_id_squads_squad_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Delete_fleets_fleet_id_squads_squad_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IDelete_fleets_fleet_id_squads_squad_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** Not found */
export class Put_fleets_fleet_id_squads_squad_id_not_found implements IPut_fleets_fleet_id_squads_squad_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IPut_fleets_fleet_id_squads_squad_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Put_fleets_fleet_id_squads_squad_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Put_fleets_fleet_id_squads_squad_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IPut_fleets_fleet_id_squads_squad_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_fleets_fleet_id_wings_200_ok implements IGet_fleets_fleet_id_wings_200_ok {
    /** id integer */
    id!: number;
    /** name string */
    name!: string;
    /** squads array */
    squads!: Squads[];

    constructor(data?: IGet_fleets_fleet_id_wings_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.squads = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["squads"])) {
                this.squads = [] as any;
                for (let item of _data["squads"])
                    this.squads!.push(Squads.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Get_fleets_fleet_id_wings_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_fleets_fleet_id_wings_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.squads)) {
            data["squads"] = [];
            for (let item of this.squads)
                data["squads"].push(item.toJSON());
        }
        return data;
    }
}

/** 200 ok object */
export interface IGet_fleets_fleet_id_wings_200_ok {
    /** id integer */
    id: number;
    /** name string */
    name: string;
    /** squads array */
    squads: Squads[];
}

/** Not found */
export class Get_fleets_fleet_id_wings_not_found implements IGet_fleets_fleet_id_wings_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_fleets_fleet_id_wings_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_fleets_fleet_id_wings_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_fleets_fleet_id_wings_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_fleets_fleet_id_wings_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 201 created object */
export class Post_fleets_fleet_id_wings_created implements IPost_fleets_fleet_id_wings_created {
    /** The wing_id of the newly created wing */
    wing_id!: number;

    constructor(data?: IPost_fleets_fleet_id_wings_created) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wing_id = _data["wing_id"];
        }
    }

    static fromJS(data: any): Post_fleets_fleet_id_wings_created {
        data = typeof data === 'object' ? data : {};
        let result = new Post_fleets_fleet_id_wings_created();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wing_id"] = this.wing_id;
        return data;
    }
}

/** 201 created object */
export interface IPost_fleets_fleet_id_wings_created {
    /** The wing_id of the newly created wing */
    wing_id: number;
}

/** Not found */
export class Post_fleets_fleet_id_wings_not_found implements IPost_fleets_fleet_id_wings_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IPost_fleets_fleet_id_wings_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Post_fleets_fleet_id_wings_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Post_fleets_fleet_id_wings_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IPost_fleets_fleet_id_wings_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** Not found */
export class Delete_fleets_fleet_id_wings_wing_id_not_found implements IDelete_fleets_fleet_id_wings_wing_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IDelete_fleets_fleet_id_wings_wing_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Delete_fleets_fleet_id_wings_wing_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Delete_fleets_fleet_id_wings_wing_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IDelete_fleets_fleet_id_wings_wing_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** Not found */
export class Put_fleets_fleet_id_wings_wing_id_not_found implements IPut_fleets_fleet_id_wings_wing_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IPut_fleets_fleet_id_wings_wing_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Put_fleets_fleet_id_wings_wing_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Put_fleets_fleet_id_wings_wing_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IPut_fleets_fleet_id_wings_wing_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 201 created object */
export class Post_fleets_fleet_id_wings_wing_id_squads_created implements IPost_fleets_fleet_id_wings_wing_id_squads_created {
    /** The squad_id of the newly created squad */
    squad_id!: number;

    constructor(data?: IPost_fleets_fleet_id_wings_wing_id_squads_created) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.squad_id = _data["squad_id"];
        }
    }

    static fromJS(data: any): Post_fleets_fleet_id_wings_wing_id_squads_created {
        data = typeof data === 'object' ? data : {};
        let result = new Post_fleets_fleet_id_wings_wing_id_squads_created();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["squad_id"] = this.squad_id;
        return data;
    }
}

/** 201 created object */
export interface IPost_fleets_fleet_id_wings_wing_id_squads_created {
    /** The squad_id of the newly created squad */
    squad_id: number;
}

/** Not found */
export class Post_fleets_fleet_id_wings_wing_id_squads_not_found implements IPost_fleets_fleet_id_wings_wing_id_squads_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IPost_fleets_fleet_id_wings_wing_id_squads_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Post_fleets_fleet_id_wings_wing_id_squads_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Post_fleets_fleet_id_wings_wing_id_squads_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IPost_fleets_fleet_id_wings_wing_id_squads_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_fw_leaderboards_ok implements IGet_fw_leaderboards_ok {
    /** Top 4 rankings of factions by number of kills from yesterday, last week and in total */
    kills!: Kills3;
    /** Top 4 rankings of factions by victory points from yesterday, last week and in total */
    victory_points!: Victory_points3;

    constructor(data?: IGet_fw_leaderboards_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.kills = new Kills3();
            this.victory_points = new Victory_points3();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kills = _data["kills"] ? Kills3.fromJS(_data["kills"]) : new Kills3();
            this.victory_points = _data["victory_points"] ? Victory_points3.fromJS(_data["victory_points"]) : new Victory_points3();
        }
    }

    static fromJS(data: any): Get_fw_leaderboards_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_fw_leaderboards_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kills"] = this.kills ? this.kills.toJSON() : <any>undefined;
        data["victory_points"] = this.victory_points ? this.victory_points.toJSON() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_fw_leaderboards_ok {
    /** Top 4 rankings of factions by number of kills from yesterday, last week and in total */
    kills: Kills3;
    /** Top 4 rankings of factions by victory points from yesterday, last week and in total */
    victory_points: Victory_points3;
}

/** 200 ok object */
export class Get_fw_leaderboards_characters_ok implements IGet_fw_leaderboards_characters_ok {
    /** Top 100 rankings of pilots by number of kills from yesterday, last week and in total */
    kills!: Kills4;
    /** Top 100 rankings of pilots by victory points from yesterday, last week and in total */
    victory_points!: Victory_points4;

    constructor(data?: IGet_fw_leaderboards_characters_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.kills = new Kills4();
            this.victory_points = new Victory_points4();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kills = _data["kills"] ? Kills4.fromJS(_data["kills"]) : new Kills4();
            this.victory_points = _data["victory_points"] ? Victory_points4.fromJS(_data["victory_points"]) : new Victory_points4();
        }
    }

    static fromJS(data: any): Get_fw_leaderboards_characters_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_fw_leaderboards_characters_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kills"] = this.kills ? this.kills.toJSON() : <any>undefined;
        data["victory_points"] = this.victory_points ? this.victory_points.toJSON() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_fw_leaderboards_characters_ok {
    /** Top 100 rankings of pilots by number of kills from yesterday, last week and in total */
    kills: Kills4;
    /** Top 100 rankings of pilots by victory points from yesterday, last week and in total */
    victory_points: Victory_points4;
}

/** 200 ok object */
export class Get_fw_leaderboards_corporations_ok implements IGet_fw_leaderboards_corporations_ok {
    /** Top 10 rankings of corporations by number of kills from yesterday, last week and in total */
    kills!: Kills5;
    /** Top 10 rankings of corporations by victory points from yesterday, last week and in total */
    victory_points!: Victory_points5;

    constructor(data?: IGet_fw_leaderboards_corporations_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.kills = new Kills5();
            this.victory_points = new Victory_points5();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kills = _data["kills"] ? Kills5.fromJS(_data["kills"]) : new Kills5();
            this.victory_points = _data["victory_points"] ? Victory_points5.fromJS(_data["victory_points"]) : new Victory_points5();
        }
    }

    static fromJS(data: any): Get_fw_leaderboards_corporations_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_fw_leaderboards_corporations_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kills"] = this.kills ? this.kills.toJSON() : <any>undefined;
        data["victory_points"] = this.victory_points ? this.victory_points.toJSON() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_fw_leaderboards_corporations_ok {
    /** Top 10 rankings of corporations by number of kills from yesterday, last week and in total */
    kills: Kills5;
    /** Top 10 rankings of corporations by victory points from yesterday, last week and in total */
    victory_points: Victory_points5;
}

/** 200 ok object */
export class Get_fw_stats_200_ok implements IGet_fw_stats_200_ok {
    /** faction_id integer */
    faction_id!: number;
    /** Summary of kills against an enemy faction for the given faction */
    kills!: Kills6;
    /** How many pilots fight for the given faction */
    pilots!: number;
    /** The number of solar systems controlled by the given faction */
    systems_controlled!: number;
    /** Summary of victory points gained for the given faction */
    victory_points!: Victory_points6;

    constructor(data?: IGet_fw_stats_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.kills = new Kills6();
            this.victory_points = new Victory_points6();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faction_id = _data["faction_id"];
            this.kills = _data["kills"] ? Kills6.fromJS(_data["kills"]) : new Kills6();
            this.pilots = _data["pilots"];
            this.systems_controlled = _data["systems_controlled"];
            this.victory_points = _data["victory_points"] ? Victory_points6.fromJS(_data["victory_points"]) : new Victory_points6();
        }
    }

    static fromJS(data: any): Get_fw_stats_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_fw_stats_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faction_id"] = this.faction_id;
        data["kills"] = this.kills ? this.kills.toJSON() : <any>undefined;
        data["pilots"] = this.pilots;
        data["systems_controlled"] = this.systems_controlled;
        data["victory_points"] = this.victory_points ? this.victory_points.toJSON() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_fw_stats_200_ok {
    /** faction_id integer */
    faction_id: number;
    /** Summary of kills against an enemy faction for the given faction */
    kills: Kills6;
    /** How many pilots fight for the given faction */
    pilots: number;
    /** The number of solar systems controlled by the given faction */
    systems_controlled: number;
    /** Summary of victory points gained for the given faction */
    victory_points: Victory_points6;
}

/** 200 ok object */
export class Get_fw_wars_200_ok implements IGet_fw_wars_200_ok {
    /** The faction ID of the enemy faction. */
    against_id!: number;
    /** faction_id integer */
    faction_id!: number;

    constructor(data?: IGet_fw_wars_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.against_id = _data["against_id"];
            this.faction_id = _data["faction_id"];
        }
    }

    static fromJS(data: any): Get_fw_wars_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_fw_wars_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["against_id"] = this.against_id;
        data["faction_id"] = this.faction_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_fw_wars_200_ok {
    /** The faction ID of the enemy faction. */
    against_id: number;
    /** faction_id integer */
    faction_id: number;
}

/** 200 ok object */
export class Get_incursions_200_ok implements IGet_incursions_200_ok {
    /** The constellation id in which this incursion takes place */
    constellation_id!: number;
    /** The attacking faction's id */
    faction_id!: number;
    /** Whether the final encounter has boss or not */
    has_boss!: boolean;
    /** A list of infested solar system ids that are a part of this incursion */
    infested_solar_systems!: number[];
    /** Influence of this incursion as a float from 0 to 1 */
    influence!: number;
    /** Staging solar system for this incursion */
    staging_solar_system_id!: number;
    /** The state of this incursion */
    state!: Get_incursions_200_okState;
    /** The type of this incursion */
    type!: string;

    constructor(data?: IGet_incursions_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.infested_solar_systems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constellation_id = _data["constellation_id"];
            this.faction_id = _data["faction_id"];
            this.has_boss = _data["has_boss"];
            if (Array.isArray(_data["infested_solar_systems"])) {
                this.infested_solar_systems = [] as any;
                for (let item of _data["infested_solar_systems"])
                    this.infested_solar_systems!.push(item);
            }
            this.influence = _data["influence"];
            this.staging_solar_system_id = _data["staging_solar_system_id"];
            this.state = _data["state"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Get_incursions_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_incursions_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constellation_id"] = this.constellation_id;
        data["faction_id"] = this.faction_id;
        data["has_boss"] = this.has_boss;
        if (Array.isArray(this.infested_solar_systems)) {
            data["infested_solar_systems"] = [];
            for (let item of this.infested_solar_systems)
                data["infested_solar_systems"].push(item);
        }
        data["influence"] = this.influence;
        data["staging_solar_system_id"] = this.staging_solar_system_id;
        data["state"] = this.state;
        data["type"] = this.type;
        return data;
    }
}

/** 200 ok object */
export interface IGet_incursions_200_ok {
    /** The constellation id in which this incursion takes place */
    constellation_id: number;
    /** The attacking faction's id */
    faction_id: number;
    /** Whether the final encounter has boss or not */
    has_boss: boolean;
    /** A list of infested solar system ids that are a part of this incursion */
    infested_solar_systems: number[];
    /** Influence of this incursion as a float from 0 to 1 */
    influence: number;
    /** Staging solar system for this incursion */
    staging_solar_system_id: number;
    /** The state of this incursion */
    state: Get_incursions_200_okState;
    /** The type of this incursion */
    type: string;
}

/** 200 ok object */
export class Get_industry_facilities_200_ok implements IGet_industry_facilities_200_ok {
    /** ID of the facility */
    facility_id!: number;
    /** Owner of the facility */
    owner_id!: number;
    /** Region ID where the facility is */
    region_id!: number;
    /** Solar system ID where the facility is */
    solar_system_id!: number;
    /** Tax imposed by the facility */
    tax?: number | undefined;
    /** Type ID of the facility */
    type_id!: number;

    constructor(data?: IGet_industry_facilities_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facility_id = _data["facility_id"];
            this.owner_id = _data["owner_id"];
            this.region_id = _data["region_id"];
            this.solar_system_id = _data["solar_system_id"];
            this.tax = _data["tax"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_industry_facilities_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_industry_facilities_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facility_id"] = this.facility_id;
        data["owner_id"] = this.owner_id;
        data["region_id"] = this.region_id;
        data["solar_system_id"] = this.solar_system_id;
        data["tax"] = this.tax;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_industry_facilities_200_ok {
    /** ID of the facility */
    facility_id: number;
    /** Owner of the facility */
    owner_id: number;
    /** Region ID where the facility is */
    region_id: number;
    /** Solar system ID where the facility is */
    solar_system_id: number;
    /** Tax imposed by the facility */
    tax?: number | undefined;
    /** Type ID of the facility */
    type_id: number;
}

/** 200 ok object */
export class Get_industry_systems_200_ok implements IGet_industry_systems_200_ok {
    /** cost_indices array */
    cost_indices!: Cost_indices[];
    /** solar_system_id integer */
    solar_system_id!: number;

    constructor(data?: IGet_industry_systems_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.cost_indices = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cost_indices"])) {
                this.cost_indices = [] as any;
                for (let item of _data["cost_indices"])
                    this.cost_indices!.push(Cost_indices.fromJS(item));
            }
            this.solar_system_id = _data["solar_system_id"];
        }
    }

    static fromJS(data: any): Get_industry_systems_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_industry_systems_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cost_indices)) {
            data["cost_indices"] = [];
            for (let item of this.cost_indices)
                data["cost_indices"].push(item.toJSON());
        }
        data["solar_system_id"] = this.solar_system_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_industry_systems_200_ok {
    /** cost_indices array */
    cost_indices: Cost_indices[];
    /** solar_system_id integer */
    solar_system_id: number;
}

/** 200 ok object */
export class Get_insurance_prices_200_ok implements IGet_insurance_prices_200_ok {
    /** A list of a available insurance levels for this ship type */
    levels!: Levels[];
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_insurance_prices_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.levels = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(Levels.fromJS(item));
            }
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_insurance_prices_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_insurance_prices_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_insurance_prices_200_ok {
    /** A list of a available insurance levels for this ship type */
    levels: Levels[];
    /** type_id integer */
    type_id: number;
}

/** 200 ok object */
export class Get_killmails_killmail_id_killmail_hash_ok implements IGet_killmails_killmail_id_killmail_hash_ok {
    /** attackers array */
    attackers!: Attackers[];
    /** ID of the killmail */
    killmail_id!: number;
    /** Time that the victim was killed and the killmail generated
 */
    killmail_time!: Date;
    /** Moon if the kill took place at one */
    moon_id?: number | undefined;
    /** Solar system that the kill took place in
 */
    solar_system_id!: number;
    /** victim object */
    victim!: Victim;
    /** War if the killmail is generated in relation to an official war
 */
    war_id?: number | undefined;

    constructor(data?: IGet_killmails_killmail_id_killmail_hash_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attackers = [];
            this.victim = new Victim();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attackers"])) {
                this.attackers = [] as any;
                for (let item of _data["attackers"])
                    this.attackers!.push(Attackers.fromJS(item));
            }
            this.killmail_id = _data["killmail_id"];
            this.killmail_time = _data["killmail_time"] ? new Date(_data["killmail_time"].toString()) : <any>undefined;
            this.moon_id = _data["moon_id"];
            this.solar_system_id = _data["solar_system_id"];
            this.victim = _data["victim"] ? Victim.fromJS(_data["victim"]) : new Victim();
            this.war_id = _data["war_id"];
        }
    }

    static fromJS(data: any): Get_killmails_killmail_id_killmail_hash_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_killmails_killmail_id_killmail_hash_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attackers)) {
            data["attackers"] = [];
            for (let item of this.attackers)
                data["attackers"].push(item.toJSON());
        }
        data["killmail_id"] = this.killmail_id;
        data["killmail_time"] = this.killmail_time ? this.killmail_time.toISOString() : <any>undefined;
        data["moon_id"] = this.moon_id;
        data["solar_system_id"] = this.solar_system_id;
        data["victim"] = this.victim ? this.victim.toJSON() : <any>undefined;
        data["war_id"] = this.war_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_killmails_killmail_id_killmail_hash_ok {
    /** attackers array */
    attackers: Attackers[];
    /** ID of the killmail */
    killmail_id: number;
    /** Time that the victim was killed and the killmail generated
 */
    killmail_time: Date;
    /** Moon if the kill took place at one */
    moon_id?: number | undefined;
    /** Solar system that the kill took place in
 */
    solar_system_id: number;
    /** victim object */
    victim: Victim;
    /** War if the killmail is generated in relation to an official war
 */
    war_id?: number | undefined;
}

/** Unprocessable entity */
export class Get_killmails_killmail_id_killmail_hash_unprocessable_entity implements IGet_killmails_killmail_id_killmail_hash_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;

    constructor(data?: IGet_killmails_killmail_id_killmail_hash_unprocessable_entity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_killmails_killmail_id_killmail_hash_unprocessable_entity {
        data = typeof data === 'object' ? data : {};
        let result = new Get_killmails_killmail_id_killmail_hash_unprocessable_entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Unprocessable entity */
export interface IGet_killmails_killmail_id_killmail_hash_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_loyalty_stores_corporation_id_offers_200_ok implements IGet_loyalty_stores_corporation_id_offers_200_ok {
    /** Analysis kredit cost */
    ak_cost?: number | undefined;
    /** isk_cost integer */
    isk_cost!: number;
    /** lp_cost integer */
    lp_cost!: number;
    /** offer_id integer */
    offer_id!: number;
    /** quantity integer */
    quantity!: number;
    /** required_items array */
    required_items!: Required_items[];
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_loyalty_stores_corporation_id_offers_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.required_items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ak_cost = _data["ak_cost"];
            this.isk_cost = _data["isk_cost"];
            this.lp_cost = _data["lp_cost"];
            this.offer_id = _data["offer_id"];
            this.quantity = _data["quantity"];
            if (Array.isArray(_data["required_items"])) {
                this.required_items = [] as any;
                for (let item of _data["required_items"])
                    this.required_items!.push(Required_items.fromJS(item));
            }
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_loyalty_stores_corporation_id_offers_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_loyalty_stores_corporation_id_offers_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ak_cost"] = this.ak_cost;
        data["isk_cost"] = this.isk_cost;
        data["lp_cost"] = this.lp_cost;
        data["offer_id"] = this.offer_id;
        data["quantity"] = this.quantity;
        if (Array.isArray(this.required_items)) {
            data["required_items"] = [];
            for (let item of this.required_items)
                data["required_items"].push(item.toJSON());
        }
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_loyalty_stores_corporation_id_offers_200_ok {
    /** Analysis kredit cost */
    ak_cost?: number | undefined;
    /** isk_cost integer */
    isk_cost: number;
    /** lp_cost integer */
    lp_cost: number;
    /** offer_id integer */
    offer_id: number;
    /** quantity integer */
    quantity: number;
    /** required_items array */
    required_items: Required_items[];
    /** type_id integer */
    type_id: number;
}

/** Not found */
export class Get_loyalty_stores_corporation_id_offers_not_found implements IGet_loyalty_stores_corporation_id_offers_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_loyalty_stores_corporation_id_offers_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_loyalty_stores_corporation_id_offers_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_loyalty_stores_corporation_id_offers_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_loyalty_stores_corporation_id_offers_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_markets_groups_market_group_id_ok implements IGet_markets_groups_market_group_id_ok {
    /** description string */
    description!: string;
    /** market_group_id integer */
    market_group_id!: number;
    /** name string */
    name!: string;
    /** parent_group_id integer */
    parent_group_id?: number | undefined;
    /** types array */
    types!: number[];

    constructor(data?: IGet_markets_groups_market_group_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.types = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.market_group_id = _data["market_group_id"];
            this.name = _data["name"];
            this.parent_group_id = _data["parent_group_id"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static fromJS(data: any): Get_markets_groups_market_group_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_markets_groups_market_group_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["market_group_id"] = this.market_group_id;
        data["name"] = this.name;
        data["parent_group_id"] = this.parent_group_id;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

/** 200 ok object */
export interface IGet_markets_groups_market_group_id_ok {
    /** description string */
    description: string;
    /** market_group_id integer */
    market_group_id: number;
    /** name string */
    name: string;
    /** parent_group_id integer */
    parent_group_id?: number | undefined;
    /** types array */
    types: number[];
}

/** Not found */
export class Get_markets_groups_market_group_id_not_found implements IGet_markets_groups_market_group_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_markets_groups_market_group_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_markets_groups_market_group_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_markets_groups_market_group_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_markets_groups_market_group_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_markets_prices_200_ok implements IGet_markets_prices_200_ok {
    /** adjusted_price number */
    adjusted_price?: number | undefined;
    /** average_price number */
    average_price?: number | undefined;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_markets_prices_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adjusted_price = _data["adjusted_price"];
            this.average_price = _data["average_price"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_markets_prices_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_markets_prices_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adjusted_price"] = this.adjusted_price;
        data["average_price"] = this.average_price;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_markets_prices_200_ok {
    /** adjusted_price number */
    adjusted_price?: number | undefined;
    /** average_price number */
    average_price?: number | undefined;
    /** type_id integer */
    type_id: number;
}

/** 200 ok object */
export class Get_markets_structures_structure_id_200_ok implements IGet_markets_structures_structure_id_200_ok {
    /** duration integer */
    duration!: number;
    /** is_buy_order boolean */
    is_buy_order!: boolean;
    /** issued string */
    issued!: Date;
    /** location_id integer */
    location_id!: number;
    /** min_volume integer */
    min_volume!: number;
    /** order_id integer */
    order_id!: number;
    /** price number */
    price!: number;
    /** range string */
    range!: Get_markets_structures_structure_id_200_okRange;
    /** type_id integer */
    type_id!: number;
    /** volume_remain integer */
    volume_remain!: number;
    /** volume_total integer */
    volume_total!: number;

    constructor(data?: IGet_markets_structures_structure_id_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
            this.is_buy_order = _data["is_buy_order"];
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : <any>undefined;
            this.location_id = _data["location_id"];
            this.min_volume = _data["min_volume"];
            this.order_id = _data["order_id"];
            this.price = _data["price"];
            this.range = _data["range"];
            this.type_id = _data["type_id"];
            this.volume_remain = _data["volume_remain"];
            this.volume_total = _data["volume_total"];
        }
    }

    static fromJS(data: any): Get_markets_structures_structure_id_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_markets_structures_structure_id_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["is_buy_order"] = this.is_buy_order;
        data["issued"] = this.issued ? this.issued.toISOString() : <any>undefined;
        data["location_id"] = this.location_id;
        data["min_volume"] = this.min_volume;
        data["order_id"] = this.order_id;
        data["price"] = this.price;
        data["range"] = this.range;
        data["type_id"] = this.type_id;
        data["volume_remain"] = this.volume_remain;
        data["volume_total"] = this.volume_total;
        return data;
    }
}

/** 200 ok object */
export interface IGet_markets_structures_structure_id_200_ok {
    /** duration integer */
    duration: number;
    /** is_buy_order boolean */
    is_buy_order: boolean;
    /** issued string */
    issued: Date;
    /** location_id integer */
    location_id: number;
    /** min_volume integer */
    min_volume: number;
    /** order_id integer */
    order_id: number;
    /** price number */
    price: number;
    /** range string */
    range: Get_markets_structures_structure_id_200_okRange;
    /** type_id integer */
    type_id: number;
    /** volume_remain integer */
    volume_remain: number;
    /** volume_total integer */
    volume_total: number;
}

/** 200 ok object */
export class Get_markets_region_id_history_200_ok implements IGet_markets_region_id_history_200_ok {
    /** average number */
    average!: number;
    /** The date of this historical statistic entry */
    date!: Date;
    /** highest number */
    highest!: number;
    /** lowest number */
    lowest!: number;
    /** Total number of orders happened that day */
    order_count!: number;
    /** Total */
    volume!: number;

    constructor(data?: IGet_markets_region_id_history_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.average = _data["average"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.highest = _data["highest"];
            this.lowest = _data["lowest"];
            this.order_count = _data["order_count"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): Get_markets_region_id_history_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_markets_region_id_history_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["average"] = this.average;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["highest"] = this.highest;
        data["lowest"] = this.lowest;
        data["order_count"] = this.order_count;
        data["volume"] = this.volume;
        return data;
    }
}

/** 200 ok object */
export interface IGet_markets_region_id_history_200_ok {
    /** average number */
    average: number;
    /** The date of this historical statistic entry */
    date: Date;
    /** highest number */
    highest: number;
    /** lowest number */
    lowest: number;
    /** Total number of orders happened that day */
    order_count: number;
    /** Total */
    volume: number;
}

/** Not found */
export class Get_markets_region_id_history_not_found implements IGet_markets_region_id_history_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_markets_region_id_history_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_markets_region_id_history_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_markets_region_id_history_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_markets_region_id_history_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** Unprocessable entity */
export class Get_markets_region_id_history_unprocessable_entity implements IGet_markets_region_id_history_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;

    constructor(data?: IGet_markets_region_id_history_unprocessable_entity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_markets_region_id_history_unprocessable_entity {
        data = typeof data === 'object' ? data : {};
        let result = new Get_markets_region_id_history_unprocessable_entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Unprocessable entity */
export interface IGet_markets_region_id_history_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;
}

/** Error 520 */
export class Get_markets_region_id_history_error_520 implements IGet_markets_region_id_history_error_520 {
    /** Error 520 message */
    error?: string | undefined;

    constructor(data?: IGet_markets_region_id_history_error_520) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_markets_region_id_history_error_520 {
        data = typeof data === 'object' ? data : {};
        let result = new Get_markets_region_id_history_error_520();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Error 520 */
export interface IGet_markets_region_id_history_error_520 {
    /** Error 520 message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_markets_region_id_orders_200_ok implements IGet_markets_region_id_orders_200_ok {
    /** duration integer */
    duration!: number;
    /** is_buy_order boolean */
    is_buy_order!: boolean;
    /** issued string */
    issued!: Date;
    /** location_id integer */
    location_id!: number;
    /** min_volume integer */
    min_volume!: number;
    /** order_id integer */
    order_id!: number;
    /** price number */
    price!: number;
    /** range string */
    range!: Get_markets_region_id_orders_200_okRange;
    /** The solar system this order was placed */
    system_id!: number;
    /** type_id integer */
    type_id!: number;
    /** volume_remain integer */
    volume_remain!: number;
    /** volume_total integer */
    volume_total!: number;

    constructor(data?: IGet_markets_region_id_orders_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
            this.is_buy_order = _data["is_buy_order"];
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : <any>undefined;
            this.location_id = _data["location_id"];
            this.min_volume = _data["min_volume"];
            this.order_id = _data["order_id"];
            this.price = _data["price"];
            this.range = _data["range"];
            this.system_id = _data["system_id"];
            this.type_id = _data["type_id"];
            this.volume_remain = _data["volume_remain"];
            this.volume_total = _data["volume_total"];
        }
    }

    static fromJS(data: any): Get_markets_region_id_orders_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_markets_region_id_orders_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["is_buy_order"] = this.is_buy_order;
        data["issued"] = this.issued ? this.issued.toISOString() : <any>undefined;
        data["location_id"] = this.location_id;
        data["min_volume"] = this.min_volume;
        data["order_id"] = this.order_id;
        data["price"] = this.price;
        data["range"] = this.range;
        data["system_id"] = this.system_id;
        data["type_id"] = this.type_id;
        data["volume_remain"] = this.volume_remain;
        data["volume_total"] = this.volume_total;
        return data;
    }
}

/** 200 ok object */
export interface IGet_markets_region_id_orders_200_ok {
    /** duration integer */
    duration: number;
    /** is_buy_order boolean */
    is_buy_order: boolean;
    /** issued string */
    issued: Date;
    /** location_id integer */
    location_id: number;
    /** min_volume integer */
    min_volume: number;
    /** order_id integer */
    order_id: number;
    /** price number */
    price: number;
    /** range string */
    range: Get_markets_region_id_orders_200_okRange;
    /** The solar system this order was placed */
    system_id: number;
    /** type_id integer */
    type_id: number;
    /** volume_remain integer */
    volume_remain: number;
    /** volume_total integer */
    volume_total: number;
}

/** Not found */
export class Get_markets_region_id_orders_not_found implements IGet_markets_region_id_orders_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_markets_region_id_orders_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_markets_region_id_orders_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_markets_region_id_orders_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_markets_region_id_orders_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** Unprocessable entity */
export class Get_markets_region_id_orders_unprocessable_entity implements IGet_markets_region_id_orders_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;

    constructor(data?: IGet_markets_region_id_orders_unprocessable_entity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_markets_region_id_orders_unprocessable_entity {
        data = typeof data === 'object' ? data : {};
        let result = new Get_markets_region_id_orders_unprocessable_entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Unprocessable entity */
export interface IGet_markets_region_id_orders_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_opportunities_groups_group_id_ok implements IGet_opportunities_groups_group_id_ok {
    /** The groups that are connected to this group on the opportunities map */
    connected_groups!: number[];
    /** description string */
    description!: string;
    /** group_id integer */
    group_id!: number;
    /** name string */
    name!: string;
    /** notification string */
    notification!: string;
    /** Tasks need to complete for this group */
    required_tasks!: number[];

    constructor(data?: IGet_opportunities_groups_group_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.connected_groups = [];
            this.required_tasks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["connected_groups"])) {
                this.connected_groups = [] as any;
                for (let item of _data["connected_groups"])
                    this.connected_groups!.push(item);
            }
            this.description = _data["description"];
            this.group_id = _data["group_id"];
            this.name = _data["name"];
            this.notification = _data["notification"];
            if (Array.isArray(_data["required_tasks"])) {
                this.required_tasks = [] as any;
                for (let item of _data["required_tasks"])
                    this.required_tasks!.push(item);
            }
        }
    }

    static fromJS(data: any): Get_opportunities_groups_group_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_opportunities_groups_group_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connected_groups)) {
            data["connected_groups"] = [];
            for (let item of this.connected_groups)
                data["connected_groups"].push(item);
        }
        data["description"] = this.description;
        data["group_id"] = this.group_id;
        data["name"] = this.name;
        data["notification"] = this.notification;
        if (Array.isArray(this.required_tasks)) {
            data["required_tasks"] = [];
            for (let item of this.required_tasks)
                data["required_tasks"].push(item);
        }
        return data;
    }
}

/** 200 ok object */
export interface IGet_opportunities_groups_group_id_ok {
    /** The groups that are connected to this group on the opportunities map */
    connected_groups: number[];
    /** description string */
    description: string;
    /** group_id integer */
    group_id: number;
    /** name string */
    name: string;
    /** notification string */
    notification: string;
    /** Tasks need to complete for this group */
    required_tasks: number[];
}

/** 200 ok object */
export class Get_opportunities_tasks_task_id_ok implements IGet_opportunities_tasks_task_id_ok {
    /** description string */
    description!: string;
    /** name string */
    name!: string;
    /** notification string */
    notification!: string;
    /** task_id integer */
    task_id!: number;

    constructor(data?: IGet_opportunities_tasks_task_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.name = _data["name"];
            this.notification = _data["notification"];
            this.task_id = _data["task_id"];
        }
    }

    static fromJS(data: any): Get_opportunities_tasks_task_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_opportunities_tasks_task_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["name"] = this.name;
        data["notification"] = this.notification;
        data["task_id"] = this.task_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_opportunities_tasks_task_id_ok {
    /** description string */
    description: string;
    /** name string */
    name: string;
    /** notification string */
    notification: string;
    /** task_id integer */
    task_id: number;
}

/** Not found */
export class Get_route_origin_destination_not_found implements IGet_route_origin_destination_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_route_origin_destination_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_route_origin_destination_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_route_origin_destination_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_route_origin_destination_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_sovereignty_campaigns_200_ok implements IGet_sovereignty_campaigns_200_ok {
    /** Score for all attacking parties, only present in Defense Events.
 */
    attackers_score?: number | undefined;
    /** Unique ID for this campaign. */
    campaign_id!: number;
    /** The constellation in which the campaign will take place.
 */
    constellation_id!: number;
    /** Defending alliance, only present in Defense Events
 */
    defender_id?: number | undefined;
    /** Score for the defending alliance, only present in Defense Events.
 */
    defender_score?: number | undefined;
    /** Type of event this campaign is for. tcu_defense, ihub_defense and station_defense are referred to as "Defense Events", station_freeport as "Freeport Events".
 */
    event_type!: Get_sovereignty_campaigns_200_okEvent_type;
    /** Alliance participating and their respective scores, only present in Freeport Events.
 */
    participants?: Participants[] | undefined;
    /** The solar system the structure is located in.
 */
    solar_system_id!: number;
    /** Time the event is scheduled to start.
 */
    start_time!: Date;
    /** The structure item ID that is related to this campaign.
 */
    structure_id!: number;

    constructor(data?: IGet_sovereignty_campaigns_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attackers_score = _data["attackers_score"];
            this.campaign_id = _data["campaign_id"];
            this.constellation_id = _data["constellation_id"];
            this.defender_id = _data["defender_id"];
            this.defender_score = _data["defender_score"];
            this.event_type = _data["event_type"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(Participants.fromJS(item));
            }
            this.solar_system_id = _data["solar_system_id"];
            this.start_time = _data["start_time"] ? new Date(_data["start_time"].toString()) : <any>undefined;
            this.structure_id = _data["structure_id"];
        }
    }

    static fromJS(data: any): Get_sovereignty_campaigns_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_sovereignty_campaigns_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attackers_score"] = this.attackers_score;
        data["campaign_id"] = this.campaign_id;
        data["constellation_id"] = this.constellation_id;
        data["defender_id"] = this.defender_id;
        data["defender_score"] = this.defender_score;
        data["event_type"] = this.event_type;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        data["solar_system_id"] = this.solar_system_id;
        data["start_time"] = this.start_time ? this.start_time.toISOString() : <any>undefined;
        data["structure_id"] = this.structure_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_sovereignty_campaigns_200_ok {
    /** Score for all attacking parties, only present in Defense Events.
 */
    attackers_score?: number | undefined;
    /** Unique ID for this campaign. */
    campaign_id: number;
    /** The constellation in which the campaign will take place.
 */
    constellation_id: number;
    /** Defending alliance, only present in Defense Events
 */
    defender_id?: number | undefined;
    /** Score for the defending alliance, only present in Defense Events.
 */
    defender_score?: number | undefined;
    /** Type of event this campaign is for. tcu_defense, ihub_defense and station_defense are referred to as "Defense Events", station_freeport as "Freeport Events".
 */
    event_type: Get_sovereignty_campaigns_200_okEvent_type;
    /** Alliance participating and their respective scores, only present in Freeport Events.
 */
    participants?: Participants[] | undefined;
    /** The solar system the structure is located in.
 */
    solar_system_id: number;
    /** Time the event is scheduled to start.
 */
    start_time: Date;
    /** The structure item ID that is related to this campaign.
 */
    structure_id: number;
}

/** 200 ok object */
export class Get_sovereignty_map_200_ok implements IGet_sovereignty_map_200_ok {
    /** alliance_id integer */
    alliance_id?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;
    /** system_id integer */
    system_id!: number;

    constructor(data?: IGet_sovereignty_map_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.corporation_id = _data["corporation_id"];
            this.faction_id = _data["faction_id"];
            this.system_id = _data["system_id"];
        }
    }

    static fromJS(data: any): Get_sovereignty_map_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_sovereignty_map_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["corporation_id"] = this.corporation_id;
        data["faction_id"] = this.faction_id;
        data["system_id"] = this.system_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_sovereignty_map_200_ok {
    /** alliance_id integer */
    alliance_id?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;
    /** system_id integer */
    system_id: number;
}

/** 200 ok object */
export class Get_sovereignty_structures_200_ok implements IGet_sovereignty_structures_200_ok {
    /** The alliance that owns the structure.
 */
    alliance_id!: number;
    /** Solar system in which the structure is located.
 */
    solar_system_id!: number;
    /** Unique item ID for this structure. */
    structure_id!: number;
    /** A reference to the type of structure this is.
 */
    structure_type_id!: number;
    /** The occupancy level for the next or current vulnerability window. This takes into account all development indexes and capital system bonuses. Also known as Activity Defense Multiplier from in the client. It increases the time that attackers must spend using their entosis links on the structure.
 */
    vulnerability_occupancy_level?: number | undefined;
    /** The time at which the next or current vulnerability window ends. At the end of a vulnerability window the next window is recalculated and locked in along with the vulnerabilityOccupancyLevel. If the structure is not in 100% entosis control of the defender, it will go in to 'overtime' and stay vulnerable for as long as that situation persists. Only once the defenders have 100% entosis control and has the vulnerableEndTime passed does the vulnerability interval expire and a new one is calculated.
 */
    vulnerable_end_time?: Date | undefined;
    /** The next time at which the structure will become vulnerable. Or the start time of the current window if current time is between this and vulnerableEndTime.
 */
    vulnerable_start_time?: Date | undefined;

    constructor(data?: IGet_sovereignty_structures_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.solar_system_id = _data["solar_system_id"];
            this.structure_id = _data["structure_id"];
            this.structure_type_id = _data["structure_type_id"];
            this.vulnerability_occupancy_level = _data["vulnerability_occupancy_level"];
            this.vulnerable_end_time = _data["vulnerable_end_time"] ? new Date(_data["vulnerable_end_time"].toString()) : <any>undefined;
            this.vulnerable_start_time = _data["vulnerable_start_time"] ? new Date(_data["vulnerable_start_time"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_sovereignty_structures_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_sovereignty_structures_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["solar_system_id"] = this.solar_system_id;
        data["structure_id"] = this.structure_id;
        data["structure_type_id"] = this.structure_type_id;
        data["vulnerability_occupancy_level"] = this.vulnerability_occupancy_level;
        data["vulnerable_end_time"] = this.vulnerable_end_time ? this.vulnerable_end_time.toISOString() : <any>undefined;
        data["vulnerable_start_time"] = this.vulnerable_start_time ? this.vulnerable_start_time.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_sovereignty_structures_200_ok {
    /** The alliance that owns the structure.
 */
    alliance_id: number;
    /** Solar system in which the structure is located.
 */
    solar_system_id: number;
    /** Unique item ID for this structure. */
    structure_id: number;
    /** A reference to the type of structure this is.
 */
    structure_type_id: number;
    /** The occupancy level for the next or current vulnerability window. This takes into account all development indexes and capital system bonuses. Also known as Activity Defense Multiplier from in the client. It increases the time that attackers must spend using their entosis links on the structure.
 */
    vulnerability_occupancy_level?: number | undefined;
    /** The time at which the next or current vulnerability window ends. At the end of a vulnerability window the next window is recalculated and locked in along with the vulnerabilityOccupancyLevel. If the structure is not in 100% entosis control of the defender, it will go in to 'overtime' and stay vulnerable for as long as that situation persists. Only once the defenders have 100% entosis control and has the vulnerableEndTime passed does the vulnerability interval expire and a new one is calculated.
 */
    vulnerable_end_time?: Date | undefined;
    /** The next time at which the structure will become vulnerable. Or the start time of the current window if current time is between this and vulnerableEndTime.
 */
    vulnerable_start_time?: Date | undefined;
}

/** 200 ok object */
export class Get_status_ok implements IGet_status_ok {
    /** Current online player count */
    players!: number;
    /** Running version as string */
    server_version!: string;
    /** Server start timestamp */
    start_time!: Date;
    /** If the server is in VIP mode */
    vip?: boolean | undefined;

    constructor(data?: IGet_status_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.players = _data["players"];
            this.server_version = _data["server_version"];
            this.start_time = _data["start_time"] ? new Date(_data["start_time"].toString()) : <any>undefined;
            this.vip = _data["vip"];
        }
    }

    static fromJS(data: any): Get_status_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_status_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["players"] = this.players;
        data["server_version"] = this.server_version;
        data["start_time"] = this.start_time ? this.start_time.toISOString() : <any>undefined;
        data["vip"] = this.vip;
        return data;
    }
}

/** 200 ok object */
export interface IGet_status_ok {
    /** Current online player count */
    players: number;
    /** Running version as string */
    server_version: string;
    /** Server start timestamp */
    start_time: Date;
    /** If the server is in VIP mode */
    vip?: boolean | undefined;
}

/** Unprocessable entity */
export class Post_ui_openwindow_newmail_unprocessable_entity implements IPost_ui_openwindow_newmail_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;

    constructor(data?: IPost_ui_openwindow_newmail_unprocessable_entity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Post_ui_openwindow_newmail_unprocessable_entity {
        data = typeof data === 'object' ? data : {};
        let result = new Post_ui_openwindow_newmail_unprocessable_entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Unprocessable entity */
export interface IPost_ui_openwindow_newmail_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_ancestries_200_ok implements IGet_universe_ancestries_200_ok {
    /** The bloodline associated with this ancestry */
    bloodline_id!: number;
    /** description string */
    description!: string;
    /** icon_id integer */
    icon_id?: number | undefined;
    /** id integer */
    id!: number;
    /** name string */
    name!: string;
    /** short_description string */
    short_description?: string | undefined;

    constructor(data?: IGet_universe_ancestries_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bloodline_id = _data["bloodline_id"];
            this.description = _data["description"];
            this.icon_id = _data["icon_id"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.short_description = _data["short_description"];
        }
    }

    static fromJS(data: any): Get_universe_ancestries_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_ancestries_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bloodline_id"] = this.bloodline_id;
        data["description"] = this.description;
        data["icon_id"] = this.icon_id;
        data["id"] = this.id;
        data["name"] = this.name;
        data["short_description"] = this.short_description;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_ancestries_200_ok {
    /** The bloodline associated with this ancestry */
    bloodline_id: number;
    /** description string */
    description: string;
    /** icon_id integer */
    icon_id?: number | undefined;
    /** id integer */
    id: number;
    /** name string */
    name: string;
    /** short_description string */
    short_description?: string | undefined;
}

/** 200 ok object */
export class Get_universe_asteroid_belts_asteroid_belt_id_ok implements IGet_universe_asteroid_belts_asteroid_belt_id_ok {
    /** name string */
    name!: string;
    /** position object */
    position!: Position;
    /** The solar system this asteroid belt is in */
    system_id!: number;

    constructor(data?: IGet_universe_asteroid_belts_asteroid_belt_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.position = new Position();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.position = _data["position"] ? Position.fromJS(_data["position"]) : new Position();
            this.system_id = _data["system_id"];
        }
    }

    static fromJS(data: any): Get_universe_asteroid_belts_asteroid_belt_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_asteroid_belts_asteroid_belt_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["system_id"] = this.system_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_asteroid_belts_asteroid_belt_id_ok {
    /** name string */
    name: string;
    /** position object */
    position: Position;
    /** The solar system this asteroid belt is in */
    system_id: number;
}

/** Not found */
export class Get_universe_asteroid_belts_asteroid_belt_id_not_found implements IGet_universe_asteroid_belts_asteroid_belt_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_asteroid_belts_asteroid_belt_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_asteroid_belts_asteroid_belt_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_asteroid_belts_asteroid_belt_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_asteroid_belts_asteroid_belt_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_bloodlines_200_ok implements IGet_universe_bloodlines_200_ok {
    /** bloodline_id integer */
    bloodline_id!: number;
    /** charisma integer */
    charisma!: number;
    /** corporation_id integer */
    corporation_id!: number;
    /** description string */
    description!: string;
    /** intelligence integer */
    intelligence!: number;
    /** memory integer */
    memory!: number;
    /** name string */
    name!: string;
    /** perception integer */
    perception!: number;
    /** race_id integer */
    race_id!: number;
    /** ship_type_id integer */
    ship_type_id!: number | undefined;
    /** willpower integer */
    willpower!: number;

    constructor(data?: IGet_universe_bloodlines_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bloodline_id = _data["bloodline_id"];
            this.charisma = _data["charisma"];
            this.corporation_id = _data["corporation_id"];
            this.description = _data["description"];
            this.intelligence = _data["intelligence"];
            this.memory = _data["memory"];
            this.name = _data["name"];
            this.perception = _data["perception"];
            this.race_id = _data["race_id"];
            this.ship_type_id = _data["ship_type_id"];
            this.willpower = _data["willpower"];
        }
    }

    static fromJS(data: any): Get_universe_bloodlines_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_bloodlines_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bloodline_id"] = this.bloodline_id;
        data["charisma"] = this.charisma;
        data["corporation_id"] = this.corporation_id;
        data["description"] = this.description;
        data["intelligence"] = this.intelligence;
        data["memory"] = this.memory;
        data["name"] = this.name;
        data["perception"] = this.perception;
        data["race_id"] = this.race_id;
        data["ship_type_id"] = this.ship_type_id;
        data["willpower"] = this.willpower;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_bloodlines_200_ok {
    /** bloodline_id integer */
    bloodline_id: number;
    /** charisma integer */
    charisma: number;
    /** corporation_id integer */
    corporation_id: number;
    /** description string */
    description: string;
    /** intelligence integer */
    intelligence: number;
    /** memory integer */
    memory: number;
    /** name string */
    name: string;
    /** perception integer */
    perception: number;
    /** race_id integer */
    race_id: number;
    /** ship_type_id integer */
    ship_type_id: number | undefined;
    /** willpower integer */
    willpower: number;
}

/** 200 ok object */
export class Get_universe_categories_category_id_ok implements IGet_universe_categories_category_id_ok {
    /** category_id integer */
    category_id!: number;
    /** groups array */
    groups!: number[];
    /** name string */
    name!: string;
    /** published boolean */
    published!: boolean;

    constructor(data?: IGet_universe_categories_category_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.groups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category_id = _data["category_id"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
            this.name = _data["name"];
            this.published = _data["published"];
        }
    }

    static fromJS(data: any): Get_universe_categories_category_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_categories_category_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category_id"] = this.category_id;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["published"] = this.published;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_categories_category_id_ok {
    /** category_id integer */
    category_id: number;
    /** groups array */
    groups: number[];
    /** name string */
    name: string;
    /** published boolean */
    published: boolean;
}

/** Not found */
export class Get_universe_categories_category_id_not_found implements IGet_universe_categories_category_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_categories_category_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_categories_category_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_categories_category_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_categories_category_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_constellations_constellation_id_ok implements IGet_universe_constellations_constellation_id_ok {
    /** constellation_id integer */
    constellation_id!: number;
    /** name string */
    name!: string;
    /** position object */
    position!: Position2;
    /** The region this constellation is in */
    region_id!: number;
    /** systems array */
    systems!: number[];

    constructor(data?: IGet_universe_constellations_constellation_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.position = new Position2();
            this.systems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constellation_id = _data["constellation_id"];
            this.name = _data["name"];
            this.position = _data["position"] ? Position2.fromJS(_data["position"]) : new Position2();
            this.region_id = _data["region_id"];
            if (Array.isArray(_data["systems"])) {
                this.systems = [] as any;
                for (let item of _data["systems"])
                    this.systems!.push(item);
            }
        }
    }

    static fromJS(data: any): Get_universe_constellations_constellation_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_constellations_constellation_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constellation_id"] = this.constellation_id;
        data["name"] = this.name;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["region_id"] = this.region_id;
        if (Array.isArray(this.systems)) {
            data["systems"] = [];
            for (let item of this.systems)
                data["systems"].push(item);
        }
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_constellations_constellation_id_ok {
    /** constellation_id integer */
    constellation_id: number;
    /** name string */
    name: string;
    /** position object */
    position: Position2;
    /** The region this constellation is in */
    region_id: number;
    /** systems array */
    systems: number[];
}

/** Not found */
export class Get_universe_constellations_constellation_id_not_found implements IGet_universe_constellations_constellation_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_constellations_constellation_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_constellations_constellation_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_constellations_constellation_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_constellations_constellation_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_graphics_graphic_id_ok implements IGet_universe_graphics_graphic_id_ok {
    /** collision_file string */
    collision_file?: string | undefined;
    /** graphic_file string */
    graphic_file?: string | undefined;
    /** graphic_id integer */
    graphic_id!: number;
    /** icon_folder string */
    icon_folder?: string | undefined;
    /** sof_dna string */
    sof_dna?: string | undefined;
    /** sof_fation_name string */
    sof_fation_name?: string | undefined;
    /** sof_hull_name string */
    sof_hull_name?: string | undefined;
    /** sof_race_name string */
    sof_race_name?: string | undefined;

    constructor(data?: IGet_universe_graphics_graphic_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.collision_file = _data["collision_file"];
            this.graphic_file = _data["graphic_file"];
            this.graphic_id = _data["graphic_id"];
            this.icon_folder = _data["icon_folder"];
            this.sof_dna = _data["sof_dna"];
            this.sof_fation_name = _data["sof_fation_name"];
            this.sof_hull_name = _data["sof_hull_name"];
            this.sof_race_name = _data["sof_race_name"];
        }
    }

    static fromJS(data: any): Get_universe_graphics_graphic_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_graphics_graphic_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collision_file"] = this.collision_file;
        data["graphic_file"] = this.graphic_file;
        data["graphic_id"] = this.graphic_id;
        data["icon_folder"] = this.icon_folder;
        data["sof_dna"] = this.sof_dna;
        data["sof_fation_name"] = this.sof_fation_name;
        data["sof_hull_name"] = this.sof_hull_name;
        data["sof_race_name"] = this.sof_race_name;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_graphics_graphic_id_ok {
    /** collision_file string */
    collision_file?: string | undefined;
    /** graphic_file string */
    graphic_file?: string | undefined;
    /** graphic_id integer */
    graphic_id: number;
    /** icon_folder string */
    icon_folder?: string | undefined;
    /** sof_dna string */
    sof_dna?: string | undefined;
    /** sof_fation_name string */
    sof_fation_name?: string | undefined;
    /** sof_hull_name string */
    sof_hull_name?: string | undefined;
    /** sof_race_name string */
    sof_race_name?: string | undefined;
}

/** Not found */
export class Get_universe_graphics_graphic_id_not_found implements IGet_universe_graphics_graphic_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_graphics_graphic_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_graphics_graphic_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_graphics_graphic_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_graphics_graphic_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_groups_group_id_ok implements IGet_universe_groups_group_id_ok {
    /** category_id integer */
    category_id!: number;
    /** group_id integer */
    group_id!: number;
    /** name string */
    name!: string;
    /** published boolean */
    published!: boolean;
    /** types array */
    types!: number[];

    constructor(data?: IGet_universe_groups_group_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.types = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category_id = _data["category_id"];
            this.group_id = _data["group_id"];
            this.name = _data["name"];
            this.published = _data["published"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static fromJS(data: any): Get_universe_groups_group_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_groups_group_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category_id"] = this.category_id;
        data["group_id"] = this.group_id;
        data["name"] = this.name;
        data["published"] = this.published;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_groups_group_id_ok {
    /** category_id integer */
    category_id: number;
    /** group_id integer */
    group_id: number;
    /** name string */
    name: string;
    /** published boolean */
    published: boolean;
    /** types array */
    types: number[];
}

/** Not found */
export class Get_universe_groups_group_id_not_found implements IGet_universe_groups_group_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_groups_group_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_groups_group_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_groups_group_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_groups_group_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Post_universe_ids_ok implements IPost_universe_ids_ok {
    /** agents array */
    agents?: Agents[] | undefined;
    /** alliances array */
    alliances?: Alliances[] | undefined;
    /** characters array */
    characters?: Characters[] | undefined;
    /** constellations array */
    constellations?: Constellations[] | undefined;
    /** corporations array */
    corporations?: Corporations[] | undefined;
    /** factions array */
    factions?: Factions[] | undefined;
    /** inventory_types array */
    inventory_types?: Inventory_types[] | undefined;
    /** regions array */
    regions?: Regions[] | undefined;
    /** stations array */
    stations?: Stations[] | undefined;
    /** systems array */
    systems?: Systems[] | undefined;

    constructor(data?: IPost_universe_ids_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(Agents.fromJS(item));
            }
            if (Array.isArray(_data["alliances"])) {
                this.alliances = [] as any;
                for (let item of _data["alliances"])
                    this.alliances!.push(Alliances.fromJS(item));
            }
            if (Array.isArray(_data["characters"])) {
                this.characters = [] as any;
                for (let item of _data["characters"])
                    this.characters!.push(Characters.fromJS(item));
            }
            if (Array.isArray(_data["constellations"])) {
                this.constellations = [] as any;
                for (let item of _data["constellations"])
                    this.constellations!.push(Constellations.fromJS(item));
            }
            if (Array.isArray(_data["corporations"])) {
                this.corporations = [] as any;
                for (let item of _data["corporations"])
                    this.corporations!.push(Corporations.fromJS(item));
            }
            if (Array.isArray(_data["factions"])) {
                this.factions = [] as any;
                for (let item of _data["factions"])
                    this.factions!.push(Factions.fromJS(item));
            }
            if (Array.isArray(_data["inventory_types"])) {
                this.inventory_types = [] as any;
                for (let item of _data["inventory_types"])
                    this.inventory_types!.push(Inventory_types.fromJS(item));
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(Regions.fromJS(item));
            }
            if (Array.isArray(_data["stations"])) {
                this.stations = [] as any;
                for (let item of _data["stations"])
                    this.stations!.push(Stations.fromJS(item));
            }
            if (Array.isArray(_data["systems"])) {
                this.systems = [] as any;
                for (let item of _data["systems"])
                    this.systems!.push(Systems.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Post_universe_ids_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Post_universe_ids_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        if (Array.isArray(this.alliances)) {
            data["alliances"] = [];
            for (let item of this.alliances)
                data["alliances"].push(item.toJSON());
        }
        if (Array.isArray(this.characters)) {
            data["characters"] = [];
            for (let item of this.characters)
                data["characters"].push(item.toJSON());
        }
        if (Array.isArray(this.constellations)) {
            data["constellations"] = [];
            for (let item of this.constellations)
                data["constellations"].push(item.toJSON());
        }
        if (Array.isArray(this.corporations)) {
            data["corporations"] = [];
            for (let item of this.corporations)
                data["corporations"].push(item.toJSON());
        }
        if (Array.isArray(this.factions)) {
            data["factions"] = [];
            for (let item of this.factions)
                data["factions"].push(item.toJSON());
        }
        if (Array.isArray(this.inventory_types)) {
            data["inventory_types"] = [];
            for (let item of this.inventory_types)
                data["inventory_types"].push(item.toJSON());
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item.toJSON());
        }
        if (Array.isArray(this.stations)) {
            data["stations"] = [];
            for (let item of this.stations)
                data["stations"].push(item.toJSON());
        }
        if (Array.isArray(this.systems)) {
            data["systems"] = [];
            for (let item of this.systems)
                data["systems"].push(item.toJSON());
        }
        return data;
    }
}

/** 200 ok object */
export interface IPost_universe_ids_ok {
    /** agents array */
    agents?: Agents[] | undefined;
    /** alliances array */
    alliances?: Alliances[] | undefined;
    /** characters array */
    characters?: Characters[] | undefined;
    /** constellations array */
    constellations?: Constellations[] | undefined;
    /** corporations array */
    corporations?: Corporations[] | undefined;
    /** factions array */
    factions?: Factions[] | undefined;
    /** inventory_types array */
    inventory_types?: Inventory_types[] | undefined;
    /** regions array */
    regions?: Regions[] | undefined;
    /** stations array */
    stations?: Stations[] | undefined;
    /** systems array */
    systems?: Systems[] | undefined;
}

/** 200 ok object */
export class Get_universe_moons_moon_id_ok implements IGet_universe_moons_moon_id_ok {
    /** moon_id integer */
    moon_id!: number;
    /** name string */
    name!: string;
    /** position object */
    position!: Position3;
    /** The solar system this moon is in */
    system_id!: number;

    constructor(data?: IGet_universe_moons_moon_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.position = new Position3();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moon_id = _data["moon_id"];
            this.name = _data["name"];
            this.position = _data["position"] ? Position3.fromJS(_data["position"]) : new Position3();
            this.system_id = _data["system_id"];
        }
    }

    static fromJS(data: any): Get_universe_moons_moon_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_moons_moon_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moon_id"] = this.moon_id;
        data["name"] = this.name;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["system_id"] = this.system_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_moons_moon_id_ok {
    /** moon_id integer */
    moon_id: number;
    /** name string */
    name: string;
    /** position object */
    position: Position3;
    /** The solar system this moon is in */
    system_id: number;
}

/** Not found */
export class Get_universe_moons_moon_id_not_found implements IGet_universe_moons_moon_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_moons_moon_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_moons_moon_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_moons_moon_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_moons_moon_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_planets_planet_id_ok implements IGet_universe_planets_planet_id_ok {
    /** name string */
    name!: string;
    /** planet_id integer */
    planet_id!: number;
    /** position object */
    position!: Position4;
    /** The solar system this planet is in */
    system_id!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_universe_planets_planet_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.position = new Position4();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.planet_id = _data["planet_id"];
            this.position = _data["position"] ? Position4.fromJS(_data["position"]) : new Position4();
            this.system_id = _data["system_id"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_universe_planets_planet_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_planets_planet_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["planet_id"] = this.planet_id;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["system_id"] = this.system_id;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_planets_planet_id_ok {
    /** name string */
    name: string;
    /** planet_id integer */
    planet_id: number;
    /** position object */
    position: Position4;
    /** The solar system this planet is in */
    system_id: number;
    /** type_id integer */
    type_id: number;
}

/** Not found */
export class Get_universe_planets_planet_id_not_found implements IGet_universe_planets_planet_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_planets_planet_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_planets_planet_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_planets_planet_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_planets_planet_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_races_200_ok implements IGet_universe_races_200_ok {
    /** The alliance generally associated with this race */
    alliance_id!: number;
    /** description string */
    description!: string;
    /** name string */
    name!: string;
    /** race_id integer */
    race_id!: number;

    constructor(data?: IGet_universe_races_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.race_id = _data["race_id"];
        }
    }

    static fromJS(data: any): Get_universe_races_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_races_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["description"] = this.description;
        data["name"] = this.name;
        data["race_id"] = this.race_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_races_200_ok {
    /** The alliance generally associated with this race */
    alliance_id: number;
    /** description string */
    description: string;
    /** name string */
    name: string;
    /** race_id integer */
    race_id: number;
}

/** 200 ok object */
export class Get_universe_regions_region_id_ok implements IGet_universe_regions_region_id_ok {
    /** constellations array */
    constellations!: number[];
    /** description string */
    description?: string | undefined;
    /** name string */
    name!: string;
    /** region_id integer */
    region_id!: number;

    constructor(data?: IGet_universe_regions_region_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.constellations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["constellations"])) {
                this.constellations = [] as any;
                for (let item of _data["constellations"])
                    this.constellations!.push(item);
            }
            this.description = _data["description"];
            this.name = _data["name"];
            this.region_id = _data["region_id"];
        }
    }

    static fromJS(data: any): Get_universe_regions_region_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_regions_region_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.constellations)) {
            data["constellations"] = [];
            for (let item of this.constellations)
                data["constellations"].push(item);
        }
        data["description"] = this.description;
        data["name"] = this.name;
        data["region_id"] = this.region_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_regions_region_id_ok {
    /** constellations array */
    constellations: number[];
    /** description string */
    description?: string | undefined;
    /** name string */
    name: string;
    /** region_id integer */
    region_id: number;
}

/** Not found */
export class Get_universe_regions_region_id_not_found implements IGet_universe_regions_region_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_regions_region_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_regions_region_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_regions_region_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_regions_region_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_schematics_schematic_id_ok implements IGet_universe_schematics_schematic_id_ok {
    /** Time in seconds to process a run */
    cycle_time!: number;
    /** schematic_name string */
    schematic_name!: string;

    constructor(data?: IGet_universe_schematics_schematic_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cycle_time = _data["cycle_time"];
            this.schematic_name = _data["schematic_name"];
        }
    }

    static fromJS(data: any): Get_universe_schematics_schematic_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_schematics_schematic_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycle_time"] = this.cycle_time;
        data["schematic_name"] = this.schematic_name;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_schematics_schematic_id_ok {
    /** Time in seconds to process a run */
    cycle_time: number;
    /** schematic_name string */
    schematic_name: string;
}

/** Schematic not found */
export class Get_universe_schematics_schematic_id_not_found implements IGet_universe_schematics_schematic_id_not_found {
    /** error message */
    error?: string | undefined;

    constructor(data?: IGet_universe_schematics_schematic_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_schematics_schematic_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_schematics_schematic_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Schematic not found */
export interface IGet_universe_schematics_schematic_id_not_found {
    /** error message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_stargates_stargate_id_ok implements IGet_universe_stargates_stargate_id_ok {
    /** destination object */
    destination!: Destination;
    /** name string */
    name!: string;
    /** position object */
    position!: Position5;
    /** stargate_id integer */
    stargate_id!: number;
    /** The solar system this stargate is in */
    system_id!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_universe_stargates_stargate_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.destination = new Destination();
            this.position = new Position5();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destination = _data["destination"] ? Destination.fromJS(_data["destination"]) : new Destination();
            this.name = _data["name"];
            this.position = _data["position"] ? Position5.fromJS(_data["position"]) : new Position5();
            this.stargate_id = _data["stargate_id"];
            this.system_id = _data["system_id"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_universe_stargates_stargate_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_stargates_stargate_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["stargate_id"] = this.stargate_id;
        data["system_id"] = this.system_id;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_stargates_stargate_id_ok {
    /** destination object */
    destination: Destination;
    /** name string */
    name: string;
    /** position object */
    position: Position5;
    /** stargate_id integer */
    stargate_id: number;
    /** The solar system this stargate is in */
    system_id: number;
    /** type_id integer */
    type_id: number;
}

/** Not found */
export class Get_universe_stargates_stargate_id_not_found implements IGet_universe_stargates_stargate_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_stargates_stargate_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_stargates_stargate_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_stargates_stargate_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_stargates_stargate_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_stars_star_id_ok implements IGet_universe_stars_star_id_ok {
    /** Age of star in years */
    age!: number;
    /** luminosity number */
    luminosity!: number;
    /** name string */
    name!: string;
    /** radius integer */
    radius!: number;
    /** solar_system_id integer */
    solar_system_id!: number;
    /** spectral_class string */
    spectral_class!: Get_universe_stars_star_id_okSpectral_class;
    /** temperature integer */
    temperature!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_universe_stars_star_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.luminosity = _data["luminosity"];
            this.name = _data["name"];
            this.radius = _data["radius"];
            this.solar_system_id = _data["solar_system_id"];
            this.spectral_class = _data["spectral_class"];
            this.temperature = _data["temperature"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_universe_stars_star_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_stars_star_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["luminosity"] = this.luminosity;
        data["name"] = this.name;
        data["radius"] = this.radius;
        data["solar_system_id"] = this.solar_system_id;
        data["spectral_class"] = this.spectral_class;
        data["temperature"] = this.temperature;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_stars_star_id_ok {
    /** Age of star in years */
    age: number;
    /** luminosity number */
    luminosity: number;
    /** name string */
    name: string;
    /** radius integer */
    radius: number;
    /** solar_system_id integer */
    solar_system_id: number;
    /** spectral_class string */
    spectral_class: Get_universe_stars_star_id_okSpectral_class;
    /** temperature integer */
    temperature: number;
    /** type_id integer */
    type_id: number;
}

/** 200 ok object */
export class Get_universe_system_jumps_200_ok implements IGet_universe_system_jumps_200_ok {
    /** ship_jumps integer */
    ship_jumps!: number;
    /** system_id integer */
    system_id!: number;

    constructor(data?: IGet_universe_system_jumps_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ship_jumps = _data["ship_jumps"];
            this.system_id = _data["system_id"];
        }
    }

    static fromJS(data: any): Get_universe_system_jumps_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_system_jumps_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ship_jumps"] = this.ship_jumps;
        data["system_id"] = this.system_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_system_jumps_200_ok {
    /** ship_jumps integer */
    ship_jumps: number;
    /** system_id integer */
    system_id: number;
}

/** 200 ok object */
export class Get_wars_war_id_ok implements IGet_wars_war_id_ok {
    /** The aggressor corporation or alliance that declared this war, only contains either corporation_id or alliance_id */
    aggressor!: Aggressor;
    /** allied corporations or alliances, each object contains either corporation_id or alliance_id */
    allies?: Allies[] | undefined;
    /** Time that the war was declared */
    declared!: Date;
    /** The defending corporation or alliance that declared this war, only contains either corporation_id or alliance_id */
    defender!: Defender;
    /** Time the war ended and shooting was no longer allowed */
    finished?: Date | undefined;
    /** ID of the specified war */
    id!: number;
    /** Was the war declared mutual by both parties */
    mutual!: boolean;
    /** Is the war currently open for allies or not */
    open_for_allies!: boolean;
    /** Time the war was retracted but both sides could still shoot each other */
    retracted?: Date | undefined;
    /** Time when the war started and both sides could shoot each other */
    started?: Date | undefined;

    constructor(data?: IGet_wars_war_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.aggressor = new Aggressor();
            this.defender = new Defender();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aggressor = _data["aggressor"] ? Aggressor.fromJS(_data["aggressor"]) : new Aggressor();
            if (Array.isArray(_data["allies"])) {
                this.allies = [] as any;
                for (let item of _data["allies"])
                    this.allies!.push(Allies.fromJS(item));
            }
            this.declared = _data["declared"] ? new Date(_data["declared"].toString()) : <any>undefined;
            this.defender = _data["defender"] ? Defender.fromJS(_data["defender"]) : new Defender();
            this.finished = _data["finished"] ? new Date(_data["finished"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.mutual = _data["mutual"];
            this.open_for_allies = _data["open_for_allies"];
            this.retracted = _data["retracted"] ? new Date(_data["retracted"].toString()) : <any>undefined;
            this.started = _data["started"] ? new Date(_data["started"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_wars_war_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_wars_war_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aggressor"] = this.aggressor ? this.aggressor.toJSON() : <any>undefined;
        if (Array.isArray(this.allies)) {
            data["allies"] = [];
            for (let item of this.allies)
                data["allies"].push(item.toJSON());
        }
        data["declared"] = this.declared ? this.declared.toISOString() : <any>undefined;
        data["defender"] = this.defender ? this.defender.toJSON() : <any>undefined;
        data["finished"] = this.finished ? this.finished.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["mutual"] = this.mutual;
        data["open_for_allies"] = this.open_for_allies;
        data["retracted"] = this.retracted ? this.retracted.toISOString() : <any>undefined;
        data["started"] = this.started ? this.started.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_wars_war_id_ok {
    /** The aggressor corporation or alliance that declared this war, only contains either corporation_id or alliance_id */
    aggressor: Aggressor;
    /** allied corporations or alliances, each object contains either corporation_id or alliance_id */
    allies?: Allies[] | undefined;
    /** Time that the war was declared */
    declared: Date;
    /** The defending corporation or alliance that declared this war, only contains either corporation_id or alliance_id */
    defender: Defender;
    /** Time the war ended and shooting was no longer allowed */
    finished?: Date | undefined;
    /** ID of the specified war */
    id: number;
    /** Was the war declared mutual by both parties */
    mutual: boolean;
    /** Is the war currently open for allies or not */
    open_for_allies: boolean;
    /** Time the war was retracted but both sides could still shoot each other */
    retracted?: Date | undefined;
    /** Time when the war started and both sides could shoot each other */
    started?: Date | undefined;
}

/** Unprocessable entity */
export class Get_wars_war_id_unprocessable_entity implements IGet_wars_war_id_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;

    constructor(data?: IGet_wars_war_id_unprocessable_entity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_wars_war_id_unprocessable_entity {
        data = typeof data === 'object' ? data : {};
        let result = new Get_wars_war_id_unprocessable_entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Unprocessable entity */
export interface IGet_wars_war_id_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_wars_war_id_killmails_200_ok implements IGet_wars_war_id_killmails_200_ok {
    /** A hash of this killmail */
    killmail_hash!: string;
    /** ID of this killmail */
    killmail_id!: number;

    constructor(data?: IGet_wars_war_id_killmails_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.killmail_hash = _data["killmail_hash"];
            this.killmail_id = _data["killmail_id"];
        }
    }

    static fromJS(data: any): Get_wars_war_id_killmails_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_wars_war_id_killmails_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["killmail_hash"] = this.killmail_hash;
        data["killmail_id"] = this.killmail_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_wars_war_id_killmails_200_ok {
    /** A hash of this killmail */
    killmail_hash: string;
    /** ID of this killmail */
    killmail_id: number;
}

/** Unprocessable entity */
export class Get_wars_war_id_killmails_unprocessable_entity implements IGet_wars_war_id_killmails_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;

    constructor(data?: IGet_wars_war_id_killmails_unprocessable_entity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_wars_war_id_killmails_unprocessable_entity {
        data = typeof data === 'object' ? data : {};
        let result = new Get_wars_war_id_killmails_unprocessable_entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Unprocessable entity */
export interface IGet_wars_war_id_killmails_unprocessable_entity {
    /** Unprocessable entity message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_alliances_alliance_id_contacts_200_ok implements IGet_alliances_alliance_id_contacts_200_ok {
    /** contact_id integer */
    contact_id!: number;
    /** contact_type string */
    contact_type!: Get_alliances_alliance_id_contacts_200_okContact_type;
    /** label_ids array */
    label_ids?: number[] | undefined;
    /** Standing of the contact */
    standing!: number;

    constructor(data?: IGet_alliances_alliance_id_contacts_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact_id = _data["contact_id"];
            this.contact_type = _data["contact_type"];
            if (Array.isArray(_data["label_ids"])) {
                this.label_ids = [] as any;
                for (let item of _data["label_ids"])
                    this.label_ids!.push(item);
            }
            this.standing = _data["standing"];
        }
    }

    static fromJS(data: any): Get_alliances_alliance_id_contacts_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_alliances_alliance_id_contacts_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact_id"] = this.contact_id;
        data["contact_type"] = this.contact_type;
        if (Array.isArray(this.label_ids)) {
            data["label_ids"] = [];
            for (let item of this.label_ids)
                data["label_ids"].push(item);
        }
        data["standing"] = this.standing;
        return data;
    }
}

/** 200 ok object */
export interface IGet_alliances_alliance_id_contacts_200_ok {
    /** contact_id integer */
    contact_id: number;
    /** contact_type string */
    contact_type: Get_alliances_alliance_id_contacts_200_okContact_type;
    /** label_ids array */
    label_ids?: number[] | undefined;
    /** Standing of the contact */
    standing: number;
}

/** 200 ok object */
export class Post_characters_affiliation_200_ok implements IPost_characters_affiliation_200_ok {
    /** The character's alliance ID, if their corporation is in an alliance */
    alliance_id?: number | undefined;
    /** The character's ID */
    character_id!: number;
    /** The character's corporation ID */
    corporation_id!: number;
    /** The character's faction ID, if their corporation is in a faction */
    faction_id?: number | undefined;

    constructor(data?: IPost_characters_affiliation_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.character_id = _data["character_id"];
            this.corporation_id = _data["corporation_id"];
            this.faction_id = _data["faction_id"];
        }
    }

    static fromJS(data: any): Post_characters_affiliation_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Post_characters_affiliation_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["character_id"] = this.character_id;
        data["corporation_id"] = this.corporation_id;
        data["faction_id"] = this.faction_id;
        return data;
    }
}

/** 200 ok object */
export interface IPost_characters_affiliation_200_ok {
    /** The character's alliance ID, if their corporation is in an alliance */
    alliance_id?: number | undefined;
    /** The character's ID */
    character_id: number;
    /** The character's corporation ID */
    corporation_id: number;
    /** The character's faction ID, if their corporation is in a faction */
    faction_id?: number | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_agents_research_200_ok implements IGet_characters_character_id_agents_research_200_ok {
    /** agent_id integer */
    agent_id!: number;
    /** points_per_day number */
    points_per_day!: number;
    /** remainder_points number */
    remainder_points!: number;
    /** skill_type_id integer */
    skill_type_id!: number;
    /** started_at string */
    started_at!: Date;

    constructor(data?: IGet_characters_character_id_agents_research_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agent_id = _data["agent_id"];
            this.points_per_day = _data["points_per_day"];
            this.remainder_points = _data["remainder_points"];
            this.skill_type_id = _data["skill_type_id"];
            this.started_at = _data["started_at"] ? new Date(_data["started_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_characters_character_id_agents_research_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_agents_research_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agent_id"] = this.agent_id;
        data["points_per_day"] = this.points_per_day;
        data["remainder_points"] = this.remainder_points;
        data["skill_type_id"] = this.skill_type_id;
        data["started_at"] = this.started_at ? this.started_at.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_agents_research_200_ok {
    /** agent_id integer */
    agent_id: number;
    /** points_per_day number */
    points_per_day: number;
    /** remainder_points number */
    remainder_points: number;
    /** skill_type_id integer */
    skill_type_id: number;
    /** started_at string */
    started_at: Date;
}

/** 200 ok object */
export class Post_characters_character_id_assets_locations_200_ok implements IPost_characters_character_id_assets_locations_200_ok {
    /** item_id integer */
    item_id!: number;
    /** position object */
    position!: Position6;

    constructor(data?: IPost_characters_character_id_assets_locations_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.position = new Position6();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item_id = _data["item_id"];
            this.position = _data["position"] ? Position6.fromJS(_data["position"]) : new Position6();
        }
    }

    static fromJS(data: any): Post_characters_character_id_assets_locations_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Post_characters_character_id_assets_locations_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item_id"] = this.item_id;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IPost_characters_character_id_assets_locations_200_ok {
    /** item_id integer */
    item_id: number;
    /** position object */
    position: Position6;
}

/** 200 ok object */
export class Get_characters_character_id_bookmarks_200_ok implements IGet_characters_character_id_bookmarks_200_ok {
    /** bookmark_id integer */
    bookmark_id!: number;
    /** Optional object that is returned if a bookmark was made on a planet or a random location in space. */
    coordinates?: Coordinates2 | undefined;
    /** created string */
    created!: Date;
    /** creator_id integer */
    creator_id!: number;
    /** folder_id integer */
    folder_id?: number | undefined;
    /** Optional object that is returned if a bookmark was made on a particular item. */
    item?: Item2 | undefined;
    /** label string */
    label!: string;
    /** location_id integer */
    location_id!: number;
    /** notes string */
    notes!: string;

    constructor(data?: IGet_characters_character_id_bookmarks_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookmark_id = _data["bookmark_id"];
            this.coordinates = _data["coordinates"] ? Coordinates2.fromJS(_data["coordinates"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.creator_id = _data["creator_id"];
            this.folder_id = _data["folder_id"];
            this.item = _data["item"] ? Item2.fromJS(_data["item"]) : <any>undefined;
            this.label = _data["label"];
            this.location_id = _data["location_id"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_bookmarks_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_bookmarks_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookmark_id"] = this.bookmark_id;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["creator_id"] = this.creator_id;
        data["folder_id"] = this.folder_id;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["label"] = this.label;
        data["location_id"] = this.location_id;
        data["notes"] = this.notes;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_bookmarks_200_ok {
    /** bookmark_id integer */
    bookmark_id: number;
    /** Optional object that is returned if a bookmark was made on a planet or a random location in space. */
    coordinates?: Coordinates2 | undefined;
    /** created string */
    created: Date;
    /** creator_id integer */
    creator_id: number;
    /** folder_id integer */
    folder_id?: number | undefined;
    /** Optional object that is returned if a bookmark was made on a particular item. */
    item?: Item2 | undefined;
    /** label string */
    label: string;
    /** location_id integer */
    location_id: number;
    /** notes string */
    notes: string;
}

/** 200 ok object */
export class Get_characters_character_id_bookmarks_folders_200_ok implements IGet_characters_character_id_bookmarks_folders_200_ok {
    /** folder_id integer */
    folder_id!: number;
    /** name string */
    name!: string;

    constructor(data?: IGet_characters_character_id_bookmarks_folders_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folder_id = _data["folder_id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_bookmarks_folders_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_bookmarks_folders_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folder_id"] = this.folder_id;
        data["name"] = this.name;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_bookmarks_folders_200_ok {
    /** folder_id integer */
    folder_id: number;
    /** name string */
    name: string;
}

/** 200 ok object */
export class Get_characters_character_id_contacts_200_ok implements IGet_characters_character_id_contacts_200_ok {
    /** contact_id integer */
    contact_id!: number;
    /** contact_type string */
    contact_type!: Get_characters_character_id_contacts_200_okContact_type;
    /** Whether this contact is in the blocked list. Note a missing value denotes unknown, not true or false */
    is_blocked?: boolean | undefined;
    /** Whether this contact is being watched */
    is_watched?: boolean | undefined;
    /** label_ids array */
    label_ids?: number[] | undefined;
    /** Standing of the contact */
    standing!: number;

    constructor(data?: IGet_characters_character_id_contacts_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact_id = _data["contact_id"];
            this.contact_type = _data["contact_type"];
            this.is_blocked = _data["is_blocked"];
            this.is_watched = _data["is_watched"];
            if (Array.isArray(_data["label_ids"])) {
                this.label_ids = [] as any;
                for (let item of _data["label_ids"])
                    this.label_ids!.push(item);
            }
            this.standing = _data["standing"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_contacts_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_contacts_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact_id"] = this.contact_id;
        data["contact_type"] = this.contact_type;
        data["is_blocked"] = this.is_blocked;
        data["is_watched"] = this.is_watched;
        if (Array.isArray(this.label_ids)) {
            data["label_ids"] = [];
            for (let item of this.label_ids)
                data["label_ids"].push(item);
        }
        data["standing"] = this.standing;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_contacts_200_ok {
    /** contact_id integer */
    contact_id: number;
    /** contact_type string */
    contact_type: Get_characters_character_id_contacts_200_okContact_type;
    /** Whether this contact is in the blocked list. Note a missing value denotes unknown, not true or false */
    is_blocked?: boolean | undefined;
    /** Whether this contact is being watched */
    is_watched?: boolean | undefined;
    /** label_ids array */
    label_ids?: number[] | undefined;
    /** Standing of the contact */
    standing: number;
}

/** Error 520 */
export class Post_characters_character_id_contacts_error_520 implements IPost_characters_character_id_contacts_error_520 {
    /** Error 520 message */
    error?: string | undefined;

    constructor(data?: IPost_characters_character_id_contacts_error_520) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Post_characters_character_id_contacts_error_520 {
        data = typeof data === 'object' ? data : {};
        let result = new Post_characters_character_id_contacts_error_520();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Error 520 */
export interface IPost_characters_character_id_contacts_error_520 {
    /** Error 520 message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_corporationhistory_200_ok implements IGet_characters_character_id_corporationhistory_200_ok {
    /** corporation_id integer */
    corporation_id!: number;
    /** True if the corporation has been deleted */
    is_deleted?: boolean | undefined;
    /** An incrementing ID that can be used to canonically establish order of records in cases where dates may be ambiguous */
    record_id!: number;
    /** start_date string */
    start_date!: Date;

    constructor(data?: IGet_characters_character_id_corporationhistory_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporation_id = _data["corporation_id"];
            this.is_deleted = _data["is_deleted"];
            this.record_id = _data["record_id"];
            this.start_date = _data["start_date"] ? new Date(_data["start_date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_characters_character_id_corporationhistory_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_corporationhistory_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corporation_id"] = this.corporation_id;
        data["is_deleted"] = this.is_deleted;
        data["record_id"] = this.record_id;
        data["start_date"] = this.start_date ? this.start_date.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_corporationhistory_200_ok {
    /** corporation_id integer */
    corporation_id: number;
    /** True if the corporation has been deleted */
    is_deleted?: boolean | undefined;
    /** An incrementing ID that can be used to canonically establish order of records in cases where dates may be ambiguous */
    record_id: number;
    /** start_date string */
    start_date: Date;
}

/** 200 ok object */
export class Get_characters_character_id_fatigue_ok implements IGet_characters_character_id_fatigue_ok {
    /** Character's jump fatigue expiry */
    jump_fatigue_expire_date?: Date | undefined;
    /** Character's last jump activation */
    last_jump_date?: Date | undefined;
    /** Character's last jump update */
    last_update_date?: Date | undefined;

    constructor(data?: IGet_characters_character_id_fatigue_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jump_fatigue_expire_date = _data["jump_fatigue_expire_date"] ? new Date(_data["jump_fatigue_expire_date"].toString()) : <any>undefined;
            this.last_jump_date = _data["last_jump_date"] ? new Date(_data["last_jump_date"].toString()) : <any>undefined;
            this.last_update_date = _data["last_update_date"] ? new Date(_data["last_update_date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_characters_character_id_fatigue_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_fatigue_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jump_fatigue_expire_date"] = this.jump_fatigue_expire_date ? this.jump_fatigue_expire_date.toISOString() : <any>undefined;
        data["last_jump_date"] = this.last_jump_date ? this.last_jump_date.toISOString() : <any>undefined;
        data["last_update_date"] = this.last_update_date ? this.last_update_date.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_fatigue_ok {
    /** Character's jump fatigue expiry */
    jump_fatigue_expire_date?: Date | undefined;
    /** Character's last jump activation */
    last_jump_date?: Date | undefined;
    /** Character's last jump update */
    last_update_date?: Date | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_fittings_200_ok implements IGet_characters_character_id_fittings_200_ok {
    /** description string */
    description!: string;
    /** fitting_id integer */
    fitting_id!: number;
    /** items array */
    items!: Items2[];
    /** name string */
    name!: string;
    /** ship_type_id integer */
    ship_type_id!: number;

    constructor(data?: IGet_characters_character_id_fittings_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.fitting_id = _data["fitting_id"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Items2.fromJS(item));
            }
            this.name = _data["name"];
            this.ship_type_id = _data["ship_type_id"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_fittings_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_fittings_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["fitting_id"] = this.fitting_id;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["ship_type_id"] = this.ship_type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_fittings_200_ok {
    /** description string */
    description: string;
    /** fitting_id integer */
    fitting_id: number;
    /** items array */
    items: Items2[];
    /** name string */
    name: string;
    /** ship_type_id integer */
    ship_type_id: number;
}

/** 201 created object */
export class Post_characters_character_id_fittings_created implements IPost_characters_character_id_fittings_created {
    /** fitting_id integer */
    fitting_id!: number;

    constructor(data?: IPost_characters_character_id_fittings_created) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fitting_id = _data["fitting_id"];
        }
    }

    static fromJS(data: any): Post_characters_character_id_fittings_created {
        data = typeof data === 'object' ? data : {};
        let result = new Post_characters_character_id_fittings_created();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fitting_id"] = this.fitting_id;
        return data;
    }
}

/** 201 created object */
export interface IPost_characters_character_id_fittings_created {
    /** fitting_id integer */
    fitting_id: number;
}

/** 200 ok object */
export class Get_characters_character_id_medals_200_ok implements IGet_characters_character_id_medals_200_ok {
    /** corporation_id integer */
    corporation_id!: number;
    /** date string */
    date!: Date;
    /** description string */
    description!: string;
    /** graphics array */
    graphics!: Graphics[];
    /** issuer_id integer */
    issuer_id!: number;
    /** medal_id integer */
    medal_id!: number;
    /** reason string */
    reason!: string;
    /** status string */
    status!: Get_characters_character_id_medals_200_okStatus;
    /** title string */
    title!: string;

    constructor(data?: IGet_characters_character_id_medals_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.graphics = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporation_id = _data["corporation_id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.description = _data["description"];
            if (Array.isArray(_data["graphics"])) {
                this.graphics = [] as any;
                for (let item of _data["graphics"])
                    this.graphics!.push(Graphics.fromJS(item));
            }
            this.issuer_id = _data["issuer_id"];
            this.medal_id = _data["medal_id"];
            this.reason = _data["reason"];
            this.status = _data["status"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_medals_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_medals_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corporation_id"] = this.corporation_id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (Array.isArray(this.graphics)) {
            data["graphics"] = [];
            for (let item of this.graphics)
                data["graphics"].push(item.toJSON());
        }
        data["issuer_id"] = this.issuer_id;
        data["medal_id"] = this.medal_id;
        data["reason"] = this.reason;
        data["status"] = this.status;
        data["title"] = this.title;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_medals_200_ok {
    /** corporation_id integer */
    corporation_id: number;
    /** date string */
    date: Date;
    /** description string */
    description: string;
    /** graphics array */
    graphics: Graphics[];
    /** issuer_id integer */
    issuer_id: number;
    /** medal_id integer */
    medal_id: number;
    /** reason string */
    reason: string;
    /** status string */
    status: Get_characters_character_id_medals_200_okStatus;
    /** title string */
    title: string;
}

/** 200 ok object */
export class Get_characters_character_id_notifications_contacts_200_ok implements IGet_characters_character_id_notifications_contacts_200_ok {
    /** message string */
    message!: string;
    /** notification_id integer */
    notification_id!: number;
    /** send_date string */
    send_date!: Date;
    /** sender_character_id integer */
    sender_character_id!: number;
    /** A number representing the standing level the receiver has been added at by the sender. The standing levels are as follows: -10 -> Terrible | -5 -> Bad |  0 -> Neutral |  5 -> Good |  10 -> Excellent */
    standing_level!: number;

    constructor(data?: IGet_characters_character_id_notifications_contacts_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.notification_id = _data["notification_id"];
            this.send_date = _data["send_date"] ? new Date(_data["send_date"].toString()) : <any>undefined;
            this.sender_character_id = _data["sender_character_id"];
            this.standing_level = _data["standing_level"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_notifications_contacts_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_notifications_contacts_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["notification_id"] = this.notification_id;
        data["send_date"] = this.send_date ? this.send_date.toISOString() : <any>undefined;
        data["sender_character_id"] = this.sender_character_id;
        data["standing_level"] = this.standing_level;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_notifications_contacts_200_ok {
    /** message string */
    message: string;
    /** notification_id integer */
    notification_id: number;
    /** send_date string */
    send_date: Date;
    /** sender_character_id integer */
    sender_character_id: number;
    /** A number representing the standing level the receiver has been added at by the sender. The standing levels are as follows: -10 -> Terrible | -5 -> Bad |  0 -> Neutral |  5 -> Good |  10 -> Excellent */
    standing_level: number;
}

/** 200 ok object */
export class Get_characters_character_id_online_ok implements IGet_characters_character_id_online_ok {
    /** Timestamp of the last login */
    last_login?: Date | undefined;
    /** Timestamp of the last logout */
    last_logout?: Date | undefined;
    /** Total number of times the character has logged in */
    logins?: number | undefined;
    /** If the character is online */
    online!: boolean;

    constructor(data?: IGet_characters_character_id_online_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last_login = _data["last_login"] ? new Date(_data["last_login"].toString()) : <any>undefined;
            this.last_logout = _data["last_logout"] ? new Date(_data["last_logout"].toString()) : <any>undefined;
            this.logins = _data["logins"];
            this.online = _data["online"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_online_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_online_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last_login"] = this.last_login ? this.last_login.toISOString() : <any>undefined;
        data["last_logout"] = this.last_logout ? this.last_logout.toISOString() : <any>undefined;
        data["logins"] = this.logins;
        data["online"] = this.online;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_online_ok {
    /** Timestamp of the last login */
    last_login?: Date | undefined;
    /** Timestamp of the last logout */
    last_logout?: Date | undefined;
    /** Total number of times the character has logged in */
    logins?: number | undefined;
    /** If the character is online */
    online: boolean;
}

/** 200 ok object */
export class Get_characters_character_id_orders_200_ok implements IGet_characters_character_id_orders_200_ok {
    /** Number of days for which order is valid (starting from the issued date). An order expires at time issued + duration */
    duration!: number;
    /** For buy orders, the amount of ISK in escrow */
    escrow?: number | undefined;
    /** True if the order is a bid (buy) order */
    is_buy_order?: boolean | undefined;
    /** Signifies whether the buy/sell order was placed on behalf of a corporation. */
    is_corporation!: boolean;
    /** Date and time when this order was issued */
    issued!: Date;
    /** ID of the location where order was placed */
    location_id!: number;
    /** For buy orders, the minimum quantity that will be accepted in a matching sell order */
    min_volume?: number | undefined;
    /** Unique order ID */
    order_id!: number;
    /** Cost per unit for this order */
    price!: number;
    /** Valid order range, numbers are ranges in jumps */
    range!: Get_characters_character_id_orders_200_okRange;
    /** ID of the region where order was placed */
    region_id!: number;
    /** The type ID of the item transacted in this order */
    type_id!: number;
    /** Quantity of items still required or offered */
    volume_remain!: number;
    /** Quantity of items required or offered at time order was placed */
    volume_total!: number;

    constructor(data?: IGet_characters_character_id_orders_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
            this.escrow = _data["escrow"];
            this.is_buy_order = _data["is_buy_order"];
            this.is_corporation = _data["is_corporation"];
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : <any>undefined;
            this.location_id = _data["location_id"];
            this.min_volume = _data["min_volume"];
            this.order_id = _data["order_id"];
            this.price = _data["price"];
            this.range = _data["range"];
            this.region_id = _data["region_id"];
            this.type_id = _data["type_id"];
            this.volume_remain = _data["volume_remain"];
            this.volume_total = _data["volume_total"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_orders_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_orders_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["escrow"] = this.escrow;
        data["is_buy_order"] = this.is_buy_order;
        data["is_corporation"] = this.is_corporation;
        data["issued"] = this.issued ? this.issued.toISOString() : <any>undefined;
        data["location_id"] = this.location_id;
        data["min_volume"] = this.min_volume;
        data["order_id"] = this.order_id;
        data["price"] = this.price;
        data["range"] = this.range;
        data["region_id"] = this.region_id;
        data["type_id"] = this.type_id;
        data["volume_remain"] = this.volume_remain;
        data["volume_total"] = this.volume_total;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_orders_200_ok {
    /** Number of days for which order is valid (starting from the issued date). An order expires at time issued + duration */
    duration: number;
    /** For buy orders, the amount of ISK in escrow */
    escrow?: number | undefined;
    /** True if the order is a bid (buy) order */
    is_buy_order?: boolean | undefined;
    /** Signifies whether the buy/sell order was placed on behalf of a corporation. */
    is_corporation: boolean;
    /** Date and time when this order was issued */
    issued: Date;
    /** ID of the location where order was placed */
    location_id: number;
    /** For buy orders, the minimum quantity that will be accepted in a matching sell order */
    min_volume?: number | undefined;
    /** Unique order ID */
    order_id: number;
    /** Cost per unit for this order */
    price: number;
    /** Valid order range, numbers are ranges in jumps */
    range: Get_characters_character_id_orders_200_okRange;
    /** ID of the region where order was placed */
    region_id: number;
    /** The type ID of the item transacted in this order */
    type_id: number;
    /** Quantity of items still required or offered */
    volume_remain: number;
    /** Quantity of items required or offered at time order was placed */
    volume_total: number;
}

/** 200 ok object */
export class Get_characters_character_id_portrait_ok implements IGet_characters_character_id_portrait_ok {
    /** px128x128 string */
    px128x128?: string | undefined;
    /** px256x256 string */
    px256x256?: string | undefined;
    /** px512x512 string */
    px512x512?: string | undefined;
    /** px64x64 string */
    px64x64?: string | undefined;

    constructor(data?: IGet_characters_character_id_portrait_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.px128x128 = _data["px128x128"];
            this.px256x256 = _data["px256x256"];
            this.px512x512 = _data["px512x512"];
            this.px64x64 = _data["px64x64"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_portrait_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_portrait_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["px128x128"] = this.px128x128;
        data["px256x256"] = this.px256x256;
        data["px512x512"] = this.px512x512;
        data["px64x64"] = this.px64x64;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_portrait_ok {
    /** px128x128 string */
    px128x128?: string | undefined;
    /** px256x256 string */
    px256x256?: string | undefined;
    /** px512x512 string */
    px512x512?: string | undefined;
    /** px64x64 string */
    px64x64?: string | undefined;
}

/** No image server for this datasource */
export class Get_characters_character_id_portrait_not_found implements IGet_characters_character_id_portrait_not_found {
    /** error message */
    error?: string | undefined;

    constructor(data?: IGet_characters_character_id_portrait_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_portrait_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_portrait_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** No image server for this datasource */
export interface IGet_characters_character_id_portrait_not_found {
    /** error message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_skillqueue_200_ok implements IGet_characters_character_id_skillqueue_200_ok {
    /** Date on which training of the skill will complete. Omitted if the skill queue is paused. */
    finish_date?: Date | undefined;
    /** finished_level integer */
    finished_level!: number;
    /** level_end_sp integer */
    level_end_sp?: number | undefined;
    /** Amount of SP that was in the skill when it started training it's current level. Used to calculate % of current level complete. */
    level_start_sp?: number | undefined;
    /** queue_position integer */
    queue_position!: number;
    /** skill_id integer */
    skill_id!: number;
    /** start_date string */
    start_date?: Date | undefined;
    /** training_start_sp integer */
    training_start_sp?: number | undefined;

    constructor(data?: IGet_characters_character_id_skillqueue_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finish_date = _data["finish_date"] ? new Date(_data["finish_date"].toString()) : <any>undefined;
            this.finished_level = _data["finished_level"];
            this.level_end_sp = _data["level_end_sp"];
            this.level_start_sp = _data["level_start_sp"];
            this.queue_position = _data["queue_position"];
            this.skill_id = _data["skill_id"];
            this.start_date = _data["start_date"] ? new Date(_data["start_date"].toString()) : <any>undefined;
            this.training_start_sp = _data["training_start_sp"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_skillqueue_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_skillqueue_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finish_date"] = this.finish_date ? this.finish_date.toISOString() : <any>undefined;
        data["finished_level"] = this.finished_level;
        data["level_end_sp"] = this.level_end_sp;
        data["level_start_sp"] = this.level_start_sp;
        data["queue_position"] = this.queue_position;
        data["skill_id"] = this.skill_id;
        data["start_date"] = this.start_date ? this.start_date.toISOString() : <any>undefined;
        data["training_start_sp"] = this.training_start_sp;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_skillqueue_200_ok {
    /** Date on which training of the skill will complete. Omitted if the skill queue is paused. */
    finish_date?: Date | undefined;
    /** finished_level integer */
    finished_level: number;
    /** level_end_sp integer */
    level_end_sp?: number | undefined;
    /** Amount of SP that was in the skill when it started training it's current level. Used to calculate % of current level complete. */
    level_start_sp?: number | undefined;
    /** queue_position integer */
    queue_position: number;
    /** skill_id integer */
    skill_id: number;
    /** start_date string */
    start_date?: Date | undefined;
    /** training_start_sp integer */
    training_start_sp?: number | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_standings_200_ok implements IGet_characters_character_id_standings_200_ok {
    /** from_id integer */
    from_id!: number;
    /** from_type string */
    from_type!: Get_characters_character_id_standings_200_okFrom_type;
    /** standing number */
    standing!: number;

    constructor(data?: IGet_characters_character_id_standings_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from_id = _data["from_id"];
            this.from_type = _data["from_type"];
            this.standing = _data["standing"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_standings_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_standings_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from_id"] = this.from_id;
        data["from_type"] = this.from_type;
        data["standing"] = this.standing;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_standings_200_ok {
    /** from_id integer */
    from_id: number;
    /** from_type string */
    from_type: Get_characters_character_id_standings_200_okFrom_type;
    /** standing number */
    standing: number;
}

/** 200 ok object */
export class Get_characters_character_id_titles_200_ok implements IGet_characters_character_id_titles_200_ok {
    /** name string */
    name?: string | undefined;
    /** title_id integer */
    title_id?: number | undefined;

    constructor(data?: IGet_characters_character_id_titles_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.title_id = _data["title_id"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_titles_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_titles_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title_id"] = this.title_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_titles_200_ok {
    /** name string */
    name?: string | undefined;
    /** title_id integer */
    title_id?: number | undefined;
}

/** 200 ok object */
export class Post_corporations_corporation_id_assets_locations_200_ok implements IPost_corporations_corporation_id_assets_locations_200_ok {
    /** item_id integer */
    item_id!: number;
    /** position object */
    position!: Position7;

    constructor(data?: IPost_corporations_corporation_id_assets_locations_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.position = new Position7();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item_id = _data["item_id"];
            this.position = _data["position"] ? Position7.fromJS(_data["position"]) : new Position7();
        }
    }

    static fromJS(data: any): Post_corporations_corporation_id_assets_locations_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Post_corporations_corporation_id_assets_locations_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item_id"] = this.item_id;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IPost_corporations_corporation_id_assets_locations_200_ok {
    /** item_id integer */
    item_id: number;
    /** position object */
    position: Position7;
}

/** Not found */
export class Post_corporations_corporation_id_assets_locations_not_found implements IPost_corporations_corporation_id_assets_locations_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IPost_corporations_corporation_id_assets_locations_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Post_corporations_corporation_id_assets_locations_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Post_corporations_corporation_id_assets_locations_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IPost_corporations_corporation_id_assets_locations_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_contacts_200_ok implements IGet_corporations_corporation_id_contacts_200_ok {
    /** contact_id integer */
    contact_id!: number;
    /** contact_type string */
    contact_type!: Get_corporations_corporation_id_contacts_200_okContact_type;
    /** Whether this contact is being watched */
    is_watched?: boolean | undefined;
    /** label_ids array */
    label_ids?: number[] | undefined;
    /** Standing of the contact */
    standing!: number;

    constructor(data?: IGet_corporations_corporation_id_contacts_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact_id = _data["contact_id"];
            this.contact_type = _data["contact_type"];
            this.is_watched = _data["is_watched"];
            if (Array.isArray(_data["label_ids"])) {
                this.label_ids = [] as any;
                for (let item of _data["label_ids"])
                    this.label_ids!.push(item);
            }
            this.standing = _data["standing"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_contacts_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_contacts_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact_id"] = this.contact_id;
        data["contact_type"] = this.contact_type;
        data["is_watched"] = this.is_watched;
        if (Array.isArray(this.label_ids)) {
            data["label_ids"] = [];
            for (let item of this.label_ids)
                data["label_ids"].push(item);
        }
        data["standing"] = this.standing;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_contacts_200_ok {
    /** contact_id integer */
    contact_id: number;
    /** contact_type string */
    contact_type: Get_corporations_corporation_id_contacts_200_okContact_type;
    /** Whether this contact is being watched */
    is_watched?: boolean | undefined;
    /** label_ids array */
    label_ids?: number[] | undefined;
    /** Standing of the contact */
    standing: number;
}

/** 200 ok object */
export class Get_corporations_corporation_id_divisions_ok implements IGet_corporations_corporation_id_divisions_ok {
    /** hangar array */
    hangar?: Hangar[] | undefined;
    /** wallet array */
    wallet?: Wallet[] | undefined;

    constructor(data?: IGet_corporations_corporation_id_divisions_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hangar"])) {
                this.hangar = [] as any;
                for (let item of _data["hangar"])
                    this.hangar!.push(Hangar.fromJS(item));
            }
            if (Array.isArray(_data["wallet"])) {
                this.wallet = [] as any;
                for (let item of _data["wallet"])
                    this.wallet!.push(Wallet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_divisions_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_divisions_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hangar)) {
            data["hangar"] = [];
            for (let item of this.hangar)
                data["hangar"].push(item.toJSON());
        }
        if (Array.isArray(this.wallet)) {
            data["wallet"] = [];
            for (let item of this.wallet)
                data["wallet"].push(item.toJSON());
        }
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_divisions_ok {
    /** hangar array */
    hangar?: Hangar[] | undefined;
    /** wallet array */
    wallet?: Wallet[] | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_facilities_200_ok implements IGet_corporations_corporation_id_facilities_200_ok {
    /** facility_id integer */
    facility_id!: number;
    /** system_id integer */
    system_id!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_corporations_corporation_id_facilities_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facility_id = _data["facility_id"];
            this.system_id = _data["system_id"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_facilities_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_facilities_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facility_id"] = this.facility_id;
        data["system_id"] = this.system_id;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_facilities_200_ok {
    /** facility_id integer */
    facility_id: number;
    /** system_id integer */
    system_id: number;
    /** type_id integer */
    type_id: number;
}

/** 200 ok object */
export class Get_corporations_corporation_id_icons_ok implements IGet_corporations_corporation_id_icons_ok {
    /** px128x128 string */
    px128x128?: string | undefined;
    /** px256x256 string */
    px256x256?: string | undefined;
    /** px64x64 string */
    px64x64?: string | undefined;

    constructor(data?: IGet_corporations_corporation_id_icons_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.px128x128 = _data["px128x128"];
            this.px256x256 = _data["px256x256"];
            this.px64x64 = _data["px64x64"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_icons_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_icons_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["px128x128"] = this.px128x128;
        data["px256x256"] = this.px256x256;
        data["px64x64"] = this.px64x64;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_icons_ok {
    /** px128x128 string */
    px128x128?: string | undefined;
    /** px256x256 string */
    px256x256?: string | undefined;
    /** px64x64 string */
    px64x64?: string | undefined;
}

/** No image server for this datasource */
export class Get_corporations_corporation_id_icons_not_found implements IGet_corporations_corporation_id_icons_not_found {
    /** error message */
    error?: string | undefined;

    constructor(data?: IGet_corporations_corporation_id_icons_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_icons_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_icons_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** No image server for this datasource */
export interface IGet_corporations_corporation_id_icons_not_found {
    /** error message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_medals_200_ok implements IGet_corporations_corporation_id_medals_200_ok {
    /** created_at string */
    created_at!: Date;
    /** ID of the character who created this medal */
    creator_id!: number;
    /** description string */
    description!: string;
    /** medal_id integer */
    medal_id!: number;
    /** title string */
    title!: string;

    constructor(data?: IGet_corporations_corporation_id_medals_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.creator_id = _data["creator_id"];
            this.description = _data["description"];
            this.medal_id = _data["medal_id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_medals_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_medals_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["creator_id"] = this.creator_id;
        data["description"] = this.description;
        data["medal_id"] = this.medal_id;
        data["title"] = this.title;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_medals_200_ok {
    /** created_at string */
    created_at: Date;
    /** ID of the character who created this medal */
    creator_id: number;
    /** description string */
    description: string;
    /** medal_id integer */
    medal_id: number;
    /** title string */
    title: string;
}

/** 200 ok object */
export class Get_corporations_corporation_id_medals_issued_200_ok implements IGet_corporations_corporation_id_medals_issued_200_ok {
    /** ID of the character who was rewarded this medal */
    character_id!: number;
    /** issued_at string */
    issued_at!: Date;
    /** ID of the character who issued the medal */
    issuer_id!: number;
    /** medal_id integer */
    medal_id!: number;
    /** reason string */
    reason!: string;
    /** status string */
    status!: Get_corporations_corporation_id_medals_issued_200_okStatus;

    constructor(data?: IGet_corporations_corporation_id_medals_issued_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.character_id = _data["character_id"];
            this.issued_at = _data["issued_at"] ? new Date(_data["issued_at"].toString()) : <any>undefined;
            this.issuer_id = _data["issuer_id"];
            this.medal_id = _data["medal_id"];
            this.reason = _data["reason"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_medals_issued_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_medals_issued_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["character_id"] = this.character_id;
        data["issued_at"] = this.issued_at ? this.issued_at.toISOString() : <any>undefined;
        data["issuer_id"] = this.issuer_id;
        data["medal_id"] = this.medal_id;
        data["reason"] = this.reason;
        data["status"] = this.status;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_medals_issued_200_ok {
    /** ID of the character who was rewarded this medal */
    character_id: number;
    /** issued_at string */
    issued_at: Date;
    /** ID of the character who issued the medal */
    issuer_id: number;
    /** medal_id integer */
    medal_id: number;
    /** reason string */
    reason: string;
    /** status string */
    status: Get_corporations_corporation_id_medals_issued_200_okStatus;
}

/** 200 ok object */
export class Get_corporations_corporation_id_members_titles_200_ok implements IGet_corporations_corporation_id_members_titles_200_ok {
    /** character_id integer */
    character_id!: number;
    /** A list of title_id */
    titles!: number[];

    constructor(data?: IGet_corporations_corporation_id_members_titles_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.titles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.character_id = _data["character_id"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(item);
            }
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_members_titles_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_members_titles_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["character_id"] = this.character_id;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item);
        }
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_members_titles_200_ok {
    /** character_id integer */
    character_id: number;
    /** A list of title_id */
    titles: number[];
}

/** 200 ok object */
export class Get_corporations_corporation_id_membertracking_200_ok implements IGet_corporations_corporation_id_membertracking_200_ok {
    /** base_id integer */
    base_id?: number | undefined;
    /** character_id integer */
    character_id!: number;
    /** location_id integer */
    location_id?: number | undefined;
    /** logoff_date string */
    logoff_date?: Date | undefined;
    /** logon_date string */
    logon_date?: Date | undefined;
    /** ship_type_id integer */
    ship_type_id?: number | undefined;
    /** start_date string */
    start_date?: Date | undefined;

    constructor(data?: IGet_corporations_corporation_id_membertracking_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base_id = _data["base_id"];
            this.character_id = _data["character_id"];
            this.location_id = _data["location_id"];
            this.logoff_date = _data["logoff_date"] ? new Date(_data["logoff_date"].toString()) : <any>undefined;
            this.logon_date = _data["logon_date"] ? new Date(_data["logon_date"].toString()) : <any>undefined;
            this.ship_type_id = _data["ship_type_id"];
            this.start_date = _data["start_date"] ? new Date(_data["start_date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_membertracking_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_membertracking_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base_id"] = this.base_id;
        data["character_id"] = this.character_id;
        data["location_id"] = this.location_id;
        data["logoff_date"] = this.logoff_date ? this.logoff_date.toISOString() : <any>undefined;
        data["logon_date"] = this.logon_date ? this.logon_date.toISOString() : <any>undefined;
        data["ship_type_id"] = this.ship_type_id;
        data["start_date"] = this.start_date ? this.start_date.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_membertracking_200_ok {
    /** base_id integer */
    base_id?: number | undefined;
    /** character_id integer */
    character_id: number;
    /** location_id integer */
    location_id?: number | undefined;
    /** logoff_date string */
    logoff_date?: Date | undefined;
    /** logon_date string */
    logon_date?: Date | undefined;
    /** ship_type_id integer */
    ship_type_id?: number | undefined;
    /** start_date string */
    start_date?: Date | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_orders_history_200_ok implements IGet_corporations_corporation_id_orders_history_200_ok {
    /** Number of days the order was valid for (starting from the issued date). An order expires at time issued + duration */
    duration!: number;
    /** For buy orders, the amount of ISK in escrow */
    escrow?: number | undefined;
    /** True if the order is a bid (buy) order */
    is_buy_order?: boolean | undefined;
    /** Date and time when this order was issued */
    issued!: Date;
    /** The character who issued this order */
    issued_by?: number | undefined;
    /** ID of the location where order was placed */
    location_id!: number;
    /** For buy orders, the minimum quantity that will be accepted in a matching sell order */
    min_volume?: number | undefined;
    /** Unique order ID */
    order_id!: number;
    /** Cost per unit for this order */
    price!: number;
    /** Valid order range, numbers are ranges in jumps */
    range!: Get_corporations_corporation_id_orders_history_200_okRange;
    /** ID of the region where order was placed */
    region_id!: number;
    /** Current order state */
    state!: Get_corporations_corporation_id_orders_history_200_okState;
    /** The type ID of the item transacted in this order */
    type_id!: number;
    /** Quantity of items still required or offered */
    volume_remain!: number;
    /** Quantity of items required or offered at time order was placed */
    volume_total!: number;
    /** The corporation wallet division used for this order */
    wallet_division!: number;

    constructor(data?: IGet_corporations_corporation_id_orders_history_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
            this.escrow = _data["escrow"];
            this.is_buy_order = _data["is_buy_order"];
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : <any>undefined;
            this.issued_by = _data["issued_by"];
            this.location_id = _data["location_id"];
            this.min_volume = _data["min_volume"];
            this.order_id = _data["order_id"];
            this.price = _data["price"];
            this.range = _data["range"];
            this.region_id = _data["region_id"];
            this.state = _data["state"];
            this.type_id = _data["type_id"];
            this.volume_remain = _data["volume_remain"];
            this.volume_total = _data["volume_total"];
            this.wallet_division = _data["wallet_division"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_orders_history_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_orders_history_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["escrow"] = this.escrow;
        data["is_buy_order"] = this.is_buy_order;
        data["issued"] = this.issued ? this.issued.toISOString() : <any>undefined;
        data["issued_by"] = this.issued_by;
        data["location_id"] = this.location_id;
        data["min_volume"] = this.min_volume;
        data["order_id"] = this.order_id;
        data["price"] = this.price;
        data["range"] = this.range;
        data["region_id"] = this.region_id;
        data["state"] = this.state;
        data["type_id"] = this.type_id;
        data["volume_remain"] = this.volume_remain;
        data["volume_total"] = this.volume_total;
        data["wallet_division"] = this.wallet_division;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_orders_history_200_ok {
    /** Number of days the order was valid for (starting from the issued date). An order expires at time issued + duration */
    duration: number;
    /** For buy orders, the amount of ISK in escrow */
    escrow?: number | undefined;
    /** True if the order is a bid (buy) order */
    is_buy_order?: boolean | undefined;
    /** Date and time when this order was issued */
    issued: Date;
    /** The character who issued this order */
    issued_by?: number | undefined;
    /** ID of the location where order was placed */
    location_id: number;
    /** For buy orders, the minimum quantity that will be accepted in a matching sell order */
    min_volume?: number | undefined;
    /** Unique order ID */
    order_id: number;
    /** Cost per unit for this order */
    price: number;
    /** Valid order range, numbers are ranges in jumps */
    range: Get_corporations_corporation_id_orders_history_200_okRange;
    /** ID of the region where order was placed */
    region_id: number;
    /** Current order state */
    state: Get_corporations_corporation_id_orders_history_200_okState;
    /** The type ID of the item transacted in this order */
    type_id: number;
    /** Quantity of items still required or offered */
    volume_remain: number;
    /** Quantity of items required or offered at time order was placed */
    volume_total: number;
    /** The corporation wallet division used for this order */
    wallet_division: number;
}

/** 200 ok object */
export class Get_corporations_corporation_id_roles_200_ok implements IGet_corporations_corporation_id_roles_200_ok {
    /** character_id integer */
    character_id!: number;
    /** grantable_roles array */
    grantable_roles?: Grantable_roles[] | undefined;
    /** grantable_roles_at_base array */
    grantable_roles_at_base?: Grantable_roles_at_base[] | undefined;
    /** grantable_roles_at_hq array */
    grantable_roles_at_hq?: Grantable_roles_at_hq[] | undefined;
    /** grantable_roles_at_other array */
    grantable_roles_at_other?: Grantable_roles_at_other[] | undefined;
    /** roles array */
    roles?: Roles[] | undefined;
    /** roles_at_base array */
    roles_at_base?: Roles_at_base[] | undefined;
    /** roles_at_hq array */
    roles_at_hq?: Roles_at_hq[] | undefined;
    /** roles_at_other array */
    roles_at_other?: Roles_at_other[] | undefined;

    constructor(data?: IGet_corporations_corporation_id_roles_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.character_id = _data["character_id"];
            if (Array.isArray(_data["grantable_roles"])) {
                this.grantable_roles = [] as any;
                for (let item of _data["grantable_roles"])
                    this.grantable_roles!.push(item);
            }
            if (Array.isArray(_data["grantable_roles_at_base"])) {
                this.grantable_roles_at_base = [] as any;
                for (let item of _data["grantable_roles_at_base"])
                    this.grantable_roles_at_base!.push(item);
            }
            if (Array.isArray(_data["grantable_roles_at_hq"])) {
                this.grantable_roles_at_hq = [] as any;
                for (let item of _data["grantable_roles_at_hq"])
                    this.grantable_roles_at_hq!.push(item);
            }
            if (Array.isArray(_data["grantable_roles_at_other"])) {
                this.grantable_roles_at_other = [] as any;
                for (let item of _data["grantable_roles_at_other"])
                    this.grantable_roles_at_other!.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["roles_at_base"])) {
                this.roles_at_base = [] as any;
                for (let item of _data["roles_at_base"])
                    this.roles_at_base!.push(item);
            }
            if (Array.isArray(_data["roles_at_hq"])) {
                this.roles_at_hq = [] as any;
                for (let item of _data["roles_at_hq"])
                    this.roles_at_hq!.push(item);
            }
            if (Array.isArray(_data["roles_at_other"])) {
                this.roles_at_other = [] as any;
                for (let item of _data["roles_at_other"])
                    this.roles_at_other!.push(item);
            }
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_roles_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_roles_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["character_id"] = this.character_id;
        if (Array.isArray(this.grantable_roles)) {
            data["grantable_roles"] = [];
            for (let item of this.grantable_roles)
                data["grantable_roles"].push(item);
        }
        if (Array.isArray(this.grantable_roles_at_base)) {
            data["grantable_roles_at_base"] = [];
            for (let item of this.grantable_roles_at_base)
                data["grantable_roles_at_base"].push(item);
        }
        if (Array.isArray(this.grantable_roles_at_hq)) {
            data["grantable_roles_at_hq"] = [];
            for (let item of this.grantable_roles_at_hq)
                data["grantable_roles_at_hq"].push(item);
        }
        if (Array.isArray(this.grantable_roles_at_other)) {
            data["grantable_roles_at_other"] = [];
            for (let item of this.grantable_roles_at_other)
                data["grantable_roles_at_other"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.roles_at_base)) {
            data["roles_at_base"] = [];
            for (let item of this.roles_at_base)
                data["roles_at_base"].push(item);
        }
        if (Array.isArray(this.roles_at_hq)) {
            data["roles_at_hq"] = [];
            for (let item of this.roles_at_hq)
                data["roles_at_hq"].push(item);
        }
        if (Array.isArray(this.roles_at_other)) {
            data["roles_at_other"] = [];
            for (let item of this.roles_at_other)
                data["roles_at_other"].push(item);
        }
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_roles_200_ok {
    /** character_id integer */
    character_id: number;
    /** grantable_roles array */
    grantable_roles?: Grantable_roles[] | undefined;
    /** grantable_roles_at_base array */
    grantable_roles_at_base?: Grantable_roles_at_base[] | undefined;
    /** grantable_roles_at_hq array */
    grantable_roles_at_hq?: Grantable_roles_at_hq[] | undefined;
    /** grantable_roles_at_other array */
    grantable_roles_at_other?: Grantable_roles_at_other[] | undefined;
    /** roles array */
    roles?: Roles[] | undefined;
    /** roles_at_base array */
    roles_at_base?: Roles_at_base[] | undefined;
    /** roles_at_hq array */
    roles_at_hq?: Roles_at_hq[] | undefined;
    /** roles_at_other array */
    roles_at_other?: Roles_at_other[] | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_roles_history_200_ok implements IGet_corporations_corporation_id_roles_history_200_ok {
    /** changed_at string */
    changed_at!: Date;
    /** The character whose roles are changed */
    character_id!: number;
    /** ID of the character who issued this change */
    issuer_id!: number;
    /** new_roles array */
    new_roles!: New_roles[];
    /** old_roles array */
    old_roles!: Old_roles[];
    /** role_type string */
    role_type!: Get_corporations_corporation_id_roles_history_200_okRole_type;

    constructor(data?: IGet_corporations_corporation_id_roles_history_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.new_roles = [];
            this.old_roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changed_at = _data["changed_at"] ? new Date(_data["changed_at"].toString()) : <any>undefined;
            this.character_id = _data["character_id"];
            this.issuer_id = _data["issuer_id"];
            if (Array.isArray(_data["new_roles"])) {
                this.new_roles = [] as any;
                for (let item of _data["new_roles"])
                    this.new_roles!.push(item);
            }
            if (Array.isArray(_data["old_roles"])) {
                this.old_roles = [] as any;
                for (let item of _data["old_roles"])
                    this.old_roles!.push(item);
            }
            this.role_type = _data["role_type"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_roles_history_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_roles_history_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changed_at"] = this.changed_at ? this.changed_at.toISOString() : <any>undefined;
        data["character_id"] = this.character_id;
        data["issuer_id"] = this.issuer_id;
        if (Array.isArray(this.new_roles)) {
            data["new_roles"] = [];
            for (let item of this.new_roles)
                data["new_roles"].push(item);
        }
        if (Array.isArray(this.old_roles)) {
            data["old_roles"] = [];
            for (let item of this.old_roles)
                data["old_roles"].push(item);
        }
        data["role_type"] = this.role_type;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_roles_history_200_ok {
    /** changed_at string */
    changed_at: Date;
    /** The character whose roles are changed */
    character_id: number;
    /** ID of the character who issued this change */
    issuer_id: number;
    /** new_roles array */
    new_roles: New_roles[];
    /** old_roles array */
    old_roles: Old_roles[];
    /** role_type string */
    role_type: Get_corporations_corporation_id_roles_history_200_okRole_type;
}

/** 200 ok object */
export class Get_corporations_corporation_id_standings_200_ok implements IGet_corporations_corporation_id_standings_200_ok {
    /** from_id integer */
    from_id!: number;
    /** from_type string */
    from_type!: Get_corporations_corporation_id_standings_200_okFrom_type;
    /** standing number */
    standing!: number;

    constructor(data?: IGet_corporations_corporation_id_standings_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from_id = _data["from_id"];
            this.from_type = _data["from_type"];
            this.standing = _data["standing"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_standings_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_standings_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from_id"] = this.from_id;
        data["from_type"] = this.from_type;
        data["standing"] = this.standing;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_standings_200_ok {
    /** from_id integer */
    from_id: number;
    /** from_type string */
    from_type: Get_corporations_corporation_id_standings_200_okFrom_type;
    /** standing number */
    standing: number;
}

/** 200 ok object */
export class Get_corporations_corporation_id_starbases_200_ok implements IGet_corporations_corporation_id_starbases_200_ok {
    /** The moon this starbase (POS) is anchored on, unanchored POSes do not have this information */
    moon_id?: number | undefined;
    /** When the POS onlined, for starbases (POSes) in online state */
    onlined_since?: Date | undefined;
    /** When the POS will be out of reinforcement, for starbases (POSes) in reinforced state */
    reinforced_until?: Date | undefined;
    /** Unique ID for this starbase (POS) */
    starbase_id!: number;
    /** state string */
    state?: Get_corporations_corporation_id_starbases_200_okState | undefined;
    /** The solar system this starbase (POS) is in, unanchored POSes have this information */
    system_id!: number;
    /** Starbase (POS) type */
    type_id!: number;
    /** When the POS started unanchoring, for starbases (POSes) in unanchoring state */
    unanchor_at?: Date | undefined;

    constructor(data?: IGet_corporations_corporation_id_starbases_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moon_id = _data["moon_id"];
            this.onlined_since = _data["onlined_since"] ? new Date(_data["onlined_since"].toString()) : <any>undefined;
            this.reinforced_until = _data["reinforced_until"] ? new Date(_data["reinforced_until"].toString()) : <any>undefined;
            this.starbase_id = _data["starbase_id"];
            this.state = _data["state"];
            this.system_id = _data["system_id"];
            this.type_id = _data["type_id"];
            this.unanchor_at = _data["unanchor_at"] ? new Date(_data["unanchor_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_starbases_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_starbases_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moon_id"] = this.moon_id;
        data["onlined_since"] = this.onlined_since ? this.onlined_since.toISOString() : <any>undefined;
        data["reinforced_until"] = this.reinforced_until ? this.reinforced_until.toISOString() : <any>undefined;
        data["starbase_id"] = this.starbase_id;
        data["state"] = this.state;
        data["system_id"] = this.system_id;
        data["type_id"] = this.type_id;
        data["unanchor_at"] = this.unanchor_at ? this.unanchor_at.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_starbases_200_ok {
    /** The moon this starbase (POS) is anchored on, unanchored POSes do not have this information */
    moon_id?: number | undefined;
    /** When the POS onlined, for starbases (POSes) in online state */
    onlined_since?: Date | undefined;
    /** When the POS will be out of reinforcement, for starbases (POSes) in reinforced state */
    reinforced_until?: Date | undefined;
    /** Unique ID for this starbase (POS) */
    starbase_id: number;
    /** state string */
    state?: Get_corporations_corporation_id_starbases_200_okState | undefined;
    /** The solar system this starbase (POS) is in, unanchored POSes have this information */
    system_id: number;
    /** Starbase (POS) type */
    type_id: number;
    /** When the POS started unanchoring, for starbases (POSes) in unanchoring state */
    unanchor_at?: Date | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_starbases_starbase_id_ok implements IGet_corporations_corporation_id_starbases_starbase_id_ok {
    /** allow_alliance_members boolean */
    allow_alliance_members!: boolean;
    /** allow_corporation_members boolean */
    allow_corporation_members!: boolean;
    /** Who can anchor starbase (POS) and its structures */
    anchor!: Get_corporations_corporation_id_starbases_starbase_id_okAnchor;
    /** attack_if_at_war boolean */
    attack_if_at_war!: boolean;
    /** attack_if_other_security_status_dropping boolean */
    attack_if_other_security_status_dropping!: boolean;
    /** Starbase (POS) will attack if target's security standing is lower than this value */
    attack_security_status_threshold?: number | undefined;
    /** Starbase (POS) will attack if target's standing is lower than this value */
    attack_standing_threshold?: number | undefined;
    /** Who can take fuel blocks out of the starbase (POS)'s fuel bay */
    fuel_bay_take!: Get_corporations_corporation_id_starbases_starbase_id_okFuel_bay_take;
    /** Who can view the starbase (POS)'s fule bay. Characters either need to have required role or belong to the starbase (POS) owner's corporation or alliance, as described by the enum, all other access settings follows the same scheme */
    fuel_bay_view!: Get_corporations_corporation_id_starbases_starbase_id_okFuel_bay_view;
    /** Fuel blocks and other things that will be consumed when operating a starbase (POS) */
    fuels?: Fuels[] | undefined;
    /** Who can offline starbase (POS) and its structures */
    offline!: Get_corporations_corporation_id_starbases_starbase_id_okOffline;
    /** Who can online starbase (POS) and its structures */
    online!: Get_corporations_corporation_id_starbases_starbase_id_okOnline;
    /** Who can unanchor starbase (POS) and its structures */
    unanchor!: Get_corporations_corporation_id_starbases_starbase_id_okUnanchor;
    /** True if the starbase (POS) is using alliance standings, otherwise using corporation's */
    use_alliance_standings!: boolean;

    constructor(data?: IGet_corporations_corporation_id_starbases_starbase_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allow_alliance_members = _data["allow_alliance_members"];
            this.allow_corporation_members = _data["allow_corporation_members"];
            this.anchor = _data["anchor"];
            this.attack_if_at_war = _data["attack_if_at_war"];
            this.attack_if_other_security_status_dropping = _data["attack_if_other_security_status_dropping"];
            this.attack_security_status_threshold = _data["attack_security_status_threshold"];
            this.attack_standing_threshold = _data["attack_standing_threshold"];
            this.fuel_bay_take = _data["fuel_bay_take"];
            this.fuel_bay_view = _data["fuel_bay_view"];
            if (Array.isArray(_data["fuels"])) {
                this.fuels = [] as any;
                for (let item of _data["fuels"])
                    this.fuels!.push(Fuels.fromJS(item));
            }
            this.offline = _data["offline"];
            this.online = _data["online"];
            this.unanchor = _data["unanchor"];
            this.use_alliance_standings = _data["use_alliance_standings"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_starbases_starbase_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_starbases_starbase_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allow_alliance_members"] = this.allow_alliance_members;
        data["allow_corporation_members"] = this.allow_corporation_members;
        data["anchor"] = this.anchor;
        data["attack_if_at_war"] = this.attack_if_at_war;
        data["attack_if_other_security_status_dropping"] = this.attack_if_other_security_status_dropping;
        data["attack_security_status_threshold"] = this.attack_security_status_threshold;
        data["attack_standing_threshold"] = this.attack_standing_threshold;
        data["fuel_bay_take"] = this.fuel_bay_take;
        data["fuel_bay_view"] = this.fuel_bay_view;
        if (Array.isArray(this.fuels)) {
            data["fuels"] = [];
            for (let item of this.fuels)
                data["fuels"].push(item.toJSON());
        }
        data["offline"] = this.offline;
        data["online"] = this.online;
        data["unanchor"] = this.unanchor;
        data["use_alliance_standings"] = this.use_alliance_standings;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_starbases_starbase_id_ok {
    /** allow_alliance_members boolean */
    allow_alliance_members: boolean;
    /** allow_corporation_members boolean */
    allow_corporation_members: boolean;
    /** Who can anchor starbase (POS) and its structures */
    anchor: Get_corporations_corporation_id_starbases_starbase_id_okAnchor;
    /** attack_if_at_war boolean */
    attack_if_at_war: boolean;
    /** attack_if_other_security_status_dropping boolean */
    attack_if_other_security_status_dropping: boolean;
    /** Starbase (POS) will attack if target's security standing is lower than this value */
    attack_security_status_threshold?: number | undefined;
    /** Starbase (POS) will attack if target's standing is lower than this value */
    attack_standing_threshold?: number | undefined;
    /** Who can take fuel blocks out of the starbase (POS)'s fuel bay */
    fuel_bay_take: Get_corporations_corporation_id_starbases_starbase_id_okFuel_bay_take;
    /** Who can view the starbase (POS)'s fule bay. Characters either need to have required role or belong to the starbase (POS) owner's corporation or alliance, as described by the enum, all other access settings follows the same scheme */
    fuel_bay_view: Get_corporations_corporation_id_starbases_starbase_id_okFuel_bay_view;
    /** Fuel blocks and other things that will be consumed when operating a starbase (POS) */
    fuels?: Fuels[] | undefined;
    /** Who can offline starbase (POS) and its structures */
    offline: Get_corporations_corporation_id_starbases_starbase_id_okOffline;
    /** Who can online starbase (POS) and its structures */
    online: Get_corporations_corporation_id_starbases_starbase_id_okOnline;
    /** Who can unanchor starbase (POS) and its structures */
    unanchor: Get_corporations_corporation_id_starbases_starbase_id_okUnanchor;
    /** True if the starbase (POS) is using alliance standings, otherwise using corporation's */
    use_alliance_standings: boolean;
}

/** 200 ok object */
export class Get_corporations_corporation_id_titles_200_ok implements IGet_corporations_corporation_id_titles_200_ok {
    /** grantable_roles array */
    grantable_roles?: Grantable_roles2[] | undefined;
    /** grantable_roles_at_base array */
    grantable_roles_at_base?: Grantable_roles_at_base2[] | undefined;
    /** grantable_roles_at_hq array */
    grantable_roles_at_hq?: Grantable_roles_at_hq2[] | undefined;
    /** grantable_roles_at_other array */
    grantable_roles_at_other?: Grantable_roles_at_other2[] | undefined;
    /** name string */
    name?: string | undefined;
    /** roles array */
    roles?: Roles2[] | undefined;
    /** roles_at_base array */
    roles_at_base?: Roles_at_base2[] | undefined;
    /** roles_at_hq array */
    roles_at_hq?: Roles_at_hq2[] | undefined;
    /** roles_at_other array */
    roles_at_other?: Roles_at_other2[] | undefined;
    /** title_id integer */
    title_id?: number | undefined;

    constructor(data?: IGet_corporations_corporation_id_titles_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["grantable_roles"])) {
                this.grantable_roles = [] as any;
                for (let item of _data["grantable_roles"])
                    this.grantable_roles!.push(item);
            }
            if (Array.isArray(_data["grantable_roles_at_base"])) {
                this.grantable_roles_at_base = [] as any;
                for (let item of _data["grantable_roles_at_base"])
                    this.grantable_roles_at_base!.push(item);
            }
            if (Array.isArray(_data["grantable_roles_at_hq"])) {
                this.grantable_roles_at_hq = [] as any;
                for (let item of _data["grantable_roles_at_hq"])
                    this.grantable_roles_at_hq!.push(item);
            }
            if (Array.isArray(_data["grantable_roles_at_other"])) {
                this.grantable_roles_at_other = [] as any;
                for (let item of _data["grantable_roles_at_other"])
                    this.grantable_roles_at_other!.push(item);
            }
            this.name = _data["name"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["roles_at_base"])) {
                this.roles_at_base = [] as any;
                for (let item of _data["roles_at_base"])
                    this.roles_at_base!.push(item);
            }
            if (Array.isArray(_data["roles_at_hq"])) {
                this.roles_at_hq = [] as any;
                for (let item of _data["roles_at_hq"])
                    this.roles_at_hq!.push(item);
            }
            if (Array.isArray(_data["roles_at_other"])) {
                this.roles_at_other = [] as any;
                for (let item of _data["roles_at_other"])
                    this.roles_at_other!.push(item);
            }
            this.title_id = _data["title_id"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_titles_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_titles_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.grantable_roles)) {
            data["grantable_roles"] = [];
            for (let item of this.grantable_roles)
                data["grantable_roles"].push(item);
        }
        if (Array.isArray(this.grantable_roles_at_base)) {
            data["grantable_roles_at_base"] = [];
            for (let item of this.grantable_roles_at_base)
                data["grantable_roles_at_base"].push(item);
        }
        if (Array.isArray(this.grantable_roles_at_hq)) {
            data["grantable_roles_at_hq"] = [];
            for (let item of this.grantable_roles_at_hq)
                data["grantable_roles_at_hq"].push(item);
        }
        if (Array.isArray(this.grantable_roles_at_other)) {
            data["grantable_roles_at_other"] = [];
            for (let item of this.grantable_roles_at_other)
                data["grantable_roles_at_other"].push(item);
        }
        data["name"] = this.name;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.roles_at_base)) {
            data["roles_at_base"] = [];
            for (let item of this.roles_at_base)
                data["roles_at_base"].push(item);
        }
        if (Array.isArray(this.roles_at_hq)) {
            data["roles_at_hq"] = [];
            for (let item of this.roles_at_hq)
                data["roles_at_hq"].push(item);
        }
        if (Array.isArray(this.roles_at_other)) {
            data["roles_at_other"] = [];
            for (let item of this.roles_at_other)
                data["roles_at_other"].push(item);
        }
        data["title_id"] = this.title_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_titles_200_ok {
    /** grantable_roles array */
    grantable_roles?: Grantable_roles2[] | undefined;
    /** grantable_roles_at_base array */
    grantable_roles_at_base?: Grantable_roles_at_base2[] | undefined;
    /** grantable_roles_at_hq array */
    grantable_roles_at_hq?: Grantable_roles_at_hq2[] | undefined;
    /** grantable_roles_at_other array */
    grantable_roles_at_other?: Grantable_roles_at_other2[] | undefined;
    /** name string */
    name?: string | undefined;
    /** roles array */
    roles?: Roles2[] | undefined;
    /** roles_at_base array */
    roles_at_base?: Roles_at_base2[] | undefined;
    /** roles_at_hq array */
    roles_at_hq?: Roles_at_hq2[] | undefined;
    /** roles_at_other array */
    roles_at_other?: Roles_at_other2[] | undefined;
    /** title_id integer */
    title_id?: number | undefined;
}

/** 200 ok object */
export class Get_dogma_effects_effect_id_ok implements IGet_dogma_effects_effect_id_ok {
    /** description string */
    description?: string | undefined;
    /** disallow_auto_repeat boolean */
    disallow_auto_repeat?: boolean | undefined;
    /** discharge_attribute_id integer */
    discharge_attribute_id?: number | undefined;
    /** display_name string */
    display_name?: string | undefined;
    /** duration_attribute_id integer */
    duration_attribute_id?: number | undefined;
    /** effect_category integer */
    effect_category?: number | undefined;
    /** effect_id integer */
    effect_id!: number;
    /** electronic_chance boolean */
    electronic_chance?: boolean | undefined;
    /** falloff_attribute_id integer */
    falloff_attribute_id?: number | undefined;
    /** icon_id integer */
    icon_id?: number | undefined;
    /** is_assistance boolean */
    is_assistance?: boolean | undefined;
    /** is_offensive boolean */
    is_offensive?: boolean | undefined;
    /** is_warp_safe boolean */
    is_warp_safe?: boolean | undefined;
    /** modifiers array */
    modifiers?: Modifiers[] | undefined;
    /** name string */
    name?: string | undefined;
    /** post_expression integer */
    post_expression?: number | undefined;
    /** pre_expression integer */
    pre_expression?: number | undefined;
    /** published boolean */
    published?: boolean | undefined;
    /** range_attribute_id integer */
    range_attribute_id?: number | undefined;
    /** range_chance boolean */
    range_chance?: boolean | undefined;
    /** tracking_speed_attribute_id integer */
    tracking_speed_attribute_id?: number | undefined;

    constructor(data?: IGet_dogma_effects_effect_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.disallow_auto_repeat = _data["disallow_auto_repeat"];
            this.discharge_attribute_id = _data["discharge_attribute_id"];
            this.display_name = _data["display_name"];
            this.duration_attribute_id = _data["duration_attribute_id"];
            this.effect_category = _data["effect_category"];
            this.effect_id = _data["effect_id"];
            this.electronic_chance = _data["electronic_chance"];
            this.falloff_attribute_id = _data["falloff_attribute_id"];
            this.icon_id = _data["icon_id"];
            this.is_assistance = _data["is_assistance"];
            this.is_offensive = _data["is_offensive"];
            this.is_warp_safe = _data["is_warp_safe"];
            if (Array.isArray(_data["modifiers"])) {
                this.modifiers = [] as any;
                for (let item of _data["modifiers"])
                    this.modifiers!.push(Modifiers.fromJS(item));
            }
            this.name = _data["name"];
            this.post_expression = _data["post_expression"];
            this.pre_expression = _data["pre_expression"];
            this.published = _data["published"];
            this.range_attribute_id = _data["range_attribute_id"];
            this.range_chance = _data["range_chance"];
            this.tracking_speed_attribute_id = _data["tracking_speed_attribute_id"];
        }
    }

    static fromJS(data: any): Get_dogma_effects_effect_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_dogma_effects_effect_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["disallow_auto_repeat"] = this.disallow_auto_repeat;
        data["discharge_attribute_id"] = this.discharge_attribute_id;
        data["display_name"] = this.display_name;
        data["duration_attribute_id"] = this.duration_attribute_id;
        data["effect_category"] = this.effect_category;
        data["effect_id"] = this.effect_id;
        data["electronic_chance"] = this.electronic_chance;
        data["falloff_attribute_id"] = this.falloff_attribute_id;
        data["icon_id"] = this.icon_id;
        data["is_assistance"] = this.is_assistance;
        data["is_offensive"] = this.is_offensive;
        data["is_warp_safe"] = this.is_warp_safe;
        if (Array.isArray(this.modifiers)) {
            data["modifiers"] = [];
            for (let item of this.modifiers)
                data["modifiers"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["post_expression"] = this.post_expression;
        data["pre_expression"] = this.pre_expression;
        data["published"] = this.published;
        data["range_attribute_id"] = this.range_attribute_id;
        data["range_chance"] = this.range_chance;
        data["tracking_speed_attribute_id"] = this.tracking_speed_attribute_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_dogma_effects_effect_id_ok {
    /** description string */
    description?: string | undefined;
    /** disallow_auto_repeat boolean */
    disallow_auto_repeat?: boolean | undefined;
    /** discharge_attribute_id integer */
    discharge_attribute_id?: number | undefined;
    /** display_name string */
    display_name?: string | undefined;
    /** duration_attribute_id integer */
    duration_attribute_id?: number | undefined;
    /** effect_category integer */
    effect_category?: number | undefined;
    /** effect_id integer */
    effect_id: number;
    /** electronic_chance boolean */
    electronic_chance?: boolean | undefined;
    /** falloff_attribute_id integer */
    falloff_attribute_id?: number | undefined;
    /** icon_id integer */
    icon_id?: number | undefined;
    /** is_assistance boolean */
    is_assistance?: boolean | undefined;
    /** is_offensive boolean */
    is_offensive?: boolean | undefined;
    /** is_warp_safe boolean */
    is_warp_safe?: boolean | undefined;
    /** modifiers array */
    modifiers?: Modifiers[] | undefined;
    /** name string */
    name?: string | undefined;
    /** post_expression integer */
    post_expression?: number | undefined;
    /** pre_expression integer */
    pre_expression?: number | undefined;
    /** published boolean */
    published?: boolean | undefined;
    /** range_attribute_id integer */
    range_attribute_id?: number | undefined;
    /** range_chance boolean */
    range_chance?: boolean | undefined;
    /** tracking_speed_attribute_id integer */
    tracking_speed_attribute_id?: number | undefined;
}

/** Not found */
export class Get_dogma_effects_effect_id_not_found implements IGet_dogma_effects_effect_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_dogma_effects_effect_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_dogma_effects_effect_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_dogma_effects_effect_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_dogma_effects_effect_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_fw_systems_200_ok implements IGet_fw_systems_200_ok {
    /** contested string */
    contested!: Get_fw_systems_200_okContested;
    /** occupier_faction_id integer */
    occupier_faction_id!: number;
    /** owner_faction_id integer */
    owner_faction_id!: number;
    /** solar_system_id integer */
    solar_system_id!: number;
    /** victory_points integer */
    victory_points!: number;
    /** victory_points_threshold integer */
    victory_points_threshold!: number;

    constructor(data?: IGet_fw_systems_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contested = _data["contested"];
            this.occupier_faction_id = _data["occupier_faction_id"];
            this.owner_faction_id = _data["owner_faction_id"];
            this.solar_system_id = _data["solar_system_id"];
            this.victory_points = _data["victory_points"];
            this.victory_points_threshold = _data["victory_points_threshold"];
        }
    }

    static fromJS(data: any): Get_fw_systems_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_fw_systems_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contested"] = this.contested;
        data["occupier_faction_id"] = this.occupier_faction_id;
        data["owner_faction_id"] = this.owner_faction_id;
        data["solar_system_id"] = this.solar_system_id;
        data["victory_points"] = this.victory_points;
        data["victory_points_threshold"] = this.victory_points_threshold;
        return data;
    }
}

/** 200 ok object */
export interface IGet_fw_systems_200_ok {
    /** contested string */
    contested: Get_fw_systems_200_okContested;
    /** occupier_faction_id integer */
    occupier_faction_id: number;
    /** owner_faction_id integer */
    owner_faction_id: number;
    /** solar_system_id integer */
    solar_system_id: number;
    /** victory_points integer */
    victory_points: number;
    /** victory_points_threshold integer */
    victory_points_threshold: number;
}

/** 200 ok object */
export class Get_universe_factions_200_ok implements IGet_universe_factions_200_ok {
    /** corporation_id integer */
    corporation_id?: number | undefined;
    /** description string */
    description!: string;
    /** faction_id integer */
    faction_id!: number;
    /** is_unique boolean */
    is_unique!: boolean;
    /** militia_corporation_id integer */
    militia_corporation_id?: number | undefined;
    /** name string */
    name!: string;
    /** size_factor number */
    size_factor!: number;
    /** solar_system_id integer */
    solar_system_id?: number | undefined;
    /** station_count integer */
    station_count!: number;
    /** station_system_count integer */
    station_system_count!: number;

    constructor(data?: IGet_universe_factions_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporation_id = _data["corporation_id"];
            this.description = _data["description"];
            this.faction_id = _data["faction_id"];
            this.is_unique = _data["is_unique"];
            this.militia_corporation_id = _data["militia_corporation_id"];
            this.name = _data["name"];
            this.size_factor = _data["size_factor"];
            this.solar_system_id = _data["solar_system_id"];
            this.station_count = _data["station_count"];
            this.station_system_count = _data["station_system_count"];
        }
    }

    static fromJS(data: any): Get_universe_factions_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_factions_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corporation_id"] = this.corporation_id;
        data["description"] = this.description;
        data["faction_id"] = this.faction_id;
        data["is_unique"] = this.is_unique;
        data["militia_corporation_id"] = this.militia_corporation_id;
        data["name"] = this.name;
        data["size_factor"] = this.size_factor;
        data["solar_system_id"] = this.solar_system_id;
        data["station_count"] = this.station_count;
        data["station_system_count"] = this.station_system_count;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_factions_200_ok {
    /** corporation_id integer */
    corporation_id?: number | undefined;
    /** description string */
    description: string;
    /** faction_id integer */
    faction_id: number;
    /** is_unique boolean */
    is_unique: boolean;
    /** militia_corporation_id integer */
    militia_corporation_id?: number | undefined;
    /** name string */
    name: string;
    /** size_factor number */
    size_factor: number;
    /** solar_system_id integer */
    solar_system_id?: number | undefined;
    /** station_count integer */
    station_count: number;
    /** station_system_count integer */
    station_system_count: number;
}

/** 200 ok object */
export class Get_universe_stations_station_id_ok implements IGet_universe_stations_station_id_ok {
    /** max_dockable_ship_volume number */
    max_dockable_ship_volume!: number;
    /** name string */
    name!: string;
    /** office_rental_cost number */
    office_rental_cost!: number;
    /** ID of the corporation that controls this station */
    owner?: number | undefined;
    /** position object */
    position!: Position8;
    /** race_id integer */
    race_id?: number | undefined;
    /** reprocessing_efficiency number */
    reprocessing_efficiency!: number;
    /** reprocessing_stations_take number */
    reprocessing_stations_take!: number;
    /** services array */
    services!: Services[];
    /** station_id integer */
    station_id!: number;
    /** The solar system this station is in */
    system_id!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_universe_stations_station_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.position = new Position8();
            this.services = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.max_dockable_ship_volume = _data["max_dockable_ship_volume"];
            this.name = _data["name"];
            this.office_rental_cost = _data["office_rental_cost"];
            this.owner = _data["owner"];
            this.position = _data["position"] ? Position8.fromJS(_data["position"]) : new Position8();
            this.race_id = _data["race_id"];
            this.reprocessing_efficiency = _data["reprocessing_efficiency"];
            this.reprocessing_stations_take = _data["reprocessing_stations_take"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(item);
            }
            this.station_id = _data["station_id"];
            this.system_id = _data["system_id"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_universe_stations_station_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_stations_station_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["max_dockable_ship_volume"] = this.max_dockable_ship_volume;
        data["name"] = this.name;
        data["office_rental_cost"] = this.office_rental_cost;
        data["owner"] = this.owner;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["race_id"] = this.race_id;
        data["reprocessing_efficiency"] = this.reprocessing_efficiency;
        data["reprocessing_stations_take"] = this.reprocessing_stations_take;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item);
        }
        data["station_id"] = this.station_id;
        data["system_id"] = this.system_id;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_stations_station_id_ok {
    /** max_dockable_ship_volume number */
    max_dockable_ship_volume: number;
    /** name string */
    name: string;
    /** office_rental_cost number */
    office_rental_cost: number;
    /** ID of the corporation that controls this station */
    owner?: number | undefined;
    /** position object */
    position: Position8;
    /** race_id integer */
    race_id?: number | undefined;
    /** reprocessing_efficiency number */
    reprocessing_efficiency: number;
    /** reprocessing_stations_take number */
    reprocessing_stations_take: number;
    /** services array */
    services: Services[];
    /** station_id integer */
    station_id: number;
    /** The solar system this station is in */
    system_id: number;
    /** type_id integer */
    type_id: number;
}

/** Not found */
export class Get_universe_stations_station_id_not_found implements IGet_universe_stations_station_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_stations_station_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_stations_station_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_stations_station_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_stations_station_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_structures_structure_id_ok implements IGet_universe_structures_structure_id_ok {
    /** The full name of the structure */
    name!: string;
    /** The ID of the corporation who owns this particular structure */
    owner_id!: number;
    /** Coordinates of the structure in Cartesian space relative to the Sun, in metres.
 */
    position?: Position9 | undefined;
    /** solar_system_id integer */
    solar_system_id!: number;
    /** type_id integer */
    type_id?: number | undefined;

    constructor(data?: IGet_universe_structures_structure_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.owner_id = _data["owner_id"];
            this.position = _data["position"] ? Position9.fromJS(_data["position"]) : <any>undefined;
            this.solar_system_id = _data["solar_system_id"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_universe_structures_structure_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_structures_structure_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["owner_id"] = this.owner_id;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["solar_system_id"] = this.solar_system_id;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_structures_structure_id_ok {
    /** The full name of the structure */
    name: string;
    /** The ID of the corporation who owns this particular structure */
    owner_id: number;
    /** Coordinates of the structure in Cartesian space relative to the Sun, in metres.
 */
    position?: Position9 | undefined;
    /** solar_system_id integer */
    solar_system_id: number;
    /** type_id integer */
    type_id?: number | undefined;
}

/** Not found */
export class Get_universe_structures_structure_id_not_found implements IGet_universe_structures_structure_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_structures_structure_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_structures_structure_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_structures_structure_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_structures_structure_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_system_kills_200_ok implements IGet_universe_system_kills_200_ok {
    /** Number of NPC ships killed in this system */
    npc_kills!: number;
    /** Number of pods killed in this system */
    pod_kills!: number;
    /** Number of player ships killed in this system */
    ship_kills!: number;
    /** system_id integer */
    system_id!: number;

    constructor(data?: IGet_universe_system_kills_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.npc_kills = _data["npc_kills"];
            this.pod_kills = _data["pod_kills"];
            this.ship_kills = _data["ship_kills"];
            this.system_id = _data["system_id"];
        }
    }

    static fromJS(data: any): Get_universe_system_kills_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_system_kills_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["npc_kills"] = this.npc_kills;
        data["pod_kills"] = this.pod_kills;
        data["ship_kills"] = this.ship_kills;
        data["system_id"] = this.system_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_system_kills_200_ok {
    /** Number of NPC ships killed in this system */
    npc_kills: number;
    /** Number of pods killed in this system */
    pod_kills: number;
    /** Number of player ships killed in this system */
    ship_kills: number;
    /** system_id integer */
    system_id: number;
}

/** 200 ok object */
export class Get_alliances_alliance_id_ok implements IGet_alliances_alliance_id_ok {
    /** ID of the corporation that created the alliance */
    creator_corporation_id!: number;
    /** ID of the character that created the alliance */
    creator_id!: number;
    /** date_founded string */
    date_founded!: Date;
    /** the executor corporation ID, if this alliance is not closed */
    executor_corporation_id?: number | undefined;
    /** Faction ID this alliance is fighting for, if this alliance is enlisted in factional warfare */
    faction_id?: number | undefined;
    /** the full name of the alliance */
    name!: string;
    /** the short name of the alliance */
    ticker!: string;

    constructor(data?: IGet_alliances_alliance_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creator_corporation_id = _data["creator_corporation_id"];
            this.creator_id = _data["creator_id"];
            this.date_founded = _data["date_founded"] ? new Date(_data["date_founded"].toString()) : <any>undefined;
            this.executor_corporation_id = _data["executor_corporation_id"];
            this.faction_id = _data["faction_id"];
            this.name = _data["name"];
            this.ticker = _data["ticker"];
        }
    }

    static fromJS(data: any): Get_alliances_alliance_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_alliances_alliance_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creator_corporation_id"] = this.creator_corporation_id;
        data["creator_id"] = this.creator_id;
        data["date_founded"] = this.date_founded ? this.date_founded.toISOString() : <any>undefined;
        data["executor_corporation_id"] = this.executor_corporation_id;
        data["faction_id"] = this.faction_id;
        data["name"] = this.name;
        data["ticker"] = this.ticker;
        return data;
    }
}

/** 200 ok object */
export interface IGet_alliances_alliance_id_ok {
    /** ID of the corporation that created the alliance */
    creator_corporation_id: number;
    /** ID of the character that created the alliance */
    creator_id: number;
    /** date_founded string */
    date_founded: Date;
    /** the executor corporation ID, if this alliance is not closed */
    executor_corporation_id?: number | undefined;
    /** Faction ID this alliance is fighting for, if this alliance is enlisted in factional warfare */
    faction_id?: number | undefined;
    /** the full name of the alliance */
    name: string;
    /** the short name of the alliance */
    ticker: string;
}

/** Not found */
export class Get_alliances_alliance_id_not_found implements IGet_alliances_alliance_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_alliances_alliance_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_alliances_alliance_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_alliances_alliance_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_alliances_alliance_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_blueprints_200_ok implements IGet_characters_character_id_blueprints_200_ok {
    /** Unique ID for this item. */
    item_id!: number;
    /** Type of the location_id */
    location_flag!: Get_characters_character_id_blueprints_200_okLocation_flag;
    /** References a station, a ship or an item_id if this blueprint is located within a container. If the return value is an item_id, then the Character AssetList API must be queried to find the container using the given item_id to determine the correct location of the Blueprint. */
    location_id!: number;
    /** Material Efficiency Level of the blueprint. */
    material_efficiency!: number;
    /** A range of numbers with a minimum of -2 and no maximum value where -1 is an original and -2 is a copy. It can be a positive integer if it is a stack of blueprint originals fresh from the market (e.g. no activities performed on them yet). */
    quantity!: number;
    /** Number of runs remaining if the blueprint is a copy, -1 if it is an original. */
    runs!: number;
    /** Time Efficiency Level of the blueprint. */
    time_efficiency!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_characters_character_id_blueprints_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item_id = _data["item_id"];
            this.location_flag = _data["location_flag"];
            this.location_id = _data["location_id"];
            this.material_efficiency = _data["material_efficiency"];
            this.quantity = _data["quantity"];
            this.runs = _data["runs"];
            this.time_efficiency = _data["time_efficiency"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_blueprints_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_blueprints_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item_id"] = this.item_id;
        data["location_flag"] = this.location_flag;
        data["location_id"] = this.location_id;
        data["material_efficiency"] = this.material_efficiency;
        data["quantity"] = this.quantity;
        data["runs"] = this.runs;
        data["time_efficiency"] = this.time_efficiency;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_blueprints_200_ok {
    /** Unique ID for this item. */
    item_id: number;
    /** Type of the location_id */
    location_flag: Get_characters_character_id_blueprints_200_okLocation_flag;
    /** References a station, a ship or an item_id if this blueprint is located within a container. If the return value is an item_id, then the Character AssetList API must be queried to find the container using the given item_id to determine the correct location of the Blueprint. */
    location_id: number;
    /** Material Efficiency Level of the blueprint. */
    material_efficiency: number;
    /** A range of numbers with a minimum of -2 and no maximum value where -1 is an original and -2 is a copy. It can be a positive integer if it is a stack of blueprint originals fresh from the market (e.g. no activities performed on them yet). */
    quantity: number;
    /** Number of runs remaining if the blueprint is a copy, -1 if it is an original. */
    runs: number;
    /** Time Efficiency Level of the blueprint. */
    time_efficiency: number;
    /** type_id integer */
    type_id: number;
}

/** Full details of a specific event */
export class Get_characters_character_id_calendar_event_id_ok implements IGet_characters_character_id_calendar_event_id_ok {
    /** date string */
    date!: Date;
    /** Length in minutes */
    duration!: number;
    /** event_id integer */
    event_id!: number;
    /** importance integer */
    importance!: number;
    /** owner_id integer */
    owner_id!: number;
    /** owner_name string */
    owner_name!: string;
    /** owner_type string */
    owner_type!: Get_characters_character_id_calendar_event_id_okOwner_type;
    /** response string */
    response!: string;
    /** text string */
    text!: string;
    /** title string */
    title!: string;

    constructor(data?: IGet_characters_character_id_calendar_event_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.event_id = _data["event_id"];
            this.importance = _data["importance"];
            this.owner_id = _data["owner_id"];
            this.owner_name = _data["owner_name"];
            this.owner_type = _data["owner_type"];
            this.response = _data["response"];
            this.text = _data["text"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_calendar_event_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_calendar_event_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["event_id"] = this.event_id;
        data["importance"] = this.importance;
        data["owner_id"] = this.owner_id;
        data["owner_name"] = this.owner_name;
        data["owner_type"] = this.owner_type;
        data["response"] = this.response;
        data["text"] = this.text;
        data["title"] = this.title;
        return data;
    }
}

/** Full details of a specific event */
export interface IGet_characters_character_id_calendar_event_id_ok {
    /** date string */
    date: Date;
    /** Length in minutes */
    duration: number;
    /** event_id integer */
    event_id: number;
    /** importance integer */
    importance: number;
    /** owner_id integer */
    owner_id: number;
    /** owner_name string */
    owner_name: string;
    /** owner_type string */
    owner_type: Get_characters_character_id_calendar_event_id_okOwner_type;
    /** response string */
    response: string;
    /** text string */
    text: string;
    /** title string */
    title: string;
}

/** Not found */
export class Get_characters_character_id_calendar_event_id_not_found implements IGet_characters_character_id_calendar_event_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_characters_character_id_calendar_event_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_calendar_event_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_calendar_event_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_characters_character_id_calendar_event_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_clones_ok implements IGet_characters_character_id_clones_ok {
    /** home_location object */
    home_location?: Home_location | undefined;
    /** jump_clones array */
    jump_clones!: Jump_clones[];
    /** last_clone_jump_date string */
    last_clone_jump_date?: Date | undefined;
    /** last_station_change_date string */
    last_station_change_date?: Date | undefined;

    constructor(data?: IGet_characters_character_id_clones_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.jump_clones = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.home_location = _data["home_location"] ? Home_location.fromJS(_data["home_location"]) : <any>undefined;
            if (Array.isArray(_data["jump_clones"])) {
                this.jump_clones = [] as any;
                for (let item of _data["jump_clones"])
                    this.jump_clones!.push(Jump_clones.fromJS(item));
            }
            this.last_clone_jump_date = _data["last_clone_jump_date"] ? new Date(_data["last_clone_jump_date"].toString()) : <any>undefined;
            this.last_station_change_date = _data["last_station_change_date"] ? new Date(_data["last_station_change_date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_characters_character_id_clones_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_clones_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["home_location"] = this.home_location ? this.home_location.toJSON() : <any>undefined;
        if (Array.isArray(this.jump_clones)) {
            data["jump_clones"] = [];
            for (let item of this.jump_clones)
                data["jump_clones"].push(item.toJSON());
        }
        data["last_clone_jump_date"] = this.last_clone_jump_date ? this.last_clone_jump_date.toISOString() : <any>undefined;
        data["last_station_change_date"] = this.last_station_change_date ? this.last_station_change_date.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_clones_ok {
    /** home_location object */
    home_location?: Home_location | undefined;
    /** jump_clones array */
    jump_clones: Jump_clones[];
    /** last_clone_jump_date string */
    last_clone_jump_date?: Date | undefined;
    /** last_station_change_date string */
    last_station_change_date?: Date | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_mail_labels_ok implements IGet_characters_character_id_mail_labels_ok {
    /** labels array */
    labels?: Labels[] | undefined;
    /** total_unread_count integer */
    total_unread_count?: number | undefined;

    constructor(data?: IGet_characters_character_id_mail_labels_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(Labels.fromJS(item));
            }
            this.total_unread_count = _data["total_unread_count"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_mail_labels_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_mail_labels_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item.toJSON());
        }
        data["total_unread_count"] = this.total_unread_count;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_mail_labels_ok {
    /** labels array */
    labels?: Labels[] | undefined;
    /** total_unread_count integer */
    total_unread_count?: number | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_planets_planet_id_ok implements IGet_characters_character_id_planets_planet_id_ok {
    /** links array */
    links!: Links[];
    /** pins array */
    pins!: Pins[];
    /** routes array */
    routes!: Routes[];

    constructor(data?: IGet_characters_character_id_planets_planet_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.links = [];
            this.pins = [];
            this.routes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(Links.fromJS(item));
            }
            if (Array.isArray(_data["pins"])) {
                this.pins = [] as any;
                for (let item of _data["pins"])
                    this.pins!.push(Pins.fromJS(item));
            }
            if (Array.isArray(_data["routes"])) {
                this.routes = [] as any;
                for (let item of _data["routes"])
                    this.routes!.push(Routes.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Get_characters_character_id_planets_planet_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_planets_planet_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        if (Array.isArray(this.pins)) {
            data["pins"] = [];
            for (let item of this.pins)
                data["pins"].push(item.toJSON());
        }
        if (Array.isArray(this.routes)) {
            data["routes"] = [];
            for (let item of this.routes)
                data["routes"].push(item.toJSON());
        }
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_planets_planet_id_ok {
    /** links array */
    links: Links[];
    /** pins array */
    pins: Pins[];
    /** routes array */
    routes: Routes[];
}

/** Colony not found */
export class Get_characters_character_id_planets_planet_id_not_found implements IGet_characters_character_id_planets_planet_id_not_found {
    /** error message */
    error?: string | undefined;

    constructor(data?: IGet_characters_character_id_planets_planet_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_planets_planet_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_planets_planet_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Colony not found */
export interface IGet_characters_character_id_planets_planet_id_not_found {
    /** error message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_roles_ok implements IGet_characters_character_id_roles_ok {
    /** roles array */
    roles?: Roles3[] | undefined;
    /** roles_at_base array */
    roles_at_base?: Roles_at_base3[] | undefined;
    /** roles_at_hq array */
    roles_at_hq?: Roles_at_hq3[] | undefined;
    /** roles_at_other array */
    roles_at_other?: Roles_at_other3[] | undefined;

    constructor(data?: IGet_characters_character_id_roles_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["roles_at_base"])) {
                this.roles_at_base = [] as any;
                for (let item of _data["roles_at_base"])
                    this.roles_at_base!.push(item);
            }
            if (Array.isArray(_data["roles_at_hq"])) {
                this.roles_at_hq = [] as any;
                for (let item of _data["roles_at_hq"])
                    this.roles_at_hq!.push(item);
            }
            if (Array.isArray(_data["roles_at_other"])) {
                this.roles_at_other = [] as any;
                for (let item of _data["roles_at_other"])
                    this.roles_at_other!.push(item);
            }
        }
    }

    static fromJS(data: any): Get_characters_character_id_roles_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_roles_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.roles_at_base)) {
            data["roles_at_base"] = [];
            for (let item of this.roles_at_base)
                data["roles_at_base"].push(item);
        }
        if (Array.isArray(this.roles_at_hq)) {
            data["roles_at_hq"] = [];
            for (let item of this.roles_at_hq)
                data["roles_at_hq"].push(item);
        }
        if (Array.isArray(this.roles_at_other)) {
            data["roles_at_other"] = [];
            for (let item of this.roles_at_other)
                data["roles_at_other"].push(item);
        }
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_roles_ok {
    /** roles array */
    roles?: Roles3[] | undefined;
    /** roles_at_base array */
    roles_at_base?: Roles_at_base3[] | undefined;
    /** roles_at_hq array */
    roles_at_hq?: Roles_at_hq3[] | undefined;
    /** roles_at_other array */
    roles_at_other?: Roles_at_other3[] | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_search_ok implements IGet_characters_character_id_search_ok {
    /** agent array */
    agent?: number[] | undefined;
    /** alliance array */
    alliance?: number[] | undefined;
    /** character array */
    character?: number[] | undefined;
    /** constellation array */
    constellation?: number[] | undefined;
    /** corporation array */
    corporation?: number[] | undefined;
    /** faction array */
    faction?: number[] | undefined;
    /** inventory_type array */
    inventory_type?: number[] | undefined;
    /** region array */
    region?: number[] | undefined;
    /** solar_system array */
    solar_system?: number[] | undefined;
    /** station array */
    station?: number[] | undefined;
    /** structure array */
    structure?: number[] | undefined;

    constructor(data?: IGet_characters_character_id_search_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["agent"])) {
                this.agent = [] as any;
                for (let item of _data["agent"])
                    this.agent!.push(item);
            }
            if (Array.isArray(_data["alliance"])) {
                this.alliance = [] as any;
                for (let item of _data["alliance"])
                    this.alliance!.push(item);
            }
            if (Array.isArray(_data["character"])) {
                this.character = [] as any;
                for (let item of _data["character"])
                    this.character!.push(item);
            }
            if (Array.isArray(_data["constellation"])) {
                this.constellation = [] as any;
                for (let item of _data["constellation"])
                    this.constellation!.push(item);
            }
            if (Array.isArray(_data["corporation"])) {
                this.corporation = [] as any;
                for (let item of _data["corporation"])
                    this.corporation!.push(item);
            }
            if (Array.isArray(_data["faction"])) {
                this.faction = [] as any;
                for (let item of _data["faction"])
                    this.faction!.push(item);
            }
            if (Array.isArray(_data["inventory_type"])) {
                this.inventory_type = [] as any;
                for (let item of _data["inventory_type"])
                    this.inventory_type!.push(item);
            }
            if (Array.isArray(_data["region"])) {
                this.region = [] as any;
                for (let item of _data["region"])
                    this.region!.push(item);
            }
            if (Array.isArray(_data["solar_system"])) {
                this.solar_system = [] as any;
                for (let item of _data["solar_system"])
                    this.solar_system!.push(item);
            }
            if (Array.isArray(_data["station"])) {
                this.station = [] as any;
                for (let item of _data["station"])
                    this.station!.push(item);
            }
            if (Array.isArray(_data["structure"])) {
                this.structure = [] as any;
                for (let item of _data["structure"])
                    this.structure!.push(item);
            }
        }
    }

    static fromJS(data: any): Get_characters_character_id_search_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_search_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agent)) {
            data["agent"] = [];
            for (let item of this.agent)
                data["agent"].push(item);
        }
        if (Array.isArray(this.alliance)) {
            data["alliance"] = [];
            for (let item of this.alliance)
                data["alliance"].push(item);
        }
        if (Array.isArray(this.character)) {
            data["character"] = [];
            for (let item of this.character)
                data["character"].push(item);
        }
        if (Array.isArray(this.constellation)) {
            data["constellation"] = [];
            for (let item of this.constellation)
                data["constellation"].push(item);
        }
        if (Array.isArray(this.corporation)) {
            data["corporation"] = [];
            for (let item of this.corporation)
                data["corporation"].push(item);
        }
        if (Array.isArray(this.faction)) {
            data["faction"] = [];
            for (let item of this.faction)
                data["faction"].push(item);
        }
        if (Array.isArray(this.inventory_type)) {
            data["inventory_type"] = [];
            for (let item of this.inventory_type)
                data["inventory_type"].push(item);
        }
        if (Array.isArray(this.region)) {
            data["region"] = [];
            for (let item of this.region)
                data["region"].push(item);
        }
        if (Array.isArray(this.solar_system)) {
            data["solar_system"] = [];
            for (let item of this.solar_system)
                data["solar_system"].push(item);
        }
        if (Array.isArray(this.station)) {
            data["station"] = [];
            for (let item of this.station)
                data["station"].push(item);
        }
        if (Array.isArray(this.structure)) {
            data["structure"] = [];
            for (let item of this.structure)
                data["structure"].push(item);
        }
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_search_ok {
    /** agent array */
    agent?: number[] | undefined;
    /** alliance array */
    alliance?: number[] | undefined;
    /** character array */
    character?: number[] | undefined;
    /** constellation array */
    constellation?: number[] | undefined;
    /** corporation array */
    corporation?: number[] | undefined;
    /** faction array */
    faction?: number[] | undefined;
    /** inventory_type array */
    inventory_type?: number[] | undefined;
    /** region array */
    region?: number[] | undefined;
    /** solar_system array */
    solar_system?: number[] | undefined;
    /** station array */
    station?: number[] | undefined;
    /** structure array */
    structure?: number[] | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_alliancehistory_200_ok implements IGet_corporations_corporation_id_alliancehistory_200_ok {
    /** alliance_id integer */
    alliance_id?: number | undefined;
    /** True if the alliance has been closed */
    is_deleted?: boolean | undefined;
    /** An incrementing ID that can be used to canonically establish order of records in cases where dates may be ambiguous */
    record_id!: number;
    /** start_date string */
    start_date!: Date;

    constructor(data?: IGet_corporations_corporation_id_alliancehistory_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.is_deleted = _data["is_deleted"];
            this.record_id = _data["record_id"];
            this.start_date = _data["start_date"] ? new Date(_data["start_date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_alliancehistory_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_alliancehistory_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["is_deleted"] = this.is_deleted;
        data["record_id"] = this.record_id;
        data["start_date"] = this.start_date ? this.start_date.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_alliancehistory_200_ok {
    /** alliance_id integer */
    alliance_id?: number | undefined;
    /** True if the alliance has been closed */
    is_deleted?: boolean | undefined;
    /** An incrementing ID that can be used to canonically establish order of records in cases where dates may be ambiguous */
    record_id: number;
    /** start_date string */
    start_date: Date;
}

/** 200 ok object */
export class Get_corporations_corporation_id_blueprints_200_ok implements IGet_corporations_corporation_id_blueprints_200_ok {
    /** Unique ID for this item. */
    item_id!: number;
    /** Type of the location_id */
    location_flag!: Get_corporations_corporation_id_blueprints_200_okLocation_flag;
    /** References a station, a ship or an item_id if this blueprint is located within a container. */
    location_id!: number;
    /** Material Efficiency Level of the blueprint. */
    material_efficiency!: number;
    /** A range of numbers with a minimum of -2 and no maximum value where -1 is an original and -2 is a copy. It can be a positive integer if it is a stack of blueprint originals fresh from the market (e.g. no activities performed on them yet). */
    quantity!: number;
    /** Number of runs remaining if the blueprint is a copy, -1 if it is an original. */
    runs!: number;
    /** Time Efficiency Level of the blueprint. */
    time_efficiency!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_corporations_corporation_id_blueprints_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item_id = _data["item_id"];
            this.location_flag = _data["location_flag"];
            this.location_id = _data["location_id"];
            this.material_efficiency = _data["material_efficiency"];
            this.quantity = _data["quantity"];
            this.runs = _data["runs"];
            this.time_efficiency = _data["time_efficiency"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_blueprints_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_blueprints_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item_id"] = this.item_id;
        data["location_flag"] = this.location_flag;
        data["location_id"] = this.location_id;
        data["material_efficiency"] = this.material_efficiency;
        data["quantity"] = this.quantity;
        data["runs"] = this.runs;
        data["time_efficiency"] = this.time_efficiency;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_blueprints_200_ok {
    /** Unique ID for this item. */
    item_id: number;
    /** Type of the location_id */
    location_flag: Get_corporations_corporation_id_blueprints_200_okLocation_flag;
    /** References a station, a ship or an item_id if this blueprint is located within a container. */
    location_id: number;
    /** Material Efficiency Level of the blueprint. */
    material_efficiency: number;
    /** A range of numbers with a minimum of -2 and no maximum value where -1 is an original and -2 is a copy. It can be a positive integer if it is a stack of blueprint originals fresh from the market (e.g. no activities performed on them yet). */
    quantity: number;
    /** Number of runs remaining if the blueprint is a copy, -1 if it is an original. */
    runs: number;
    /** Time Efficiency Level of the blueprint. */
    time_efficiency: number;
    /** type_id integer */
    type_id: number;
}

/** 200 ok object */
export class Get_corporations_corporation_id_containers_logs_200_ok implements IGet_corporations_corporation_id_containers_logs_200_ok {
    /** action string */
    action!: Get_corporations_corporation_id_containers_logs_200_okAction;
    /** ID of the character who performed the action. */
    character_id!: number;
    /** ID of the container */
    container_id!: number;
    /** Type ID of the container */
    container_type_id!: number;
    /** location_flag string */
    location_flag!: Get_corporations_corporation_id_containers_logs_200_okLocation_flag;
    /** location_id integer */
    location_id!: number;
    /** Timestamp when this log was created */
    logged_at!: Date;
    /** new_config_bitmask integer */
    new_config_bitmask?: number | undefined;
    /** old_config_bitmask integer */
    old_config_bitmask?: number | undefined;
    /** Type of password set if action is of type SetPassword or EnterPassword */
    password_type?: Get_corporations_corporation_id_containers_logs_200_okPassword_type | undefined;
    /** Quantity of the item being acted upon */
    quantity?: number | undefined;
    /** Type ID of the item being acted upon */
    type_id?: number | undefined;

    constructor(data?: IGet_corporations_corporation_id_containers_logs_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.character_id = _data["character_id"];
            this.container_id = _data["container_id"];
            this.container_type_id = _data["container_type_id"];
            this.location_flag = _data["location_flag"];
            this.location_id = _data["location_id"];
            this.logged_at = _data["logged_at"] ? new Date(_data["logged_at"].toString()) : <any>undefined;
            this.new_config_bitmask = _data["new_config_bitmask"];
            this.old_config_bitmask = _data["old_config_bitmask"];
            this.password_type = _data["password_type"];
            this.quantity = _data["quantity"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_containers_logs_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_containers_logs_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["character_id"] = this.character_id;
        data["container_id"] = this.container_id;
        data["container_type_id"] = this.container_type_id;
        data["location_flag"] = this.location_flag;
        data["location_id"] = this.location_id;
        data["logged_at"] = this.logged_at ? this.logged_at.toISOString() : <any>undefined;
        data["new_config_bitmask"] = this.new_config_bitmask;
        data["old_config_bitmask"] = this.old_config_bitmask;
        data["password_type"] = this.password_type;
        data["quantity"] = this.quantity;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_containers_logs_200_ok {
    /** action string */
    action: Get_corporations_corporation_id_containers_logs_200_okAction;
    /** ID of the character who performed the action. */
    character_id: number;
    /** ID of the container */
    container_id: number;
    /** Type ID of the container */
    container_type_id: number;
    /** location_flag string */
    location_flag: Get_corporations_corporation_id_containers_logs_200_okLocation_flag;
    /** location_id integer */
    location_id: number;
    /** Timestamp when this log was created */
    logged_at: Date;
    /** new_config_bitmask integer */
    new_config_bitmask?: number | undefined;
    /** old_config_bitmask integer */
    old_config_bitmask?: number | undefined;
    /** Type of password set if action is of type SetPassword or EnterPassword */
    password_type?: Get_corporations_corporation_id_containers_logs_200_okPassword_type | undefined;
    /** Quantity of the item being acted upon */
    quantity?: number | undefined;
    /** Type ID of the item being acted upon */
    type_id?: number | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_orders_200_ok implements IGet_corporations_corporation_id_orders_200_ok {
    /** Number of days for which order is valid (starting from the issued date). An order expires at time issued + duration */
    duration!: number;
    /** For buy orders, the amount of ISK in escrow */
    escrow?: number | undefined;
    /** True if the order is a bid (buy) order */
    is_buy_order?: boolean | undefined;
    /** Date and time when this order was issued */
    issued!: Date;
    /** The character who issued this order */
    issued_by!: number;
    /** ID of the location where order was placed */
    location_id!: number;
    /** For buy orders, the minimum quantity that will be accepted in a matching sell order */
    min_volume?: number | undefined;
    /** Unique order ID */
    order_id!: number;
    /** Cost per unit for this order */
    price!: number;
    /** Valid order range, numbers are ranges in jumps */
    range!: Get_corporations_corporation_id_orders_200_okRange;
    /** ID of the region where order was placed */
    region_id!: number;
    /** The type ID of the item transacted in this order */
    type_id!: number;
    /** Quantity of items still required or offered */
    volume_remain!: number;
    /** Quantity of items required or offered at time order was placed */
    volume_total!: number;
    /** The corporation wallet division used for this order. */
    wallet_division!: number;

    constructor(data?: IGet_corporations_corporation_id_orders_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
            this.escrow = _data["escrow"];
            this.is_buy_order = _data["is_buy_order"];
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : <any>undefined;
            this.issued_by = _data["issued_by"];
            this.location_id = _data["location_id"];
            this.min_volume = _data["min_volume"];
            this.order_id = _data["order_id"];
            this.price = _data["price"];
            this.range = _data["range"];
            this.region_id = _data["region_id"];
            this.type_id = _data["type_id"];
            this.volume_remain = _data["volume_remain"];
            this.volume_total = _data["volume_total"];
            this.wallet_division = _data["wallet_division"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_orders_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_orders_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["escrow"] = this.escrow;
        data["is_buy_order"] = this.is_buy_order;
        data["issued"] = this.issued ? this.issued.toISOString() : <any>undefined;
        data["issued_by"] = this.issued_by;
        data["location_id"] = this.location_id;
        data["min_volume"] = this.min_volume;
        data["order_id"] = this.order_id;
        data["price"] = this.price;
        data["range"] = this.range;
        data["region_id"] = this.region_id;
        data["type_id"] = this.type_id;
        data["volume_remain"] = this.volume_remain;
        data["volume_total"] = this.volume_total;
        data["wallet_division"] = this.wallet_division;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_orders_200_ok {
    /** Number of days for which order is valid (starting from the issued date). An order expires at time issued + duration */
    duration: number;
    /** For buy orders, the amount of ISK in escrow */
    escrow?: number | undefined;
    /** True if the order is a bid (buy) order */
    is_buy_order?: boolean | undefined;
    /** Date and time when this order was issued */
    issued: Date;
    /** The character who issued this order */
    issued_by: number;
    /** ID of the location where order was placed */
    location_id: number;
    /** For buy orders, the minimum quantity that will be accepted in a matching sell order */
    min_volume?: number | undefined;
    /** Unique order ID */
    order_id: number;
    /** Cost per unit for this order */
    price: number;
    /** Valid order range, numbers are ranges in jumps */
    range: Get_corporations_corporation_id_orders_200_okRange;
    /** ID of the region where order was placed */
    region_id: number;
    /** The type ID of the item transacted in this order */
    type_id: number;
    /** Quantity of items still required or offered */
    volume_remain: number;
    /** Quantity of items required or offered at time order was placed */
    volume_total: number;
    /** The corporation wallet division used for this order. */
    wallet_division: number;
}

/** 200 ok object */
export class Post_universe_names_200_ok implements IPost_universe_names_200_ok {
    /** category string */
    category!: Post_universe_names_200_okCategory;
    /** id integer */
    id!: number;
    /** name string */
    name!: string;

    constructor(data?: IPost_universe_names_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Post_universe_names_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Post_universe_names_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** 200 ok object */
export interface IPost_universe_names_200_ok {
    /** category string */
    category: Post_universe_names_200_okCategory;
    /** id integer */
    id: number;
    /** name string */
    name: string;
}

/** Not found */
export class Post_universe_names_not_found implements IPost_universe_names_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IPost_universe_names_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Post_universe_names_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Post_universe_names_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IPost_universe_names_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_universe_types_type_id_ok implements IGet_universe_types_type_id_ok {
    /** capacity number */
    capacity?: number | undefined;
    /** description string */
    description!: string;
    /** dogma_attributes array */
    dogma_attributes?: Dogma_attributes2[] | undefined;
    /** dogma_effects array */
    dogma_effects?: Dogma_effects2[] | undefined;
    /** graphic_id integer */
    graphic_id?: number | undefined;
    /** group_id integer */
    group_id!: number;
    /** icon_id integer */
    icon_id?: number | undefined;
    /** This only exists for types that can be put on the market */
    market_group_id?: number | undefined;
    /** mass number */
    mass?: number | undefined;
    /** name string */
    name!: string;
    /** packaged_volume number */
    packaged_volume?: number | undefined;
    /** portion_size integer */
    portion_size?: number | undefined;
    /** published boolean */
    published!: boolean;
    /** radius number */
    radius?: number | undefined;
    /** type_id integer */
    type_id!: number;
    /** volume number */
    volume?: number | undefined;

    constructor(data?: IGet_universe_types_type_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.capacity = _data["capacity"];
            this.description = _data["description"];
            if (Array.isArray(_data["dogma_attributes"])) {
                this.dogma_attributes = [] as any;
                for (let item of _data["dogma_attributes"])
                    this.dogma_attributes!.push(Dogma_attributes2.fromJS(item));
            }
            if (Array.isArray(_data["dogma_effects"])) {
                this.dogma_effects = [] as any;
                for (let item of _data["dogma_effects"])
                    this.dogma_effects!.push(Dogma_effects2.fromJS(item));
            }
            this.graphic_id = _data["graphic_id"];
            this.group_id = _data["group_id"];
            this.icon_id = _data["icon_id"];
            this.market_group_id = _data["market_group_id"];
            this.mass = _data["mass"];
            this.name = _data["name"];
            this.packaged_volume = _data["packaged_volume"];
            this.portion_size = _data["portion_size"];
            this.published = _data["published"];
            this.radius = _data["radius"];
            this.type_id = _data["type_id"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): Get_universe_types_type_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_types_type_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["capacity"] = this.capacity;
        data["description"] = this.description;
        if (Array.isArray(this.dogma_attributes)) {
            data["dogma_attributes"] = [];
            for (let item of this.dogma_attributes)
                data["dogma_attributes"].push(item.toJSON());
        }
        if (Array.isArray(this.dogma_effects)) {
            data["dogma_effects"] = [];
            for (let item of this.dogma_effects)
                data["dogma_effects"].push(item.toJSON());
        }
        data["graphic_id"] = this.graphic_id;
        data["group_id"] = this.group_id;
        data["icon_id"] = this.icon_id;
        data["market_group_id"] = this.market_group_id;
        data["mass"] = this.mass;
        data["name"] = this.name;
        data["packaged_volume"] = this.packaged_volume;
        data["portion_size"] = this.portion_size;
        data["published"] = this.published;
        data["radius"] = this.radius;
        data["type_id"] = this.type_id;
        data["volume"] = this.volume;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_types_type_id_ok {
    /** capacity number */
    capacity?: number | undefined;
    /** description string */
    description: string;
    /** dogma_attributes array */
    dogma_attributes?: Dogma_attributes2[] | undefined;
    /** dogma_effects array */
    dogma_effects?: Dogma_effects2[] | undefined;
    /** graphic_id integer */
    graphic_id?: number | undefined;
    /** group_id integer */
    group_id: number;
    /** icon_id integer */
    icon_id?: number | undefined;
    /** This only exists for types that can be put on the market */
    market_group_id?: number | undefined;
    /** mass number */
    mass?: number | undefined;
    /** name string */
    name: string;
    /** packaged_volume number */
    packaged_volume?: number | undefined;
    /** portion_size integer */
    portion_size?: number | undefined;
    /** published boolean */
    published: boolean;
    /** radius number */
    radius?: number | undefined;
    /** type_id integer */
    type_id: number;
    /** volume number */
    volume?: number | undefined;
}

/** Not found */
export class Get_universe_types_type_id_not_found implements IGet_universe_types_type_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_types_type_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_types_type_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_types_type_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_types_type_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_skills_ok implements IGet_characters_character_id_skills_ok {
    /** skills array */
    skills!: Skills[];
    /** total_sp integer */
    total_sp!: number;
    /** Skill points available to be assigned */
    unallocated_sp?: number | undefined;

    constructor(data?: IGet_characters_character_id_skills_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.skills = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["skills"])) {
                this.skills = [] as any;
                for (let item of _data["skills"])
                    this.skills!.push(Skills.fromJS(item));
            }
            this.total_sp = _data["total_sp"];
            this.unallocated_sp = _data["unallocated_sp"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_skills_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_skills_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.skills)) {
            data["skills"] = [];
            for (let item of this.skills)
                data["skills"].push(item.toJSON());
        }
        data["total_sp"] = this.total_sp;
        data["unallocated_sp"] = this.unallocated_sp;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_skills_ok {
    /** skills array */
    skills: Skills[];
    /** total_sp integer */
    total_sp: number;
    /** Skill points available to be assigned */
    unallocated_sp?: number | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_structures_200_ok implements IGet_corporations_corporation_id_structures_200_ok {
    /** ID of the corporation that owns the structure */
    corporation_id!: number;
    /** Date on which the structure will run out of fuel */
    fuel_expires?: Date | undefined;
    /** The structure name */
    name?: string | undefined;
    /** The date and time when the structure's newly requested reinforcement times (e.g. next_reinforce_hour and next_reinforce_day) will take effect */
    next_reinforce_apply?: Date | undefined;
    /** The requested change to reinforce_hour that will take effect at the time shown by next_reinforce_apply */
    next_reinforce_hour?: number | undefined;
    /** The id of the ACL profile for this citadel */
    profile_id!: number;
    /** The hour of day that determines the four hour window when the structure will randomly exit its reinforcement periods and become vulnerable to attack against its armor and/or hull. The structure will become vulnerable at a random time that is +/- 2 hours centered on the value of this property */
    reinforce_hour?: number | undefined;
    /** Contains a list of service upgrades, and their state */
    services?: Services2[] | undefined;
    /** state string */
    state!: Get_corporations_corporation_id_structures_200_okState;
    /** Date at which the structure will move to it's next state */
    state_timer_end?: Date | undefined;
    /** Date at which the structure entered it's current state */
    state_timer_start?: Date | undefined;
    /** The Item ID of the structure */
    structure_id!: number;
    /** The solar system the structure is in */
    system_id!: number;
    /** The type id of the structure */
    type_id!: number;
    /** Date at which the structure will unanchor */
    unanchors_at?: Date | undefined;

    constructor(data?: IGet_corporations_corporation_id_structures_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporation_id = _data["corporation_id"];
            this.fuel_expires = _data["fuel_expires"] ? new Date(_data["fuel_expires"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.next_reinforce_apply = _data["next_reinforce_apply"] ? new Date(_data["next_reinforce_apply"].toString()) : <any>undefined;
            this.next_reinforce_hour = _data["next_reinforce_hour"];
            this.profile_id = _data["profile_id"];
            this.reinforce_hour = _data["reinforce_hour"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(Services2.fromJS(item));
            }
            this.state = _data["state"];
            this.state_timer_end = _data["state_timer_end"] ? new Date(_data["state_timer_end"].toString()) : <any>undefined;
            this.state_timer_start = _data["state_timer_start"] ? new Date(_data["state_timer_start"].toString()) : <any>undefined;
            this.structure_id = _data["structure_id"];
            this.system_id = _data["system_id"];
            this.type_id = _data["type_id"];
            this.unanchors_at = _data["unanchors_at"] ? new Date(_data["unanchors_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_structures_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_structures_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corporation_id"] = this.corporation_id;
        data["fuel_expires"] = this.fuel_expires ? this.fuel_expires.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["next_reinforce_apply"] = this.next_reinforce_apply ? this.next_reinforce_apply.toISOString() : <any>undefined;
        data["next_reinforce_hour"] = this.next_reinforce_hour;
        data["profile_id"] = this.profile_id;
        data["reinforce_hour"] = this.reinforce_hour;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["state"] = this.state;
        data["state_timer_end"] = this.state_timer_end ? this.state_timer_end.toISOString() : <any>undefined;
        data["state_timer_start"] = this.state_timer_start ? this.state_timer_start.toISOString() : <any>undefined;
        data["structure_id"] = this.structure_id;
        data["system_id"] = this.system_id;
        data["type_id"] = this.type_id;
        data["unanchors_at"] = this.unanchors_at ? this.unanchors_at.toISOString() : <any>undefined;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_structures_200_ok {
    /** ID of the corporation that owns the structure */
    corporation_id: number;
    /** Date on which the structure will run out of fuel */
    fuel_expires?: Date | undefined;
    /** The structure name */
    name?: string | undefined;
    /** The date and time when the structure's newly requested reinforcement times (e.g. next_reinforce_hour and next_reinforce_day) will take effect */
    next_reinforce_apply?: Date | undefined;
    /** The requested change to reinforce_hour that will take effect at the time shown by next_reinforce_apply */
    next_reinforce_hour?: number | undefined;
    /** The id of the ACL profile for this citadel */
    profile_id: number;
    /** The hour of day that determines the four hour window when the structure will randomly exit its reinforcement periods and become vulnerable to attack against its armor and/or hull. The structure will become vulnerable at a random time that is +/- 2 hours centered on the value of this property */
    reinforce_hour?: number | undefined;
    /** Contains a list of service upgrades, and their state */
    services?: Services2[] | undefined;
    /** state string */
    state: Get_corporations_corporation_id_structures_200_okState;
    /** Date at which the structure will move to it's next state */
    state_timer_end?: Date | undefined;
    /** Date at which the structure entered it's current state */
    state_timer_start?: Date | undefined;
    /** The Item ID of the structure */
    structure_id: number;
    /** The solar system the structure is in */
    system_id: number;
    /** The type id of the structure */
    type_id: number;
    /** Date at which the structure will unanchor */
    unanchors_at?: Date | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_wallets_division_journal_200_ok implements IGet_corporations_corporation_id_wallets_division_journal_200_ok {
    /** The amount of ISK given or taken from the wallet as a result of the given transaction. Positive when ISK is deposited into the wallet and negative when ISK is withdrawn */
    amount?: number | undefined;
    /** Wallet balance after transaction occurred */
    balance?: number | undefined;
    /** An ID that gives extra context to the particular transaction. Because of legacy reasons the context is completely different per ref_type and means different things. It is also possible to not have a context_id */
    context_id?: number | undefined;
    /** The type of the given context_id if present */
    context_id_type?: Get_corporations_corporation_id_wallets_division_journal_200_okContext_id_type | undefined;
    /** Date and time of transaction */
    date!: Date;
    /** The reason for the transaction, mirrors what is seen in the client */
    description!: string;
    /** The id of the first party involved in the transaction. This attribute has no consistency and is different or non existant for particular ref_types. The description attribute will help make sense of what this attribute means. For more info about the given ID it can be dropped into the /universe/names/ ESI route to determine its type and name */
    first_party_id?: number | undefined;
    /** Unique journal reference ID */
    id!: number;
    /** The user stated reason for the transaction. Only applies to some ref_types */
    reason?: string | undefined;
    /** "The transaction type for the given. transaction. Different transaction types will populate different attributes. Note: If you have an existing XML API application that is using ref_types, you will need to know which string ESI ref_type maps to which integer. You can look at the following file to see string->int mappings: https://github.com/ccpgames/eve-glue/blob/master/eve_glue/wallet_journal_ref.py" */
    ref_type!: Get_corporations_corporation_id_wallets_division_journal_200_okRef_type;
    /** The id of the second party involved in the transaction. This attribute has no consistency and is different or non existant for particular ref_types. The description attribute will help make sense of what this attribute means. For more info about the given ID it can be dropped into the /universe/names/ ESI route to determine its type and name */
    second_party_id?: number | undefined;
    /** Tax amount received. Only applies to tax related transactions */
    tax?: number | undefined;
    /** The corporation ID receiving any tax paid. Only applies to tax related transactions */
    tax_receiver_id?: number | undefined;

    constructor(data?: IGet_corporations_corporation_id_wallets_division_journal_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.balance = _data["balance"];
            this.context_id = _data["context_id"];
            this.context_id_type = _data["context_id_type"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.first_party_id = _data["first_party_id"];
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.ref_type = _data["ref_type"];
            this.second_party_id = _data["second_party_id"];
            this.tax = _data["tax"];
            this.tax_receiver_id = _data["tax_receiver_id"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_wallets_division_journal_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_wallets_division_journal_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["balance"] = this.balance;
        data["context_id"] = this.context_id;
        data["context_id_type"] = this.context_id_type;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["first_party_id"] = this.first_party_id;
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["ref_type"] = this.ref_type;
        data["second_party_id"] = this.second_party_id;
        data["tax"] = this.tax;
        data["tax_receiver_id"] = this.tax_receiver_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_wallets_division_journal_200_ok {
    /** The amount of ISK given or taken from the wallet as a result of the given transaction. Positive when ISK is deposited into the wallet and negative when ISK is withdrawn */
    amount?: number | undefined;
    /** Wallet balance after transaction occurred */
    balance?: number | undefined;
    /** An ID that gives extra context to the particular transaction. Because of legacy reasons the context is completely different per ref_type and means different things. It is also possible to not have a context_id */
    context_id?: number | undefined;
    /** The type of the given context_id if present */
    context_id_type?: Get_corporations_corporation_id_wallets_division_journal_200_okContext_id_type | undefined;
    /** Date and time of transaction */
    date: Date;
    /** The reason for the transaction, mirrors what is seen in the client */
    description: string;
    /** The id of the first party involved in the transaction. This attribute has no consistency and is different or non existant for particular ref_types. The description attribute will help make sense of what this attribute means. For more info about the given ID it can be dropped into the /universe/names/ ESI route to determine its type and name */
    first_party_id?: number | undefined;
    /** Unique journal reference ID */
    id: number;
    /** The user stated reason for the transaction. Only applies to some ref_types */
    reason?: string | undefined;
    /** "The transaction type for the given. transaction. Different transaction types will populate different attributes. Note: If you have an existing XML API application that is using ref_types, you will need to know which string ESI ref_type maps to which integer. You can look at the following file to see string->int mappings: https://github.com/ccpgames/eve-glue/blob/master/eve_glue/wallet_journal_ref.py" */
    ref_type: Get_corporations_corporation_id_wallets_division_journal_200_okRef_type;
    /** The id of the second party involved in the transaction. This attribute has no consistency and is different or non existant for particular ref_types. The description attribute will help make sense of what this attribute means. For more info about the given ID it can be dropped into the /universe/names/ ESI route to determine its type and name */
    second_party_id?: number | undefined;
    /** Tax amount received. Only applies to tax related transactions */
    tax?: number | undefined;
    /** The corporation ID receiving any tax paid. Only applies to tax related transactions */
    tax_receiver_id?: number | undefined;
}

/** 200 ok object */
export class Get_universe_systems_system_id_ok implements IGet_universe_systems_system_id_ok {
    /** The constellation this solar system is in */
    constellation_id!: number;
    /** name string */
    name!: string;
    /** planets array */
    planets?: Planets[] | undefined;
    /** position object */
    position!: Position10;
    /** security_class string */
    security_class?: string | undefined;
    /** security_status number */
    security_status!: number;
    /** star_id integer */
    star_id?: number | undefined;
    /** stargates array */
    stargates?: number[] | undefined;
    /** stations array */
    stations?: number[] | undefined;
    /** system_id integer */
    system_id!: number;

    constructor(data?: IGet_universe_systems_system_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.position = new Position10();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constellation_id = _data["constellation_id"];
            this.name = _data["name"];
            if (Array.isArray(_data["planets"])) {
                this.planets = [] as any;
                for (let item of _data["planets"])
                    this.planets!.push(Planets.fromJS(item));
            }
            this.position = _data["position"] ? Position10.fromJS(_data["position"]) : new Position10();
            this.security_class = _data["security_class"];
            this.security_status = _data["security_status"];
            this.star_id = _data["star_id"];
            if (Array.isArray(_data["stargates"])) {
                this.stargates = [] as any;
                for (let item of _data["stargates"])
                    this.stargates!.push(item);
            }
            if (Array.isArray(_data["stations"])) {
                this.stations = [] as any;
                for (let item of _data["stations"])
                    this.stations!.push(item);
            }
            this.system_id = _data["system_id"];
        }
    }

    static fromJS(data: any): Get_universe_systems_system_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_systems_system_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constellation_id"] = this.constellation_id;
        data["name"] = this.name;
        if (Array.isArray(this.planets)) {
            data["planets"] = [];
            for (let item of this.planets)
                data["planets"].push(item.toJSON());
        }
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["security_class"] = this.security_class;
        data["security_status"] = this.security_status;
        data["star_id"] = this.star_id;
        if (Array.isArray(this.stargates)) {
            data["stargates"] = [];
            for (let item of this.stargates)
                data["stargates"].push(item);
        }
        if (Array.isArray(this.stations)) {
            data["stations"] = [];
            for (let item of this.stations)
                data["stations"].push(item);
        }
        data["system_id"] = this.system_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_universe_systems_system_id_ok {
    /** The constellation this solar system is in */
    constellation_id: number;
    /** name string */
    name: string;
    /** planets array */
    planets?: Planets[] | undefined;
    /** position object */
    position: Position10;
    /** security_class string */
    security_class?: string | undefined;
    /** security_status number */
    security_status: number;
    /** star_id integer */
    star_id?: number | undefined;
    /** stargates array */
    stargates?: number[] | undefined;
    /** stations array */
    stations?: number[] | undefined;
    /** system_id integer */
    system_id: number;
}

/** Not found */
export class Get_universe_systems_system_id_not_found implements IGet_universe_systems_system_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_universe_systems_system_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_universe_systems_system_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_universe_systems_system_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_universe_systems_system_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_ok implements IGet_characters_character_id_ok {
    /** The character's alliance ID */
    alliance_id?: number | undefined;
    /** Creation date of the character */
    birthday!: Date;
    /** bloodline_id integer */
    bloodline_id!: number;
    /** The character's corporation ID */
    corporation_id!: number;
    /** description string */
    description?: string | undefined;
    /** ID of the faction the character is fighting for, if the character is enlisted in Factional Warfare */
    faction_id?: number | undefined;
    /** gender string */
    gender!: Get_characters_character_id_okGender;
    /** name string */
    name!: string;
    /** race_id integer */
    race_id!: number;
    /** security_status number */
    security_status?: number | undefined;
    /** The individual title of the character */
    title?: string | undefined;

    constructor(data?: IGet_characters_character_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.birthday = _data["birthday"] ? new Date(_data["birthday"].toString()) : <any>undefined;
            this.bloodline_id = _data["bloodline_id"];
            this.corporation_id = _data["corporation_id"];
            this.description = _data["description"];
            this.faction_id = _data["faction_id"];
            this.gender = _data["gender"];
            this.name = _data["name"];
            this.race_id = _data["race_id"];
            this.security_status = _data["security_status"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["bloodline_id"] = this.bloodline_id;
        data["corporation_id"] = this.corporation_id;
        data["description"] = this.description;
        data["faction_id"] = this.faction_id;
        data["gender"] = this.gender;
        data["name"] = this.name;
        data["race_id"] = this.race_id;
        data["security_status"] = this.security_status;
        data["title"] = this.title;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_ok {
    /** The character's alliance ID */
    alliance_id?: number | undefined;
    /** Creation date of the character */
    birthday: Date;
    /** bloodline_id integer */
    bloodline_id: number;
    /** The character's corporation ID */
    corporation_id: number;
    /** description string */
    description?: string | undefined;
    /** ID of the faction the character is fighting for, if the character is enlisted in Factional Warfare */
    faction_id?: number | undefined;
    /** gender string */
    gender: Get_characters_character_id_okGender;
    /** name string */
    name: string;
    /** race_id integer */
    race_id: number;
    /** security_status number */
    security_status?: number | undefined;
    /** The individual title of the character */
    title?: string | undefined;
}

/** Not found */
export class Get_characters_character_id_not_found implements IGet_characters_character_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_characters_character_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_characters_character_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_assets_200_ok implements IGet_characters_character_id_assets_200_ok {
    /** is_blueprint_copy boolean */
    is_blueprint_copy?: boolean | undefined;
    /** is_singleton boolean */
    is_singleton!: boolean;
    /** item_id integer */
    item_id!: number;
    /** location_flag string */
    location_flag!: Get_characters_character_id_assets_200_okLocation_flag;
    /** location_id integer */
    location_id!: number;
    /** location_type string */
    location_type!: Get_characters_character_id_assets_200_okLocation_type;
    /** quantity integer */
    quantity!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_characters_character_id_assets_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.is_blueprint_copy = _data["is_blueprint_copy"];
            this.is_singleton = _data["is_singleton"];
            this.item_id = _data["item_id"];
            this.location_flag = _data["location_flag"];
            this.location_id = _data["location_id"];
            this.location_type = _data["location_type"];
            this.quantity = _data["quantity"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_assets_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_assets_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["is_blueprint_copy"] = this.is_blueprint_copy;
        data["is_singleton"] = this.is_singleton;
        data["item_id"] = this.item_id;
        data["location_flag"] = this.location_flag;
        data["location_id"] = this.location_id;
        data["location_type"] = this.location_type;
        data["quantity"] = this.quantity;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_assets_200_ok {
    /** is_blueprint_copy boolean */
    is_blueprint_copy?: boolean | undefined;
    /** is_singleton boolean */
    is_singleton: boolean;
    /** item_id integer */
    item_id: number;
    /** location_flag string */
    location_flag: Get_characters_character_id_assets_200_okLocation_flag;
    /** location_id integer */
    location_id: number;
    /** location_type string */
    location_type: Get_characters_character_id_assets_200_okLocation_type;
    /** quantity integer */
    quantity: number;
    /** type_id integer */
    type_id: number;
}

/** Requested page does not exist */
export class Get_characters_character_id_assets_not_found implements IGet_characters_character_id_assets_not_found {
    /** error message */
    error?: string | undefined;

    constructor(data?: IGet_characters_character_id_assets_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_assets_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_assets_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Requested page does not exist */
export interface IGet_characters_character_id_assets_not_found {
    /** error message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_characters_character_id_notifications_200_ok implements IGet_characters_character_id_notifications_200_ok {
    /** is_read boolean */
    is_read?: boolean | undefined;
    /** notification_id integer */
    notification_id!: number;
    /** sender_id integer */
    sender_id!: number;
    /** sender_type string */
    sender_type!: Get_characters_character_id_notifications_200_okSender_type;
    /** text string */
    text?: string | undefined;
    /** timestamp string */
    timestamp!: Date;
    /** type string */
    type!: Get_characters_character_id_notifications_200_okType;

    constructor(data?: IGet_characters_character_id_notifications_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.is_read = _data["is_read"];
            this.notification_id = _data["notification_id"];
            this.sender_id = _data["sender_id"];
            this.sender_type = _data["sender_type"];
            this.text = _data["text"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_notifications_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_notifications_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["is_read"] = this.is_read;
        data["notification_id"] = this.notification_id;
        data["sender_id"] = this.sender_id;
        data["sender_type"] = this.sender_type;
        data["text"] = this.text;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["type"] = this.type;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_notifications_200_ok {
    /** is_read boolean */
    is_read?: boolean | undefined;
    /** notification_id integer */
    notification_id: number;
    /** sender_id integer */
    sender_id: number;
    /** sender_type string */
    sender_type: Get_characters_character_id_notifications_200_okSender_type;
    /** text string */
    text?: string | undefined;
    /** timestamp string */
    timestamp: Date;
    /** type string */
    type: Get_characters_character_id_notifications_200_okType;
}

/** 200 ok object */
export class Get_corporations_corporation_id_ok implements IGet_corporations_corporation_id_ok {
    /** ID of the alliance that corporation is a member of, if any */
    alliance_id?: number | undefined;
    /** ceo_id integer */
    ceo_id!: number;
    /** creator_id integer */
    creator_id!: number;
    /** date_founded string */
    date_founded?: Date | undefined;
    /** description string */
    description?: string | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;
    /** home_station_id integer */
    home_station_id?: number | undefined;
    /** member_count integer */
    member_count!: number;
    /** the full name of the corporation */
    name!: string;
    /** shares integer */
    shares?: number | undefined;
    /** tax_rate number */
    tax_rate!: number;
    /** the short name of the corporation */
    ticker!: string;
    /** url string */
    url?: string | undefined;
    /** war_eligible boolean */
    war_eligible?: boolean | undefined;

    constructor(data?: IGet_corporations_corporation_id_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.ceo_id = _data["ceo_id"];
            this.creator_id = _data["creator_id"];
            this.date_founded = _data["date_founded"] ? new Date(_data["date_founded"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.faction_id = _data["faction_id"];
            this.home_station_id = _data["home_station_id"];
            this.member_count = _data["member_count"];
            this.name = _data["name"];
            this.shares = _data["shares"];
            this.tax_rate = _data["tax_rate"];
            this.ticker = _data["ticker"];
            this.url = _data["url"];
            this.war_eligible = _data["war_eligible"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["ceo_id"] = this.ceo_id;
        data["creator_id"] = this.creator_id;
        data["date_founded"] = this.date_founded ? this.date_founded.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["faction_id"] = this.faction_id;
        data["home_station_id"] = this.home_station_id;
        data["member_count"] = this.member_count;
        data["name"] = this.name;
        data["shares"] = this.shares;
        data["tax_rate"] = this.tax_rate;
        data["ticker"] = this.ticker;
        data["url"] = this.url;
        data["war_eligible"] = this.war_eligible;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_ok {
    /** ID of the alliance that corporation is a member of, if any */
    alliance_id?: number | undefined;
    /** ceo_id integer */
    ceo_id: number;
    /** creator_id integer */
    creator_id: number;
    /** date_founded string */
    date_founded?: Date | undefined;
    /** description string */
    description?: string | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;
    /** home_station_id integer */
    home_station_id?: number | undefined;
    /** member_count integer */
    member_count: number;
    /** the full name of the corporation */
    name: string;
    /** shares integer */
    shares?: number | undefined;
    /** tax_rate number */
    tax_rate: number;
    /** the short name of the corporation */
    ticker: string;
    /** url string */
    url?: string | undefined;
    /** war_eligible boolean */
    war_eligible?: boolean | undefined;
}

/** Not found */
export class Get_corporations_corporation_id_not_found implements IGet_corporations_corporation_id_not_found {
    /** Not found message */
    error?: string | undefined;

    constructor(data?: IGet_corporations_corporation_id_not_found) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_not_found {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_not_found();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

/** Not found */
export interface IGet_corporations_corporation_id_not_found {
    /** Not found message */
    error?: string | undefined;
}

/** 200 ok object */
export class Get_corporations_corporation_id_assets_200_ok implements IGet_corporations_corporation_id_assets_200_ok {
    /** is_blueprint_copy boolean */
    is_blueprint_copy?: boolean | undefined;
    /** is_singleton boolean */
    is_singleton!: boolean;
    /** item_id integer */
    item_id!: number;
    /** location_flag string */
    location_flag!: Get_corporations_corporation_id_assets_200_okLocation_flag;
    /** location_id integer */
    location_id!: number;
    /** location_type string */
    location_type!: Get_corporations_corporation_id_assets_200_okLocation_type;
    /** quantity integer */
    quantity!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IGet_corporations_corporation_id_assets_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.is_blueprint_copy = _data["is_blueprint_copy"];
            this.is_singleton = _data["is_singleton"];
            this.item_id = _data["item_id"];
            this.location_flag = _data["location_flag"];
            this.location_id = _data["location_id"];
            this.location_type = _data["location_type"];
            this.quantity = _data["quantity"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Get_corporations_corporation_id_assets_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_corporations_corporation_id_assets_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["is_blueprint_copy"] = this.is_blueprint_copy;
        data["is_singleton"] = this.is_singleton;
        data["item_id"] = this.item_id;
        data["location_flag"] = this.location_flag;
        data["location_id"] = this.location_id;
        data["location_type"] = this.location_type;
        data["quantity"] = this.quantity;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_corporations_corporation_id_assets_200_ok {
    /** is_blueprint_copy boolean */
    is_blueprint_copy?: boolean | undefined;
    /** is_singleton boolean */
    is_singleton: boolean;
    /** item_id integer */
    item_id: number;
    /** location_flag string */
    location_flag: Get_corporations_corporation_id_assets_200_okLocation_flag;
    /** location_id integer */
    location_id: number;
    /** location_type string */
    location_type: Get_corporations_corporation_id_assets_200_okLocation_type;
    /** quantity integer */
    quantity: number;
    /** type_id integer */
    type_id: number;
}

/** 200 ok object */
export class Get_characters_character_id_wallet_journal_200_ok implements IGet_characters_character_id_wallet_journal_200_ok {
    /** The amount of ISK given or taken from the wallet as a result of the given transaction. Positive when ISK is deposited into the wallet and negative when ISK is withdrawn */
    amount?: number | undefined;
    /** Wallet balance after transaction occurred */
    balance?: number | undefined;
    /** An ID that gives extra context to the particular transaction. Because of legacy reasons the context is completely different per ref_type and means different things. It is also possible to not have a context_id */
    context_id?: number | undefined;
    /** The type of the given context_id if present */
    context_id_type?: Get_characters_character_id_wallet_journal_200_okContext_id_type | undefined;
    /** Date and time of transaction */
    date!: Date;
    /** The reason for the transaction, mirrors what is seen in the client */
    description!: string;
    /** The id of the first party involved in the transaction. This attribute has no consistency and is different or non existant for particular ref_types. The description attribute will help make sense of what this attribute means. For more info about the given ID it can be dropped into the /universe/names/ ESI route to determine its type and name */
    first_party_id?: number | undefined;
    /** Unique journal reference ID */
    id!: number;
    /** The user stated reason for the transaction. Only applies to some ref_types */
    reason?: string | undefined;
    /** "The transaction type for the given. transaction. Different transaction types will populate different attributes." */
    ref_type!: Get_characters_character_id_wallet_journal_200_okRef_type;
    /** The id of the second party involved in the transaction. This attribute has no consistency and is different or non existant for particular ref_types. The description attribute will help make sense of what this attribute means. For more info about the given ID it can be dropped into the /universe/names/ ESI route to determine its type and name */
    second_party_id?: number | undefined;
    /** Tax amount received. Only applies to tax related transactions */
    tax?: number | undefined;
    /** The corporation ID receiving any tax paid. Only applies to tax related transactions */
    tax_receiver_id?: number | undefined;

    constructor(data?: IGet_characters_character_id_wallet_journal_200_ok) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.balance = _data["balance"];
            this.context_id = _data["context_id"];
            this.context_id_type = _data["context_id_type"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.first_party_id = _data["first_party_id"];
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.ref_type = _data["ref_type"];
            this.second_party_id = _data["second_party_id"];
            this.tax = _data["tax"];
            this.tax_receiver_id = _data["tax_receiver_id"];
        }
    }

    static fromJS(data: any): Get_characters_character_id_wallet_journal_200_ok {
        data = typeof data === 'object' ? data : {};
        let result = new Get_characters_character_id_wallet_journal_200_ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["balance"] = this.balance;
        data["context_id"] = this.context_id;
        data["context_id_type"] = this.context_id_type;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["first_party_id"] = this.first_party_id;
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["ref_type"] = this.ref_type;
        data["second_party_id"] = this.second_party_id;
        data["tax"] = this.tax;
        data["tax_receiver_id"] = this.tax_receiver_id;
        return data;
    }
}

/** 200 ok object */
export interface IGet_characters_character_id_wallet_journal_200_ok {
    /** The amount of ISK given or taken from the wallet as a result of the given transaction. Positive when ISK is deposited into the wallet and negative when ISK is withdrawn */
    amount?: number | undefined;
    /** Wallet balance after transaction occurred */
    balance?: number | undefined;
    /** An ID that gives extra context to the particular transaction. Because of legacy reasons the context is completely different per ref_type and means different things. It is also possible to not have a context_id */
    context_id?: number | undefined;
    /** The type of the given context_id if present */
    context_id_type?: Get_characters_character_id_wallet_journal_200_okContext_id_type | undefined;
    /** Date and time of transaction */
    date: Date;
    /** The reason for the transaction, mirrors what is seen in the client */
    description: string;
    /** The id of the first party involved in the transaction. This attribute has no consistency and is different or non existant for particular ref_types. The description attribute will help make sense of what this attribute means. For more info about the given ID it can be dropped into the /universe/names/ ESI route to determine its type and name */
    first_party_id?: number | undefined;
    /** Unique journal reference ID */
    id: number;
    /** The user stated reason for the transaction. Only applies to some ref_types */
    reason?: string | undefined;
    /** "The transaction type for the given. transaction. Different transaction types will populate different attributes." */
    ref_type: Get_characters_character_id_wallet_journal_200_okRef_type;
    /** The id of the second party involved in the transaction. This attribute has no consistency and is different or non existant for particular ref_types. The description attribute will help make sense of what this attribute means. For more info about the given ID it can be dropped into the /universe/names/ ESI route to determine its type and name */
    second_party_id?: number | undefined;
    /** Tax amount received. Only applies to tax related transactions */
    tax?: number | undefined;
    /** The corporation ID receiving any tax paid. Only applies to tax related transactions */
    tax_receiver_id?: number | undefined;
}

/** recipient object */
export class Recipients implements IRecipients {
    /** recipient_id integer */
    recipient_id!: number;
    /** recipient_type string */
    recipient_type!: RecipientsRecipient_type;

    constructor(data?: IRecipients) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipient_id = _data["recipient_id"];
            this.recipient_type = _data["recipient_type"];
        }
    }

    static fromJS(data: any): Recipients {
        data = typeof data === 'object' ? data : {};
        let result = new Recipients();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient_id"] = this.recipient_id;
        data["recipient_type"] = this.recipient_type;
        return data;
    }
}

/** recipient object */
export interface IRecipients {
    /** recipient_id integer */
    recipient_id: number;
    /** recipient_type string */
    recipient_type: RecipientsRecipient_type;
}

export enum Post_fleets_fleet_id_members_invitationRole {
    Fleet_commander = "fleet_commander",
    Wing_commander = "wing_commander",
    Squad_commander = "squad_commander",
    Squad_member = "squad_member",
}

export enum Put_fleets_fleet_id_members_member_id_movementRole {
    Fleet_commander = "fleet_commander",
    Wing_commander = "wing_commander",
    Squad_commander = "squad_commander",
    Squad_member = "squad_member",
}

/** item object */
export class Items implements IItems {
    /** Fitting location for the item. Entries placed in 'Invalid' will be discarded. If this leaves the fitting with nothing, it will cause an error. */
    flag!: ItemsFlag;
    /** quantity integer */
    quantity!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flag = _data["flag"];
            this.quantity = _data["quantity"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Items {
        data = typeof data === 'object' ? data : {};
        let result = new Items();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flag"] = this.flag;
        data["quantity"] = this.quantity;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** item object */
export interface IItems {
    /** Fitting location for the item. Entries placed in 'Invalid' will be discarded. If this leaves the fitting with nothing, it will cause an error. */
    flag: ItemsFlag;
    /** quantity integer */
    quantity: number;
    /** type_id integer */
    type_id: number;
}

export enum Post_characters_character_id_mail_labels_labelColor {
    _0000fe = "#0000fe",
    _006634 = "#006634",
    _0099ff = "#0099ff",
    _00ff33 = "#00ff33",
    _01ffff = "#01ffff",
    _349800 = "#349800",
    _660066 = "#660066",
    _666666 = "#666666",
    _999999 = "#999999",
    _99ffff = "#99ffff",
    _9a0000 = "#9a0000",
    _ccff9a = "#ccff9a",
    _e6e6e6 = "#e6e6e6",
    _fe0000 = "#fe0000",
    _ff6600 = "#ff6600",
    _ffff01 = "#ffff01",
    _ffffcd = "#ffffcd",
    _ffffff = "#ffffff",
}

export enum Put_characters_character_id_calendar_event_id_responseResponse {
    Accepted = "accepted",
    Declined = "declined",
    Tentative = "tentative",
}

export enum Get_characters_character_id_calendar_200_okEvent_response {
    Declined = "declined",
    Not_responded = "not_responded",
    Accepted = "accepted",
    Tentative = "tentative",
}

export enum Get_characters_character_id_calendar_event_id_attendees_200_okEvent_response {
    Declined = "declined",
    Not_responded = "not_responded",
    Accepted = "accepted",
    Tentative = "tentative",
}

export enum Get_characters_character_id_contracts_200_okAvailability {
    Public = "public",
    Personal = "personal",
    Corporation = "corporation",
    Alliance = "alliance",
}

export enum Get_characters_character_id_contracts_200_okStatus {
    Outstanding = "outstanding",
    In_progress = "in_progress",
    Finished_issuer = "finished_issuer",
    Finished_contractor = "finished_contractor",
    Finished = "finished",
    Cancelled = "cancelled",
    Rejected = "rejected",
    Failed = "failed",
    Deleted = "deleted",
    Reversed = "reversed",
}

export enum Get_characters_character_id_contracts_200_okType {
    Unknown = "unknown",
    Item_exchange = "item_exchange",
    Auction = "auction",
    Courier = "courier",
    Loan = "loan",
}

export enum Get_characters_character_id_fleet_okRole {
    Fleet_commander = "fleet_commander",
    Squad_commander = "squad_commander",
    Squad_member = "squad_member",
    Wing_commander = "wing_commander",
}

export class Kills implements IKills {
    /** Last week's total number of kills by a given character against enemy factions */
    last_week!: number;
    /** Total number of kills by a given character against enemy factions since the character enlisted */
    total!: number;
    /** Yesterday's total number of kills by a given character against enemy factions */
    yesterday!: number;

    constructor(data?: IKills) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last_week = _data["last_week"];
            this.total = _data["total"];
            this.yesterday = _data["yesterday"];
        }
    }

    static fromJS(data: any): Kills {
        data = typeof data === 'object' ? data : {};
        let result = new Kills();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last_week"] = this.last_week;
        data["total"] = this.total;
        data["yesterday"] = this.yesterday;
        return data;
    }
}

export interface IKills {
    /** Last week's total number of kills by a given character against enemy factions */
    last_week: number;
    /** Total number of kills by a given character against enemy factions since the character enlisted */
    total: number;
    /** Yesterday's total number of kills by a given character against enemy factions */
    yesterday: number;
}

export class Victory_points implements IVictory_points {
    /** Last week's victory points gained by the given character */
    last_week!: number;
    /** Total victory points gained since the given character enlisted */
    total!: number;
    /** Yesterday's victory points gained by the given character */
    yesterday!: number;

    constructor(data?: IVictory_points) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last_week = _data["last_week"];
            this.total = _data["total"];
            this.yesterday = _data["yesterday"];
        }
    }

    static fromJS(data: any): Victory_points {
        data = typeof data === 'object' ? data : {};
        let result = new Victory_points();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last_week"] = this.last_week;
        data["total"] = this.total;
        data["yesterday"] = this.yesterday;
        return data;
    }
}

export interface IVictory_points {
    /** Last week's victory points gained by the given character */
    last_week: number;
    /** Total victory points gained since the given character enlisted */
    total: number;
    /** Yesterday's victory points gained by the given character */
    yesterday: number;
}

export enum Get_characters_character_id_industry_jobs_200_okStatus {
    Active = "active",
    Cancelled = "cancelled",
    Delivered = "delivered",
    Paused = "paused",
    Ready = "ready",
    Reverted = "reverted",
}

/** recipient object */
export class Recipients2 implements IRecipients2 {
    /** recipient_id integer */
    recipient_id!: number;
    /** recipient_type string */
    recipient_type!: Recipients2Recipient_type;

    constructor(data?: IRecipients2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipient_id = _data["recipient_id"];
            this.recipient_type = _data["recipient_type"];
        }
    }

    static fromJS(data: any): Recipients2 {
        data = typeof data === 'object' ? data : {};
        let result = new Recipients2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient_id"] = this.recipient_id;
        data["recipient_type"] = this.recipient_type;
        return data;
    }
}

/** recipient object */
export interface IRecipients2 {
    /** recipient_id integer */
    recipient_id: number;
    /** recipient_type string */
    recipient_type: Recipients2Recipient_type;
}

/** recipient object */
export class Recipients3 implements IRecipients3 {
    /** recipient_id integer */
    recipient_id!: number;
    /** recipient_type string */
    recipient_type!: Recipients3Recipient_type;

    constructor(data?: IRecipients3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipient_id = _data["recipient_id"];
            this.recipient_type = _data["recipient_type"];
        }
    }

    static fromJS(data: any): Recipients3 {
        data = typeof data === 'object' ? data : {};
        let result = new Recipients3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient_id"] = this.recipient_id;
        data["recipient_type"] = this.recipient_type;
        return data;
    }
}

/** recipient object */
export interface IRecipients3 {
    /** recipient_id integer */
    recipient_id: number;
    /** recipient_type string */
    recipient_type: Recipients3Recipient_type;
}

export enum Get_characters_character_id_orders_history_200_okRange {
    _1 = "1",
    _10 = "10",
    _2 = "2",
    _20 = "20",
    _3 = "3",
    _30 = "30",
    _4 = "4",
    _40 = "40",
    _5 = "5",
    Region = "region",
    Solarsystem = "solarsystem",
    Station = "station",
}

export enum Get_characters_character_id_orders_history_200_okState {
    Cancelled = "cancelled",
    Expired = "expired",
}

export enum Get_characters_character_id_planets_200_okPlanet_type {
    Temperate = "temperate",
    Barren = "barren",
    Oceanic = "oceanic",
    Ice = "ice",
    Gas = "gas",
    Lava = "lava",
    Storm = "storm",
    Plasma = "plasma",
}

export enum Get_contracts_public_region_id_200_okType {
    Unknown = "unknown",
    Item_exchange = "item_exchange",
    Auction = "auction",
    Courier = "courier",
    Loan = "loan",
}

export enum Get_corporation_corporation_id_mining_observers_200_okObserver_type {
    Structure = "structure",
}

export class Coordinates implements ICoordinates {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: ICoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Coordinates {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface ICoordinates {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

export class Item implements IItem {
    /** item_id integer */
    item_id!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item_id = _data["item_id"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item_id"] = this.item_id;
        data["type_id"] = this.type_id;
        return data;
    }
}

export interface IItem {
    /** item_id integer */
    item_id: number;
    /** type_id integer */
    type_id: number;
}

export enum Get_corporations_corporation_id_contracts_200_okAvailability {
    Public = "public",
    Personal = "personal",
    Corporation = "corporation",
    Alliance = "alliance",
}

export enum Get_corporations_corporation_id_contracts_200_okStatus {
    Outstanding = "outstanding",
    In_progress = "in_progress",
    Finished_issuer = "finished_issuer",
    Finished_contractor = "finished_contractor",
    Finished = "finished",
    Cancelled = "cancelled",
    Rejected = "rejected",
    Failed = "failed",
    Deleted = "deleted",
    Reversed = "reversed",
}

export enum Get_corporations_corporation_id_contracts_200_okType {
    Unknown = "unknown",
    Item_exchange = "item_exchange",
    Auction = "auction",
    Courier = "courier",
    Loan = "loan",
}

export enum Get_corporations_corporation_id_customs_offices_200_okStanding_level {
    Bad = "bad",
    Excellent = "excellent",
    Good = "good",
    Neutral = "neutral",
    Terrible = "terrible",
}

export class Kills2 implements IKills2 {
    /** Last week's total number of kills by members of the given corporation against enemy factions */
    last_week!: number;
    /** Total number of kills by members of the given corporation against enemy factions since the corporation enlisted */
    total!: number;
    /** Yesterday's total number of kills by members of the given corporation against enemy factions */
    yesterday!: number;

    constructor(data?: IKills2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last_week = _data["last_week"];
            this.total = _data["total"];
            this.yesterday = _data["yesterday"];
        }
    }

    static fromJS(data: any): Kills2 {
        data = typeof data === 'object' ? data : {};
        let result = new Kills2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last_week"] = this.last_week;
        data["total"] = this.total;
        data["yesterday"] = this.yesterday;
        return data;
    }
}

export interface IKills2 {
    /** Last week's total number of kills by members of the given corporation against enemy factions */
    last_week: number;
    /** Total number of kills by members of the given corporation against enemy factions since the corporation enlisted */
    total: number;
    /** Yesterday's total number of kills by members of the given corporation against enemy factions */
    yesterday: number;
}

export class Victory_points2 implements IVictory_points2 {
    /** Last week's victory points gained by members of the given corporation */
    last_week!: number;
    /** Total victory points gained since the given corporation enlisted */
    total!: number;
    /** Yesterday's victory points gained by members of the given corporation */
    yesterday!: number;

    constructor(data?: IVictory_points2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last_week = _data["last_week"];
            this.total = _data["total"];
            this.yesterday = _data["yesterday"];
        }
    }

    static fromJS(data: any): Victory_points2 {
        data = typeof data === 'object' ? data : {};
        let result = new Victory_points2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last_week"] = this.last_week;
        data["total"] = this.total;
        data["yesterday"] = this.yesterday;
        return data;
    }
}

export interface IVictory_points2 {
    /** Last week's victory points gained by members of the given corporation */
    last_week: number;
    /** Total victory points gained since the given corporation enlisted */
    total: number;
    /** Yesterday's victory points gained by members of the given corporation */
    yesterday: number;
}

export enum Get_corporations_corporation_id_industry_jobs_200_okStatus {
    Active = "active",
    Cancelled = "cancelled",
    Delivered = "delivered",
    Paused = "paused",
    Ready = "ready",
    Reverted = "reverted",
}

export enum Get_corporations_corporation_id_shareholders_200_okShareholder_type {
    Character = "character",
    Corporation = "corporation",
}

/** dogma_attribute object */
export class Dogma_attributes implements IDogma_attributes {
    /** attribute_id integer */
    attribute_id!: number;
    /** value number */
    value!: number;

    constructor(data?: IDogma_attributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attribute_id = _data["attribute_id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Dogma_attributes {
        data = typeof data === 'object' ? data : {};
        let result = new Dogma_attributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute_id"] = this.attribute_id;
        data["value"] = this.value;
        return data;
    }
}

/** dogma_attribute object */
export interface IDogma_attributes {
    /** attribute_id integer */
    attribute_id: number;
    /** value number */
    value: number;
}

/** dogma_effect object */
export class Dogma_effects implements IDogma_effects {
    /** effect_id integer */
    effect_id!: number;
    /** is_default boolean */
    is_default!: boolean;

    constructor(data?: IDogma_effects) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.effect_id = _data["effect_id"];
            this.is_default = _data["is_default"];
        }
    }

    static fromJS(data: any): Dogma_effects {
        data = typeof data === 'object' ? data : {};
        let result = new Dogma_effects();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["effect_id"] = this.effect_id;
        data["is_default"] = this.is_default;
        return data;
    }
}

/** dogma_effect object */
export interface IDogma_effects {
    /** effect_id integer */
    effect_id: number;
    /** is_default boolean */
    is_default: boolean;
}

export enum Get_fleets_fleet_id_members_200_okRole {
    Fleet_commander = "fleet_commander",
    Wing_commander = "wing_commander",
    Squad_commander = "squad_commander",
    Squad_member = "squad_member",
}

/** squad object */
export class Squads implements ISquads {
    /** id integer */
    id!: number;
    /** name string */
    name!: string;

    constructor(data?: ISquads) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Squads {
        data = typeof data === 'object' ? data : {};
        let result = new Squads();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** squad object */
export interface ISquads {
    /** id integer */
    id: number;
    /** name string */
    name: string;
}

export class Kills3 implements IKills3 {
    /** Top 4 ranking of factions active in faction warfare by total kills. A faction is considered "active" if they have participated in faction warfare in the past 14 days */
    active_total!: Active_total[];
    /** Top 4 ranking of factions by kills in the past week */
    last_week!: Last_week[];
    /** Top 4 ranking of factions by kills in the past day */
    yesterday!: Yesterday[];

    constructor(data?: IKills3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.active_total = [];
            this.last_week = [];
            this.yesterday = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["active_total"])) {
                this.active_total = [] as any;
                for (let item of _data["active_total"])
                    this.active_total!.push(Active_total.fromJS(item));
            }
            if (Array.isArray(_data["last_week"])) {
                this.last_week = [] as any;
                for (let item of _data["last_week"])
                    this.last_week!.push(Last_week.fromJS(item));
            }
            if (Array.isArray(_data["yesterday"])) {
                this.yesterday = [] as any;
                for (let item of _data["yesterday"])
                    this.yesterday!.push(Yesterday.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Kills3 {
        data = typeof data === 'object' ? data : {};
        let result = new Kills3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.active_total)) {
            data["active_total"] = [];
            for (let item of this.active_total)
                data["active_total"].push(item.toJSON());
        }
        if (Array.isArray(this.last_week)) {
            data["last_week"] = [];
            for (let item of this.last_week)
                data["last_week"].push(item.toJSON());
        }
        if (Array.isArray(this.yesterday)) {
            data["yesterday"] = [];
            for (let item of this.yesterday)
                data["yesterday"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKills3 {
    /** Top 4 ranking of factions active in faction warfare by total kills. A faction is considered "active" if they have participated in faction warfare in the past 14 days */
    active_total: Active_total[];
    /** Top 4 ranking of factions by kills in the past week */
    last_week: Last_week[];
    /** Top 4 ranking of factions by kills in the past day */
    yesterday: Yesterday[];
}

export class Victory_points3 implements IVictory_points3 {
    /** Top 4 ranking of factions active in faction warfare by total victory points. A faction is considered "active" if they have participated in faction warfare in the past 14 days */
    active_total!: Active_total2[];
    /** Top 4 ranking of factions by victory points in the past week */
    last_week!: Last_week2[];
    /** Top 4 ranking of factions by victory points in the past day */
    yesterday!: Yesterday2[];

    constructor(data?: IVictory_points3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.active_total = [];
            this.last_week = [];
            this.yesterday = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["active_total"])) {
                this.active_total = [] as any;
                for (let item of _data["active_total"])
                    this.active_total!.push(Active_total2.fromJS(item));
            }
            if (Array.isArray(_data["last_week"])) {
                this.last_week = [] as any;
                for (let item of _data["last_week"])
                    this.last_week!.push(Last_week2.fromJS(item));
            }
            if (Array.isArray(_data["yesterday"])) {
                this.yesterday = [] as any;
                for (let item of _data["yesterday"])
                    this.yesterday!.push(Yesterday2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Victory_points3 {
        data = typeof data === 'object' ? data : {};
        let result = new Victory_points3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.active_total)) {
            data["active_total"] = [];
            for (let item of this.active_total)
                data["active_total"].push(item.toJSON());
        }
        if (Array.isArray(this.last_week)) {
            data["last_week"] = [];
            for (let item of this.last_week)
                data["last_week"].push(item.toJSON());
        }
        if (Array.isArray(this.yesterday)) {
            data["yesterday"] = [];
            for (let item of this.yesterday)
                data["yesterday"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVictory_points3 {
    /** Top 4 ranking of factions active in faction warfare by total victory points. A faction is considered "active" if they have participated in faction warfare in the past 14 days */
    active_total: Active_total2[];
    /** Top 4 ranking of factions by victory points in the past week */
    last_week: Last_week2[];
    /** Top 4 ranking of factions by victory points in the past day */
    yesterday: Yesterday2[];
}

export class Kills4 implements IKills4 {
    /** Top 100 ranking of pilots active in faction warfare by total kills. A pilot is considered "active" if they have participated in faction warfare in the past 14 days */
    active_total!: Active_total3[];
    /** Top 100 ranking of pilots by kills in the past week */
    last_week!: Last_week3[];
    /** Top 100 ranking of pilots by kills in the past day */
    yesterday!: Yesterday3[];

    constructor(data?: IKills4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.active_total = [];
            this.last_week = [];
            this.yesterday = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["active_total"])) {
                this.active_total = [] as any;
                for (let item of _data["active_total"])
                    this.active_total!.push(Active_total3.fromJS(item));
            }
            if (Array.isArray(_data["last_week"])) {
                this.last_week = [] as any;
                for (let item of _data["last_week"])
                    this.last_week!.push(Last_week3.fromJS(item));
            }
            if (Array.isArray(_data["yesterday"])) {
                this.yesterday = [] as any;
                for (let item of _data["yesterday"])
                    this.yesterday!.push(Yesterday3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Kills4 {
        data = typeof data === 'object' ? data : {};
        let result = new Kills4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.active_total)) {
            data["active_total"] = [];
            for (let item of this.active_total)
                data["active_total"].push(item.toJSON());
        }
        if (Array.isArray(this.last_week)) {
            data["last_week"] = [];
            for (let item of this.last_week)
                data["last_week"].push(item.toJSON());
        }
        if (Array.isArray(this.yesterday)) {
            data["yesterday"] = [];
            for (let item of this.yesterday)
                data["yesterday"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKills4 {
    /** Top 100 ranking of pilots active in faction warfare by total kills. A pilot is considered "active" if they have participated in faction warfare in the past 14 days */
    active_total: Active_total3[];
    /** Top 100 ranking of pilots by kills in the past week */
    last_week: Last_week3[];
    /** Top 100 ranking of pilots by kills in the past day */
    yesterday: Yesterday3[];
}

export class Victory_points4 implements IVictory_points4 {
    /** Top 100 ranking of pilots active in faction warfare by total victory points. A pilot is considered "active" if they have participated in faction warfare in the past 14 days */
    active_total!: Active_total4[];
    /** Top 100 ranking of pilots by victory points in the past week */
    last_week!: Last_week4[];
    /** Top 100 ranking of pilots by victory points in the past day */
    yesterday!: Yesterday4[];

    constructor(data?: IVictory_points4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.active_total = [];
            this.last_week = [];
            this.yesterday = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["active_total"])) {
                this.active_total = [] as any;
                for (let item of _data["active_total"])
                    this.active_total!.push(Active_total4.fromJS(item));
            }
            if (Array.isArray(_data["last_week"])) {
                this.last_week = [] as any;
                for (let item of _data["last_week"])
                    this.last_week!.push(Last_week4.fromJS(item));
            }
            if (Array.isArray(_data["yesterday"])) {
                this.yesterday = [] as any;
                for (let item of _data["yesterday"])
                    this.yesterday!.push(Yesterday4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Victory_points4 {
        data = typeof data === 'object' ? data : {};
        let result = new Victory_points4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.active_total)) {
            data["active_total"] = [];
            for (let item of this.active_total)
                data["active_total"].push(item.toJSON());
        }
        if (Array.isArray(this.last_week)) {
            data["last_week"] = [];
            for (let item of this.last_week)
                data["last_week"].push(item.toJSON());
        }
        if (Array.isArray(this.yesterday)) {
            data["yesterday"] = [];
            for (let item of this.yesterday)
                data["yesterday"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVictory_points4 {
    /** Top 100 ranking of pilots active in faction warfare by total victory points. A pilot is considered "active" if they have participated in faction warfare in the past 14 days */
    active_total: Active_total4[];
    /** Top 100 ranking of pilots by victory points in the past week */
    last_week: Last_week4[];
    /** Top 100 ranking of pilots by victory points in the past day */
    yesterday: Yesterday4[];
}

export class Kills5 implements IKills5 {
    /** Top 10 ranking of corporations active in faction warfare by total kills. A corporation is considered "active" if they have participated in faction warfare in the past 14 days */
    active_total!: Active_total5[];
    /** Top 10 ranking of corporations by kills in the past week */
    last_week!: Last_week5[];
    /** Top 10 ranking of corporations by kills in the past day */
    yesterday!: Yesterday5[];

    constructor(data?: IKills5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.active_total = [];
            this.last_week = [];
            this.yesterday = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["active_total"])) {
                this.active_total = [] as any;
                for (let item of _data["active_total"])
                    this.active_total!.push(Active_total5.fromJS(item));
            }
            if (Array.isArray(_data["last_week"])) {
                this.last_week = [] as any;
                for (let item of _data["last_week"])
                    this.last_week!.push(Last_week5.fromJS(item));
            }
            if (Array.isArray(_data["yesterday"])) {
                this.yesterday = [] as any;
                for (let item of _data["yesterday"])
                    this.yesterday!.push(Yesterday5.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Kills5 {
        data = typeof data === 'object' ? data : {};
        let result = new Kills5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.active_total)) {
            data["active_total"] = [];
            for (let item of this.active_total)
                data["active_total"].push(item.toJSON());
        }
        if (Array.isArray(this.last_week)) {
            data["last_week"] = [];
            for (let item of this.last_week)
                data["last_week"].push(item.toJSON());
        }
        if (Array.isArray(this.yesterday)) {
            data["yesterday"] = [];
            for (let item of this.yesterday)
                data["yesterday"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKills5 {
    /** Top 10 ranking of corporations active in faction warfare by total kills. A corporation is considered "active" if they have participated in faction warfare in the past 14 days */
    active_total: Active_total5[];
    /** Top 10 ranking of corporations by kills in the past week */
    last_week: Last_week5[];
    /** Top 10 ranking of corporations by kills in the past day */
    yesterday: Yesterday5[];
}

export class Victory_points5 implements IVictory_points5 {
    /** Top 10 ranking of corporations active in faction warfare by total victory points. A corporation is considered "active" if they have participated in faction warfare in the past 14 days */
    active_total!: Active_total6[];
    /** Top 10 ranking of corporations by victory points in the past week */
    last_week!: Last_week6[];
    /** Top 10 ranking of corporations by victory points in the past day */
    yesterday!: Yesterday6[];

    constructor(data?: IVictory_points5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.active_total = [];
            this.last_week = [];
            this.yesterday = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["active_total"])) {
                this.active_total = [] as any;
                for (let item of _data["active_total"])
                    this.active_total!.push(Active_total6.fromJS(item));
            }
            if (Array.isArray(_data["last_week"])) {
                this.last_week = [] as any;
                for (let item of _data["last_week"])
                    this.last_week!.push(Last_week6.fromJS(item));
            }
            if (Array.isArray(_data["yesterday"])) {
                this.yesterday = [] as any;
                for (let item of _data["yesterday"])
                    this.yesterday!.push(Yesterday6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Victory_points5 {
        data = typeof data === 'object' ? data : {};
        let result = new Victory_points5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.active_total)) {
            data["active_total"] = [];
            for (let item of this.active_total)
                data["active_total"].push(item.toJSON());
        }
        if (Array.isArray(this.last_week)) {
            data["last_week"] = [];
            for (let item of this.last_week)
                data["last_week"].push(item.toJSON());
        }
        if (Array.isArray(this.yesterday)) {
            data["yesterday"] = [];
            for (let item of this.yesterday)
                data["yesterday"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVictory_points5 {
    /** Top 10 ranking of corporations active in faction warfare by total victory points. A corporation is considered "active" if they have participated in faction warfare in the past 14 days */
    active_total: Active_total6[];
    /** Top 10 ranking of corporations by victory points in the past week */
    last_week: Last_week6[];
    /** Top 10 ranking of corporations by victory points in the past day */
    yesterday: Yesterday6[];
}

export class Kills6 implements IKills6 {
    /** Last week's total number of kills against enemy factions */
    last_week!: number;
    /** Total number of kills against enemy factions since faction warfare began */
    total!: number;
    /** Yesterday's total number of kills against enemy factions */
    yesterday!: number;

    constructor(data?: IKills6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last_week = _data["last_week"];
            this.total = _data["total"];
            this.yesterday = _data["yesterday"];
        }
    }

    static fromJS(data: any): Kills6 {
        data = typeof data === 'object' ? data : {};
        let result = new Kills6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last_week"] = this.last_week;
        data["total"] = this.total;
        data["yesterday"] = this.yesterday;
        return data;
    }
}

export interface IKills6 {
    /** Last week's total number of kills against enemy factions */
    last_week: number;
    /** Total number of kills against enemy factions since faction warfare began */
    total: number;
    /** Yesterday's total number of kills against enemy factions */
    yesterday: number;
}

export class Victory_points6 implements IVictory_points6 {
    /** Last week's victory points gained */
    last_week!: number;
    /** Total victory points gained since faction warfare began */
    total!: number;
    /** Yesterday's victory points gained */
    yesterday!: number;

    constructor(data?: IVictory_points6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last_week = _data["last_week"];
            this.total = _data["total"];
            this.yesterday = _data["yesterday"];
        }
    }

    static fromJS(data: any): Victory_points6 {
        data = typeof data === 'object' ? data : {};
        let result = new Victory_points6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last_week"] = this.last_week;
        data["total"] = this.total;
        data["yesterday"] = this.yesterday;
        return data;
    }
}

export interface IVictory_points6 {
    /** Last week's victory points gained */
    last_week: number;
    /** Total victory points gained since faction warfare began */
    total: number;
    /** Yesterday's victory points gained */
    yesterday: number;
}

export enum Get_incursions_200_okState {
    Withdrawing = "withdrawing",
    Mobilizing = "mobilizing",
    Established = "established",
}

/** cost_indice object */
export class Cost_indices implements ICost_indices {
    /** activity string */
    activity!: Cost_indicesActivity;
    /** cost_index number */
    cost_index!: number;

    constructor(data?: ICost_indices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"];
            this.cost_index = _data["cost_index"];
        }
    }

    static fromJS(data: any): Cost_indices {
        data = typeof data === 'object' ? data : {};
        let result = new Cost_indices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity;
        data["cost_index"] = this.cost_index;
        return data;
    }
}

/** cost_indice object */
export interface ICost_indices {
    /** activity string */
    activity: Cost_indicesActivity;
    /** cost_index number */
    cost_index: number;
}

/** level object */
export class Levels implements ILevels {
    /** cost number */
    cost!: number;
    /** Localized insurance level */
    name!: string;
    /** payout number */
    payout!: number;

    constructor(data?: ILevels) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cost = _data["cost"];
            this.name = _data["name"];
            this.payout = _data["payout"];
        }
    }

    static fromJS(data: any): Levels {
        data = typeof data === 'object' ? data : {};
        let result = new Levels();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cost"] = this.cost;
        data["name"] = this.name;
        data["payout"] = this.payout;
        return data;
    }
}

/** level object */
export interface ILevels {
    /** cost number */
    cost: number;
    /** Localized insurance level */
    name: string;
    /** payout number */
    payout: number;
}

/** attacker object */
export class Attackers implements IAttackers {
    /** alliance_id integer */
    alliance_id?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;
    /** damage_done integer */
    damage_done!: number;
    /** faction_id integer */
    faction_id?: number | undefined;
    /** Was the attacker the one to achieve the final blow
 */
    final_blow!: boolean;
    /** Security status for the attacker
 */
    security_status!: number;
    /** What ship was the attacker flying
 */
    ship_type_id?: number | undefined;
    /** What weapon was used by the attacker for the kill
 */
    weapon_type_id?: number | undefined;

    constructor(data?: IAttackers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.character_id = _data["character_id"];
            this.corporation_id = _data["corporation_id"];
            this.damage_done = _data["damage_done"];
            this.faction_id = _data["faction_id"];
            this.final_blow = _data["final_blow"];
            this.security_status = _data["security_status"];
            this.ship_type_id = _data["ship_type_id"];
            this.weapon_type_id = _data["weapon_type_id"];
        }
    }

    static fromJS(data: any): Attackers {
        data = typeof data === 'object' ? data : {};
        let result = new Attackers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["character_id"] = this.character_id;
        data["corporation_id"] = this.corporation_id;
        data["damage_done"] = this.damage_done;
        data["faction_id"] = this.faction_id;
        data["final_blow"] = this.final_blow;
        data["security_status"] = this.security_status;
        data["ship_type_id"] = this.ship_type_id;
        data["weapon_type_id"] = this.weapon_type_id;
        return data;
    }
}

/** attacker object */
export interface IAttackers {
    /** alliance_id integer */
    alliance_id?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;
    /** damage_done integer */
    damage_done: number;
    /** faction_id integer */
    faction_id?: number | undefined;
    /** Was the attacker the one to achieve the final blow
 */
    final_blow: boolean;
    /** Security status for the attacker
 */
    security_status: number;
    /** What ship was the attacker flying
 */
    ship_type_id?: number | undefined;
    /** What weapon was used by the attacker for the kill
 */
    weapon_type_id?: number | undefined;
}

export class Victim implements IVictim {
    /** alliance_id integer */
    alliance_id?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;
    /** How much total damage was taken by the victim
 */
    damage_taken!: number;
    /** faction_id integer */
    faction_id?: number | undefined;
    /** items array */
    items?: Items3[] | undefined;
    /** Coordinates of the victim in Cartesian space relative to the Sun
 */
    position?: Position11 | undefined;
    /** The ship that the victim was piloting and was destroyed
 */
    ship_type_id!: number;

    constructor(data?: IVictim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.character_id = _data["character_id"];
            this.corporation_id = _data["corporation_id"];
            this.damage_taken = _data["damage_taken"];
            this.faction_id = _data["faction_id"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Items3.fromJS(item));
            }
            this.position = _data["position"] ? Position11.fromJS(_data["position"]) : <any>undefined;
            this.ship_type_id = _data["ship_type_id"];
        }
    }

    static fromJS(data: any): Victim {
        data = typeof data === 'object' ? data : {};
        let result = new Victim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["character_id"] = this.character_id;
        data["corporation_id"] = this.corporation_id;
        data["damage_taken"] = this.damage_taken;
        data["faction_id"] = this.faction_id;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["ship_type_id"] = this.ship_type_id;
        return data;
    }
}

export interface IVictim {
    /** alliance_id integer */
    alliance_id?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;
    /** How much total damage was taken by the victim
 */
    damage_taken: number;
    /** faction_id integer */
    faction_id?: number | undefined;
    /** items array */
    items?: Items3[] | undefined;
    /** Coordinates of the victim in Cartesian space relative to the Sun
 */
    position?: Position11 | undefined;
    /** The ship that the victim was piloting and was destroyed
 */
    ship_type_id: number;
}

/** required_item object */
export class Required_items implements IRequired_items {
    /** quantity integer */
    quantity!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IRequired_items) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Required_items {
        data = typeof data === 'object' ? data : {};
        let result = new Required_items();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** required_item object */
export interface IRequired_items {
    /** quantity integer */
    quantity: number;
    /** type_id integer */
    type_id: number;
}

export enum Get_markets_structures_structure_id_200_okRange {
    Station = "station",
    Region = "region",
    Solarsystem = "solarsystem",
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
    _5 = "5",
    _10 = "10",
    _20 = "20",
    _30 = "30",
    _40 = "40",
}

export enum Get_markets_region_id_orders_200_okRange {
    Station = "station",
    Region = "region",
    Solarsystem = "solarsystem",
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
    _5 = "5",
    _10 = "10",
    _20 = "20",
    _30 = "30",
    _40 = "40",
}

export enum Get_sovereignty_campaigns_200_okEvent_type {
    Tcu_defense = "tcu_defense",
    Ihub_defense = "ihub_defense",
    Station_defense = "station_defense",
    Station_freeport = "station_freeport",
}

/** participant object */
export class Participants implements IParticipants {
    /** alliance_id integer */
    alliance_id!: number;
    /** score number */
    score!: number;

    constructor(data?: IParticipants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): Participants {
        data = typeof data === 'object' ? data : {};
        let result = new Participants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["score"] = this.score;
        return data;
    }
}

/** participant object */
export interface IParticipants {
    /** alliance_id integer */
    alliance_id: number;
    /** score number */
    score: number;
}

export class Position implements IPosition {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: IPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Position {
        data = typeof data === 'object' ? data : {};
        let result = new Position();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPosition {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

export class Position2 implements IPosition2 {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: IPosition2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Position2 {
        data = typeof data === 'object' ? data : {};
        let result = new Position2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPosition2 {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

/** agent object */
export class Agents implements IAgents {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;

    constructor(data?: IAgents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Agents {
        data = typeof data === 'object' ? data : {};
        let result = new Agents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** agent object */
export interface IAgents {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;
}

/** alliance object */
export class Alliances implements IAlliances {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;

    constructor(data?: IAlliances) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Alliances {
        data = typeof data === 'object' ? data : {};
        let result = new Alliances();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** alliance object */
export interface IAlliances {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;
}

/** character object */
export class Characters implements ICharacters {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;

    constructor(data?: ICharacters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Characters {
        data = typeof data === 'object' ? data : {};
        let result = new Characters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** character object */
export interface ICharacters {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;
}

/** constellation object */
export class Constellations implements IConstellations {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;

    constructor(data?: IConstellations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Constellations {
        data = typeof data === 'object' ? data : {};
        let result = new Constellations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** constellation object */
export interface IConstellations {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;
}

/** corporation object */
export class Corporations implements ICorporations {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;

    constructor(data?: ICorporations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Corporations {
        data = typeof data === 'object' ? data : {};
        let result = new Corporations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** corporation object */
export interface ICorporations {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;
}

/** faction object */
export class Factions implements IFactions {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;

    constructor(data?: IFactions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Factions {
        data = typeof data === 'object' ? data : {};
        let result = new Factions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** faction object */
export interface IFactions {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;
}

/** inventory_type object */
export class Inventory_types implements IInventory_types {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;

    constructor(data?: IInventory_types) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Inventory_types {
        data = typeof data === 'object' ? data : {};
        let result = new Inventory_types();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** inventory_type object */
export interface IInventory_types {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;
}

/** region object */
export class Regions implements IRegions {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;

    constructor(data?: IRegions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Regions {
        data = typeof data === 'object' ? data : {};
        let result = new Regions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** region object */
export interface IRegions {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;
}

/** station object */
export class Stations implements IStations {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;

    constructor(data?: IStations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Stations {
        data = typeof data === 'object' ? data : {};
        let result = new Stations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** station object */
export interface IStations {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;
}

/** system object */
export class Systems implements ISystems {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;

    constructor(data?: ISystems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Systems {
        data = typeof data === 'object' ? data : {};
        let result = new Systems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** system object */
export interface ISystems {
    /** id integer */
    id?: number | undefined;
    /** name string */
    name?: string | undefined;
}

export class Position3 implements IPosition3 {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: IPosition3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Position3 {
        data = typeof data === 'object' ? data : {};
        let result = new Position3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPosition3 {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

export class Position4 implements IPosition4 {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: IPosition4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Position4 {
        data = typeof data === 'object' ? data : {};
        let result = new Position4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPosition4 {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

export class Destination implements IDestination {
    /** The stargate this stargate connects to */
    stargate_id!: number;
    /** The solar system this stargate connects to */
    system_id!: number;

    constructor(data?: IDestination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stargate_id = _data["stargate_id"];
            this.system_id = _data["system_id"];
        }
    }

    static fromJS(data: any): Destination {
        data = typeof data === 'object' ? data : {};
        let result = new Destination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stargate_id"] = this.stargate_id;
        data["system_id"] = this.system_id;
        return data;
    }
}

export interface IDestination {
    /** The stargate this stargate connects to */
    stargate_id: number;
    /** The solar system this stargate connects to */
    system_id: number;
}

export class Position5 implements IPosition5 {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: IPosition5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Position5 {
        data = typeof data === 'object' ? data : {};
        let result = new Position5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPosition5 {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

export enum Get_universe_stars_star_id_okSpectral_class {
    K2_V = "K2 V",
    K4_V = "K4 V",
    G2_V = "G2 V",
    G8_V = "G8 V",
    M7_V = "M7 V",
    K7_V = "K7 V",
    M2_V = "M2 V",
    K5_V = "K5 V",
    M3_V = "M3 V",
    G0_V = "G0 V",
    G7_V = "G7 V",
    G3_V = "G3 V",
    F9_V = "F9 V",
    G5_V = "G5 V",
    F6_V = "F6 V",
    K8_V = "K8 V",
    K9_V = "K9 V",
    K6_V = "K6 V",
    G9_V = "G9 V",
    G6_V = "G6 V",
    G4_VI = "G4 VI",
    G4_V = "G4 V",
    F8_V = "F8 V",
    F2_V = "F2 V",
    F1_V = "F1 V",
    K3_V = "K3 V",
    F0_VI = "F0 VI",
    G1_VI = "G1 VI",
    G0_VI = "G0 VI",
    K1_V = "K1 V",
    M4_V = "M4 V",
    M1_V = "M1 V",
    M6_V = "M6 V",
    M0_V = "M0 V",
    K2_IV = "K2 IV",
    G2_VI = "G2 VI",
    K0_V = "K0 V",
    K5_IV = "K5 IV",
    F5_VI = "F5 VI",
    G6_VI = "G6 VI",
    F6_VI = "F6 VI",
    F2_IV = "F2 IV",
    G3_VI = "G3 VI",
    M8_V = "M8 V",
    F1_VI = "F1 VI",
    K1_IV = "K1 IV",
    F7_V = "F7 V",
    G5_VI = "G5 VI",
    M5_V = "M5 V",
    G7_VI = "G7 VI",
    F5_V = "F5 V",
    F4_VI = "F4 VI",
    F8_VI = "F8 VI",
    K3_IV = "K3 IV",
    F4_IV = "F4 IV",
    F0_V = "F0 V",
    G7_IV = "G7 IV",
    G8_VI = "G8 VI",
    F2_VI = "F2 VI",
    F4_V = "F4 V",
    F7_VI = "F7 VI",
    F3_V = "F3 V",
    G1_V = "G1 V",
    G9_VI = "G9 VI",
    F3_IV = "F3 IV",
    F9_VI = "F9 VI",
    M9_V = "M9 V",
    K0_IV = "K0 IV",
    F1_IV = "F1 IV",
    G4_IV = "G4 IV",
    F3_VI = "F3 VI",
    K4_IV = "K4 IV",
    G5_IV = "G5 IV",
    G3_IV = "G3 IV",
    G1_IV = "G1 IV",
    K7_IV = "K7 IV",
    G0_IV = "G0 IV",
    K6_IV = "K6 IV",
    K9_IV = "K9 IV",
    G2_IV = "G2 IV",
    F9_IV = "F9 IV",
    F0_IV = "F0 IV",
    K8_IV = "K8 IV",
    G8_IV = "G8 IV",
    F6_IV = "F6 IV",
    F5_IV = "F5 IV",
    A0 = "A0",
    A0IV = "A0IV",
    A0IV2 = "A0IV2",
}

export class Aggressor implements IAggressor {
    /** Alliance ID if and only if the aggressor is an alliance */
    alliance_id?: number | undefined;
    /** Corporation ID if and only if the aggressor is a corporation */
    corporation_id?: number | undefined;
    /** ISK value of ships the aggressor has destroyed */
    isk_destroyed!: number;
    /** The number of ships the aggressor has killed */
    ships_killed!: number;

    constructor(data?: IAggressor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.corporation_id = _data["corporation_id"];
            this.isk_destroyed = _data["isk_destroyed"];
            this.ships_killed = _data["ships_killed"];
        }
    }

    static fromJS(data: any): Aggressor {
        data = typeof data === 'object' ? data : {};
        let result = new Aggressor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["corporation_id"] = this.corporation_id;
        data["isk_destroyed"] = this.isk_destroyed;
        data["ships_killed"] = this.ships_killed;
        return data;
    }
}

export interface IAggressor {
    /** Alliance ID if and only if the aggressor is an alliance */
    alliance_id?: number | undefined;
    /** Corporation ID if and only if the aggressor is a corporation */
    corporation_id?: number | undefined;
    /** ISK value of ships the aggressor has destroyed */
    isk_destroyed: number;
    /** The number of ships the aggressor has killed */
    ships_killed: number;
}

/** ally object */
export class Allies implements IAllies {
    /** Alliance ID if and only if this ally is an alliance */
    alliance_id?: number | undefined;
    /** Corporation ID if and only if this ally is a corporation */
    corporation_id?: number | undefined;

    constructor(data?: IAllies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.corporation_id = _data["corporation_id"];
        }
    }

    static fromJS(data: any): Allies {
        data = typeof data === 'object' ? data : {};
        let result = new Allies();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["corporation_id"] = this.corporation_id;
        return data;
    }
}

/** ally object */
export interface IAllies {
    /** Alliance ID if and only if this ally is an alliance */
    alliance_id?: number | undefined;
    /** Corporation ID if and only if this ally is a corporation */
    corporation_id?: number | undefined;
}

export class Defender implements IDefender {
    /** Alliance ID if and only if the defender is an alliance */
    alliance_id?: number | undefined;
    /** Corporation ID if and only if the defender is a corporation */
    corporation_id?: number | undefined;
    /** ISK value of ships the defender has killed */
    isk_destroyed!: number;
    /** The number of ships the defender has killed */
    ships_killed!: number;

    constructor(data?: IDefender) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alliance_id = _data["alliance_id"];
            this.corporation_id = _data["corporation_id"];
            this.isk_destroyed = _data["isk_destroyed"];
            this.ships_killed = _data["ships_killed"];
        }
    }

    static fromJS(data: any): Defender {
        data = typeof data === 'object' ? data : {};
        let result = new Defender();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alliance_id"] = this.alliance_id;
        data["corporation_id"] = this.corporation_id;
        data["isk_destroyed"] = this.isk_destroyed;
        data["ships_killed"] = this.ships_killed;
        return data;
    }
}

export interface IDefender {
    /** Alliance ID if and only if the defender is an alliance */
    alliance_id?: number | undefined;
    /** Corporation ID if and only if the defender is a corporation */
    corporation_id?: number | undefined;
    /** ISK value of ships the defender has killed */
    isk_destroyed: number;
    /** The number of ships the defender has killed */
    ships_killed: number;
}

export enum Get_alliances_alliance_id_contacts_200_okContact_type {
    Character = "character",
    Corporation = "corporation",
    Alliance = "alliance",
    Faction = "faction",
}

export class Position6 implements IPosition6 {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: IPosition6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Position6 {
        data = typeof data === 'object' ? data : {};
        let result = new Position6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPosition6 {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

export class Coordinates2 implements ICoordinates2 {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: ICoordinates2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Coordinates2 {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinates2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface ICoordinates2 {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

export class Item2 implements IItem2 {
    /** item_id integer */
    item_id!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IItem2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item_id = _data["item_id"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Item2 {
        data = typeof data === 'object' ? data : {};
        let result = new Item2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item_id"] = this.item_id;
        data["type_id"] = this.type_id;
        return data;
    }
}

export interface IItem2 {
    /** item_id integer */
    item_id: number;
    /** type_id integer */
    type_id: number;
}

export enum Get_characters_character_id_contacts_200_okContact_type {
    Character = "character",
    Corporation = "corporation",
    Alliance = "alliance",
    Faction = "faction",
}

/** item object */
export class Items2 implements IItems2 {
    /** flag string */
    flag!: Items2Flag;
    /** quantity integer */
    quantity!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IItems2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flag = _data["flag"];
            this.quantity = _data["quantity"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Items2 {
        data = typeof data === 'object' ? data : {};
        let result = new Items2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flag"] = this.flag;
        data["quantity"] = this.quantity;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** item object */
export interface IItems2 {
    /** flag string */
    flag: Items2Flag;
    /** quantity integer */
    quantity: number;
    /** type_id integer */
    type_id: number;
}

/** graphic object */
export class Graphics implements IGraphics {
    /** color integer */
    color?: number | undefined;
    /** graphic string */
    graphic!: string;
    /** layer integer */
    layer!: number;
    /** part integer */
    part!: number;

    constructor(data?: IGraphics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
            this.graphic = _data["graphic"];
            this.layer = _data["layer"];
            this.part = _data["part"];
        }
    }

    static fromJS(data: any): Graphics {
        data = typeof data === 'object' ? data : {};
        let result = new Graphics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["graphic"] = this.graphic;
        data["layer"] = this.layer;
        data["part"] = this.part;
        return data;
    }
}

/** graphic object */
export interface IGraphics {
    /** color integer */
    color?: number | undefined;
    /** graphic string */
    graphic: string;
    /** layer integer */
    layer: number;
    /** part integer */
    part: number;
}

export enum Get_characters_character_id_medals_200_okStatus {
    Public = "public",
    Private = "private",
}

export enum Get_characters_character_id_orders_200_okRange {
    _1 = "1",
    _10 = "10",
    _2 = "2",
    _20 = "20",
    _3 = "3",
    _30 = "30",
    _4 = "4",
    _40 = "40",
    _5 = "5",
    Region = "region",
    Solarsystem = "solarsystem",
    Station = "station",
}

export enum Get_characters_character_id_standings_200_okFrom_type {
    Agent = "agent",
    Npc_corp = "npc_corp",
    Faction = "faction",
}

export class Position7 implements IPosition7 {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: IPosition7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Position7 {
        data = typeof data === 'object' ? data : {};
        let result = new Position7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPosition7 {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

export enum Get_corporations_corporation_id_contacts_200_okContact_type {
    Character = "character",
    Corporation = "corporation",
    Alliance = "alliance",
    Faction = "faction",
}

/** hangar object */
export class Hangar implements IHangar {
    /** division integer */
    division?: number | undefined;
    /** name string */
    name?: string | undefined;

    constructor(data?: IHangar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.division = _data["division"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Hangar {
        data = typeof data === 'object' ? data : {};
        let result = new Hangar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        data["name"] = this.name;
        return data;
    }
}

/** hangar object */
export interface IHangar {
    /** division integer */
    division?: number | undefined;
    /** name string */
    name?: string | undefined;
}

/** wallet object */
export class Wallet implements IWallet {
    /** division integer */
    division?: number | undefined;
    /** name string */
    name?: string | undefined;

    constructor(data?: IWallet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.division = _data["division"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Wallet {
        data = typeof data === 'object' ? data : {};
        let result = new Wallet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        data["name"] = this.name;
        return data;
    }
}

/** wallet object */
export interface IWallet {
    /** division integer */
    division?: number | undefined;
    /** name string */
    name?: string | undefined;
}

export enum Get_corporations_corporation_id_medals_issued_200_okStatus {
    Private = "private",
    Public = "public",
}

export enum Get_corporations_corporation_id_orders_history_200_okRange {
    _1 = "1",
    _10 = "10",
    _2 = "2",
    _20 = "20",
    _3 = "3",
    _30 = "30",
    _4 = "4",
    _40 = "40",
    _5 = "5",
    Region = "region",
    Solarsystem = "solarsystem",
    Station = "station",
}

export enum Get_corporations_corporation_id_orders_history_200_okState {
    Cancelled = "cancelled",
    Expired = "expired",
}

/** grantable_role string */
export enum Grantable_roles {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** grantable_roles_at_base string */
export enum Grantable_roles_at_base {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** grantable_roles_at_hq string */
export enum Grantable_roles_at_hq {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** grantable_roles_at_other string */
export enum Grantable_roles_at_other {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** role string */
export enum Roles {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** roles_at_base string */
export enum Roles_at_base {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** roles_at_hq string */
export enum Roles_at_hq {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** roles_at_other string */
export enum Roles_at_other {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** new_role string */
export enum New_roles {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** old_role string */
export enum Old_roles {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

export enum Get_corporations_corporation_id_roles_history_200_okRole_type {
    Grantable_roles = "grantable_roles",
    Grantable_roles_at_base = "grantable_roles_at_base",
    Grantable_roles_at_hq = "grantable_roles_at_hq",
    Grantable_roles_at_other = "grantable_roles_at_other",
    Roles = "roles",
    Roles_at_base = "roles_at_base",
    Roles_at_hq = "roles_at_hq",
    Roles_at_other = "roles_at_other",
}

export enum Get_corporations_corporation_id_standings_200_okFrom_type {
    Agent = "agent",
    Npc_corp = "npc_corp",
    Faction = "faction",
}

export enum Get_corporations_corporation_id_starbases_200_okState {
    Offline = "offline",
    Online = "online",
    Onlining = "onlining",
    Reinforced = "reinforced",
    Unanchoring = "unanchoring",
}

export enum Get_corporations_corporation_id_starbases_starbase_id_okAnchor {
    Alliance_member = "alliance_member",
    Config_starbase_equipment_role = "config_starbase_equipment_role",
    Corporation_member = "corporation_member",
    Starbase_fuel_technician_role = "starbase_fuel_technician_role",
}

export enum Get_corporations_corporation_id_starbases_starbase_id_okFuel_bay_take {
    Alliance_member = "alliance_member",
    Config_starbase_equipment_role = "config_starbase_equipment_role",
    Corporation_member = "corporation_member",
    Starbase_fuel_technician_role = "starbase_fuel_technician_role",
}

export enum Get_corporations_corporation_id_starbases_starbase_id_okFuel_bay_view {
    Alliance_member = "alliance_member",
    Config_starbase_equipment_role = "config_starbase_equipment_role",
    Corporation_member = "corporation_member",
    Starbase_fuel_technician_role = "starbase_fuel_technician_role",
}

/** fuel object */
export class Fuels implements IFuels {
    /** quantity integer */
    quantity!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IFuels) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Fuels {
        data = typeof data === 'object' ? data : {};
        let result = new Fuels();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** fuel object */
export interface IFuels {
    /** quantity integer */
    quantity: number;
    /** type_id integer */
    type_id: number;
}

export enum Get_corporations_corporation_id_starbases_starbase_id_okOffline {
    Alliance_member = "alliance_member",
    Config_starbase_equipment_role = "config_starbase_equipment_role",
    Corporation_member = "corporation_member",
    Starbase_fuel_technician_role = "starbase_fuel_technician_role",
}

export enum Get_corporations_corporation_id_starbases_starbase_id_okOnline {
    Alliance_member = "alliance_member",
    Config_starbase_equipment_role = "config_starbase_equipment_role",
    Corporation_member = "corporation_member",
    Starbase_fuel_technician_role = "starbase_fuel_technician_role",
}

export enum Get_corporations_corporation_id_starbases_starbase_id_okUnanchor {
    Alliance_member = "alliance_member",
    Config_starbase_equipment_role = "config_starbase_equipment_role",
    Corporation_member = "corporation_member",
    Starbase_fuel_technician_role = "starbase_fuel_technician_role",
}

/** grantable_role string */
export enum Grantable_roles2 {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** grantable_roles_at_base string */
export enum Grantable_roles_at_base2 {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** grantable_roles_at_hq string */
export enum Grantable_roles_at_hq2 {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** grantable_roles_at_other string */
export enum Grantable_roles_at_other2 {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** role string */
export enum Roles2 {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** roles_at_base string */
export enum Roles_at_base2 {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** roles_at_hq string */
export enum Roles_at_hq2 {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** roles_at_other string */
export enum Roles_at_other2 {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** modifier object */
export class Modifiers implements IModifiers {
    /** domain string */
    domain?: string | undefined;
    /** effect_id integer */
    effect_id?: number | undefined;
    /** func string */
    func!: string;
    /** modified_attribute_id integer */
    modified_attribute_id?: number | undefined;
    /** modifying_attribute_id integer */
    modifying_attribute_id?: number | undefined;
    /** operator integer */
    operator?: number | undefined;

    constructor(data?: IModifiers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
            this.effect_id = _data["effect_id"];
            this.func = _data["func"];
            this.modified_attribute_id = _data["modified_attribute_id"];
            this.modifying_attribute_id = _data["modifying_attribute_id"];
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): Modifiers {
        data = typeof data === 'object' ? data : {};
        let result = new Modifiers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        data["effect_id"] = this.effect_id;
        data["func"] = this.func;
        data["modified_attribute_id"] = this.modified_attribute_id;
        data["modifying_attribute_id"] = this.modifying_attribute_id;
        data["operator"] = this.operator;
        return data;
    }
}

/** modifier object */
export interface IModifiers {
    /** domain string */
    domain?: string | undefined;
    /** effect_id integer */
    effect_id?: number | undefined;
    /** func string */
    func: string;
    /** modified_attribute_id integer */
    modified_attribute_id?: number | undefined;
    /** modifying_attribute_id integer */
    modifying_attribute_id?: number | undefined;
    /** operator integer */
    operator?: number | undefined;
}

export enum Get_fw_systems_200_okContested {
    Captured = "captured",
    Contested = "contested",
    Uncontested = "uncontested",
    Vulnerable = "vulnerable",
}

export class Position8 implements IPosition8 {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: IPosition8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Position8 {
        data = typeof data === 'object' ? data : {};
        let result = new Position8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPosition8 {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

/** service string */
export enum Services {
    BountyMissions = "bounty-missions",
    AssasinationMissions = "assasination-missions",
    CourierMissions = "courier-missions",
    Interbus = "interbus",
    ReprocessingPlant = "reprocessing-plant",
    Refinery = "refinery",
    Market = "market",
    BlackMarket = "black-market",
    StockExchange = "stock-exchange",
    Cloning = "cloning",
    Surgery = "surgery",
    DnaTherapy = "dna-therapy",
    RepairFacilities = "repair-facilities",
    Factory = "factory",
    Labratory = "labratory",
    Gambling = "gambling",
    Fitting = "fitting",
    Paintshop = "paintshop",
    News = "news",
    Storage = "storage",
    Insurance = "insurance",
    Docking = "docking",
    OfficeRental = "office-rental",
    JumpCloneFacility = "jump-clone-facility",
    LoyaltyPointStore = "loyalty-point-store",
    NavyOffices = "navy-offices",
    SecurityOffices = "security-offices",
}

export class Position9 implements IPosition9 {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: IPosition9) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Position9 {
        data = typeof data === 'object' ? data : {};
        let result = new Position9();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPosition9 {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

export enum Get_characters_character_id_blueprints_200_okLocation_flag {
    AutoFit = "AutoFit",
    Cargo = "Cargo",
    CorpseBay = "CorpseBay",
    DroneBay = "DroneBay",
    FleetHangar = "FleetHangar",
    Deliveries = "Deliveries",
    HiddenModifiers = "HiddenModifiers",
    Hangar = "Hangar",
    HangarAll = "HangarAll",
    LoSlot0 = "LoSlot0",
    LoSlot1 = "LoSlot1",
    LoSlot2 = "LoSlot2",
    LoSlot3 = "LoSlot3",
    LoSlot4 = "LoSlot4",
    LoSlot5 = "LoSlot5",
    LoSlot6 = "LoSlot6",
    LoSlot7 = "LoSlot7",
    MedSlot0 = "MedSlot0",
    MedSlot1 = "MedSlot1",
    MedSlot2 = "MedSlot2",
    MedSlot3 = "MedSlot3",
    MedSlot4 = "MedSlot4",
    MedSlot5 = "MedSlot5",
    MedSlot6 = "MedSlot6",
    MedSlot7 = "MedSlot7",
    HiSlot0 = "HiSlot0",
    HiSlot1 = "HiSlot1",
    HiSlot2 = "HiSlot2",
    HiSlot3 = "HiSlot3",
    HiSlot4 = "HiSlot4",
    HiSlot5 = "HiSlot5",
    HiSlot6 = "HiSlot6",
    HiSlot7 = "HiSlot7",
    AssetSafety = "AssetSafety",
    Locked = "Locked",
    Unlocked = "Unlocked",
    Implant = "Implant",
    QuafeBay = "QuafeBay",
    RigSlot0 = "RigSlot0",
    RigSlot1 = "RigSlot1",
    RigSlot2 = "RigSlot2",
    RigSlot3 = "RigSlot3",
    RigSlot4 = "RigSlot4",
    RigSlot5 = "RigSlot5",
    RigSlot6 = "RigSlot6",
    RigSlot7 = "RigSlot7",
    ShipHangar = "ShipHangar",
    SpecializedFuelBay = "SpecializedFuelBay",
    SpecializedOreHold = "SpecializedOreHold",
    SpecializedGasHold = "SpecializedGasHold",
    SpecializedMineralHold = "SpecializedMineralHold",
    SpecializedSalvageHold = "SpecializedSalvageHold",
    SpecializedShipHold = "SpecializedShipHold",
    SpecializedSmallShipHold = "SpecializedSmallShipHold",
    SpecializedMediumShipHold = "SpecializedMediumShipHold",
    SpecializedLargeShipHold = "SpecializedLargeShipHold",
    SpecializedIndustrialShipHold = "SpecializedIndustrialShipHold",
    SpecializedAmmoHold = "SpecializedAmmoHold",
    SpecializedCommandCenterHold = "SpecializedCommandCenterHold",
    SpecializedPlanetaryCommoditiesHold = "SpecializedPlanetaryCommoditiesHold",
    SpecializedMaterialBay = "SpecializedMaterialBay",
    SubSystemSlot0 = "SubSystemSlot0",
    SubSystemSlot1 = "SubSystemSlot1",
    SubSystemSlot2 = "SubSystemSlot2",
    SubSystemSlot3 = "SubSystemSlot3",
    SubSystemSlot4 = "SubSystemSlot4",
    SubSystemSlot5 = "SubSystemSlot5",
    SubSystemSlot6 = "SubSystemSlot6",
    SubSystemSlot7 = "SubSystemSlot7",
    FighterBay = "FighterBay",
    FighterTube0 = "FighterTube0",
    FighterTube1 = "FighterTube1",
    FighterTube2 = "FighterTube2",
    FighterTube3 = "FighterTube3",
    FighterTube4 = "FighterTube4",
    Module = "Module",
}

export enum Get_characters_character_id_calendar_event_id_okOwner_type {
    Eve_server = "eve_server",
    Corporation = "corporation",
    Faction = "faction",
    Character = "character",
    Alliance = "alliance",
}

export class Home_location implements IHome_location {
    /** location_id integer */
    location_id?: number | undefined;
    /** location_type string */
    location_type?: Home_locationLocation_type | undefined;

    constructor(data?: IHome_location) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location_id = _data["location_id"];
            this.location_type = _data["location_type"];
        }
    }

    static fromJS(data: any): Home_location {
        data = typeof data === 'object' ? data : {};
        let result = new Home_location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location_id"] = this.location_id;
        data["location_type"] = this.location_type;
        return data;
    }
}

export interface IHome_location {
    /** location_id integer */
    location_id?: number | undefined;
    /** location_type string */
    location_type?: Home_locationLocation_type | undefined;
}

/** jump_clone object */
export class Jump_clones implements IJump_clones {
    /** implants array */
    implants!: number[];
    /** jump_clone_id integer */
    jump_clone_id!: number;
    /** location_id integer */
    location_id!: number;
    /** location_type string */
    location_type!: Jump_clonesLocation_type;
    /** name string */
    name?: string | undefined;

    constructor(data?: IJump_clones) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.implants = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["implants"])) {
                this.implants = [] as any;
                for (let item of _data["implants"])
                    this.implants!.push(item);
            }
            this.jump_clone_id = _data["jump_clone_id"];
            this.location_id = _data["location_id"];
            this.location_type = _data["location_type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Jump_clones {
        data = typeof data === 'object' ? data : {};
        let result = new Jump_clones();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.implants)) {
            data["implants"] = [];
            for (let item of this.implants)
                data["implants"].push(item);
        }
        data["jump_clone_id"] = this.jump_clone_id;
        data["location_id"] = this.location_id;
        data["location_type"] = this.location_type;
        data["name"] = this.name;
        return data;
    }
}

/** jump_clone object */
export interface IJump_clones {
    /** implants array */
    implants: number[];
    /** jump_clone_id integer */
    jump_clone_id: number;
    /** location_id integer */
    location_id: number;
    /** location_type string */
    location_type: Jump_clonesLocation_type;
    /** name string */
    name?: string | undefined;
}

/** label object */
export class Labels implements ILabels {
    /** color string */
    color?: LabelsColor | undefined;
    /** label_id integer */
    label_id?: number | undefined;
    /** name string */
    name?: string | undefined;
    /** unread_count integer */
    unread_count?: number | undefined;

    constructor(data?: ILabels) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.color = LabelsColor._ffffff;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"] !== undefined ? _data["color"] : LabelsColor._ffffff;
            this.label_id = _data["label_id"];
            this.name = _data["name"];
            this.unread_count = _data["unread_count"];
        }
    }

    static fromJS(data: any): Labels {
        data = typeof data === 'object' ? data : {};
        let result = new Labels();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["label_id"] = this.label_id;
        data["name"] = this.name;
        data["unread_count"] = this.unread_count;
        return data;
    }
}

/** label object */
export interface ILabels {
    /** color string */
    color?: LabelsColor | undefined;
    /** label_id integer */
    label_id?: number | undefined;
    /** name string */
    name?: string | undefined;
    /** unread_count integer */
    unread_count?: number | undefined;
}

/** link object */
export class Links implements ILinks {
    /** destination_pin_id integer */
    destination_pin_id!: number;
    /** link_level integer */
    link_level!: number;
    /** source_pin_id integer */
    source_pin_id!: number;

    constructor(data?: ILinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destination_pin_id = _data["destination_pin_id"];
            this.link_level = _data["link_level"];
            this.source_pin_id = _data["source_pin_id"];
        }
    }

    static fromJS(data: any): Links {
        data = typeof data === 'object' ? data : {};
        let result = new Links();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destination_pin_id"] = this.destination_pin_id;
        data["link_level"] = this.link_level;
        data["source_pin_id"] = this.source_pin_id;
        return data;
    }
}

/** link object */
export interface ILinks {
    /** destination_pin_id integer */
    destination_pin_id: number;
    /** link_level integer */
    link_level: number;
    /** source_pin_id integer */
    source_pin_id: number;
}

/** pin object */
export class Pins implements IPins {
    /** contents array */
    contents?: Contents[] | undefined;
    /** expiry_time string */
    expiry_time?: Date | undefined;
    /** extractor_details object */
    extractor_details?: Extractor_details | undefined;
    /** factory_details object */
    factory_details?: Factory_details | undefined;
    /** install_time string */
    install_time?: Date | undefined;
    /** last_cycle_start string */
    last_cycle_start?: Date | undefined;
    /** latitude number */
    latitude!: number;
    /** longitude number */
    longitude!: number;
    /** pin_id integer */
    pin_id!: number;
    /** schematic_id integer */
    schematic_id?: number | undefined;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IPins) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(Contents.fromJS(item));
            }
            this.expiry_time = _data["expiry_time"] ? new Date(_data["expiry_time"].toString()) : <any>undefined;
            this.extractor_details = _data["extractor_details"] ? Extractor_details.fromJS(_data["extractor_details"]) : <any>undefined;
            this.factory_details = _data["factory_details"] ? Factory_details.fromJS(_data["factory_details"]) : <any>undefined;
            this.install_time = _data["install_time"] ? new Date(_data["install_time"].toString()) : <any>undefined;
            this.last_cycle_start = _data["last_cycle_start"] ? new Date(_data["last_cycle_start"].toString()) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.pin_id = _data["pin_id"];
            this.schematic_id = _data["schematic_id"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Pins {
        data = typeof data === 'object' ? data : {};
        let result = new Pins();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        data["expiry_time"] = this.expiry_time ? this.expiry_time.toISOString() : <any>undefined;
        data["extractor_details"] = this.extractor_details ? this.extractor_details.toJSON() : <any>undefined;
        data["factory_details"] = this.factory_details ? this.factory_details.toJSON() : <any>undefined;
        data["install_time"] = this.install_time ? this.install_time.toISOString() : <any>undefined;
        data["last_cycle_start"] = this.last_cycle_start ? this.last_cycle_start.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["pin_id"] = this.pin_id;
        data["schematic_id"] = this.schematic_id;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** pin object */
export interface IPins {
    /** contents array */
    contents?: Contents[] | undefined;
    /** expiry_time string */
    expiry_time?: Date | undefined;
    /** extractor_details object */
    extractor_details?: Extractor_details | undefined;
    /** factory_details object */
    factory_details?: Factory_details | undefined;
    /** install_time string */
    install_time?: Date | undefined;
    /** last_cycle_start string */
    last_cycle_start?: Date | undefined;
    /** latitude number */
    latitude: number;
    /** longitude number */
    longitude: number;
    /** pin_id integer */
    pin_id: number;
    /** schematic_id integer */
    schematic_id?: number | undefined;
    /** type_id integer */
    type_id: number;
}

/** route object */
export class Routes implements IRoutes {
    /** content_type_id integer */
    content_type_id!: number;
    /** destination_pin_id integer */
    destination_pin_id!: number;
    /** quantity number */
    quantity!: number;
    /** route_id integer */
    route_id!: number;
    /** source_pin_id integer */
    source_pin_id!: number;
    /** list of pin ID waypoints */
    waypoints?: number[] | undefined;

    constructor(data?: IRoutes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content_type_id = _data["content_type_id"];
            this.destination_pin_id = _data["destination_pin_id"];
            this.quantity = _data["quantity"];
            this.route_id = _data["route_id"];
            this.source_pin_id = _data["source_pin_id"];
            if (Array.isArray(_data["waypoints"])) {
                this.waypoints = [] as any;
                for (let item of _data["waypoints"])
                    this.waypoints!.push(item);
            }
        }
    }

    static fromJS(data: any): Routes {
        data = typeof data === 'object' ? data : {};
        let result = new Routes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content_type_id"] = this.content_type_id;
        data["destination_pin_id"] = this.destination_pin_id;
        data["quantity"] = this.quantity;
        data["route_id"] = this.route_id;
        data["source_pin_id"] = this.source_pin_id;
        if (Array.isArray(this.waypoints)) {
            data["waypoints"] = [];
            for (let item of this.waypoints)
                data["waypoints"].push(item);
        }
        return data;
    }
}

/** route object */
export interface IRoutes {
    /** content_type_id integer */
    content_type_id: number;
    /** destination_pin_id integer */
    destination_pin_id: number;
    /** quantity number */
    quantity: number;
    /** route_id integer */
    route_id: number;
    /** source_pin_id integer */
    source_pin_id: number;
    /** list of pin ID waypoints */
    waypoints?: number[] | undefined;
}

/** role string */
export enum Roles3 {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** roles_at_base string */
export enum Roles_at_base3 {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** roles_at_hq string */
export enum Roles_at_hq3 {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

/** roles_at_other string */
export enum Roles_at_other3 {
    Account_Take_1 = "Account_Take_1",
    Account_Take_2 = "Account_Take_2",
    Account_Take_3 = "Account_Take_3",
    Account_Take_4 = "Account_Take_4",
    Account_Take_5 = "Account_Take_5",
    Account_Take_6 = "Account_Take_6",
    Account_Take_7 = "Account_Take_7",
    Accountant = "Accountant",
    Auditor = "Auditor",
    Communications_Officer = "Communications_Officer",
    Config_Equipment = "Config_Equipment",
    Config_Starbase_Equipment = "Config_Starbase_Equipment",
    Container_Take_1 = "Container_Take_1",
    Container_Take_2 = "Container_Take_2",
    Container_Take_3 = "Container_Take_3",
    Container_Take_4 = "Container_Take_4",
    Container_Take_5 = "Container_Take_5",
    Container_Take_6 = "Container_Take_6",
    Container_Take_7 = "Container_Take_7",
    Contract_Manager = "Contract_Manager",
    Diplomat = "Diplomat",
    Director = "Director",
    Factory_Manager = "Factory_Manager",
    Fitting_Manager = "Fitting_Manager",
    Hangar_Query_1 = "Hangar_Query_1",
    Hangar_Query_2 = "Hangar_Query_2",
    Hangar_Query_3 = "Hangar_Query_3",
    Hangar_Query_4 = "Hangar_Query_4",
    Hangar_Query_5 = "Hangar_Query_5",
    Hangar_Query_6 = "Hangar_Query_6",
    Hangar_Query_7 = "Hangar_Query_7",
    Hangar_Take_1 = "Hangar_Take_1",
    Hangar_Take_2 = "Hangar_Take_2",
    Hangar_Take_3 = "Hangar_Take_3",
    Hangar_Take_4 = "Hangar_Take_4",
    Hangar_Take_5 = "Hangar_Take_5",
    Hangar_Take_6 = "Hangar_Take_6",
    Hangar_Take_7 = "Hangar_Take_7",
    Junior_Accountant = "Junior_Accountant",
    Personnel_Manager = "Personnel_Manager",
    Rent_Factory_Facility = "Rent_Factory_Facility",
    Rent_Office = "Rent_Office",
    Rent_Research_Facility = "Rent_Research_Facility",
    Security_Officer = "Security_Officer",
    Starbase_Defense_Operator = "Starbase_Defense_Operator",
    Starbase_Fuel_Technician = "Starbase_Fuel_Technician",
    Station_Manager = "Station_Manager",
    Trader = "Trader",
}

export enum Get_corporations_corporation_id_blueprints_200_okLocation_flag {
    AssetSafety = "AssetSafety",
    AutoFit = "AutoFit",
    Bonus = "Bonus",
    Booster = "Booster",
    BoosterBay = "BoosterBay",
    Capsule = "Capsule",
    Cargo = "Cargo",
    CorpDeliveries = "CorpDeliveries",
    CorpSAG1 = "CorpSAG1",
    CorpSAG2 = "CorpSAG2",
    CorpSAG3 = "CorpSAG3",
    CorpSAG4 = "CorpSAG4",
    CorpSAG5 = "CorpSAG5",
    CorpSAG6 = "CorpSAG6",
    CorpSAG7 = "CorpSAG7",
    CrateLoot = "CrateLoot",
    Deliveries = "Deliveries",
    DroneBay = "DroneBay",
    DustBattle = "DustBattle",
    DustDatabank = "DustDatabank",
    FighterBay = "FighterBay",
    FighterTube0 = "FighterTube0",
    FighterTube1 = "FighterTube1",
    FighterTube2 = "FighterTube2",
    FighterTube3 = "FighterTube3",
    FighterTube4 = "FighterTube4",
    FleetHangar = "FleetHangar",
    FrigateEscapeBay = "FrigateEscapeBay",
    Hangar = "Hangar",
    HangarAll = "HangarAll",
    HiSlot0 = "HiSlot0",
    HiSlot1 = "HiSlot1",
    HiSlot2 = "HiSlot2",
    HiSlot3 = "HiSlot3",
    HiSlot4 = "HiSlot4",
    HiSlot5 = "HiSlot5",
    HiSlot6 = "HiSlot6",
    HiSlot7 = "HiSlot7",
    HiddenModifiers = "HiddenModifiers",
    Implant = "Implant",
    Impounded = "Impounded",
    JunkyardReprocessed = "JunkyardReprocessed",
    JunkyardTrashed = "JunkyardTrashed",
    LoSlot0 = "LoSlot0",
    LoSlot1 = "LoSlot1",
    LoSlot2 = "LoSlot2",
    LoSlot3 = "LoSlot3",
    LoSlot4 = "LoSlot4",
    LoSlot5 = "LoSlot5",
    LoSlot6 = "LoSlot6",
    LoSlot7 = "LoSlot7",
    Locked = "Locked",
    MedSlot0 = "MedSlot0",
    MedSlot1 = "MedSlot1",
    MedSlot2 = "MedSlot2",
    MedSlot3 = "MedSlot3",
    MedSlot4 = "MedSlot4",
    MedSlot5 = "MedSlot5",
    MedSlot6 = "MedSlot6",
    MedSlot7 = "MedSlot7",
    OfficeFolder = "OfficeFolder",
    Pilot = "Pilot",
    PlanetSurface = "PlanetSurface",
    QuafeBay = "QuafeBay",
    QuantumCoreRoom = "QuantumCoreRoom",
    Reward = "Reward",
    RigSlot0 = "RigSlot0",
    RigSlot1 = "RigSlot1",
    RigSlot2 = "RigSlot2",
    RigSlot3 = "RigSlot3",
    RigSlot4 = "RigSlot4",
    RigSlot5 = "RigSlot5",
    RigSlot6 = "RigSlot6",
    RigSlot7 = "RigSlot7",
    SecondaryStorage = "SecondaryStorage",
    ServiceSlot0 = "ServiceSlot0",
    ServiceSlot1 = "ServiceSlot1",
    ServiceSlot2 = "ServiceSlot2",
    ServiceSlot3 = "ServiceSlot3",
    ServiceSlot4 = "ServiceSlot4",
    ServiceSlot5 = "ServiceSlot5",
    ServiceSlot6 = "ServiceSlot6",
    ServiceSlot7 = "ServiceSlot7",
    ShipHangar = "ShipHangar",
    ShipOffline = "ShipOffline",
    Skill = "Skill",
    SkillInTraining = "SkillInTraining",
    SpecializedAmmoHold = "SpecializedAmmoHold",
    SpecializedCommandCenterHold = "SpecializedCommandCenterHold",
    SpecializedFuelBay = "SpecializedFuelBay",
    SpecializedGasHold = "SpecializedGasHold",
    SpecializedIndustrialShipHold = "SpecializedIndustrialShipHold",
    SpecializedLargeShipHold = "SpecializedLargeShipHold",
    SpecializedMaterialBay = "SpecializedMaterialBay",
    SpecializedMediumShipHold = "SpecializedMediumShipHold",
    SpecializedMineralHold = "SpecializedMineralHold",
    SpecializedOreHold = "SpecializedOreHold",
    SpecializedPlanetaryCommoditiesHold = "SpecializedPlanetaryCommoditiesHold",
    SpecializedSalvageHold = "SpecializedSalvageHold",
    SpecializedShipHold = "SpecializedShipHold",
    SpecializedSmallShipHold = "SpecializedSmallShipHold",
    StructureActive = "StructureActive",
    StructureFuel = "StructureFuel",
    StructureInactive = "StructureInactive",
    StructureOffline = "StructureOffline",
    SubSystemBay = "SubSystemBay",
    SubSystemSlot0 = "SubSystemSlot0",
    SubSystemSlot1 = "SubSystemSlot1",
    SubSystemSlot2 = "SubSystemSlot2",
    SubSystemSlot3 = "SubSystemSlot3",
    SubSystemSlot4 = "SubSystemSlot4",
    SubSystemSlot5 = "SubSystemSlot5",
    SubSystemSlot6 = "SubSystemSlot6",
    SubSystemSlot7 = "SubSystemSlot7",
    Unlocked = "Unlocked",
    Wallet = "Wallet",
    Wardrobe = "Wardrobe",
}

export enum Get_corporations_corporation_id_containers_logs_200_okAction {
    Add = "add",
    Assemble = "assemble",
    Configure = "configure",
    Enter_password = "enter_password",
    Lock = "lock",
    Move = "move",
    Repackage = "repackage",
    Set_name = "set_name",
    Set_password = "set_password",
    Unlock = "unlock",
}

export enum Get_corporations_corporation_id_containers_logs_200_okLocation_flag {
    AssetSafety = "AssetSafety",
    AutoFit = "AutoFit",
    Bonus = "Bonus",
    Booster = "Booster",
    BoosterBay = "BoosterBay",
    Capsule = "Capsule",
    Cargo = "Cargo",
    CorpDeliveries = "CorpDeliveries",
    CorpSAG1 = "CorpSAG1",
    CorpSAG2 = "CorpSAG2",
    CorpSAG3 = "CorpSAG3",
    CorpSAG4 = "CorpSAG4",
    CorpSAG5 = "CorpSAG5",
    CorpSAG6 = "CorpSAG6",
    CorpSAG7 = "CorpSAG7",
    CrateLoot = "CrateLoot",
    Deliveries = "Deliveries",
    DroneBay = "DroneBay",
    DustBattle = "DustBattle",
    DustDatabank = "DustDatabank",
    FighterBay = "FighterBay",
    FighterTube0 = "FighterTube0",
    FighterTube1 = "FighterTube1",
    FighterTube2 = "FighterTube2",
    FighterTube3 = "FighterTube3",
    FighterTube4 = "FighterTube4",
    FleetHangar = "FleetHangar",
    FrigateEscapeBay = "FrigateEscapeBay",
    Hangar = "Hangar",
    HangarAll = "HangarAll",
    HiSlot0 = "HiSlot0",
    HiSlot1 = "HiSlot1",
    HiSlot2 = "HiSlot2",
    HiSlot3 = "HiSlot3",
    HiSlot4 = "HiSlot4",
    HiSlot5 = "HiSlot5",
    HiSlot6 = "HiSlot6",
    HiSlot7 = "HiSlot7",
    HiddenModifiers = "HiddenModifiers",
    Implant = "Implant",
    Impounded = "Impounded",
    JunkyardReprocessed = "JunkyardReprocessed",
    JunkyardTrashed = "JunkyardTrashed",
    LoSlot0 = "LoSlot0",
    LoSlot1 = "LoSlot1",
    LoSlot2 = "LoSlot2",
    LoSlot3 = "LoSlot3",
    LoSlot4 = "LoSlot4",
    LoSlot5 = "LoSlot5",
    LoSlot6 = "LoSlot6",
    LoSlot7 = "LoSlot7",
    Locked = "Locked",
    MedSlot0 = "MedSlot0",
    MedSlot1 = "MedSlot1",
    MedSlot2 = "MedSlot2",
    MedSlot3 = "MedSlot3",
    MedSlot4 = "MedSlot4",
    MedSlot5 = "MedSlot5",
    MedSlot6 = "MedSlot6",
    MedSlot7 = "MedSlot7",
    OfficeFolder = "OfficeFolder",
    Pilot = "Pilot",
    PlanetSurface = "PlanetSurface",
    QuafeBay = "QuafeBay",
    QuantumCoreRoom = "QuantumCoreRoom",
    Reward = "Reward",
    RigSlot0 = "RigSlot0",
    RigSlot1 = "RigSlot1",
    RigSlot2 = "RigSlot2",
    RigSlot3 = "RigSlot3",
    RigSlot4 = "RigSlot4",
    RigSlot5 = "RigSlot5",
    RigSlot6 = "RigSlot6",
    RigSlot7 = "RigSlot7",
    SecondaryStorage = "SecondaryStorage",
    ServiceSlot0 = "ServiceSlot0",
    ServiceSlot1 = "ServiceSlot1",
    ServiceSlot2 = "ServiceSlot2",
    ServiceSlot3 = "ServiceSlot3",
    ServiceSlot4 = "ServiceSlot4",
    ServiceSlot5 = "ServiceSlot5",
    ServiceSlot6 = "ServiceSlot6",
    ServiceSlot7 = "ServiceSlot7",
    ShipHangar = "ShipHangar",
    ShipOffline = "ShipOffline",
    Skill = "Skill",
    SkillInTraining = "SkillInTraining",
    SpecializedAmmoHold = "SpecializedAmmoHold",
    SpecializedCommandCenterHold = "SpecializedCommandCenterHold",
    SpecializedFuelBay = "SpecializedFuelBay",
    SpecializedGasHold = "SpecializedGasHold",
    SpecializedIndustrialShipHold = "SpecializedIndustrialShipHold",
    SpecializedLargeShipHold = "SpecializedLargeShipHold",
    SpecializedMaterialBay = "SpecializedMaterialBay",
    SpecializedMediumShipHold = "SpecializedMediumShipHold",
    SpecializedMineralHold = "SpecializedMineralHold",
    SpecializedOreHold = "SpecializedOreHold",
    SpecializedPlanetaryCommoditiesHold = "SpecializedPlanetaryCommoditiesHold",
    SpecializedSalvageHold = "SpecializedSalvageHold",
    SpecializedShipHold = "SpecializedShipHold",
    SpecializedSmallShipHold = "SpecializedSmallShipHold",
    StructureActive = "StructureActive",
    StructureFuel = "StructureFuel",
    StructureInactive = "StructureInactive",
    StructureOffline = "StructureOffline",
    SubSystemBay = "SubSystemBay",
    SubSystemSlot0 = "SubSystemSlot0",
    SubSystemSlot1 = "SubSystemSlot1",
    SubSystemSlot2 = "SubSystemSlot2",
    SubSystemSlot3 = "SubSystemSlot3",
    SubSystemSlot4 = "SubSystemSlot4",
    SubSystemSlot5 = "SubSystemSlot5",
    SubSystemSlot6 = "SubSystemSlot6",
    SubSystemSlot7 = "SubSystemSlot7",
    Unlocked = "Unlocked",
    Wallet = "Wallet",
    Wardrobe = "Wardrobe",
}

export enum Get_corporations_corporation_id_containers_logs_200_okPassword_type {
    Config = "config",
    General = "general",
}

export enum Get_corporations_corporation_id_orders_200_okRange {
    _1 = "1",
    _10 = "10",
    _2 = "2",
    _20 = "20",
    _3 = "3",
    _30 = "30",
    _4 = "4",
    _40 = "40",
    _5 = "5",
    Region = "region",
    Solarsystem = "solarsystem",
    Station = "station",
}

export enum Post_universe_names_200_okCategory {
    Alliance = "alliance",
    Character = "character",
    Constellation = "constellation",
    Corporation = "corporation",
    Inventory_type = "inventory_type",
    Region = "region",
    Solar_system = "solar_system",
    Station = "station",
    Faction = "faction",
}

/** dogma_attribute object */
export class Dogma_attributes2 implements IDogma_attributes2 {
    /** attribute_id integer */
    attribute_id!: number;
    /** value number */
    value!: number;

    constructor(data?: IDogma_attributes2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attribute_id = _data["attribute_id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Dogma_attributes2 {
        data = typeof data === 'object' ? data : {};
        let result = new Dogma_attributes2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute_id"] = this.attribute_id;
        data["value"] = this.value;
        return data;
    }
}

/** dogma_attribute object */
export interface IDogma_attributes2 {
    /** attribute_id integer */
    attribute_id: number;
    /** value number */
    value: number;
}

/** dogma_effect object */
export class Dogma_effects2 implements IDogma_effects2 {
    /** effect_id integer */
    effect_id!: number;
    /** is_default boolean */
    is_default!: boolean;

    constructor(data?: IDogma_effects2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.effect_id = _data["effect_id"];
            this.is_default = _data["is_default"];
        }
    }

    static fromJS(data: any): Dogma_effects2 {
        data = typeof data === 'object' ? data : {};
        let result = new Dogma_effects2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["effect_id"] = this.effect_id;
        data["is_default"] = this.is_default;
        return data;
    }
}

/** dogma_effect object */
export interface IDogma_effects2 {
    /** effect_id integer */
    effect_id: number;
    /** is_default boolean */
    is_default: boolean;
}

/** skill object */
export class Skills implements ISkills {
    /** active_skill_level integer */
    active_skill_level!: number;
    /** skill_id integer */
    skill_id!: number;
    /** skillpoints_in_skill integer */
    skillpoints_in_skill!: number;
    /** trained_skill_level integer */
    trained_skill_level!: number;

    constructor(data?: ISkills) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active_skill_level = _data["active_skill_level"];
            this.skill_id = _data["skill_id"];
            this.skillpoints_in_skill = _data["skillpoints_in_skill"];
            this.trained_skill_level = _data["trained_skill_level"];
        }
    }

    static fromJS(data: any): Skills {
        data = typeof data === 'object' ? data : {};
        let result = new Skills();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active_skill_level"] = this.active_skill_level;
        data["skill_id"] = this.skill_id;
        data["skillpoints_in_skill"] = this.skillpoints_in_skill;
        data["trained_skill_level"] = this.trained_skill_level;
        return data;
    }
}

/** skill object */
export interface ISkills {
    /** active_skill_level integer */
    active_skill_level: number;
    /** skill_id integer */
    skill_id: number;
    /** skillpoints_in_skill integer */
    skillpoints_in_skill: number;
    /** trained_skill_level integer */
    trained_skill_level: number;
}

/** service object */
export class Services2 implements IServices2 {
    /** name string */
    name!: string;
    /** state string */
    state!: Services2State;

    constructor(data?: IServices2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): Services2 {
        data = typeof data === 'object' ? data : {};
        let result = new Services2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["state"] = this.state;
        return data;
    }
}

/** service object */
export interface IServices2 {
    /** name string */
    name: string;
    /** state string */
    state: Services2State;
}

export enum Get_corporations_corporation_id_structures_200_okState {
    Anchor_vulnerable = "anchor_vulnerable",
    Anchoring = "anchoring",
    Armor_reinforce = "armor_reinforce",
    Armor_vulnerable = "armor_vulnerable",
    Deploy_vulnerable = "deploy_vulnerable",
    Fitting_invulnerable = "fitting_invulnerable",
    Hull_reinforce = "hull_reinforce",
    Hull_vulnerable = "hull_vulnerable",
    Online_deprecated = "online_deprecated",
    Onlining_vulnerable = "onlining_vulnerable",
    Shield_vulnerable = "shield_vulnerable",
    Unanchored = "unanchored",
    Unknown = "unknown",
}

export enum Get_corporations_corporation_id_wallets_division_journal_200_okContext_id_type {
    Structure_id = "structure_id",
    Station_id = "station_id",
    Market_transaction_id = "market_transaction_id",
    Character_id = "character_id",
    Corporation_id = "corporation_id",
    Alliance_id = "alliance_id",
    Eve_system = "eve_system",
    Industry_job_id = "industry_job_id",
    Contract_id = "contract_id",
    Planet_id = "planet_id",
    System_id = "system_id",
    Type_id = "type_id",
}

export enum Get_corporations_corporation_id_wallets_division_journal_200_okRef_type {
    Acceleration_gate_fee = "acceleration_gate_fee",
    Advertisement_listing_fee = "advertisement_listing_fee",
    Agent_donation = "agent_donation",
    Agent_location_services = "agent_location_services",
    Agent_miscellaneous = "agent_miscellaneous",
    Agent_mission_collateral_paid = "agent_mission_collateral_paid",
    Agent_mission_collateral_refunded = "agent_mission_collateral_refunded",
    Agent_mission_reward = "agent_mission_reward",
    Agent_mission_reward_corporation_tax = "agent_mission_reward_corporation_tax",
    Agent_mission_time_bonus_reward = "agent_mission_time_bonus_reward",
    Agent_mission_time_bonus_reward_corporation_tax = "agent_mission_time_bonus_reward_corporation_tax",
    Agent_security_services = "agent_security_services",
    Agent_services_rendered = "agent_services_rendered",
    Agents_preward = "agents_preward",
    Alliance_maintainance_fee = "alliance_maintainance_fee",
    Alliance_registration_fee = "alliance_registration_fee",
    Asset_safety_recovery_tax = "asset_safety_recovery_tax",
    Bounty = "bounty",
    Bounty_prize = "bounty_prize",
    Bounty_prize_corporation_tax = "bounty_prize_corporation_tax",
    Bounty_prizes = "bounty_prizes",
    Bounty_reimbursement = "bounty_reimbursement",
    Bounty_surcharge = "bounty_surcharge",
    Brokers_fee = "brokers_fee",
    Clone_activation = "clone_activation",
    Clone_transfer = "clone_transfer",
    Contraband_fine = "contraband_fine",
    Contract_auction_bid = "contract_auction_bid",
    Contract_auction_bid_corp = "contract_auction_bid_corp",
    Contract_auction_bid_refund = "contract_auction_bid_refund",
    Contract_auction_sold = "contract_auction_sold",
    Contract_brokers_fee = "contract_brokers_fee",
    Contract_brokers_fee_corp = "contract_brokers_fee_corp",
    Contract_collateral = "contract_collateral",
    Contract_collateral_deposited_corp = "contract_collateral_deposited_corp",
    Contract_collateral_payout = "contract_collateral_payout",
    Contract_collateral_refund = "contract_collateral_refund",
    Contract_deposit = "contract_deposit",
    Contract_deposit_corp = "contract_deposit_corp",
    Contract_deposit_refund = "contract_deposit_refund",
    Contract_deposit_sales_tax = "contract_deposit_sales_tax",
    Contract_price = "contract_price",
    Contract_price_payment_corp = "contract_price_payment_corp",
    Contract_reversal = "contract_reversal",
    Contract_reward = "contract_reward",
    Contract_reward_deposited = "contract_reward_deposited",
    Contract_reward_deposited_corp = "contract_reward_deposited_corp",
    Contract_reward_refund = "contract_reward_refund",
    Contract_sales_tax = "contract_sales_tax",
    Copying = "copying",
    Corporate_reward_payout = "corporate_reward_payout",
    Corporate_reward_tax = "corporate_reward_tax",
    Corporation_account_withdrawal = "corporation_account_withdrawal",
    Corporation_bulk_payment = "corporation_bulk_payment",
    Corporation_dividend_payment = "corporation_dividend_payment",
    Corporation_liquidation = "corporation_liquidation",
    Corporation_logo_change_cost = "corporation_logo_change_cost",
    Corporation_payment = "corporation_payment",
    Corporation_registration_fee = "corporation_registration_fee",
    Courier_mission_escrow = "courier_mission_escrow",
    Cspa = "cspa",
    Cspaofflinerefund = "cspaofflinerefund",
    Daily_challenge_reward = "daily_challenge_reward",
    Datacore_fee = "datacore_fee",
    Dna_modification_fee = "dna_modification_fee",
    Docking_fee = "docking_fee",
    Duel_wager_escrow = "duel_wager_escrow",
    Duel_wager_payment = "duel_wager_payment",
    Duel_wager_refund = "duel_wager_refund",
    Ess_escrow_transfer = "ess_escrow_transfer",
    External_trade_delivery = "external_trade_delivery",
    External_trade_freeze = "external_trade_freeze",
    External_trade_thaw = "external_trade_thaw",
    Factory_slot_rental_fee = "factory_slot_rental_fee",
    Flux_payout = "flux_payout",
    Flux_tax = "flux_tax",
    Flux_ticket_repayment = "flux_ticket_repayment",
    Flux_ticket_sale = "flux_ticket_sale",
    Gm_cash_transfer = "gm_cash_transfer",
    Industry_job_tax = "industry_job_tax",
    Infrastructure_hub_maintenance = "infrastructure_hub_maintenance",
    Inheritance = "inheritance",
    Insurance = "insurance",
    Item_trader_payment = "item_trader_payment",
    Jump_clone_activation_fee = "jump_clone_activation_fee",
    Jump_clone_installation_fee = "jump_clone_installation_fee",
    Kill_right_fee = "kill_right_fee",
    Lp_store = "lp_store",
    Manufacturing = "manufacturing",
    Market_escrow = "market_escrow",
    Market_fine_paid = "market_fine_paid",
    Market_provider_tax = "market_provider_tax",
    Market_transaction = "market_transaction",
    Medal_creation = "medal_creation",
    Medal_issued = "medal_issued",
    Milestone_reward_payment = "milestone_reward_payment",
    Mission_completion = "mission_completion",
    Mission_cost = "mission_cost",
    Mission_expiration = "mission_expiration",
    Mission_reward = "mission_reward",
    Office_rental_fee = "office_rental_fee",
    Operation_bonus = "operation_bonus",
    Opportunity_reward = "opportunity_reward",
    Planetary_construction = "planetary_construction",
    Planetary_export_tax = "planetary_export_tax",
    Planetary_import_tax = "planetary_import_tax",
    Player_donation = "player_donation",
    Player_trading = "player_trading",
    Project_discovery_reward = "project_discovery_reward",
    Project_discovery_tax = "project_discovery_tax",
    Reaction = "reaction",
    Redeemed_isk_token = "redeemed_isk_token",
    Release_of_impounded_property = "release_of_impounded_property",
    Repair_bill = "repair_bill",
    Reprocessing_tax = "reprocessing_tax",
    Researching_material_productivity = "researching_material_productivity",
    Researching_technology = "researching_technology",
    Researching_time_productivity = "researching_time_productivity",
    Resource_wars_reward = "resource_wars_reward",
    Reverse_engineering = "reverse_engineering",
    Season_challenge_reward = "season_challenge_reward",
    Security_processing_fee = "security_processing_fee",
    Shares = "shares",
    Skill_purchase = "skill_purchase",
    Sovereignity_bill = "sovereignity_bill",
    Store_purchase = "store_purchase",
    Store_purchase_refund = "store_purchase_refund",
    Structure_gate_jump = "structure_gate_jump",
    Transaction_tax = "transaction_tax",
    Upkeep_adjustment_fee = "upkeep_adjustment_fee",
    War_ally_contract = "war_ally_contract",
    War_fee = "war_fee",
    War_fee_surrender = "war_fee_surrender",
}

/** planet object */
export class Planets implements IPlanets {
    /** asteroid_belts array */
    asteroid_belts?: number[] | undefined;
    /** moons array */
    moons?: number[] | undefined;
    /** planet_id integer */
    planet_id!: number;

    constructor(data?: IPlanets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["asteroid_belts"])) {
                this.asteroid_belts = [] as any;
                for (let item of _data["asteroid_belts"])
                    this.asteroid_belts!.push(item);
            }
            if (Array.isArray(_data["moons"])) {
                this.moons = [] as any;
                for (let item of _data["moons"])
                    this.moons!.push(item);
            }
            this.planet_id = _data["planet_id"];
        }
    }

    static fromJS(data: any): Planets {
        data = typeof data === 'object' ? data : {};
        let result = new Planets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.asteroid_belts)) {
            data["asteroid_belts"] = [];
            for (let item of this.asteroid_belts)
                data["asteroid_belts"].push(item);
        }
        if (Array.isArray(this.moons)) {
            data["moons"] = [];
            for (let item of this.moons)
                data["moons"].push(item);
        }
        data["planet_id"] = this.planet_id;
        return data;
    }
}

/** planet object */
export interface IPlanets {
    /** asteroid_belts array */
    asteroid_belts?: number[] | undefined;
    /** moons array */
    moons?: number[] | undefined;
    /** planet_id integer */
    planet_id: number;
}

export class Position10 implements IPosition10 {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: IPosition10) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Position10 {
        data = typeof data === 'object' ? data : {};
        let result = new Position10();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPosition10 {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

export enum Get_characters_character_id_okGender {
    Female = "female",
    Male = "male",
}

export enum Get_characters_character_id_assets_200_okLocation_flag {
    AssetSafety = "AssetSafety",
    AutoFit = "AutoFit",
    BoosterBay = "BoosterBay",
    Cargo = "Cargo",
    CorpseBay = "CorpseBay",
    Deliveries = "Deliveries",
    DroneBay = "DroneBay",
    FighterBay = "FighterBay",
    FighterTube0 = "FighterTube0",
    FighterTube1 = "FighterTube1",
    FighterTube2 = "FighterTube2",
    FighterTube3 = "FighterTube3",
    FighterTube4 = "FighterTube4",
    FleetHangar = "FleetHangar",
    FrigateEscapeBay = "FrigateEscapeBay",
    Hangar = "Hangar",
    HangarAll = "HangarAll",
    HiSlot0 = "HiSlot0",
    HiSlot1 = "HiSlot1",
    HiSlot2 = "HiSlot2",
    HiSlot3 = "HiSlot3",
    HiSlot4 = "HiSlot4",
    HiSlot5 = "HiSlot5",
    HiSlot6 = "HiSlot6",
    HiSlot7 = "HiSlot7",
    HiddenModifiers = "HiddenModifiers",
    Implant = "Implant",
    LoSlot0 = "LoSlot0",
    LoSlot1 = "LoSlot1",
    LoSlot2 = "LoSlot2",
    LoSlot3 = "LoSlot3",
    LoSlot4 = "LoSlot4",
    LoSlot5 = "LoSlot5",
    LoSlot6 = "LoSlot6",
    LoSlot7 = "LoSlot7",
    Locked = "Locked",
    MedSlot0 = "MedSlot0",
    MedSlot1 = "MedSlot1",
    MedSlot2 = "MedSlot2",
    MedSlot3 = "MedSlot3",
    MedSlot4 = "MedSlot4",
    MedSlot5 = "MedSlot5",
    MedSlot6 = "MedSlot6",
    MedSlot7 = "MedSlot7",
    QuafeBay = "QuafeBay",
    RigSlot0 = "RigSlot0",
    RigSlot1 = "RigSlot1",
    RigSlot2 = "RigSlot2",
    RigSlot3 = "RigSlot3",
    RigSlot4 = "RigSlot4",
    RigSlot5 = "RigSlot5",
    RigSlot6 = "RigSlot6",
    RigSlot7 = "RigSlot7",
    ShipHangar = "ShipHangar",
    Skill = "Skill",
    SpecializedAmmoHold = "SpecializedAmmoHold",
    SpecializedAsteroidHold = "SpecializedAsteroidHold",
    SpecializedCommandCenterHold = "SpecializedCommandCenterHold",
    SpecializedFuelBay = "SpecializedFuelBay",
    SpecializedGasHold = "SpecializedGasHold",
    SpecializedIceHold = "SpecializedIceHold",
    SpecializedIndustrialShipHold = "SpecializedIndustrialShipHold",
    SpecializedLargeShipHold = "SpecializedLargeShipHold",
    SpecializedMaterialBay = "SpecializedMaterialBay",
    SpecializedMediumShipHold = "SpecializedMediumShipHold",
    SpecializedMineralHold = "SpecializedMineralHold",
    SpecializedOreHold = "SpecializedOreHold",
    SpecializedPlanetaryCommoditiesHold = "SpecializedPlanetaryCommoditiesHold",
    SpecializedSalvageHold = "SpecializedSalvageHold",
    SpecializedShipHold = "SpecializedShipHold",
    SpecializedSmallShipHold = "SpecializedSmallShipHold",
    StructureDeedBay = "StructureDeedBay",
    SubSystemBay = "SubSystemBay",
    SubSystemSlot0 = "SubSystemSlot0",
    SubSystemSlot1 = "SubSystemSlot1",
    SubSystemSlot2 = "SubSystemSlot2",
    SubSystemSlot3 = "SubSystemSlot3",
    SubSystemSlot4 = "SubSystemSlot4",
    SubSystemSlot5 = "SubSystemSlot5",
    SubSystemSlot6 = "SubSystemSlot6",
    SubSystemSlot7 = "SubSystemSlot7",
    Unlocked = "Unlocked",
    Wardrobe = "Wardrobe",
}

export enum Get_characters_character_id_assets_200_okLocation_type {
    Station = "station",
    Solar_system = "solar_system",
    Item = "item",
    Other = "other",
}

export enum Get_characters_character_id_notifications_200_okSender_type {
    Character = "character",
    Corporation = "corporation",
    Alliance = "alliance",
    Faction = "faction",
    Other = "other",
}

export enum Get_characters_character_id_notifications_200_okType {
    AcceptedAlly = "AcceptedAlly",
    AcceptedSurrender = "AcceptedSurrender",
    AgentRetiredTrigravian = "AgentRetiredTrigravian",
    AllAnchoringMsg = "AllAnchoringMsg",
    AllMaintenanceBillMsg = "AllMaintenanceBillMsg",
    AllStrucInvulnerableMsg = "AllStrucInvulnerableMsg",
    AllStructVulnerableMsg = "AllStructVulnerableMsg",
    AllWarCorpJoinedAllianceMsg = "AllWarCorpJoinedAllianceMsg",
    AllWarDeclaredMsg = "AllWarDeclaredMsg",
    AllWarInvalidatedMsg = "AllWarInvalidatedMsg",
    AllWarRetractedMsg = "AllWarRetractedMsg",
    AllWarSurrenderMsg = "AllWarSurrenderMsg",
    AllianceCapitalChanged = "AllianceCapitalChanged",
    AllianceWarDeclaredV2 = "AllianceWarDeclaredV2",
    AllyContractCancelled = "AllyContractCancelled",
    AllyJoinedWarAggressorMsg = "AllyJoinedWarAggressorMsg",
    AllyJoinedWarAllyMsg = "AllyJoinedWarAllyMsg",
    AllyJoinedWarDefenderMsg = "AllyJoinedWarDefenderMsg",
    BattlePunishFriendlyFire = "BattlePunishFriendlyFire",
    BillOutOfMoneyMsg = "BillOutOfMoneyMsg",
    BillPaidCorpAllMsg = "BillPaidCorpAllMsg",
    BountyClaimMsg = "BountyClaimMsg",
    BountyESSShared = "BountyESSShared",
    BountyESSTaken = "BountyESSTaken",
    BountyPlacedAlliance = "BountyPlacedAlliance",
    BountyPlacedChar = "BountyPlacedChar",
    BountyPlacedCorp = "BountyPlacedCorp",
    BountyYourBountyClaimed = "BountyYourBountyClaimed",
    BuddyConnectContactAdd = "BuddyConnectContactAdd",
    CharAppAcceptMsg = "CharAppAcceptMsg",
    CharAppRejectMsg = "CharAppRejectMsg",
    CharAppWithdrawMsg = "CharAppWithdrawMsg",
    CharLeftCorpMsg = "CharLeftCorpMsg",
    CharMedalMsg = "CharMedalMsg",
    CharTerminationMsg = "CharTerminationMsg",
    CloneActivationMsg = "CloneActivationMsg",
    CloneActivationMsg2 = "CloneActivationMsg2",
    CloneMovedMsg = "CloneMovedMsg",
    CloneRevokedMsg1 = "CloneRevokedMsg1",
    CloneRevokedMsg2 = "CloneRevokedMsg2",
    CombatOperationFinished = "CombatOperationFinished",
    ContactAdd = "ContactAdd",
    ContactEdit = "ContactEdit",
    ContainerPasswordMsg = "ContainerPasswordMsg",
    ContractRegionChangedToPochven = "ContractRegionChangedToPochven",
    CorpAllBillMsg = "CorpAllBillMsg",
    CorpAppAcceptMsg = "CorpAppAcceptMsg",
    CorpAppInvitedMsg = "CorpAppInvitedMsg",
    CorpAppNewMsg = "CorpAppNewMsg",
    CorpAppRejectCustomMsg = "CorpAppRejectCustomMsg",
    CorpAppRejectMsg = "CorpAppRejectMsg",
    CorpBecameWarEligible = "CorpBecameWarEligible",
    CorpDividendMsg = "CorpDividendMsg",
    CorpFriendlyFireDisableTimerCompleted = "CorpFriendlyFireDisableTimerCompleted",
    CorpFriendlyFireDisableTimerStarted = "CorpFriendlyFireDisableTimerStarted",
    CorpFriendlyFireEnableTimerCompleted = "CorpFriendlyFireEnableTimerCompleted",
    CorpFriendlyFireEnableTimerStarted = "CorpFriendlyFireEnableTimerStarted",
    CorpKicked = "CorpKicked",
    CorpLiquidationMsg = "CorpLiquidationMsg",
    CorpNewCEOMsg = "CorpNewCEOMsg",
    CorpNewsMsg = "CorpNewsMsg",
    CorpNoLongerWarEligible = "CorpNoLongerWarEligible",
    CorpOfficeExpirationMsg = "CorpOfficeExpirationMsg",
    CorpStructLostMsg = "CorpStructLostMsg",
    CorpTaxChangeMsg = "CorpTaxChangeMsg",
    CorpVoteCEORevokedMsg = "CorpVoteCEORevokedMsg",
    CorpVoteMsg = "CorpVoteMsg",
    CorpWarDeclaredMsg = "CorpWarDeclaredMsg",
    CorpWarDeclaredV2 = "CorpWarDeclaredV2",
    CorpWarFightingLegalMsg = "CorpWarFightingLegalMsg",
    CorpWarInvalidatedMsg = "CorpWarInvalidatedMsg",
    CorpWarRetractedMsg = "CorpWarRetractedMsg",
    CorpWarSurrenderMsg = "CorpWarSurrenderMsg",
    CustomsMsg = "CustomsMsg",
    DeclareWar = "DeclareWar",
    DistrictAttacked = "DistrictAttacked",
    DustAppAcceptedMsg = "DustAppAcceptedMsg",
    ESSMainBankLink = "ESSMainBankLink",
    EntosisCaptureStarted = "EntosisCaptureStarted",
    ExpertSystemExpired = "ExpertSystemExpired",
    ExpertSystemExpiryImminent = "ExpertSystemExpiryImminent",
    FWAllianceKickMsg = "FWAllianceKickMsg",
    FWAllianceWarningMsg = "FWAllianceWarningMsg",
    FWCharKickMsg = "FWCharKickMsg",
    FWCharRankGainMsg = "FWCharRankGainMsg",
    FWCharRankLossMsg = "FWCharRankLossMsg",
    FWCharWarningMsg = "FWCharWarningMsg",
    FWCorpJoinMsg = "FWCorpJoinMsg",
    FWCorpKickMsg = "FWCorpKickMsg",
    FWCorpLeaveMsg = "FWCorpLeaveMsg",
    FWCorpWarningMsg = "FWCorpWarningMsg",
    FacWarCorpJoinRequestMsg = "FacWarCorpJoinRequestMsg",
    FacWarCorpJoinWithdrawMsg = "FacWarCorpJoinWithdrawMsg",
    FacWarCorpLeaveRequestMsg = "FacWarCorpLeaveRequestMsg",
    FacWarCorpLeaveWithdrawMsg = "FacWarCorpLeaveWithdrawMsg",
    FacWarLPDisqualifiedEvent = "FacWarLPDisqualifiedEvent",
    FacWarLPDisqualifiedKill = "FacWarLPDisqualifiedKill",
    FacWarLPPayoutEvent = "FacWarLPPayoutEvent",
    FacWarLPPayoutKill = "FacWarLPPayoutKill",
    GameTimeAdded = "GameTimeAdded",
    GameTimeReceived = "GameTimeReceived",
    GameTimeSent = "GameTimeSent",
    GiftReceived = "GiftReceived",
    IHubDestroyedByBillFailure = "IHubDestroyedByBillFailure",
    IncursionCompletedMsg = "IncursionCompletedMsg",
    IndustryOperationFinished = "IndustryOperationFinished",
    IndustryTeamAuctionLost = "IndustryTeamAuctionLost",
    IndustryTeamAuctionWon = "IndustryTeamAuctionWon",
    InfrastructureHubBillAboutToExpire = "InfrastructureHubBillAboutToExpire",
    InsuranceExpirationMsg = "InsuranceExpirationMsg",
    InsuranceFirstShipMsg = "InsuranceFirstShipMsg",
    InsuranceInvalidatedMsg = "InsuranceInvalidatedMsg",
    InsuranceIssuedMsg = "InsuranceIssuedMsg",
    InsurancePayoutMsg = "InsurancePayoutMsg",
    InvasionCompletedMsg = "InvasionCompletedMsg",
    InvasionSystemLogin = "InvasionSystemLogin",
    InvasionSystemStart = "InvasionSystemStart",
    JumpCloneDeletedMsg1 = "JumpCloneDeletedMsg1",
    JumpCloneDeletedMsg2 = "JumpCloneDeletedMsg2",
    KillReportFinalBlow = "KillReportFinalBlow",
    KillReportVictim = "KillReportVictim",
    KillRightAvailable = "KillRightAvailable",
    KillRightAvailableOpen = "KillRightAvailableOpen",
    KillRightEarned = "KillRightEarned",
    KillRightUnavailable = "KillRightUnavailable",
    KillRightUnavailableOpen = "KillRightUnavailableOpen",
    KillRightUsed = "KillRightUsed",
    LocateCharMsg = "LocateCharMsg",
    MadeWarMutual = "MadeWarMutual",
    MercOfferRetractedMsg = "MercOfferRetractedMsg",
    MercOfferedNegotiationMsg = "MercOfferedNegotiationMsg",
    MissionCanceledTriglavian = "MissionCanceledTriglavian",
    MissionOfferExpirationMsg = "MissionOfferExpirationMsg",
    MissionTimeoutMsg = "MissionTimeoutMsg",
    MoonminingAutomaticFracture = "MoonminingAutomaticFracture",
    MoonminingExtractionCancelled = "MoonminingExtractionCancelled",
    MoonminingExtractionFinished = "MoonminingExtractionFinished",
    MoonminingExtractionStarted = "MoonminingExtractionStarted",
    MoonminingLaserFired = "MoonminingLaserFired",
    MutualWarExpired = "MutualWarExpired",
    MutualWarInviteAccepted = "MutualWarInviteAccepted",
    MutualWarInviteRejected = "MutualWarInviteRejected",
    MutualWarInviteSent = "MutualWarInviteSent",
    NPCStandingsGained = "NPCStandingsGained",
    NPCStandingsLost = "NPCStandingsLost",
    OfferToAllyRetracted = "OfferToAllyRetracted",
    OfferedSurrender = "OfferedSurrender",
    OfferedToAlly = "OfferedToAlly",
    OfficeLeaseCanceledInsufficientStandings = "OfficeLeaseCanceledInsufficientStandings",
    OldLscMessages = "OldLscMessages",
    OperationFinished = "OperationFinished",
    OrbitalAttacked = "OrbitalAttacked",
    OrbitalReinforced = "OrbitalReinforced",
    OwnershipTransferred = "OwnershipTransferred",
    RaffleCreated = "RaffleCreated",
    RaffleExpired = "RaffleExpired",
    RaffleFinished = "RaffleFinished",
    ReimbursementMsg = "ReimbursementMsg",
    ResearchMissionAvailableMsg = "ResearchMissionAvailableMsg",
    RetractsWar = "RetractsWar",
    SeasonalChallengeCompleted = "SeasonalChallengeCompleted",
    SovAllClaimAquiredMsg = "SovAllClaimAquiredMsg",
    SovAllClaimLostMsg = "SovAllClaimLostMsg",
    SovCommandNodeEventStarted = "SovCommandNodeEventStarted",
    SovCorpBillLateMsg = "SovCorpBillLateMsg",
    SovCorpClaimFailMsg = "SovCorpClaimFailMsg",
    SovDisruptorMsg = "SovDisruptorMsg",
    SovStationEnteredFreeport = "SovStationEnteredFreeport",
    SovStructureDestroyed = "SovStructureDestroyed",
    SovStructureReinforced = "SovStructureReinforced",
    SovStructureSelfDestructCancel = "SovStructureSelfDestructCancel",
    SovStructureSelfDestructFinished = "SovStructureSelfDestructFinished",
    SovStructureSelfDestructRequested = "SovStructureSelfDestructRequested",
    SovereigntyIHDamageMsg = "SovereigntyIHDamageMsg",
    SovereigntySBUDamageMsg = "SovereigntySBUDamageMsg",
    SovereigntyTCUDamageMsg = "SovereigntyTCUDamageMsg",
    StationAggressionMsg1 = "StationAggressionMsg1",
    StationAggressionMsg2 = "StationAggressionMsg2",
    StationConquerMsg = "StationConquerMsg",
    StationServiceDisabled = "StationServiceDisabled",
    StationServiceEnabled = "StationServiceEnabled",
    StationStateChangeMsg = "StationStateChangeMsg",
    StoryLineMissionAvailableMsg = "StoryLineMissionAvailableMsg",
    StructureAnchoring = "StructureAnchoring",
    StructureCourierContractChanged = "StructureCourierContractChanged",
    StructureDestroyed = "StructureDestroyed",
    StructureFuelAlert = "StructureFuelAlert",
    StructureImpendingAbandonmentAssetsAtRisk = "StructureImpendingAbandonmentAssetsAtRisk",
    StructureItemsDelivered = "StructureItemsDelivered",
    StructureItemsMovedToSafety = "StructureItemsMovedToSafety",
    StructureLostArmor = "StructureLostArmor",
    StructureLostShields = "StructureLostShields",
    StructureOnline = "StructureOnline",
    StructureServicesOffline = "StructureServicesOffline",
    StructureUnanchoring = "StructureUnanchoring",
    StructureUnderAttack = "StructureUnderAttack",
    StructureWentHighPower = "StructureWentHighPower",
    StructureWentLowPower = "StructureWentLowPower",
    StructuresJobsCancelled = "StructuresJobsCancelled",
    StructuresJobsPaused = "StructuresJobsPaused",
    StructuresReinforcementChanged = "StructuresReinforcementChanged",
    TowerAlertMsg = "TowerAlertMsg",
    TowerResourceAlertMsg = "TowerResourceAlertMsg",
    TransactionReversalMsg = "TransactionReversalMsg",
    TutorialMsg = "TutorialMsg",
    WarAdopted_ = "WarAdopted ",
    WarAllyInherited = "WarAllyInherited",
    WarAllyOfferDeclinedMsg = "WarAllyOfferDeclinedMsg",
    WarConcordInvalidates = "WarConcordInvalidates",
    WarDeclared = "WarDeclared",
    WarEndedHqSecurityDrop = "WarEndedHqSecurityDrop",
    WarHQRemovedFromSpace = "WarHQRemovedFromSpace",
    WarInherited = "WarInherited",
    WarInvalid = "WarInvalid",
    WarRetracted = "WarRetracted",
    WarRetractedByConcord = "WarRetractedByConcord",
    WarSurrenderDeclinedMsg = "WarSurrenderDeclinedMsg",
    WarSurrenderOfferMsg = "WarSurrenderOfferMsg",
}

export enum Get_corporations_corporation_id_assets_200_okLocation_flag {
    AssetSafety = "AssetSafety",
    AutoFit = "AutoFit",
    Bonus = "Bonus",
    Booster = "Booster",
    BoosterBay = "BoosterBay",
    Capsule = "Capsule",
    Cargo = "Cargo",
    CorpDeliveries = "CorpDeliveries",
    CorpSAG1 = "CorpSAG1",
    CorpSAG2 = "CorpSAG2",
    CorpSAG3 = "CorpSAG3",
    CorpSAG4 = "CorpSAG4",
    CorpSAG5 = "CorpSAG5",
    CorpSAG6 = "CorpSAG6",
    CorpSAG7 = "CorpSAG7",
    CrateLoot = "CrateLoot",
    Deliveries = "Deliveries",
    DroneBay = "DroneBay",
    DustBattle = "DustBattle",
    DustDatabank = "DustDatabank",
    FighterBay = "FighterBay",
    FighterTube0 = "FighterTube0",
    FighterTube1 = "FighterTube1",
    FighterTube2 = "FighterTube2",
    FighterTube3 = "FighterTube3",
    FighterTube4 = "FighterTube4",
    FleetHangar = "FleetHangar",
    FrigateEscapeBay = "FrigateEscapeBay",
    Hangar = "Hangar",
    HangarAll = "HangarAll",
    HiSlot0 = "HiSlot0",
    HiSlot1 = "HiSlot1",
    HiSlot2 = "HiSlot2",
    HiSlot3 = "HiSlot3",
    HiSlot4 = "HiSlot4",
    HiSlot5 = "HiSlot5",
    HiSlot6 = "HiSlot6",
    HiSlot7 = "HiSlot7",
    HiddenModifiers = "HiddenModifiers",
    Implant = "Implant",
    Impounded = "Impounded",
    JunkyardReprocessed = "JunkyardReprocessed",
    JunkyardTrashed = "JunkyardTrashed",
    LoSlot0 = "LoSlot0",
    LoSlot1 = "LoSlot1",
    LoSlot2 = "LoSlot2",
    LoSlot3 = "LoSlot3",
    LoSlot4 = "LoSlot4",
    LoSlot5 = "LoSlot5",
    LoSlot6 = "LoSlot6",
    LoSlot7 = "LoSlot7",
    Locked = "Locked",
    MedSlot0 = "MedSlot0",
    MedSlot1 = "MedSlot1",
    MedSlot2 = "MedSlot2",
    MedSlot3 = "MedSlot3",
    MedSlot4 = "MedSlot4",
    MedSlot5 = "MedSlot5",
    MedSlot6 = "MedSlot6",
    MedSlot7 = "MedSlot7",
    OfficeFolder = "OfficeFolder",
    Pilot = "Pilot",
    PlanetSurface = "PlanetSurface",
    QuafeBay = "QuafeBay",
    QuantumCoreRoom = "QuantumCoreRoom",
    Reward = "Reward",
    RigSlot0 = "RigSlot0",
    RigSlot1 = "RigSlot1",
    RigSlot2 = "RigSlot2",
    RigSlot3 = "RigSlot3",
    RigSlot4 = "RigSlot4",
    RigSlot5 = "RigSlot5",
    RigSlot6 = "RigSlot6",
    RigSlot7 = "RigSlot7",
    SecondaryStorage = "SecondaryStorage",
    ServiceSlot0 = "ServiceSlot0",
    ServiceSlot1 = "ServiceSlot1",
    ServiceSlot2 = "ServiceSlot2",
    ServiceSlot3 = "ServiceSlot3",
    ServiceSlot4 = "ServiceSlot4",
    ServiceSlot5 = "ServiceSlot5",
    ServiceSlot6 = "ServiceSlot6",
    ServiceSlot7 = "ServiceSlot7",
    ShipHangar = "ShipHangar",
    ShipOffline = "ShipOffline",
    Skill = "Skill",
    SkillInTraining = "SkillInTraining",
    SpecializedAmmoHold = "SpecializedAmmoHold",
    SpecializedAsteroidHold = "SpecializedAsteroidHold",
    SpecializedCommandCenterHold = "SpecializedCommandCenterHold",
    SpecializedFuelBay = "SpecializedFuelBay",
    SpecializedGasHold = "SpecializedGasHold",
    SpecializedIceHold = "SpecializedIceHold",
    SpecializedIndustrialShipHold = "SpecializedIndustrialShipHold",
    SpecializedLargeShipHold = "SpecializedLargeShipHold",
    SpecializedMaterialBay = "SpecializedMaterialBay",
    SpecializedMediumShipHold = "SpecializedMediumShipHold",
    SpecializedMineralHold = "SpecializedMineralHold",
    SpecializedOreHold = "SpecializedOreHold",
    SpecializedPlanetaryCommoditiesHold = "SpecializedPlanetaryCommoditiesHold",
    SpecializedSalvageHold = "SpecializedSalvageHold",
    SpecializedShipHold = "SpecializedShipHold",
    SpecializedSmallShipHold = "SpecializedSmallShipHold",
    StructureActive = "StructureActive",
    StructureFuel = "StructureFuel",
    StructureInactive = "StructureInactive",
    StructureOffline = "StructureOffline",
    SubSystemBay = "SubSystemBay",
    SubSystemSlot0 = "SubSystemSlot0",
    SubSystemSlot1 = "SubSystemSlot1",
    SubSystemSlot2 = "SubSystemSlot2",
    SubSystemSlot3 = "SubSystemSlot3",
    SubSystemSlot4 = "SubSystemSlot4",
    SubSystemSlot5 = "SubSystemSlot5",
    SubSystemSlot6 = "SubSystemSlot6",
    SubSystemSlot7 = "SubSystemSlot7",
    Unlocked = "Unlocked",
    Wallet = "Wallet",
    Wardrobe = "Wardrobe",
}

export enum Get_corporations_corporation_id_assets_200_okLocation_type {
    Station = "station",
    Solar_system = "solar_system",
    Item = "item",
    Other = "other",
}

export enum Get_characters_character_id_wallet_journal_200_okContext_id_type {
    Structure_id = "structure_id",
    Station_id = "station_id",
    Market_transaction_id = "market_transaction_id",
    Character_id = "character_id",
    Corporation_id = "corporation_id",
    Alliance_id = "alliance_id",
    Eve_system = "eve_system",
    Industry_job_id = "industry_job_id",
    Contract_id = "contract_id",
    Planet_id = "planet_id",
    System_id = "system_id",
    Type_id = "type_id",
}

export enum Get_characters_character_id_wallet_journal_200_okRef_type {
    Acceleration_gate_fee = "acceleration_gate_fee",
    Advertisement_listing_fee = "advertisement_listing_fee",
    Agent_donation = "agent_donation",
    Agent_location_services = "agent_location_services",
    Agent_miscellaneous = "agent_miscellaneous",
    Agent_mission_collateral_paid = "agent_mission_collateral_paid",
    Agent_mission_collateral_refunded = "agent_mission_collateral_refunded",
    Agent_mission_reward = "agent_mission_reward",
    Agent_mission_reward_corporation_tax = "agent_mission_reward_corporation_tax",
    Agent_mission_time_bonus_reward = "agent_mission_time_bonus_reward",
    Agent_mission_time_bonus_reward_corporation_tax = "agent_mission_time_bonus_reward_corporation_tax",
    Agent_security_services = "agent_security_services",
    Agent_services_rendered = "agent_services_rendered",
    Agents_preward = "agents_preward",
    Alliance_maintainance_fee = "alliance_maintainance_fee",
    Alliance_registration_fee = "alliance_registration_fee",
    Asset_safety_recovery_tax = "asset_safety_recovery_tax",
    Bounty = "bounty",
    Bounty_prize = "bounty_prize",
    Bounty_prize_corporation_tax = "bounty_prize_corporation_tax",
    Bounty_prizes = "bounty_prizes",
    Bounty_reimbursement = "bounty_reimbursement",
    Bounty_surcharge = "bounty_surcharge",
    Brokers_fee = "brokers_fee",
    Clone_activation = "clone_activation",
    Clone_transfer = "clone_transfer",
    Contraband_fine = "contraband_fine",
    Contract_auction_bid = "contract_auction_bid",
    Contract_auction_bid_corp = "contract_auction_bid_corp",
    Contract_auction_bid_refund = "contract_auction_bid_refund",
    Contract_auction_sold = "contract_auction_sold",
    Contract_brokers_fee = "contract_brokers_fee",
    Contract_brokers_fee_corp = "contract_brokers_fee_corp",
    Contract_collateral = "contract_collateral",
    Contract_collateral_deposited_corp = "contract_collateral_deposited_corp",
    Contract_collateral_payout = "contract_collateral_payout",
    Contract_collateral_refund = "contract_collateral_refund",
    Contract_deposit = "contract_deposit",
    Contract_deposit_corp = "contract_deposit_corp",
    Contract_deposit_refund = "contract_deposit_refund",
    Contract_deposit_sales_tax = "contract_deposit_sales_tax",
    Contract_price = "contract_price",
    Contract_price_payment_corp = "contract_price_payment_corp",
    Contract_reversal = "contract_reversal",
    Contract_reward = "contract_reward",
    Contract_reward_deposited = "contract_reward_deposited",
    Contract_reward_deposited_corp = "contract_reward_deposited_corp",
    Contract_reward_refund = "contract_reward_refund",
    Contract_sales_tax = "contract_sales_tax",
    Copying = "copying",
    Corporate_reward_payout = "corporate_reward_payout",
    Corporate_reward_tax = "corporate_reward_tax",
    Corporation_account_withdrawal = "corporation_account_withdrawal",
    Corporation_bulk_payment = "corporation_bulk_payment",
    Corporation_dividend_payment = "corporation_dividend_payment",
    Corporation_liquidation = "corporation_liquidation",
    Corporation_logo_change_cost = "corporation_logo_change_cost",
    Corporation_payment = "corporation_payment",
    Corporation_registration_fee = "corporation_registration_fee",
    Courier_mission_escrow = "courier_mission_escrow",
    Cspa = "cspa",
    Cspaofflinerefund = "cspaofflinerefund",
    Daily_challenge_reward = "daily_challenge_reward",
    Datacore_fee = "datacore_fee",
    Dna_modification_fee = "dna_modification_fee",
    Docking_fee = "docking_fee",
    Duel_wager_escrow = "duel_wager_escrow",
    Duel_wager_payment = "duel_wager_payment",
    Duel_wager_refund = "duel_wager_refund",
    Ess_escrow_transfer = "ess_escrow_transfer",
    External_trade_delivery = "external_trade_delivery",
    External_trade_freeze = "external_trade_freeze",
    External_trade_thaw = "external_trade_thaw",
    Factory_slot_rental_fee = "factory_slot_rental_fee",
    Flux_payout = "flux_payout",
    Flux_tax = "flux_tax",
    Flux_ticket_repayment = "flux_ticket_repayment",
    Flux_ticket_sale = "flux_ticket_sale",
    Gm_cash_transfer = "gm_cash_transfer",
    Industry_job_tax = "industry_job_tax",
    Infrastructure_hub_maintenance = "infrastructure_hub_maintenance",
    Inheritance = "inheritance",
    Insurance = "insurance",
    Item_trader_payment = "item_trader_payment",
    Jump_clone_activation_fee = "jump_clone_activation_fee",
    Jump_clone_installation_fee = "jump_clone_installation_fee",
    Kill_right_fee = "kill_right_fee",
    Lp_store = "lp_store",
    Manufacturing = "manufacturing",
    Market_escrow = "market_escrow",
    Market_fine_paid = "market_fine_paid",
    Market_provider_tax = "market_provider_tax",
    Market_transaction = "market_transaction",
    Medal_creation = "medal_creation",
    Medal_issued = "medal_issued",
    Milestone_reward_payment = "milestone_reward_payment",
    Mission_completion = "mission_completion",
    Mission_cost = "mission_cost",
    Mission_expiration = "mission_expiration",
    Mission_reward = "mission_reward",
    Office_rental_fee = "office_rental_fee",
    Operation_bonus = "operation_bonus",
    Opportunity_reward = "opportunity_reward",
    Planetary_construction = "planetary_construction",
    Planetary_export_tax = "planetary_export_tax",
    Planetary_import_tax = "planetary_import_tax",
    Player_donation = "player_donation",
    Player_trading = "player_trading",
    Project_discovery_reward = "project_discovery_reward",
    Project_discovery_tax = "project_discovery_tax",
    Reaction = "reaction",
    Redeemed_isk_token = "redeemed_isk_token",
    Release_of_impounded_property = "release_of_impounded_property",
    Repair_bill = "repair_bill",
    Reprocessing_tax = "reprocessing_tax",
    Researching_material_productivity = "researching_material_productivity",
    Researching_technology = "researching_technology",
    Researching_time_productivity = "researching_time_productivity",
    Resource_wars_reward = "resource_wars_reward",
    Reverse_engineering = "reverse_engineering",
    Season_challenge_reward = "season_challenge_reward",
    Security_processing_fee = "security_processing_fee",
    Shares = "shares",
    Skill_purchase = "skill_purchase",
    Sovereignity_bill = "sovereignity_bill",
    Store_purchase = "store_purchase",
    Store_purchase_refund = "store_purchase_refund",
    Structure_gate_jump = "structure_gate_jump",
    Transaction_tax = "transaction_tax",
    Upkeep_adjustment_fee = "upkeep_adjustment_fee",
    War_ally_contract = "war_ally_contract",
    War_fee = "war_fee",
    War_fee_surrender = "war_fee_surrender",
}

export enum RecipientsRecipient_type {
    Alliance = "alliance",
    Character = "character",
    Corporation = "corporation",
    Mailing_list = "mailing_list",
}

export enum ItemsFlag {
    Cargo = "Cargo",
    DroneBay = "DroneBay",
    FighterBay = "FighterBay",
    HiSlot0 = "HiSlot0",
    HiSlot1 = "HiSlot1",
    HiSlot2 = "HiSlot2",
    HiSlot3 = "HiSlot3",
    HiSlot4 = "HiSlot4",
    HiSlot5 = "HiSlot5",
    HiSlot6 = "HiSlot6",
    HiSlot7 = "HiSlot7",
    Invalid = "Invalid",
    LoSlot0 = "LoSlot0",
    LoSlot1 = "LoSlot1",
    LoSlot2 = "LoSlot2",
    LoSlot3 = "LoSlot3",
    LoSlot4 = "LoSlot4",
    LoSlot5 = "LoSlot5",
    LoSlot6 = "LoSlot6",
    LoSlot7 = "LoSlot7",
    MedSlot0 = "MedSlot0",
    MedSlot1 = "MedSlot1",
    MedSlot2 = "MedSlot2",
    MedSlot3 = "MedSlot3",
    MedSlot4 = "MedSlot4",
    MedSlot5 = "MedSlot5",
    MedSlot6 = "MedSlot6",
    MedSlot7 = "MedSlot7",
    RigSlot0 = "RigSlot0",
    RigSlot1 = "RigSlot1",
    RigSlot2 = "RigSlot2",
    ServiceSlot0 = "ServiceSlot0",
    ServiceSlot1 = "ServiceSlot1",
    ServiceSlot2 = "ServiceSlot2",
    ServiceSlot3 = "ServiceSlot3",
    ServiceSlot4 = "ServiceSlot4",
    ServiceSlot5 = "ServiceSlot5",
    ServiceSlot6 = "ServiceSlot6",
    ServiceSlot7 = "ServiceSlot7",
    SubSystemSlot0 = "SubSystemSlot0",
    SubSystemSlot1 = "SubSystemSlot1",
    SubSystemSlot2 = "SubSystemSlot2",
    SubSystemSlot3 = "SubSystemSlot3",
}

export enum Recipients2Recipient_type {
    Alliance = "alliance",
    Character = "character",
    Corporation = "corporation",
    Mailing_list = "mailing_list",
}

export enum Recipients3Recipient_type {
    Alliance = "alliance",
    Character = "character",
    Corporation = "corporation",
    Mailing_list = "mailing_list",
}

/** active_total object */
export class Active_total implements IActive_total {
    /** Amount of kills */
    amount?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;

    constructor(data?: IActive_total) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.faction_id = _data["faction_id"];
        }
    }

    static fromJS(data: any): Active_total {
        data = typeof data === 'object' ? data : {};
        let result = new Active_total();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["faction_id"] = this.faction_id;
        return data;
    }
}

/** active_total object */
export interface IActive_total {
    /** Amount of kills */
    amount?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;
}

/** last_week object */
export class Last_week implements ILast_week {
    /** Amount of kills */
    amount?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;

    constructor(data?: ILast_week) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.faction_id = _data["faction_id"];
        }
    }

    static fromJS(data: any): Last_week {
        data = typeof data === 'object' ? data : {};
        let result = new Last_week();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["faction_id"] = this.faction_id;
        return data;
    }
}

/** last_week object */
export interface ILast_week {
    /** Amount of kills */
    amount?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;
}

/** yesterday object */
export class Yesterday implements IYesterday {
    /** Amount of kills */
    amount?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;

    constructor(data?: IYesterday) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.faction_id = _data["faction_id"];
        }
    }

    static fromJS(data: any): Yesterday {
        data = typeof data === 'object' ? data : {};
        let result = new Yesterday();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["faction_id"] = this.faction_id;
        return data;
    }
}

/** yesterday object */
export interface IYesterday {
    /** Amount of kills */
    amount?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;
}

/** active_total object */
export class Active_total2 implements IActive_total2 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;

    constructor(data?: IActive_total2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.faction_id = _data["faction_id"];
        }
    }

    static fromJS(data: any): Active_total2 {
        data = typeof data === 'object' ? data : {};
        let result = new Active_total2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["faction_id"] = this.faction_id;
        return data;
    }
}

/** active_total object */
export interface IActive_total2 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;
}

/** last_week object */
export class Last_week2 implements ILast_week2 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;

    constructor(data?: ILast_week2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.faction_id = _data["faction_id"];
        }
    }

    static fromJS(data: any): Last_week2 {
        data = typeof data === 'object' ? data : {};
        let result = new Last_week2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["faction_id"] = this.faction_id;
        return data;
    }
}

/** last_week object */
export interface ILast_week2 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;
}

/** yesterday object */
export class Yesterday2 implements IYesterday2 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;

    constructor(data?: IYesterday2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.faction_id = _data["faction_id"];
        }
    }

    static fromJS(data: any): Yesterday2 {
        data = typeof data === 'object' ? data : {};
        let result = new Yesterday2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["faction_id"] = this.faction_id;
        return data;
    }
}

/** yesterday object */
export interface IYesterday2 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** faction_id integer */
    faction_id?: number | undefined;
}

/** active_total object */
export class Active_total3 implements IActive_total3 {
    /** Amount of kills */
    amount?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;

    constructor(data?: IActive_total3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.character_id = _data["character_id"];
        }
    }

    static fromJS(data: any): Active_total3 {
        data = typeof data === 'object' ? data : {};
        let result = new Active_total3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["character_id"] = this.character_id;
        return data;
    }
}

/** active_total object */
export interface IActive_total3 {
    /** Amount of kills */
    amount?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;
}

/** last_week object */
export class Last_week3 implements ILast_week3 {
    /** Amount of kills */
    amount?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;

    constructor(data?: ILast_week3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.character_id = _data["character_id"];
        }
    }

    static fromJS(data: any): Last_week3 {
        data = typeof data === 'object' ? data : {};
        let result = new Last_week3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["character_id"] = this.character_id;
        return data;
    }
}

/** last_week object */
export interface ILast_week3 {
    /** Amount of kills */
    amount?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;
}

/** yesterday object */
export class Yesterday3 implements IYesterday3 {
    /** Amount of kills */
    amount?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;

    constructor(data?: IYesterday3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.character_id = _data["character_id"];
        }
    }

    static fromJS(data: any): Yesterday3 {
        data = typeof data === 'object' ? data : {};
        let result = new Yesterday3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["character_id"] = this.character_id;
        return data;
    }
}

/** yesterday object */
export interface IYesterday3 {
    /** Amount of kills */
    amount?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;
}

/** active_total object */
export class Active_total4 implements IActive_total4 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;

    constructor(data?: IActive_total4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.character_id = _data["character_id"];
        }
    }

    static fromJS(data: any): Active_total4 {
        data = typeof data === 'object' ? data : {};
        let result = new Active_total4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["character_id"] = this.character_id;
        return data;
    }
}

/** active_total object */
export interface IActive_total4 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;
}

/** last_week object */
export class Last_week4 implements ILast_week4 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;

    constructor(data?: ILast_week4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.character_id = _data["character_id"];
        }
    }

    static fromJS(data: any): Last_week4 {
        data = typeof data === 'object' ? data : {};
        let result = new Last_week4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["character_id"] = this.character_id;
        return data;
    }
}

/** last_week object */
export interface ILast_week4 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;
}

/** yesterday object */
export class Yesterday4 implements IYesterday4 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;

    constructor(data?: IYesterday4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.character_id = _data["character_id"];
        }
    }

    static fromJS(data: any): Yesterday4 {
        data = typeof data === 'object' ? data : {};
        let result = new Yesterday4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["character_id"] = this.character_id;
        return data;
    }
}

/** yesterday object */
export interface IYesterday4 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** character_id integer */
    character_id?: number | undefined;
}

/** active_total object */
export class Active_total5 implements IActive_total5 {
    /** Amount of kills */
    amount?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;

    constructor(data?: IActive_total5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.corporation_id = _data["corporation_id"];
        }
    }

    static fromJS(data: any): Active_total5 {
        data = typeof data === 'object' ? data : {};
        let result = new Active_total5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["corporation_id"] = this.corporation_id;
        return data;
    }
}

/** active_total object */
export interface IActive_total5 {
    /** Amount of kills */
    amount?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;
}

/** last_week object */
export class Last_week5 implements ILast_week5 {
    /** Amount of kills */
    amount?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;

    constructor(data?: ILast_week5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.corporation_id = _data["corporation_id"];
        }
    }

    static fromJS(data: any): Last_week5 {
        data = typeof data === 'object' ? data : {};
        let result = new Last_week5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["corporation_id"] = this.corporation_id;
        return data;
    }
}

/** last_week object */
export interface ILast_week5 {
    /** Amount of kills */
    amount?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;
}

/** yesterday object */
export class Yesterday5 implements IYesterday5 {
    /** Amount of kills */
    amount?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;

    constructor(data?: IYesterday5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.corporation_id = _data["corporation_id"];
        }
    }

    static fromJS(data: any): Yesterday5 {
        data = typeof data === 'object' ? data : {};
        let result = new Yesterday5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["corporation_id"] = this.corporation_id;
        return data;
    }
}

/** yesterday object */
export interface IYesterday5 {
    /** Amount of kills */
    amount?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;
}

/** active_total object */
export class Active_total6 implements IActive_total6 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;

    constructor(data?: IActive_total6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.corporation_id = _data["corporation_id"];
        }
    }

    static fromJS(data: any): Active_total6 {
        data = typeof data === 'object' ? data : {};
        let result = new Active_total6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["corporation_id"] = this.corporation_id;
        return data;
    }
}

/** active_total object */
export interface IActive_total6 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;
}

/** last_week object */
export class Last_week6 implements ILast_week6 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;

    constructor(data?: ILast_week6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.corporation_id = _data["corporation_id"];
        }
    }

    static fromJS(data: any): Last_week6 {
        data = typeof data === 'object' ? data : {};
        let result = new Last_week6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["corporation_id"] = this.corporation_id;
        return data;
    }
}

/** last_week object */
export interface ILast_week6 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;
}

/** yesterday object */
export class Yesterday6 implements IYesterday6 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;

    constructor(data?: IYesterday6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.corporation_id = _data["corporation_id"];
        }
    }

    static fromJS(data: any): Yesterday6 {
        data = typeof data === 'object' ? data : {};
        let result = new Yesterday6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["corporation_id"] = this.corporation_id;
        return data;
    }
}

/** yesterday object */
export interface IYesterday6 {
    /** Amount of victory points */
    amount?: number | undefined;
    /** corporation_id integer */
    corporation_id?: number | undefined;
}

export enum Cost_indicesActivity {
    Copying = "copying",
    Duplicating = "duplicating",
    Invention = "invention",
    Manufacturing = "manufacturing",
    None = "none",
    Reaction = "reaction",
    Researching_material_efficiency = "researching_material_efficiency",
    Researching_technology = "researching_technology",
    Researching_time_efficiency = "researching_time_efficiency",
    Reverse_engineering = "reverse_engineering",
}

/** item object */
export class Items3 implements IItems3 {
    /** Flag for the location of the item
 */
    flag!: number;
    /** item_type_id integer */
    item_type_id!: number;
    /** items array */
    items?: Items4[] | undefined;
    /** How many of the item were destroyed if any
 */
    quantity_destroyed?: number | undefined;
    /** How many of the item were dropped if any
 */
    quantity_dropped?: number | undefined;
    /** singleton integer */
    singleton!: number;

    constructor(data?: IItems3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flag = _data["flag"];
            this.item_type_id = _data["item_type_id"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Items4.fromJS(item));
            }
            this.quantity_destroyed = _data["quantity_destroyed"];
            this.quantity_dropped = _data["quantity_dropped"];
            this.singleton = _data["singleton"];
        }
    }

    static fromJS(data: any): Items3 {
        data = typeof data === 'object' ? data : {};
        let result = new Items3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flag"] = this.flag;
        data["item_type_id"] = this.item_type_id;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["quantity_destroyed"] = this.quantity_destroyed;
        data["quantity_dropped"] = this.quantity_dropped;
        data["singleton"] = this.singleton;
        return data;
    }
}

/** item object */
export interface IItems3 {
    /** Flag for the location of the item
 */
    flag: number;
    /** item_type_id integer */
    item_type_id: number;
    /** items array */
    items?: Items4[] | undefined;
    /** How many of the item were destroyed if any
 */
    quantity_destroyed?: number | undefined;
    /** How many of the item were dropped if any
 */
    quantity_dropped?: number | undefined;
    /** singleton integer */
    singleton: number;
}

export class Position11 implements IPosition11 {
    /** x number */
    x!: number;
    /** y number */
    y!: number;
    /** z number */
    z!: number;

    constructor(data?: IPosition11) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Position11 {
        data = typeof data === 'object' ? data : {};
        let result = new Position11();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPosition11 {
    /** x number */
    x: number;
    /** y number */
    y: number;
    /** z number */
    z: number;
}

export enum Items2Flag {
    Cargo = "Cargo",
    DroneBay = "DroneBay",
    FighterBay = "FighterBay",
    HiSlot0 = "HiSlot0",
    HiSlot1 = "HiSlot1",
    HiSlot2 = "HiSlot2",
    HiSlot3 = "HiSlot3",
    HiSlot4 = "HiSlot4",
    HiSlot5 = "HiSlot5",
    HiSlot6 = "HiSlot6",
    HiSlot7 = "HiSlot7",
    Invalid = "Invalid",
    LoSlot0 = "LoSlot0",
    LoSlot1 = "LoSlot1",
    LoSlot2 = "LoSlot2",
    LoSlot3 = "LoSlot3",
    LoSlot4 = "LoSlot4",
    LoSlot5 = "LoSlot5",
    LoSlot6 = "LoSlot6",
    LoSlot7 = "LoSlot7",
    MedSlot0 = "MedSlot0",
    MedSlot1 = "MedSlot1",
    MedSlot2 = "MedSlot2",
    MedSlot3 = "MedSlot3",
    MedSlot4 = "MedSlot4",
    MedSlot5 = "MedSlot5",
    MedSlot6 = "MedSlot6",
    MedSlot7 = "MedSlot7",
    RigSlot0 = "RigSlot0",
    RigSlot1 = "RigSlot1",
    RigSlot2 = "RigSlot2",
    ServiceSlot0 = "ServiceSlot0",
    ServiceSlot1 = "ServiceSlot1",
    ServiceSlot2 = "ServiceSlot2",
    ServiceSlot3 = "ServiceSlot3",
    ServiceSlot4 = "ServiceSlot4",
    ServiceSlot5 = "ServiceSlot5",
    ServiceSlot6 = "ServiceSlot6",
    ServiceSlot7 = "ServiceSlot7",
    SubSystemSlot0 = "SubSystemSlot0",
    SubSystemSlot1 = "SubSystemSlot1",
    SubSystemSlot2 = "SubSystemSlot2",
    SubSystemSlot3 = "SubSystemSlot3",
}

export enum Home_locationLocation_type {
    Station = "station",
    Structure = "structure",
}

export enum Jump_clonesLocation_type {
    Station = "station",
    Structure = "structure",
}

export enum LabelsColor {
    _0000fe = "#0000fe",
    _006634 = "#006634",
    _0099ff = "#0099ff",
    _00ff33 = "#00ff33",
    _01ffff = "#01ffff",
    _349800 = "#349800",
    _660066 = "#660066",
    _666666 = "#666666",
    _999999 = "#999999",
    _99ffff = "#99ffff",
    _9a0000 = "#9a0000",
    _ccff9a = "#ccff9a",
    _e6e6e6 = "#e6e6e6",
    _fe0000 = "#fe0000",
    _ff6600 = "#ff6600",
    _ffff01 = "#ffff01",
    _ffffcd = "#ffffcd",
    _ffffff = "#ffffff",
}

/** content object */
export class Contents implements IContents {
    /** amount integer */
    amount!: number;
    /** type_id integer */
    type_id!: number;

    constructor(data?: IContents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.type_id = _data["type_id"];
        }
    }

    static fromJS(data: any): Contents {
        data = typeof data === 'object' ? data : {};
        let result = new Contents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["type_id"] = this.type_id;
        return data;
    }
}

/** content object */
export interface IContents {
    /** amount integer */
    amount: number;
    /** type_id integer */
    type_id: number;
}

export class Extractor_details implements IExtractor_details {
    /** in seconds */
    cycle_time?: number | undefined;
    /** head_radius number */
    head_radius?: number | undefined;
    /** heads array */
    heads!: Heads[];
    /** product_type_id integer */
    product_type_id?: number | undefined;
    /** qty_per_cycle integer */
    qty_per_cycle?: number | undefined;

    constructor(data?: IExtractor_details) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.heads = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cycle_time = _data["cycle_time"];
            this.head_radius = _data["head_radius"];
            if (Array.isArray(_data["heads"])) {
                this.heads = [] as any;
                for (let item of _data["heads"])
                    this.heads!.push(Heads.fromJS(item));
            }
            this.product_type_id = _data["product_type_id"];
            this.qty_per_cycle = _data["qty_per_cycle"];
        }
    }

    static fromJS(data: any): Extractor_details {
        data = typeof data === 'object' ? data : {};
        let result = new Extractor_details();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycle_time"] = this.cycle_time;
        data["head_radius"] = this.head_radius;
        if (Array.isArray(this.heads)) {
            data["heads"] = [];
            for (let item of this.heads)
                data["heads"].push(item.toJSON());
        }
        data["product_type_id"] = this.product_type_id;
        data["qty_per_cycle"] = this.qty_per_cycle;
        return data;
    }
}

export interface IExtractor_details {
    /** in seconds */
    cycle_time?: number | undefined;
    /** head_radius number */
    head_radius?: number | undefined;
    /** heads array */
    heads: Heads[];
    /** product_type_id integer */
    product_type_id?: number | undefined;
    /** qty_per_cycle integer */
    qty_per_cycle?: number | undefined;
}

export class Factory_details implements IFactory_details {
    /** schematic_id integer */
    schematic_id!: number;

    constructor(data?: IFactory_details) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schematic_id = _data["schematic_id"];
        }
    }

    static fromJS(data: any): Factory_details {
        data = typeof data === 'object' ? data : {};
        let result = new Factory_details();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schematic_id"] = this.schematic_id;
        return data;
    }
}

export interface IFactory_details {
    /** schematic_id integer */
    schematic_id: number;
}

export enum Services2State {
    Online = "online",
    Offline = "offline",
    Cleanup = "cleanup",
}

/** item object */
export class Items4 implements IItems4 {
    /** flag integer */
    flag!: number;
    /** item_type_id integer */
    item_type_id!: number;
    /** quantity_destroyed integer */
    quantity_destroyed?: number | undefined;
    /** quantity_dropped integer */
    quantity_dropped?: number | undefined;
    /** singleton integer */
    singleton!: number;

    constructor(data?: IItems4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flag = _data["flag"];
            this.item_type_id = _data["item_type_id"];
            this.quantity_destroyed = _data["quantity_destroyed"];
            this.quantity_dropped = _data["quantity_dropped"];
            this.singleton = _data["singleton"];
        }
    }

    static fromJS(data: any): Items4 {
        data = typeof data === 'object' ? data : {};
        let result = new Items4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flag"] = this.flag;
        data["item_type_id"] = this.item_type_id;
        data["quantity_destroyed"] = this.quantity_destroyed;
        data["quantity_dropped"] = this.quantity_dropped;
        data["singleton"] = this.singleton;
        return data;
    }
}

/** item object */
export interface IItems4 {
    /** flag integer */
    flag: number;
    /** item_type_id integer */
    item_type_id: number;
    /** quantity_destroyed integer */
    quantity_destroyed?: number | undefined;
    /** quantity_dropped integer */
    quantity_dropped?: number | undefined;
    /** singleton integer */
    singleton: number;
}

/** head object */
export class Heads implements IHeads {
    /** head_id integer */
    head_id!: number;
    /** latitude number */
    latitude!: number;
    /** longitude number */
    longitude!: number;

    constructor(data?: IHeads) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.head_id = _data["head_id"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): Heads {
        data = typeof data === 'object' ? data : {};
        let result = new Heads();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["head_id"] = this.head_id;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

/** head object */
export interface IHeads {
    /** head_id integer */
    head_id: number;
    /** latitude number */
    latitude: number;
    /** longitude number */
    longitude: number;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}